{
 " ao(à) paciente {nome}{cpf}": " пациенту(-ке) {nome}{cpf}",
 " junto ao plano de saúde {c}": " в страховой компании {c}",
 " às {h}": " в {h}",
 "\"1\", \"1 / 10\" ou \"Página 1 de 10\", no canto que quiser.": "\"1\", \"1 / 10\" или \"Страница 1 из 10\", в любом углу.",
 "\"{nome}\" está no {provedor}.": "«{nome}» находится в {provedor}.",
 "\"{nome}\" não é JPG nem PNG. Converta para JPG e tente de novo.": "\"{nome}\" не JPG и не PNG. Преобразуйте в JPG и попробуйте снова.",
 "\"{nome}\" não é um PDF.": "\"{nome}\" не является PDF.",
 "\"{nova}\" às {hora} coincide com: {outras}.": "«{nova}» в {hora} совпадает с: {outras}.",
 "\"{n}\" agora é do grupo. Em até 1 minuto os outros membros veem tudo.": "«{n}» теперь принадлежит группе. В течение 1 минуты остальные участники увидят всё.",
 "\"{titulo}\" foi criada com os mesmos dados.": "Задача «{titulo}» создана с теми же данными.",
 "\"{titulo}\" já foi adicionado em {data}.": "«{titulo}» уже добавлено {data}.",
 "% ao mês": "% в месяц",
 "(No computador do administrador: 32-LIGAR-DRIVE-ONEDRIVE.bat.)": "(На компьютере администратора: 32-LIGAR-DRIVE-ONEDRIVE.bat.)",
 "(cópia)": "(копия)",
 "(sem título)": "(без названия)",
 "+ Adicionar alerta": "+ Добавить напоминание",
 "+ Adicionar outra OAB": "+ Добавить ещё OAB",
 "+ Adicionar pausa": "+ Добавить перерыв",
 "+ Adicionar subtarefa": "+ Добавить подзадачу",
 "+ Matéria em {nome}": "+ Предмет в {nome}",
 "+ Perfil": "+ Профиль",
 "+ Subtarefa": "+ Подзадача",
 "+5 min": "+5 мин",
 "+{n} acompanhante(s)": "+{n} сопровождающих",
 "+{n} páginas acima da meta": "+{n} стр. сверх цели",
 ", carteirinha nº {n},": ", полис № {n},",
 ", pago em {d}{f}": ", оплачено {d}{f}",
 "1 cápsula": "1 капсула",
 "1 dose": "1 доза",
 "1 dose (30 g)": "1 доза (30 г)",
 "1 pessoa": "1 человек",
 "1 publicação nova": "1 новая публикация",
 "1 página": "1 страница",
 "1 tarja no documento": "1 закрашенная область в документе",
 "1. Instale o My Planner e crie sua conta.  2. Abra este link de novo (ou digite o código em Ajustes › Grupos e convites).": "1. Установите My Planner и создайте аккаунт.  2. Снова откройте эту ссылку (или введите код в Настройки › Группы и приглашения).",
 "1. Quais dados tratamos": "1. Какие данные мы обрабатываем",
 "1. Sobre o app": "1. О приложении",
 "1ª dose": "1-я доза",
 "2 por folha": "2 на лист",
 "2 xícaras de farinha\n3 ovos\n1 colher de fermento": "2 стакана муки\n3 яйца\n1 ложка разрыхлителя",
 "2, 4, 6 ou 9 páginas em cada folha (para imprimir).": "2, 4, 6 или 9 страниц на каждом листе (для печати).",
 "2. Para que usamos": "2. Для чего мы их используем",
 "2. Sua conta": "2. Ваш аккаунт",
 "2ª dose": "2-я доза",
 "3 a 5 g": "3–5 г",
 "3. Bases legais (LGPD)": "3. Правовые основания (LGPD)",
 "3. Uso correto": "3. Правильное использование",
 "3ª dose": "3-я доза",
 "4 por folha": "4 на лист",
 "4. Com quem compartilhamos": "4. С кем мы делимся данными",
 "4. Planos e testes": "4. Тарифы и пробные периоды",
 "5. Limites": "5. Ограничения",
 "5. Segurança": "5. Безопасность",
 "6 por folha": "6 на лист",
 "6. Por quanto tempo": "6. Как долго мы храним данные",
 "7. Seus direitos (art. 18 da LGPD)": "7. Ваши права (art. 18 LGPD)",
 "8. Crianças e adolescentes": "8. Дети и подростки",
 "9 por folha": "9 на лист",
 "9. Mudanças": "9. Изменения",
 "@letra-dom": "В",
 "@letra-qua": "С",
 "@letra-qui": "Ч",
 "@letra-sab": "С",
 "@letra-seg": "П",
 "@letra-sex": "П",
 "@letra-ter": "В",
 "A IA está classificando...": "ИИ распределяет по категориям...",
 "A IA está lendo a caixa...": "ИИ читает блок...",
 "A IA lê as páginas e o PDF passa a aceitar busca e cópia.": "ИИ читает страницы, и в PDF можно искать и копировать текст.",
 "A IA lê o PDF e sugere um nome claro.": "ИИ читает PDF и предлагает понятное имя.",
 "A IA não devolveu uma resposta no formato esperado. Tente de novo.": "ИИ вернул ответ не в ожидаемом формате. Попробуйте ещё раз.",
 "A IA não encontrou dados para esta ficha no arquivo.": "ИИ не нашёл в файле данных для этой карточки.",
 "A IA não encontrou tarefas nesta caixa.": "ИИ не нашёл задач в этом блоке.",
 "A IA resume o PDF e responde perguntas.": "ИИ кратко пересказывает PDF и отвечает на вопросы.",
 "A SEFAZ registra que a nota chegou ao seu conhecimento (não confirma nem recusa a compra) e libera o XML completo na próxima busca, em até 1 hora.": "SEFAZ отмечает, что вы ознакомлены со счётом (это не подтверждает и не отклоняет покупку), и открывает полный XML при следующем поиске, в течение 1 часа.",
 "A VENCER (7 DIAS)": "СКОРО СРОК (7 ДНЕЙ)",
 "A aba inteira": "Вся вкладка",
 "A aba {aba} está perto do limite. Arquive ou apague itens antigos dela.": "Вкладка {aba} почти заполнена. Архивируйте или удалите в ней старые записи.",
 "A aba {aba} não está assinada. O vínculo fica guardado e volta ao assinar.": "Вкладка {aba} не оплачена. Связь сохранится и вернётся после оформления подписки.",
 "A busca de \"{nome}\" está ampla demais. Use o nome completo.": "Поиск по «{nome}» слишком широкий. Укажите полное имя.",
 "A busca de GIFs ainda não foi ligada neste app. Enquanto isso, use as figurinhas animadas (🎉).": "Поиск GIF в этом приложении пока не включён. А пока используйте анимированные стикеры (🎉).",
 "A cada": "Каждые",
 "A cada N páginas": "Каждые N страниц",
 "A cada quantos dias": "Раз в сколько дней",
 "A cada {n} dia(s)": "Каждые {n} дн.",
 "A cada {n} mês(es)": "Каждые {n} мес.",
 "A cada {n} mês(es) · dia {d}": "Каждые {n} мес. · {d} число",
 "A cada {n} semana(s)": "Каждые {n} нед.",
 "A cada {n} semana(s) · {dia}": "Каждые {n} нед. · {dia}",
 "A caixa está em {aba}, em \"Anotações recebidas\".": "Блок находится в {aba}, в разделе «Полученные заметки».",
 "A caixa foi para {destino}.": "Блок отправлен в {destino}.",
 "A chave fica guardada só neste dispositivo, no cofre do sistema. Em outro dispositivo, cadastre de novo.": "Ключ хранится только на этом устройстве, в системном хранилище. На другом устройстве добавьте его заново.",
 "A chave fica guardada só neste navegador. Use num computador pessoal.": "Ключ хранится только в этом браузере. Используйте личный компьютер.",
 "A conexão é criptografada. O cofre usa criptografia de ponta a ponta (AES-256): nem o suporte consegue ler. O app pode ser bloqueado com senha, desenho ou biometria.": "Соединение зашифровано. Сейф использует сквозное шифрование (AES-256): даже поддержка не может его прочитать. Приложение можно заблокировать паролем, графическим ключом или биометрией.",
 "A confirmação pelo WhatsApp ainda não foi ligada no servidor.": "Подтверждение через WhatsApp ещё не включено на сервере.",
 "A conta e todos os dados guardados na nuvem: tarefas, anotações, abas, fichas, mensagens, arquivos enviados ao app e configurações. Também são apagados os dados deste dispositivo. Não há como desfazer.": "Аккаунт и все данные в облаке: задачи, заметки, вкладки, карточки, сообщения, файлы, отправленные в приложение, и настройки. Данные на этом устройстве тоже удаляются. Отменить нельзя.",
 "A cor aparece na barra, nos títulos e nas tarefas ligadas a esta aba.": "Цвет используется в панели, заголовках и задачах, связанных с этой вкладкой.",
 "A cor do My Planner é a cor de destaque do app. Cada tarefa pode ter uma cor própria na ficha.": "Цвет My Planner — это акцентный цвет приложения. У каждой задачи может быть свой цвет в карточке.",
 "A data de fim é anterior à de início.": "Дата окончания раньше даты начала.",
 "A data inicial precisa ser antes da final.": "Начальная дата должна быть раньше конечной.",
 "A equipe vai olhar o erro e corrigir numa próxima atualização.": "Команда изучит ошибку и исправит её в одном из следующих обновлений.",
 "A equipe vê e altera conforme o papel de cada um": "Команда видит и изменяет данные в зависимости от роли",
 "A fazer": "К выполнению",
 "A foto passa de 8 MB.": "Фото больше 8 МБ.",
 "A foto é grande demais. Instale o app novo para recortar a foto.": "Фото слишком большое. Установите новую версию приложения, чтобы обрезать фото.",
 "A função \"nuvem\" ainda não foi publicada no servidor. Rode o 32-LIGAR-DRIVE-ONEDRIVE.bat.": "Функция «nuvem» ещё не опубликована на сервере. Запустите 32-LIGAR-DRIVE-ONEDRIVE.bat.",
 "A função \"nuvem\" ainda não foi publicada no servidor. Rode o 9-LIGAR-DRIVE-ONEDRIVE.bat (veja COMO RODAR, versão 0.15.1).": "Функция «nuvem» ещё не опубликована на сервере. Запустите 9-LIGAR-DRIVE-ONEDRIVE.bat (см. COMO RODAR, версия 0.15.1).",
 "A gravação ainda está sendo preparada. Tente de novo em alguns minutos.": "Запись ещё готовится. Попробуйте снова через несколько минут.",
 "A hora fica marcada neste fuso. Em outro fuso, o app mostra e avisa no horário convertido.": "Время задаётся в этом часовом поясе. В другом поясе приложение покажет и напомнит по пересчитанному времени.",
 "A imagem original não está neste dispositivo.": "Исходного изображения нет на этом устройстве.",
 "A pagar": "К оплате",
 "A pagar: {v}": "К оплате: {v}",
 "A permissão da agenda foi retirada. Libere de novo nas configurações do celular.": "Доступ к календарю был отозван. Разрешите его снова в настройках телефона.",
 "A pessoa sai do grupo e deixa de receber os envios.": "Человек выходит из группы и перестаёт получать отправки.",
 "A receber": "К получению",
 "A receber: {v}": "К получению: {v}",
 "A reunião ainda está sendo gravada.": "Встреча ещё записывается.",
 "A senha atual não confere.": "Текущий пароль неверен.",
 "A senha do cofre precisa ter 6 caracteres ou mais.": "Пароль сейфа должен содержать не менее 6 символов.",
 "A senha precisa ter 8 caracteres ou mais.": "Пароль должен содержать 8 символов или больше.",
 "A senha precisa ter pelo menos 8 caracteres.": "Пароль должен содержать не менее 8 символов.",
 "A senha é a mesma no celular e no My Planner Web.": "Пароль одинаковый в телефоне и в My Planner Web.",
 "A sincronização roda ao abrir o app e depois de cada alteração. Tarefas ligadas à agenda mostram 📆.": "Синхронизация выполняется при открытии приложения и после каждого изменения. У задач, связанных с календарём, отображается 📆.",
 "A sua equipe num lugar só": "Ваша команда в одном месте",
 "A tarefa da casa não entra no My Planner sozinha. \"Enviar para o My Planner\" abre a ficha completa para escolher dia, horário, frequência, pausas e alertas.": "Дело по дому не попадает в My Planner само. «Отправить в My Planner» открывает полную карточку, где можно выбрать день, время, частоту, перерывы и напоминания.",
 "A validade não pode ser antes da emissão.": "Срок действия не может быть раньше даты выдачи.",
 "A versão para iPhone chega em breve na App Store. Enquanto isso, use o My Planner Web.": "Версия для iPhone скоро появится в App Store. А пока используйте My Planner Web.",
 "A versão para iPhone chega em breve na App Store. Enquanto isso, use o My Planner Web: no Safari, toque em Compartilhar > Adicionar à Tela de Início para ele virar um ícone no celular.": "Версия для iPhone скоро появится в App Store. А пока пользуйтесь My Planner Web: в Safari нажмите «Поделиться» > «На экран „Домой“», чтобы добавить значок на телефон.",
 "A4, Carta, A5 ou Ofício, sem cortar nada.": "A4, Letter, A5 или Legal, ничего не обрезая.",
 "ADICIONAR AMIGO": "ДОБАВИТЬ ДРУГА",
 "AGUARDANDO RESPOSTA": "ОЖИДАЮТ ОТВЕТА",
 "AMIGOS": "ДРУЗЬЯ",
 "ANOTAÇÕES": "ЗАМЕТКИ",
 "ANOTAÇÕES RECEBIDAS · {aba}": "ПОЛУЧЕННЫЕ ЗАМЕТКИ · {aba}",
 "ATIVIDADE": "АКТИВНОСТЬ",
 "ATIVIDADE FÍSICA": "ФИЗИЧЕСКАЯ АКТИВНОСТЬ",
 "ATRASADAS": "ПРОСРОЧЕНО",
 "Aba": "Вкладка",
 "Aba bloqueada": "Вкладка заблокирована",
 "Aba {nome}": "Вкладка {nome}",
 "Abas": "Вкладки",
 "Abas liberadas pelo suporte": "Вкладки, открытые поддержкой",
 "Abas para comprar": "Вкладки для покупки",
 "Abas que você já tem": "Ваши вкладки",
 "Abastecimento": "Заправка",
 "Abastecimentos": "Заправки",
 "Abdominal": "Скручивания на пресс",
 "Abertura do prazo da declaração do IR": "Начало приёма деклараций IR (подоходный налог)",
 "Abra a empresa e toque em \"Buscar notas\" para digitar a senha do cofre.": "Откройте компанию и нажмите «Найти счета», чтобы ввести пароль сейфа.",
 "Abra o My Planner Anne e entre com o seu CPF e senha.": "Откройте My Planner Anne и войдите по номеру документа и паролю.",
 "Abra o My Planner no celular.": "Откройте My Planner на телефоне.",
 "Abra o cofre": "Откройте сейф",
 "Abra um PDF para começar.": "Откройте PDF, чтобы начать.",
 "Abra uma matéria e toque em \"Estudar agora\" para cronometrar. Defina metas semanais em cada matéria.": "Откройте предмет и нажмите «Учиться сейчас», чтобы засечь время. Задайте недельные цели для каждого предмета.",
 "Abraço": "Обнимаю",
 "Abre a janela do celular: WhatsApp, e-mail, Google Drive, OneDrive, salvar em Arquivos e outros.": "Открывает меню «Поделиться» на телефоне: WhatsApp, почта, Google Drive, OneDrive, «Сохранить в Файлы» и другое.",
 "Abre o PDF para ler aqui mesmo.": "Открывает PDF для чтения прямо здесь.",
 "Abre o Scanner PDF (bordas e sombras corrigidas).": "Открывает PDF-сканер (края и тени исправлены).",
 "Abrir": "Открыть",
 "Abrir Ajustes": "Открыть настройки",
 "Abrir PDF": "Открыть PDF",
 "Abrir PDF do celular, Drive ou OneDrive": "Открыть PDF с телефона, Drive или OneDrive",
 "Abrir a aba": "Открыть вкладку",
 "Abrir a cópia guardada": "Открыть сохранённую копию",
 "Abrir a pasta no Drive": "Открыть папку на Drive",
 "Abrir com outro app": "Открыть в другом приложении",
 "Abrir configurações": "Открыть настройки",
 "Abrir em outro app": "Открыть в другом приложении",
 "Abrir no DJEN": "Открыть в DJEN",
 "Abrir no modo seguro": "Открыть в безопасном режиме",
 "Abrir normalmente": "Открыть как обычно",
 "Abrir nota fiscal": "Открыть чек",
 "Abrir o PDF": "Открыть PDF",
 "Abrir o PDF no {nome}": "Открыть PDF в {nome}",
 "Abrir o XML": "Открыть XML",
 "Abrir o app": "Открыть приложение",
 "Abrir o app My Planner": "Открыть приложение My Planner",
 "Abrir o cartão": "Открыть карту",
 "Abrir o cofre": "Открыть сейф",
 "Abrir o cofre para ver": "Откройте сейф, чтобы увидеть",
 "Abrir o diário oficial": "Открыть официальный вестник",
 "Abrir ou baixar": "Открыть или скачать",
 "Abrir página": "Открыть страницу",
 "Abrir site": "Открыть сайт",
 "Abrir {nome}": "Открыть {nome}",
 "Acabamento": "Отделка",
 "Acabou": "Закончилось",
 "Academia": "Зал",
 "Aceitar": "Принять",
 "Aceitar, editar ou recusar": "Принять, изменить или отклонить",
 "Aceite os termos para continuar.": "Примите условия, чтобы продолжить.",
 "Aceito": "Принято",
 "Aceito com alterações": "Принято с изменениями",
 "Acerto de contas": "Взаиморасчёт",
 "Acerto de contas: {v}": "Взаиморасчёт: {v}",
 "Acessibilidade": "Доступность",
 "Acesso ilimitado": "Неограниченный доступ",
 "Acesso ilimitado a todas as funções, sem prazo": "Неограниченный доступ ко всем функциям, бессрочно",
 "Achatar": "Сгладить",
 "Acompanha tudo, inclusive os gastos, e registra no diário.": "Следит за всем, включая расходы, и ведёт дневник.",
 "Acompanhamento": "Гарнир",
 "Acompanhantes": "Сопровождающие",
 "Acrescentar no fim da página": "Добавить в конец страницы",
 "Adaptador de tomada": "Переходник для розетки",
 "Adestramento": "Дрессировка",
 "Adicionar": "Добавить",
 "Adicionar amigo": "Добавить друга",
 "Adicionar amigos do app": "Добавить друзей из приложения",
 "Adicionar ao Planner?": "Добавить в Planner?",
 "Adicionar arquivo": "Добавить файл",
 "Adicionar cômodo": "Добавить комнату",
 "Adicionar fotos e vídeos": "Добавить фото и видео",
 "Adicionar imagem": "Добавить изображение",
 "Adicionar item (ex.: 2 ovos mexidos)": "Добавить продукт (напр.: 2 яйца-болтуньи)",
 "Adicionar na página": "Добавить на страницу",
 "Adicionar passo": "Добавить шаг",
 "Adicionar país": "Добавить страну",
 "Adicionar página": "Добавить страницу",
 "Adicionar texto": "Добавить текст",
 "Adicionar {nome}": "Добавить: {nome}",
 "Adicionar à equipe": "Добавить в команду",
 "Adicione um amigo pelo código dele ou mande o seu código para quem você quer.": "Добавьте друга по его коду или отправьте свой код тому, кого хотите добавить.",
 "Admin": "Админ",
 "Administração": "Менеджмент",
 "Adubar a cada quantos dias": "Подкармливать раз в сколько дней",
 "Adubar: {p}": "Подкормка: {p}",
 "Adubei hoje": "Подкормил(а) сегодня",
 "Advogado": "Юрист",
 "Advogados": "Юристы",
 "Afundo": "Выпады",
 "Agachamento": "Приседания",
 "Agenda do Google": "Google Календарь",
 "Agenda limpa": "Расписание очищено",
 "Agenda não liberada": "Нет доступа к календарю",
 "Agenda sincronizada ✓": "Календарь синхронизирован ✓",
 "Agenda, anotações, finanças, estudos, mensagens e muito mais num app só.": "Календарь, заметки, финансы, учёба, сообщения и многое другое в одном приложении.",
 "Agenda, cadastro dos pacientes e pagamentos, sem o prontuário.": "Расписание, карточки пациентов и оплаты, без медицинских карт.",
 "Agendado": "Запланировано",
 "Agendado no My Planner": "Запланировано в My Planner",
 "Agendamento no pet shop": "Запись в зоомагазин",
 "Agendar": "Запланировать",
 "Agendar no My Planner": "Запланировать в My Planner",
 "Agendar no My Planner (dias e horários)": "Запланировать в My Planner (дни и время)",
 "Agora não": "Не сейчас",
 "Agora o verso do documento.": "Теперь оборотная сторона документа.",
 "Agora, {hora}": "Сейчас, {hora}",
 "Agora: {ml}": "Сейчас: {ml}",
 "Aguardando o celular · {s}s": "Ожидание телефона · {s} с",
 "Aguarde": "Подождите",
 "Aguarde um pouco": "Подождите немного",
 "Aguarde...": "Подождите...",
 "Ainda a pagar no mês": "Ещё к оплате в этом месяце",
 "Ainda a receber no mês": "Ещё к получению в этом месяце",
 "Ainda não confirmado": "Ещё не подтверждён",
 "Ainda não disponível: falta configurar no servidor.": "Пока недоступно: не настроено на сервере.",
 "Ainda não guardou nada este mês. Que tal separar {v} (10% do que entrou) assim que o dinheiro cair?": "В этом месяце вы ещё ничего не отложили. Может, отложить {v} (10% поступлений), как только придут деньги?",
 "Ainda não há feriados deste país para este ano.": "Для этой страны пока нет праздников на этот год.",
 "Ainda não há nada nesta aba para compartilhar. Crie primeiro (ex.: a viagem) e volte aqui.": "В этой вкладке пока нечего показывать группе. Сначала создайте (например, поездку) и вернитесь сюда.",
 "Ainda não há outras pessoas no grupo (ou você não vê a lista de membros).": "В группе пока нет других участников (или вы не видите список участников).",
 "Ainda não marcado como feito. Toque para abrir.": "Ещё не отмечено как выполненное. Нажмите, чтобы открыть.",
 "Ainda não sincronizado": "Ещё не синхронизировано",
 "Ainda sem chave neste dispositivo.": "На этом устройстве ещё нет ключа.",
 "Airbnb": "Airbnb",
 "Airbnb, Booking ou direto: reservas, limpeza no check-out, receitas, despesas e lucro do mês": "Airbnb, Booking или напрямую: бронирования, уборка после выезда, доходы, расходы и прибыль за месяц",
 "Ajuda na organização": "Помогает с организацией",
 "Ajudante": "Помощник",
 "Ajustar": "Изменить",
 "Ajustar a data final": "Изменить дату окончания",
 "Ajustar a folha": "Подогнать лист",
 "Ajustar tamanho da página": "Изменить размер страницы",
 "Ajuste visual": "Настройка вида",
 "Ajustes": "Настройки",
 "Alarme dos remédios": "Будильник для лекарств",
 "Alarme que insiste até marcar como tomado": "Будильник, который звонит, пока не отметите приём",
 "Alemão": "Немецкий",
 "Alergia": "Аллергия",
 "Alergias": "Аллергии",
 "Alergias e alertas": "Аллергии и предупреждения",
 "Alertas": "Напоминания",
 "Alertas das tarefas": "Напоминания о задачах",
 "Alertas dos compromissos": "Оповещения о встречах",
 "Algo deu errado, mas o app continua aberto": "Что-то пошло не так, но приложение по-прежнему открыто",
 "Alguns arquivos foram guardados em outro dispositivo.": "Некоторые файлы сохранены на другом устройстве.",
 "Alguns relógios (como os da Huawei) podem não enviar dados para o Health Connect. Nesse caso, digite à mão.": "Некоторые часы (например, Huawei) могут не передавать данные в Health Connect. В этом случае введите их вручную.",
 "Alguém": "Кто-то",
 "Alguém indicou o app para você?": "Вам кто-то порекомендовал приложение?",
 "Alimentação": "Питание",
 "Alimentação & Despensa": "Питание и кладовая",
 "Alimentação {semana}": "Питание {semana}",
 "Alimento": "Продукт",
 "Alinhamento e balanceamento": "Развал-схождение и балансировка",
 "Almoço": "Обед",
 "Alongamento": "Растяжка",
 "Alta": "Высокая",
 "Alterado por último por {nome}": "Последнее изменение: {nome}",
 "Alterar metadados": "Изменить метаданные",
 "Alterar o valor pago": "Изменить уплаченную сумму",
 "Alterações": "Изменения",
 "Alto-falante": "Динамик",
 "Aluga como": "Сдаётся как",
 "Alugar a casa ou um cômodo": "Сдавать дом или комнату",
 "Aluguel": "Аренда",
 "Aluguel & Hospedagem": "Аренда и размещение",
 "Aluguel de carro": "Аренда авто",
 "Aluno": "Ученик",
 "Alunos": "Ученики",
 "Alvará ou licença": "Разрешение или лицензия",
 "Alvenaria": "Кладка",
 "Alvo": "Целевая сумма",
 "Alíquota do ISS (%)": "Ставка ISS (%)",
 "Alíquota do ISS deste serviço (%)": "Ставка ISS для этой услуги (%)",
 "Amanhã": "Завтра",
 "Ambiente": "Среда",
 "Ameno": "Умеренный",
 "Amigos": "Друзья",
 "Amor": "Любовь",
 "Amortização": "Погашение долга",
 "Ampliar a foto": "Увеличить фото",
 "Amém": "Аминь",
 "Analisar com IA": "Анализ с ИИ",
 "Anamnese e histórico (no cofre)": "Анамнез и история (в сейфе)",
 "Anexar arquivos": "Вложить файлы",
 "Anexar comprovante": "Прикрепить квитанцию",
 "Anexar documentos, importar extratos e salvar relatórios, PDFs e cópias de segurança.": "Прикреплять документы, импортировать выписки и сохранять отчёты, PDF и резервные копии.",
 "Anexos": "Вложения",
 "Anexos guardados aqui no dispositivo: {n}": "Вложения только на этом устройстве: {n}",
 "Animais e natureza": "Животные и природа",
 "Animação": "Анимация",
 "Anime": "Аниме",
 "Aniversário": "День рождения",
 "Aniversário de Campo Grande": "День города Кампу-Гранди",
 "Aniversário de São Paulo": "День города Сан-Паулу",
 "Ano": "Год",
 "Ano anterior": "Предыдущий год",
 "Ano de lançamento": "Год выхода",
 "Ano de {ano}": "{ano} год",
 "Ano passado": "Прошлый год",
 "Anotar pela foto da página": "Записать по фото страницы",
 "Anotação": "Заметка",
 "Anotação de {data}": "Заметка от {data}",
 "Anotação do professor": "Заметка учителя",
 "Anotação à mão": "Рукописная заметка",
 "Anotações": "Заметки",
 "Anotações Rápidas": "Быстрые заметки",
 "Anotações arquivadas": "Архивные заметки",
 "Anotações arquivadas ({n})": "Архивные заметки ({n})",
 "Anote cada reserva com as datas, a origem e os valores. A limpeza do check-out entra sozinha na lista de limpezas.": "Записывайте каждое бронирование с датами, источником и суммами. Уборка после выезда сама попадает в список уборок.",
 "Anote o dia a dia da obra com fotos. Marque as fotos como Antes ou Depois para ver a evolução.": "Ведите дневник стройки с фото. Отмечайте фото как «До» или «После», чтобы видеть прогресс.",
 "Anote o que emprestou ou pegou emprestado, com foto e prazo. O app avisa no dia da devolução.": "Записывайте, что вы дали или взяли взаймы, с фото и сроком. Приложение напомнит в день возврата.",
 "Anote os lugares que quer conhecer. Pesquise no Google Maps ou no Waze, trace a rota passando por todos e coloque no roteiro do dia.": "Записывайте места, которые хотите посетить. Найдите их в Google Maps или Waze, проложите маршрут через все и добавьте в программу дня.",
 "Anteriores ({n})": "Прошедшие ({n})",
 "Antes": "До",
 "Antes de começar, confira o que o app usa e por quê. Você pode mudar tudo depois em Ajustes > Privacidade e termos.": "Прежде чем начать, посмотрите, что использует приложение и зачем. Всё это можно изменить позже в разделе Настройки > Конфиденциальность и условия.",
 "Antes de uma data": "До даты",
 "Antes do início": "До начала",
 "Antes e depois": "До и после",
 "Antes: {lista}": "Заранее: {lista}",
 "Antipulgas": "От блох",
 "Anual": "Ежегодно",
 "Ao ar livre": "На улице",
 "Ao cancelar, a aba fica em preto e branco e os vínculos somem das tarefas, mas nada é apagado.": "При отмене вкладка станет чёрно-белой, а связи исчезнут из задач, но ничего не будет удалено.",
 "Ao criar a conta ou continuar usando o app, você concorda com estes termos e com a política de privacidade abaixo.": "Создавая аккаунт или продолжая пользоваться приложением, вы соглашаетесь с этими условиями и с политикой конфиденциальности ниже.",
 "Ao fechar, a página é salva.": "При закрытии страница сохраняется.",
 "Ao salvar, você cria a senha do cofre. Este campo é criptografado no dispositivo.": "При сохранении вы создадите пароль сейфа. Это поле шифруется на устройстве.",
 "Ao tocar em \"Arquivo\" ou \"Foto\" em Estudos e Documentos, o seletor do celular mostra o Google Drive, o OneDrive e o Dropbox (quando os apps estão instalados). Escolha o arquivo direto de lá.": "Если нажать «Файл» или «Фото» в разделах Учёба и Документы, на телефоне откроется выбор с Google Drive, OneDrive и Dropbox (если эти приложения установлены). Выберите файл прямо там.",
 "Ao tocar num arquivo anexado, ele abre no app do celular que você escolher (no Android, \"Apenas uma vez\" ou \"Sempre\"). O que você editar lá fica salvo no próprio arquivo.": "Нажмите на вложенный файл, чтобы открыть его в выбранном приложении телефона (на Android «Только сейчас» или «Всегда»). Изменения сохраняются в самом файле.",
 "Apaga a conta e todos os vencimentos dela.": "Удаляет счёт и все его сроки оплаты.",
 "Apaga as matérias e páginas deste fichário. As tarefas do planner continuam.": "Удаляет предметы и страницы этой папки. Задачи в планере сохранятся.",
 "Apaga as páginas desta matéria. O tempo estudado continua no histórico.": "Удаляет страницы этого предмета. Время занятий останется в истории.",
 "Apaga o cartão e as compras dele.": "Удаляет карту и её покупки.",
 "Apaga para sempre a conta e todos os dados na nuvem e neste dispositivo. Não há como desfazer.": "Навсегда удаляет аккаунт и все данные в облаке и на этом устройстве. Отменить нельзя.",
 "Apaga todas as tarefas da agenda, passadas e futuras.": "Удаляет все задачи из расписания, прошлые и будущие.",
 "Apaga todas as {n} parcelas.": "Удаляет все {n} платежей рассрочки.",
 "Apaga todos os meses desta conta.": "Удаляет все месяцы этого счёта.",
 "Apagar": "Удалить",
 "Apagar \"{nome}\"?": "Удалить «{nome}»?",
 "Apagar a caixa?": "Удалить блок?",
 "Apagar a chave": "Удалить ключ",
 "Apagar a chave deste dispositivo?": "Удалить ключ с этого устройства?",
 "Apagar a conta?": "Удалить аккаунт?",
 "Apagar a lista de erros?": "Очистить список ошибок?",
 "Apagar a pasta (os documentos continuam)": "Удалить папку (документы останутся)",
 "Apagar as da agenda": "Удалить из календаря",
 "Apagar caixa": "Удалить блок",
 "Apagar de verdade (as páginas com tarja viram imagem)": "Удалить по-настоящему (страницы с закраской станут изображениями)",
 "Apagar de vez": "Удалить навсегда",
 "Apagar desenho": "Стереть рисунок",
 "Apagar envio": "Удалить отправку",
 "Apagar lista": "Очистить список",
 "Apagar minha conta": "Удалить мой аккаунт",
 "Apagar minha conta e todos os dados": "Удалить мой аккаунт и все данные",
 "Apagar o escritório": "Удалить офис",
 "Apagar o escritório?": "Удалить офис?",
 "Apagar o grupo": "Удалить группу",
 "Apagar o grupo?": "Удалить группу?",
 "Apagar o lançamento?": "Удалить запись?",
 "Apagar para todos": "Удалить у всех",
 "Apagar tudo": "Удалить всё",
 "Apagar tudo antes de": "Удалить всё до",
 "Apague de uma vez as tarefas de hoje, do mês, de um período ou pelo nome. Antes de apagar, o app mostra o que vai sair e pede a sua senha.": "Удалите сразу задачи на сегодня, за месяц, за период или по названию. Перед удалением приложение покажет, что будет удалено, и попросит ваш пароль.",
 "Aparece na barra quando estiver liberada": "Появится на панели, когда станет доступна",
 "Aparecem no Planner, junto com os pontos facultativos (Carnaval, Quarta-feira de Cinzas e Corpus Christi).": "Отображаются в Planner вместе с необязательными выходными (Карнавал, Пепельная среда и Праздник Тела и Крови Христовых).",
 "Aplicar": "Применить",
 "Aponte a câmera do celular para este QR Code.": "Наведите камеру телефона на этот QR-код.",
 "Aponte para o QR Code na tela do computador": "Наведите на QR-код на экране компьютера",
 "Apostila": "Методичка",
 "Apostilas, listas, slides, vídeos, links e recados. Pelo ⋮ › Enviar para um grupo, cada aluno recebe no app dele.": "Методички, задания, слайды, видео, ссылки и объявления. Через ⋮ › Отправить в группу каждый ученик получит их в своём приложении.",
 "App usado no botão \"Rota\" dos endereços (tarefas, consultas, roteiro da viagem, obras, escola...).": "Приложение для кнопки «Маршрут» у адресов (задачи, приёмы, маршрут поездки, ремонт, школа...).",
 "Apple Saúde": "Apple Здоровье",
 "Apple Watch: já grava tudo no app Saúde do iPhone. Não precisa fazer nada.": "Apple Watch: часы уже записывают всё в приложение «Здоровье» на iPhone. Ничего делать не нужно.",
 "Apresentação": "Выступление",
 "Aprovação": "Согласование",
 "Aqui": "Здесь",
 "Ar-condicionado": "Кондиционер",
 "Arco-íris": "Радуга",
 "Arenoso": "Песчаный",
 "Armazenamento": "Хранилище",
 "Armário": "Шкаф",
 "Arquivadas ({n})": "Архив ({n})",
 "Arquivados ({n})": "В архиве ({n})",
 "Arquivar": "В архив",
 "Arquivar a caixa de anotações?": "Архивировать блок заметок?",
 "Arquivar conversa": "Архивировать чат",
 "Arquivo": "Файл",
 "Arquivo (Drive, OneDrive, Dropbox ou do dispositivo)": "Файл (Drive, OneDrive, Dropbox или с устройства)",
 "Arquivo OFX ou CSV do banco": "Файл OFX или CSV из банка",
 "Arquivo adicionado": "Файл добавлен",
 "Arquivo menor (para WhatsApp e e-mail)": "Файл поменьше (для WhatsApp и почты)",
 "Arquivo menor para WhatsApp e e-mail.": "Файл поменьше для WhatsApp и почты.",
 "Arquivo não encontrado.": "Файл не найден.",
 "Arquivo ou PDF": "Файл или PDF",
 "Arquivo ou documento": "Файл или документ",
 "Arquivos": "Файлы",
 "Arquivos (frente, verso, PDF)": "Файлы (лицевая, оборотная сторона, PDF)",
 "Arquivos (importar e exportar)": "Файлы (импорт и экспорт)",
 "Arquivos de {nome}": "Файлы: {nome}",
 "Arquivos na nuvem e cópias de segurança": "Файлы в облаке и резервные копии",
 "Arrasou!": "Огонь!",
 "Arraste as bolinhas até as 4 pontas da folha. O app recorta e endireita a página.": "Перетащите точки к 4 углам листа. Приложение обрежет и выровняет страницу.",
 "Arraste o dedo sobre o que quer esconder. Toque numa tarja para tirar.": "Проведите пальцем по тому, что нужно скрыть. Нажмите на полосу, чтобы убрать её.",
 "Arraste para a direita para excluir, ou para a esquerda para enviar a outra aba.": "Проведите вправо, чтобы удалить, или влево, чтобы отправить в другую вкладку.",
 "Arraste para a direita para excluir.": "Проведите вправо, чтобы удалить.",
 "Arraste para mudar a ordem, gire, duplique, apague e ponha página em branco.": "Перетаскивайте, чтобы менять порядок, поворачивайте, дублируйте, удаляйте и добавляйте пустые страницы.",
 "Arraste para ver o resto do quadro. Ele cresce para baixo e para a direita.": "Перетащите, чтобы увидеть остальную часть доски. Она растёт вниз и вправо.",
 "Arraste um documento para a direita para excluir.": "Проведите документ вправо, чтобы удалить.",
 "Arraste uma caixa para a esquerda para arquivar ou para a direita para excluir.": "Проведите блок влево, чтобы архивировать, или вправо, чтобы удалить.",
 "Arraste uma caixa para a esquerda para arquivar ou para a direita para excluir. Segure ⋮⋮ para mudar a ordem.": "Смахните блок влево, чтобы архивировать, или вправо, чтобы удалить. Удерживайте ⋮⋮, чтобы изменить порядок.",
 "Arroz": "Рис",
 "Artes": "Искусство",
 "As assinaturas Claude Pro, ChatGPT Plus e Gemini Advanced não podem ser usadas por outros apps. Para ligar a IA aqui, crie uma chave de API na sua conta (o Gemini tem uso gratuito; Claude e ChatGPT cobram por uso, centavos por análise).": "Подписки Claude Pro, ChatGPT Plus и Gemini Advanced нельзя использовать в других приложениях. Чтобы подключить ИИ здесь, создайте API-ключ в своём аккаунте (у Gemini есть бесплатное использование; Claude и ChatGPT берут плату за использование, копейки за анализ).",
 "As chamadas ainda não foram ligadas no servidor (17-LIGAR-MENSAGENS.bat).": "Звонки на сервере ещё не включены (17-LIGAR-MENSAGENS.bat).",
 "As compras dele também saem das Finanças.": "Её покупки тоже будут удалены из Финансов.",
 "As compras parceladas entram com todas as parcelas: as próximas já aparecem nas faturas seguintes.": "Покупки в рассрочку вносятся со всеми платежами: следующие уже видны в будущих счетах по карте.",
 "As fotos deste documento estão no dispositivo onde ele foi escaneado. Lá dá para editar, compartilhar e ler o texto.": "Фото этого документа хранятся на устройстве, где он был отсканирован. Там можно редактировать, делиться и читать текст.",
 "As imagens vão só para a IA que você escolheu, com a sua chave.": "Изображения отправляются только выбранному вами ИИ, с вашим ключом.",
 "As limpezas dos check-outs aparecem aqui sozinhas, com checklist e fotos de antes e depois.": "Уборки после выезда появляются здесь сами, с чек-листом и фото до и после.",
 "As notas emitidas aqui, as encontradas na busca e os XML importados aparecem nesta lista.": "Счета, выставленные здесь, найденные при поиске и импортированные XML появляются в этом списке.",
 "As parcelas aparecem aqui. Anexe o comprovante (foto, PDF ou print do PIX) em cada uma.": "Здесь появляются платежи. Прикрепите к каждому подтверждение (фото, PDF или скриншот PIX).",
 "As parcelas dos próximos 12 meses já estão no My Planner.": "Платежи на ближайшие 12 месяцев уже в My Planner.",
 "As parcelas em aberto são refeitas com o valor, os juros e o prazo atuais do contrato. As pagas não mudam.": "Неоплаченные платежи пересчитываются по текущей сумме, ставке и сроку договора. Оплаченные не меняются.",
 "As páginas deste documento estão no dispositivo onde ele foi escaneado. Abra por lá ou use a cópia guardada no Drive ou no OneDrive.": "Страницы этого документа хранятся на устройстве, где он был отсканирован. Откройте его там или используйте копию в Drive или OneDrive.",
 "As páginas viram imagem mais leve: ótimo para PDFs escaneados. O texto deixa de ser pesquisável (use o OCR depois, se precisar).": "Страницы становятся более лёгкими изображениями: отлично для сканов. Текст больше не будет доступен для поиска (при необходимости потом используйте OCR).",
 "As páginas vão só para a IA que você escolheu, com a sua chave.": "Страницы отправляются только выбранному вами ИИ, с вашим ключом.",
 "As receitas do cardápio já têm tudo na despensa.": "Для рецептов из меню всё уже есть в кладовой.",
 "As senhas novas não conferem.": "Новые пароли не совпадают.",
 "As senhas não conferem.": "Пароли не совпадают.",
 "As tarefas continuam no My Planner. Quer apagar também as que vieram da agenda do Google?": "Задачи останутся в My Planner. Удалить также те, что пришли из Google Календаря?",
 "As tarefas do cômodo continuam em Minha Casa, sem cômodo.": "Задачи комнаты останутся в разделе «Мой дом» без комнаты.",
 "As tarefas vinculadas continuam no My Planner.": "Связанные задачи останутся в My Planner.",
 "Aspirar e passar pano": "Пропылесосить и помыть пол",
 "Assinada": "Оформлена",
 "Assinar": "Подписать",
 "Assinar (simulação de teste)": "Подписаться (тестовая симуляция)",
 "Assinar o documento": "Подписать документ",
 "Assinatura": "Подпись",
 "Assinatura do profissional": "Подпись специалиста",
 "Assinatura e segurança": "Подпись и безопасность",
 "Assinaturas (simulação de teste)": "Подписки (тестовая симуляция)",
 "Assine a aba em Ajustes para enviar anotações para ela.": "Оформите подписку на вкладку в Настройках, чтобы отправлять в неё заметки.",
 "Assine a aba em Ajustes para vincular.": "Оформите подписку на вкладку в Настройках, чтобы связать.",
 "Assine a aba em Ajustes › Compras para enviar anotações para ela.": "Оформите подписку на вкладку в Настройки › Покупки, чтобы отправлять в неё заметки.",
 "Assine a aba em Ajustes › Compras para vincular.": "Оформите подписку на вкладку в Настройки › Покупки, чтобы связать.",
 "Assine a aba para abrir o vínculo.": "Оформите подписку на вкладку, чтобы открыть связь.",
 "Assisti mais uma aula": "Посмотрел(а) ещё один урок",
 "Assistido": "Просмотрено",
 "Assistindo": "Смотрю",
 "Assistência técnica (nome)": "Сервисный центр (название)",
 "Assistência: {nome}": "Сервис: {nome}",
 "Assunto": "Тема",
 "Assunto (ex.: Reunião semanal)": "Тема (напр.: Еженедельная встреча)",
 "Atender": "Ответить",
 "Atendimento": "Приём",
 "Atendimentos": "Приёмы",
 "Ativar avisos": "Включить уведомления",
 "Ativar monitor": "Включить мониторинг",
 "Ativas": "Активные",
 "Atividade": "Дело",
 "Atividade do roteiro": "Пункт маршрута",
 "Atividade hoje": "Активность сегодня",
 "Atividade: {blocos}": "Активность: {blocos}",
 "Atividades": "Занятия",
 "Atividades de hoje": "Активности на сегодня",
 "Atividades e materiais": "Задания и материалы",
 "Atividades físicas e saúde": "Спорт и здоровье",
 "Atrasada": "Просрочено",
 "Atrasada há {n} dia(s)": "Просрочено на {n} дн.",
 "Atrasadas": "Просрочены",
 "Atrasados": "Просроченные",
 "Atuais": "Текущие",
 "Atualidades": "Актуальные события",
 "Atualizar": "Обновить",
 "Atualizar agora": "Обновить сейчас",
 "Atualizar alarmes no My Planner": "Обновить будильники в My Planner",
 "Atualizar rega e adubo na agenda": "Обновить полив и подкормку в расписании",
 "Atualização automática disponível no app instalado (APK).": "Автообновление доступно в установленном приложении (APK).",
 "Atualização baixada. Entra ao reabrir o app ou ao tocar no aviso.": "Обновление загружено. Применится при повторном запуске приложения или по нажатию на уведомление.",
 "Atualização pronta": "Обновление готово",
 "Atualizações": "Обновления",
 "Até": "До",
 "Audiência": "Судебное заседание",
 "Aula dada": "Урок проведён",
 "Aula {a} de {n} ({p}%)": "Урок {a} из {n} ({p}%)",
 "Aulas assistidas": "Просмотрено уроков",
 "Autoajuda": "Саморазвитие",
 "Autor": "Автор",
 "Avaliação": "Оценивание",
 "Avaliações e notas": "Оценивание и отметки",
 "Avançado": "Дополнительно",
 "Aveia": "Овсянка",
 "Avisar a hora de sair": "Напомнить, когда выходить",
 "Avisar antes de vencer": "Напомнить до истечения срока",
 "Avisar no celular quando alguém incluir algo": "Уведомлять на телефоне, когда кто-то что-то добавляет",
 "Aviso": "Объявление",
 "Aviso com as tarefas do dia": "Уведомление с задачами на день",
 "Aviso de teste enviado pelo servidor. Ele chega em alguns segundos; saia do app para ver na barra do celular.": "Тестовое уведомление отправлено сервером. Оно придёт через несколько секунд; выйдите из приложения, чтобы увидеть его в панели уведомлений.",
 "Aviso enviado": "Уведомление отправлено",
 "Aviso {dias} dia(s) antes e no dia": "Уведомление за {dias} дн. и в сам день",
 "Avisos no celular": "Уведомления на телефоне",
 "Avisos no celular passam pelos serviços da Expo, da Google e da Apple.": "Уведомления на телефоне проходят через сервисы Expo, Google и Apple.",
 "Ação": "Боевик",
 "Ações": "Акции",
 "BOLETO E DOCUMENTOS": "BOLETO И ДОКУМЕНТЫ",
 "Backup importado.": "Резервная копия импортирована.",
 "Bairro": "Район",
 "Baixa": "Низкая",
 "Baixando atualização...": "Загрузка обновления...",
 "Baixar": "Скачать",
 "Baixar a versão {v}": "Скачать версию {v}",
 "Baixar agora": "Скачать",
 "Baixar o My Planner para Android": "Скачать My Planner для Android",
 "Baixar o My Planner para Android (versão {v})": "Скачать My Planner для Android (версия {v})",
 "Baixar o My Planner para iPhone": "Скачать My Planner для iPhone",
 "Baixar o PDF da nota (DANFSe)": "Скачать PDF счёта (DANFSe)",
 "Baixar o PDF?": "Скачать PDF?",
 "Baixar o XML completo (dá ciência na SEFAZ)": "Скачать полный XML (подтверждает ознакомление в SEFAZ)",
 "Baixe a versão mais recente para Android: {apk}": "Скачайте последнюю версию для Android: {apk}",
 "Baixe aqui a versão mais recente: {link}": "Скачайте последнюю версию здесь: {link}",
 "Balança": "Качается",
 "Balanço e relatórios": "Баланс и отчёты",
 "Banana": "Банан",
 "Banco": "Банк",
 "Banco, financeira ou pessoa": "Банк, кредитная организация или человек",
 "Bandeiras": "Флаги",
 "Banheiro": "Ванная",
 "Banho": "Купание",
 "Banho e tosa": "Купание и стрижка",
 "Barra": "Панель",
 "Bateria": "Аккумулятор",
 "Batimentos (média)": "Пульс (средний)",
 "Batizado": "Крестины",
 "Bebida": "Напиток",
 "Bebê": "Малыш",
 "Beijo": "Целую",
 "Bem": "Актив",
 "Bem clara": "Очень светлая",
 "Bem-Estar": "Здоровье",
 "Bem-Estar · Cronograma alimentar": "Здоровье · План питания",
 "Bens": "Активы",
 "Bichos e diversão": "Животные и развлечения",
 "Bicicleta": "Велосипед",
 "Bicicleta ergométrica": "Велотренажёр",
 "Biografia": "Биография",
 "Biologia": "Биология",
 "Biometria (digital ou rosto)": "Биометрия (отпечаток или лицо)",
 "Biometria ({tipos})": "Биометрия ({tipos})",
 "Biometria não confirmada.": "Биометрия не подтверждена.",
 "Bloqueado": "Заблокировано",
 "Bloquear": "Заблокировать",
 "Bloquear agora": "Заблокировать сейчас",
 "Bloqueio": "Блокировка",
 "Blusas de frio": "Тёплые кофты",
 "Boa noite": "Спокойной ночи",
 "Boa sorte!": "Удачи!",
 "Boas-vindas ao My Planner": "Добро пожаловать в My Planner",
 "Boas-vindas pelo WhatsApp": "Приветствие в WhatsApp",
 "Boleto": "Boleto",
 "Boleto anexado": "Boleto прикреплён",
 "Boleto do banco {b}": "Boleto банка {b}",
 "Boleto e documentos (foto, PDF ou arquivo)": "Boleto и документы (фото, PDF или файл)",
 "Boleto ou conta (foto, PDF ou arquivo)": "Boleto или счёт (фото, PDF или файл)",
 "Boleto por foto": "Boleto по фото",
 "Bolinha": "Кружок",
 "Bom dia": "Доброе утро",
 "Bom dia!": "Доброе утро!",
 "Bom dia! Seu dia no My Planner": "Доброе утро! Ваш день в My Planner",
 "Booking": "Booking",
 "Bora!": "Погнали!",
 "Borboleta": "Бабочка",
 "Borracha": "Ластик",
 "Botas para neve": "Зимние сапоги",
 "Brasil": "Бразилия",
 "Braços acima da cabeça": "Руки над головой",
 "Brilho": "Блеск",
 "Brinquedo ou livro para a viagem": "Игрушка или книга в дорогу",
 "Busca de notas": "Поиск счетов",
 "Busca o nome nos diários municipais reunidos pelo Querido Diário (Open Knowledge Brasil). Nem todos os municípios estão incluídos, e os diários oficiais não fazem parte do DJEN.": "Ищет имя в муниципальных вестниках, собранных Querido Diário (Open Knowledge Brasil). Включены не все муниципалитеты, а официальные вестники не входят в DJEN.",
 "Buscando...": "Поиск...",
 "Buscar": "Поиск",
 "Buscar GIF (ex.: parabéns, bom dia)": "Поиск GIF (напр.: поздравляю, доброе утро)",
 "Buscar cidade, país ou GMT": "Город, страна или GMT",
 "Buscar conversa": "Поиск чатов",
 "Buscar documento, titular ou órgão": "Поиск документа, владельца или органа",
 "Buscar em {nome}": "Поиск в «{nome}»",
 "Buscar emoji (ex.: coração, risada)": "Поиск эмодзи (напр.: сердце, смех)",
 "Buscar figurinha": "Поиск стикеров",
 "Buscar notas": "Найти счета",
 "Buscar ou digitar um alimento": "Найдите или введите продукт",
 "Buscar país": "Поиск страны",
 "Buscar pelo nome ou pelo texto": "Поиск по названию или тексту",
 "Buscar produto, loja ou observação": "Поиск по товару, магазину или примечанию",
 "Buscar tarefas": "Поиск задач",
 "Buscar: processo, parte, tribunal, palavra...": "Поиск: дело, сторона, суд, слово...",
 "CAIXA {n}": "КОРОБКА {n}",
 "CARDS DE ANOTAÇÕES": "КАРТОЧКИ ЗАМЕТОК",
 "CARTÕES": "КАРТЫ",
 "CEP": "CEP (индекс)",
 "CID (se o paciente pedir na declaração)": "CID (если пациент просит указать в справке)",
 "CID: {c}": "CID: {c}",
 "CNH": "Водительское (CNH)",
 "CNPJ (se tiver)": "CNPJ (если есть)",
 "CNPJ ou CPF": "CNPJ или CPF",
 "COMPROVANTE DE PAGAMENTO": "КВИТАНЦИЯ ОБ ОПЛАТЕ",
 "COMPROVANTE DE RECEBIMENTO": "ПОДТВЕРЖДЕНИЕ ПОЛУЧЕНИЯ",
 "COMPROVANTES ANTERIORES": "ПРЕДЫДУЩИЕ КВИТАНЦИИ",
 "CONTAS DO MÊS": "СЧЕТА МЕСЯЦА",
 "CPF": "CPF",
 "CPF (Brasil)": "CPF (Бразилия)",
 "CPF de quem paga": "CPF плательщика",
 "CPF do paciente": "CPF пациента",
 "CPF do pagador": "CPF плательщика",
 "CPF inválido": "Неверный CPF",
 "CPF ou CNPJ de quem recebeu": "CPF или CNPJ получателя",
 "CPF ou senha incorretos.": "Неверный CPF или пароль.",
 "CRIAR CÔMODO": "СОЗДАТЬ КОМНАТУ",
 "CRIAR UM GRUPO": "СОЗДАТЬ ГРУППУ",
 "CRONOGRAMA ALIMENTAR": "ПЛАН ПИТАНИЯ",
 "CUIDADOS PESSOAIS": "УХОД ЗА СОБОЙ",
 "Cabeleireiro": "Парикмахер",
 "Cabelo": "Волосы",
 "Cachorro": "Собака",
 "Cactos e suculentas": "Кактусы и суккуленты",
 "Cada aba extra: {n} dias grátis; depois {preco} por ano.": "Каждая доп. вкладка: {n} дн. бесплатно; затем {preco} в год.",
 "Cada arquivo pronto vai para o {nome}. Os PDFs abertos ficam também neste dispositivo, na lista abaixo.": "Каждый готовый файл отправляется в {nome}. Открытые PDF также остаются на этом устройстве, в списке ниже.",
 "Cada dia da semana": "Каждый день недели",
 "Cada documento novo vai para o {nome} quando você sai dele. As fotos das páginas ficam só neste dispositivo.": "Каждый новый документ отправляется в {nome}, когда вы из него выходите. Фото страниц остаются только на этом устройстве.",
 "Cada pessoa da equipe recebe a reunião em Recebidos e coloca no Planner com um toque, com o alerta.": "Каждый в команде получает встречу во «Входящих» и одним касанием добавляет её в Planner с напоминанием.",
 "Cada pessoa do grupo recebe e decide se aceita.": "Каждый в группе получит это и решит, принять ли.",
 "Cada página guarda um resumo, aula ou capítulo. Marque como revisada quando terminar.": "На каждой странице — конспект, лекция или глава. Отметьте как повторённую, когда закончите.",
 "Cada página vira uma imagem JPG.": "Каждая страница становится изображением JPG.",
 "Cada refeição se repete nos dias dela": "Каждый приём пищи повторяется в свои дни",
 "Cadastrar": "Добавить",
 "Cadastrar cartão de crédito": "Добавить кредитную карту",
 "Cadastrar pela foto (página do curso, certificado, folheto)": "Добавить по фото (страница курса, сертификат, буклет)",
 "Cadastrar pela foto da capa": "Добавить по фото обложки",
 "Cadastre \"Meus dados\" para os recibos saírem com seu nome, conselho e número.": "Заполните «Мои данные», чтобы в квитанциях были ваше имя, совет и номер.",
 "Cadastre RG, CNH, passaporte, contratos e certidões. O app avisa antes de vencer e envia o documento com um toque.": "Добавьте удостоверение личности, водительское, паспорт, договоры и справки. Приложение напомнит до истечения срока и отправит документ одним касанием.",
 "Cadastre a empresa (ou você, como profissional) com CNPJ ou CPF, município e regime. Depois ligue o certificado A1 para emitir NFS-e pelo Padrão Nacional e buscar as notas emitidas e recebidas.": "Добавьте компанию (или себя как специалиста) с CNPJ или CPF, муниципалитетом и налоговым режимом. Затем подключите сертификат A1, чтобы выставлять NFS-e по Padrão Nacional и искать выставленные и полученные счета.",
 "Cadastre a obra e, dentro dela, as etapas com orçamento, o diário com fotos, os profissionais e as entregas de material.": "Добавьте объект, а внутри него этапы с бюджетом, дневник с фото, мастеров и поставки материалов.",
 "Cadastre a viagem e, dentro dela, o roteiro de cada dia, as reservas e a mala. Durante a viagem, o roteiro aparece no My Planner.": "Добавьте поездку, а внутри неё маршрут на каждый день, бронирования и багаж. Во время поездки маршрут отображается в My Planner.",
 "Cadastre apenas o seu próprio nome e a sua OAB.": "Указывайте только своё имя и свой номер OAB.",
 "Cadastre as crianças: provas, reuniões, consultas e vacinas ficam dentro de cada uma.": "Добавьте детей: контрольные, собрания, приёмы врача и прививки хранятся у каждого.",
 "Cadastre cada pet: carteira de vacinação, vermífugos, remédios e pet shop ficam dentro dele.": "Добавьте каждого питомца: прививки, глистогонные, лекарства и зоомагазин хранятся у него.",
 "Cadastre cada planta com luz, solo e de quantos em quantos dias regar e adubar. O app monta o calendário na agenda.": "Добавьте каждое растение с освещением, почвой и периодичностью полива и подкормки. Приложение составит календарь в расписании.",
 "Cadastre cada veículo. Dentro dele ficam as manutenções (com aviso por km e por data) e os vencimentos de IPVA, licenciamento e seguro.": "Добавьте каждое транспортное средство. Внутри — ТО (с напоминанием по пробегу и по дате) и сроки IPVA, регистрации и страховки.",
 "Cadastre digital ou rosto no aparelho para usar.": "Добавьте отпечаток пальца или лицо на устройстве, чтобы пользоваться.",
 "Cadastre o cartão primeiro": "Сначала добавьте карту",
 "Cadastre o financiamento ou empréstimo com o valor, os juros e o número de parcelas. O app calcula as parcelas, o saldo devedor e avisa os vencimentos.": "Добавьте кредит или заём с суммой, ставкой и количеством платежей. Приложение рассчитает платежи, остаток долга и напомнит о сроках.",
 "Cadastre o imóvel inteiro ou cada quarto que você aluga. Dentro de cada um ficam as reservas, a limpeza e as despesas.": "Добавьте весь объект или каждую сдаваемую комнату. Внутри — бронирования, уборка и расходы.",
 "Cadastre o livro com o total de páginas e a meta por dia. Toque em ⋮ para somar as páginas lidas.": "Добавьте книгу с общим числом страниц и целью на день. Нажмите ⋮, чтобы добавить прочитанные страницы.",
 "Cadastre o remédio com os horários e toque em ⋮ para colocar na linha do tempo com alarme.": "Добавьте лекарство с временем приёма и нажмите ⋮, чтобы поставить его в хронологию дня с будильником.",
 "Cadastre os alunos da turma na aba Alunos.": "Добавьте учеников класса во вкладке «Ученики».",
 "Cadastre os clientes para separar as horas.": "Добавьте клиентов, чтобы разделять часы.",
 "Cadastre os clientes que recebem as suas notas. O endereço é opcional (se preencher, informe CEP, código IBGE, rua, número e bairro).": "Добавьте клиентов, которые получают ваши счета. Адрес необязателен (если заполняете, укажите CEP, код IBGE, улицу, номер дома и район).",
 "Cadastre os serviços que você mais emite, com o código de tributação nacional. Na hora de emitir é só tocar.": "Добавьте услуги, по которым вы чаще всего выставляете счета, с национальным налоговым кодом. При выставлении достаточно одного нажатия.",
 "Cadastre primeiro em {nome}.": "Сначала добавьте в «{nome}».",
 "Cadastre seu nome, conselho e número do registro. Eles saem nos recibos e nas declarações.": "Укажите имя, профессиональный совет и регистрационный номер. Они будут в квитанциях и справках.",
 "Cadastre seus clientes na aba \"Tomadores\" da empresa para escolher aqui.": "Добавьте клиентов во вкладке «Заказчики» компании, чтобы выбирать их здесь.",
 "Cadastre seus dados profissionais (nome, conselho e número) em \"Meus dados\" para sair no documento.": "Укажите свои профессиональные данные (имя, совет и номер) в разделе «Мои данные», чтобы они были в документе.",
 "Cadastre seus dados profissionais (nome, conselho e número) em \"Meus dados\" para sair no recibo.": "Укажите свои профессиональные данные (имя, совет и номер) в разделе «Мои данные», чтобы они были в квитанции.",
 "Cadastre seus pacientes. Dentro de cada um ficam os atendimentos com evolução, prescrição, pagamento, recibo e declaração para o plano de saúde.": "Добавьте пациентов. Внутри каждого — приёмы с динамикой, назначениями, оплатой, квитанцией и справкой для страховой.",
 "Cadastre você e cada pessoa da família. Dentro de cada uma ficam consultas, exames, vacinas e remédios. Dados sensíveis vão para o cofre criptografado.": "Добавьте себя и каждого члена семьи. У каждого хранятся приёмы, анализы, прививки и лекарства. Конфиденциальные данные уходят в зашифрованный сейф.",
 "Cadastro aguardando liberação: desligue \"Confirm email\" no Supabase (veja COMO RODAR).": "Регистрация ожидает подтверждения: отключите «Confirm email» в Supabase (см. COMO RODAR).",
 "Cadastro recebido": "Регистрация получена",
 "Cadastro: nome, CPF ou e-mail, senha (guardada só em forma protegida) e e-mail de contato.": "Регистрация: имя, CPF или e-mail, пароль (хранится только в защищённом виде) и контактный e-mail.",
 "Cadastros": "Записи",
 "Cadastros e comprovantes": "Записи и квитанции",
 "Cadeira extensora": "Разгибание ног",
 "Café": "Кофе",
 "Café da manhã": "Завтрак",
 "Café ou bar": "Кафе или бар",
 "Café?": "Кофе?",
 "Cafés": "Кофейни",
 "Caixa": "Коробка",
 "Caixa arquivada": "Блок в архиве",
 "Caixa com checklist, lista ou texto livre": "Блок с чек-листом, списком или текстом",
 "Caixa {n}": "Коробка {n}",
 "Caixas": "Коробки",
 "Caixas e cronograma da mudança.": "Коробки и график переезда.",
 "Caixas por cômodo com etiqueta, troca de água, luz e internet, vistorias e o cronograma dos dias.": "Коробки по комнатам с наклейками, переоформление воды, света и интернета, осмотры и план по дням.",
 "Calculadora": "Калькулятор",
 "Calculando...": "Расчёт...",
 "Calendário": "Календарь",
 "Calendário da planta": "Календарь растения",
 "Calendário do imposto": "Налоговый календарь",
 "Calendários": "Календари",
 "Calorias em atividade": "Активные калории",
 "Calorias gastas em atividade (kcal)": "Калории, сожжённые при активности (ккал)",
 "Calça térmica (segunda pele)": "Термобельё",
 "Calças ou bermudas": "Брюки или шорты",
 "Cama": "Кровать",
 "Caminhada": "Ходьба",
 "Caminhão": "Грузовик",
 "Camisetas": "Футболки",
 "Campo Grande": "Кампу-Гранди",
 "Campo Grande (MS)": "Кампу-Гранди (MS)",
 "Campos de formulário": "Поля формы",
 "Cancelada": "Отменено",
 "Canceladas": "Отменённые",
 "Cancelar": "Отмена",
 "Cancelar a NFS-e": "Аннулировать NFS-e",
 "Cancelar a NFS-e {n}?": "Аннулировать NFS-e {n}?",
 "Cancelar a nota": "Аннулировать счёт",
 "Cancelar a reunião \"{nome}\"?": "Отменить встречу «{nome}»?",
 "Cancelar reunião": "Отменить встречу",
 "Caneta": "Перо",
 "Captura automática do servidor: de 2 em 2 horas, das 08h às 20h": "Автоматический сбор на сервере: каждые 2 часа, с 08:00 до 20:00",
 "Captura automática: todos os dias às 08h e 12h": "Автосбор: каждый день в 08:00 и 12:00",
 "Card": "Карточка",
 "Cardápio": "Меню",
 "Cardápio da semana, receitas, lista de compras automática e validade da despensa.": "Меню на неделю, рецепты, автоматический список покупок и сроки годности в кладовой.",
 "Cardápio só para este dia. Os outros dias continuam com o da semana.": "Меню только на этот день. В остальные дни остаётся недельное меню.",
 "Carga (kg)": "Вес (кг)",
 "Carimbo": "Штамп",
 "Carnaval": "Карнавал",
 "Carne magra": "Нежирное мясо",
 "Carregando feriados...": "Загрузка праздников...",
 "Carregando...": "Загрузка...",
 "Carro": "Машина",
 "Carta": "Letter",
 "Carteira": "Кошелёк",
 "Carteira de trabalho": "Трудовая книжка",
 "Carteira profissional (OAB, CRC, CREA...)": "Профессиональное удостоверение (OAB, CRC, CREA...)",
 "Cartão": "Карточка",
 "Cartão de contato das Mensagens: a foto, o telefone, o e-mail e a frase que você mesmo escolher pôr. Só quem conversa com você, os seus amigos e quem divide um grupo do app com você veem.": "Карточка контакта в Сообщениях: фото, телефон, e-mail и статус, которые вы сами решите указать. Их видят только те, кто переписывается с вами, ваши друзья и те, кто состоит с вами в группе приложения.",
 "Cartão de crédito": "Кредитная карта",
 "Cartão de débito": "Дебетовая карта",
 "Cartão parcelado": "Карта в рассрочку",
 "Cartões": "Карты",
 "Cartões de visita": "Визитки",
 "Cartões e dinheiro": "Карты и наличные",
 "Casa": "Дом",
 "Casa e rotina": "Дом и быт",
 "Casa, família e veículos": "Дом, семья и транспорт",
 "Casaco leve": "Лёгкая куртка",
 "Casaco pesado": "Тёплая куртка",
 "Casamento": "Свадьба",
 "Castanhas": "Орехи",
 "Categoria": "Категория",
 "Categoria de \"{d}\"": "Категория «{d}»",
 "Categorias": "Категории",
 "Caução": "Залог",
 "Ceia": "Поздний ужин",
 "Celular": "Телефон",
 "Celular confirmado": "Телефон подтверждён",
 "Celular e carregador": "Телефон и зарядка",
 "Certidão": "Свидетельство",
 "Certificado digital": "Электронная подпись",
 "Certificado digital A1": "Электронный сертификат A1",
 "Certificado ligado": "Сертификат подключён",
 "Chamada": "Перекличка",
 "Chamada ainda não feita neste dia. Toque em quem faltou ou confirme todos presentes.": "Перекличка в этот день ещё не проведена. Нажмите на отсутствующих или подтвердите, что все на месте.",
 "Chamada, notas, planos de aula e materiais.": "Посещаемость, оценки, планы уроков и материалы.",
 "Chamadas": "Звонки",
 "Chamadas de áudio e vídeo passam pelos servidores da LiveKit, só durante a chamada e sem gravação.": "Аудио- и видеозвонки проходят через серверы LiveKit только во время звонка и не записываются.",
 "Chamadas de áudio e vídeo passam pelos servidores da LiveKit, só durante a chamada. Só há gravação nas reuniões do Escritório, quando o administrador grava, e o arquivo vai direto para o armazenamento do app.": "Аудио- и видеозвонки проходят через серверы LiveKit только на время звонка. Запись ведётся только на встречах в разделе «Кабинет», когда её включает администратор, и файл сразу попадает в хранилище приложения.",
 "Chamando...": "Вызов...",
 "Chapéu ou boné": "Шляпа или кепка",
 "Chave da IA não cadastrada neste dispositivo (Ajustes › Inteligência artificial).": "Ключ ИИ не добавлен на этом устройстве (Настройки › Искусственный интеллект).",
 "Chave de acesso": "Ключ доступа",
 "Check-in": "Заезд",
 "Check-in: {d} a partir das {h}": "Заезд: {d} с {h}",
 "Check-in: {h} · {e}": "Заезд: {h} · {e}",
 "Check-out": "Выезд",
 "Check-out: {d} até as {h}": "Выезд: {d} до {h}",
 "Check-out: {h} · {e}": "Выезд: {h} · {e}",
 "Checklist": "Чек-лист",
 "Chinelo": "Шлёпанцы",
 "Chá de bebê": "Бэби-шауэр",
 "Cidade": "Город",
 "Cidade (para a data dos recibos)": "Город (для даты в квитанциях)",
 "Cidade de {nome}": "Город {nome}",
 "Cidades": "Города",
 "Cifrão": "Знак доллара",
 "Cinza": "Серый",
 "Cirurgia": "Операция",
 "Ciências": "Естествознание",
 "Clara": "Светлая",
 "Clareia PDFs escaneados: fundo branco, cinza ou preto e branco.": "Осветляет отсканированные PDF: белый, серый или чёрно-белый фон.",
 "Claro": "Светлый",
 "Classificar categorias com IA": "Распределить по категориям с ИИ",
 "Claude, ChatGPT ou Gemini": "Claude, ChatGPT или Gemini",
 "Cliente": "Клиент",
 "Clientes": "Клиенты",
 "Clima esperado": "Ожидаемая погода",
 "Co-anfitrião": "Соорганизатор",
 "Cobrança": "Счёт",
 "Cobranças": "Счета",
 "Coelho": "Кролик",
 "Cofre (criptografia de ponta a ponta)": "Сейф (сквозное шифрование)",
 "Cofre aberto (fecha sozinho em 5 minutos sem uso)": "Сейф открыт (закроется сам через 5 минут бездействия)",
 "Cofre ainda não criado": "Сейф ещё не создан",
 "Cofre com criptografia para RG, CNH, passaporte, contratos e certidões, com contagem até vencer e envio com um toque.": "Зашифрованный сейф для паспорта, прав, договоров и справок, с отсчётом до окончания срока и отправкой в одно касание.",
 "Cofre fechado": "Сейф закрыт",
 "Cofrinho": "Копилка",
 "Cole aqui a chave ({ini}...)": "Вставьте ключ сюда ({ini}...)",
 "Cole o link (https://...)": "Вставьте ссылку (https://...)",
 "Cole ou digite o código de barras (ou o Pix copia e cola) no campo do código: o app calcula o valor e o vencimento sozinho. Com a sua IA ligada, ele lê tudo pela foto.": "Вставьте или введите штрихкод (или код Pix «копировать и вставить») в поле кода: приложение само рассчитает сумму и срок оплаты. Если ваш ИИ включён, оно прочитает всё по фото.",
 "Coloca arquivos dentro do PDF.": "Помещает файлы внутрь PDF.",
 "Colocar na agenda": "Добавить в расписание",
 "Colocar na linha do tempo com alarme": "Поставить в хронологию дня с будильником",
 "Colocar no My Planner": "Добавить в My Planner",
 "Colocar rega e adubo na agenda": "Добавить полив и подкормку в расписание",
 "Coloque o valor da mensalidade na turma (Editar) ou no aluno. As cobranças deste mês que já existem não se repetem.": "Укажите ежемесячную плату в классе (Изменить) или у ученика. Уже созданные счета этого месяца не повторяются.",
 "Coluna": "Колонка",
 "Colágeno": "Коллаген",
 "Com a biometria ligada, ela aparece primeiro. Se falhar, use o desenho ou a senha.": "Если биометрия включена, она предлагается первой. Если не получится, используйте графический ключ или пароль.",
 "Com convênio": "По страховке",
 "Com o código do país e o DDD. Ex.: +55 41 99999-0000": "С кодом страны и кодом города. Напр.: +55 41 99999-0000",
 "Com outras pessoas": "У других",
 "Com prazo, o app calcula quanto guardar por mês. O dinheiro guardado conta como \"Guardou\" no mês.": "Если указан срок, приложение рассчитает, сколько откладывать в месяц. Отложенные деньги считаются как \"Отложено\" за месяц.",
 "Com quem": "С кем",
 "Com quem pagou, o paciente, a data e o valor de cada atendimento pago. Como pessoa física, lance cada um no app Receita Federal › Receita Saúde; com CNPJ, emita a nota de serviço.": "Кто платил, пациент, дата и сумма каждого оплаченного приёма. Как физлицо, вносите каждый в приложение Receita Federal › Receita Saúde; с CNPJ выставите счёт за услуги.",
 "Com valor a receber": "С суммой к получению",
 "Com vencimento": "Со сроком оплаты",
 "Combinado": "Договорились",
 "Combinado 👍": "Договорились 👍",
 "Combustível": "Топливо",
 "Comece cadastrando as contas fixas do mês (aluguel, luz, internet) e o seu cartão. Eu aviso antes de cada vencimento.": "Начните с постоянных платежей месяца (аренда, свет, интернет) и вашей карты. Я напомню перед каждым сроком оплаты.",
 "Comecei em": "Дата начала",
 "Comentários": "Комментарии",
 "Começa amanhã": "Начинается завтра",
 "Começa às {hora} (em {m} min)": "Начало в {hora} (через {m} мин)",
 "Começar": "Старт",
 "Começar com o modelo: café, lanche, almoço, lanche e jantar": "Начать с шаблона: завтрак, перекус, обед, перекус и ужин",
 "Começar em": "Начать с",
 "Começar o teste grátis": "Начать бесплатный период",
 "Comi outros alimentos ou quantidades": "Съел другое или другое количество",
 "Comida": "Еда",
 "Comidas e bebidas": "Еда и напитки",
 "Comido": "Съедено",
 "Comido / alterações": "Съедено / изменения",
 "Comido conta as refeições marcadas como feitas (ou com alterações) até hoje.": "«Съедено» учитывает приёмы пищи, отмеченные как выполненные (или с изменениями), по сегодняшний день.",
 "Comigo": "У меня",
 "Comissão da plataforma": "Комиссия платформы",
 "Como apagar a sua conta e os seus dados": "Как удалить аккаунт и данные",
 "Como chegar": "Как добраться",
 "Como ela está": "Как она сейчас",
 "Como estou comparado ao mês passado?": "Как у меня по сравнению с прошлым месяцем?",
 "Como funciona": "Как это работает",
 "Como planejado": "По плану",
 "Compartilhado no grupo": "Общий доступ в группе",
 "Compartilhado no grupo · só leitura": "Общий доступ в группе · только чтение",
 "Compartilhamento indisponível neste dispositivo.": "Функция «Поделиться» недоступна на этом устройстве.",
 "Compartilhar": "Поделиться",
 "Compartilhar PDF": "Поделиться PDF",
 "Compartilhar a limpeza": "Поделиться уборкой",
 "Compartilhar os dados": "Открыть доступ к данным",
 "Compartilhar os dados com a equipe": "Открыть доступ к данным команде",
 "Compartilhar os dados com o grupo?": "Открыть доступ к данным группе?",
 "Compartilhar texto": "Поделиться текстом",
 "Competência (mês de referência)": "Период (отчётный месяц)",
 "Competência {d}": "Период {d}",
 "Complemento": "Доп. адрес",
 "Complete seus dados": "Заполните свои данные",
 "Compra": "Покупка",
 "Compra e venda de imóveis, veículos e ações, recibos dedutíveis e o calendário do imposto.": "Покупка и продажа недвижимости, транспорта и акций, вычитаемые квитанции и налоговый календарь.",
 "Compra feita": "Покупка сделана",
 "Compra no cartão": "Покупка по карте",
 "Compras": "Покупки",
 "Compras da semana": "Покупки на неделю",
 "Comprimir": "Сжать",
 "Compromisso": "Встреча",
 "Compromisso da escola": "Школьное событие",
 "Comprovante": "Квитанция",
 "Comprovante guardado": "Квитанция сохранена",
 "Comprovantes": "Квитанции",
 "Computador": "Компьютер",
 "Comédia": "Комедия",
 "Concedi": "Я дал(а)",
 "Concluir": "Завершить",
 "Concluir (esquerda)": "Завершить (слева)",
 "Concluída": "Завершено",
 "Concluído": "Готово",
 "Concluído (%)": "Выполнено (%)",
 "Concluído!": "Готово!",
 "Concordo que meu nome, CPF e e-mail sejam usados apenas para identificar minha conta, e que minhas tarefas e anotações fiquem guardadas nela. Posso apagar a conta e todos os dados a qualquer momento em Ajustes › Segurança.": "Я согласен(на), что моё имя, CPF и e-mail будут использоваться только для идентификации моего аккаунта и что мои задачи и заметки будут храниться в нём. Я могу удалить аккаунт и все данные в любой момент в Настройки › Безопасность.",
 "Concordo que meu nome, CPF e e-mail sejam usados apenas para identificar minha conta, e que minhas tarefas e anotações fiquem guardadas nela. Posso apagar a conta e todos os dados a qualquer momento em Ajustes.": "Я согласен(на), что моё имя, CPF и e-mail будут использоваться только для идентификации моего аккаунта и что мои задачи и заметки будут храниться в нём. Я могу удалить аккаунт и все данные в любой момент в Настройках.",
 "Concordo que meu nome, documento e e-mail sejam usados apenas para identificar minha conta, e que minhas tarefas e anotações fiquem guardadas nela. Posso apagar a conta e todos os dados a qualquer momento em Ajustes › Segurança.": "Я согласен(на), что моё имя, документ и e-mail используются только для идентификации моего аккаунта, а мои задачи и заметки хранятся в нём. Я могу удалить аккаунт и все данные в любой момент в разделе Настройки › Безопасность.",
 "Concursos": "Конкурсы на госслужбу",
 "Condicionador": "Кондиционер",
 "Condomínio": "Квартплата (ТСЖ)",
 "Condomínio e IPTU": "Квартплата и IPTU",
 "Conectado": "Подключено",
 "Conectando...": "Подключение...",
 "Conectar": "Подключить",
 "Conectar navegador": "Подключить браузер",
 "Conectar o {nome}": "Подключить {nome}",
 "Conectar relógio ou app de saúde": "Подключить часы или приложение здоровья",
 "Conectar {nome}": "Подключить {nome}",
 "Conecte o {nome} em Ajustes › Google Drive e OneDrive.": "Подключите {nome} в разделе Настройки › Google Drive и OneDrive.",
 "Conferindo...": "Проверка...",
 "Conferir controles, chaves e Wi-Fi": "Проверить пульты, ключи и Wi-Fi",
 "Conferir o prazo no sistema oficial": "Проверить срок в официальной системе",
 "Confete": "Конфетти",
 "Configuração geral": "Общие настройки",
 "Confira a senha da sua conta e tente de novo.": "Проверьте пароль от аккаунта и попробуйте снова.",
 "Confira as datas oficiais no site da Receita Federal e ajuste se precisar.": "Сверьте официальные даты на сайте Receita Federal и при необходимости измените.",
 "Confira o código. Ele tem 6 letras e números.": "Проверьте код. Он состоит из 6 букв и цифр.",
 "Confira o e-mail ou deixe em branco.": "Проверьте e-mail или оставьте поле пустым.",
 "Confira o e-mail.": "Проверьте e-mail.",
 "Confira o prazo no sistema oficial.": "Проверьте срок в официальной системе.",
 "Confira os 11 números.": "Проверьте 11 цифр.",
 "Confira os campos antes de salvar.": "Проверьте поля перед сохранением.",
 "Confira se a sua conta Google está adicionada no celular e com a agenda sincronizando.": "Проверьте, что ваш аккаунт Google добавлен на телефоне и календарь синхронизируется.",
 "Confirmada": "Подтверждено",
 "Confirmado": "Придёт",
 "Confirmar": "Подтвердить",
 "Confirme a declaração sobre a empresa.": "Подтвердите заявление о компании.",
 "Confirme o seu celular": "Подтвердите свой телефон",
 "Confirme para ativar a biometria": "Подтвердите, чтобы включить биометрию",
 "Confirme para excluir": "Подтвердите удаление",
 "Confirme sua senha para sincronizar": "Подтвердите пароль для синхронизации",
 "Confraternização": "Праздничная встреча",
 "Confraternização Universal": "Новый год",
 "Conselho": "Совет",
 "Consignado": "Кредит под зарплату",
 "Consulta": "Приём",
 "Consulta ou vacina": "Приём или прививка",
 "Consultas": "Приёмы",
 "Consultório": "Кабинет",
 "Consumo médio: {v} km/L": "Средний расход: {v} км/л",
 "Conta": "Аккаунт",
 "Conta a pagar": "Счёт к оплате",
 "Conta a receber": "Счёт к получению",
 "Conta de consumo ou tributo": "Коммунальный счёт или налог",
 "Conta os dias em que cada item estava previsto (pelos dias da semana dele) e os que foram marcados como feitos.": "Считает дни, в которые каждый пункт был запланирован (по его дням недели), и дни, когда он отмечен как выполненный.",
 "Conta paga": "Счёт оплачен",
 "Conta recebida": "Платёж получен",
 "Conta vence hoje": "Счёт к оплате сегодня",
 "Conta vencendo": "Скоро срок оплаты",
 "Contabilidade": "Бухгалтерия",
 "Contando os acompanhantes. Toque no status do convidado para mudar.": "С учётом сопровождающих. Нажмите на статус гостя, чтобы изменить его.",
 "Contando: {cliente}": "Идёт отсчёт: {cliente}",
 "Contas": "Платежи",
 "Contas a pagar": "Счета к оплате",
 "Contas a pagar e a receber, gastos do mês, aviso de vencimento e controle do MEI (Mestre Achado).": "Счета к оплате и к получению, расходы месяца, напоминания о сроках и учёт MEI (Mestre Achado).",
 "Contas a receber": "Счета к получению",
 "Contas fixas": "Постоянные платежи",
 "Contato": "Контакт",
 "Contato de emergência": "Контакт для экстренной связи",
 "Contato do encarregado de dados:": "Контакт ответственного за данные:",
 "Conte a sua ideia para o app ficar melhor.": "Расскажите свою идею, чтобы сделать приложение лучше.",
 "Conte o que está difícil ou não funciona como deveria.": "Расскажите, что вызывает трудности или работает не так, как должно.",
 "Conte o que você fez, o que esperava e o que apareceu. Se tiver uma mensagem de erro, copie aqui.": "Расскажите, что вы сделали, что ожидали и что увидели. Если было сообщение об ошибке, скопируйте его сюда.",
 "Conte para a gente problemas, erros e ideias de melhoria. Sua mensagem vai direto para a equipe do My Planner.": "Сообщайте нам о проблемах, ошибках и идеях по улучшению. Ваше сообщение попадёт прямо к команде My Planner.",
 "Conteúdo": "Содержание",
 "Conteúdo que você cria: tarefas, anotações, finanças, documentos, fotos, anexos e dados das abas.": "Контент, который вы создаёте: задачи, заметки, финансы, документы, фото, вложения и данные вкладок.",
 "Conteúdo, matéria, tarefa de casa...": "Тема, предмет, домашнее задание...",
 "Continuar": "Продолжить",
 "Continue usando o My Planner e as Anotações por {preco} por ano. Seus dados continuam guardados.": "Продолжайте пользоваться My Planner и Заметками за {preco} в год. Ваши данные сохраняются.",
 "Contratado": "Нанят",
 "Contratado: {v}": "По договору: {v}",
 "Contrato": "Договор",
 "Conversa": "Чат",
 "Conversa do grupo": "Групповой чат",
 "Conversar": "Написать",
 "Conversar com o Mestre (precisa da sua IA)": "Поговорить с Mestre (нужен ваш ИИ)",
 "Converse com amigos e grupos, e faça chamadas de áudio e vídeo.": "Общайтесь с друзьями и группами, совершайте аудио- и видеозвонки.",
 "Converter de PDF": "Конвертировать из PDF",
 "Converter para PDF": "Конвертировать в PDF",
 "Convidado": "Гость",
 "Convidados": "Гости",
 "Convidados com confirmação de presença, fornecedores e o cronograma do grande dia.": "Гости с подтверждением участия, подрядчики и программа главного дня.",
 "Convidados e cronograma do dia, sem os valores.": "Гости и программа дня, без сумм.",
 "Convidar": "Пригласить",
 "Convidar pelo WhatsApp": "Пригласить через WhatsApp",
 "Convite": "Приглашение",
 "Convite copiado. Cole onde quiser enviar.": "Приглашение скопировано. Вставьте его, куда хотите отправить.",
 "Convite inválido ou trocado pelo administrador. Peça um link novo.": "Приглашение недействительно или изменено администратором. Попросите новую ссылку.",
 "Convite para o My Planner": "Приглашение в My Planner",
 "Convênio": "Страховка",
 "Copiar": "Копировать",
 "Copiar a lista para uma tarefa": "Скопировать список в задачу",
 "Copiar o código": "Скопировать код",
 "Copiar para hoje": "Копировать на сегодня",
 "Copo de outro tamanho": "Стакан другого объёма",
 "Copo {n}": "Стакан {n}",
 "Cor": "Цвет",
 "Cor do fichário": "Цвет папки",
 "Cor do tema": "Цвет темы",
 "Cor do tema de cada aba": "Цвет темы каждой вкладки",
 "Coração": "Сердце",
 "Corações": "Сердечки",
 "Cores das abas": "Цвета вкладок",
 "Cores das conversas": "Цвета чатов",
 "Cores e opções desta aba": "Цвета и параметры этой вкладки",
 "Corpo": "Тело",
 "Corporativo": "Корпоратив",
 "Corpus Christi": "Праздник Тела и Крови Христовых",
 "Corredor": "Коридор",
 "Correia dentada": "Ремень ГРМ",
 "Corrida": "Бег",
 "Corta as bordas em branco ou partes da página.": "Обрезает пустые поля или части страницы.",
 "Cortesia": "Бесплатно",
 "Coxa e sobrecoxa": "Куриные голени и бёдра",
 "Cozinha": "Кухня",
 "Creatina": "Креатин",
 "Criada em {data}": "Создано {data}",
 "Criado com": "Создано в",
 "Criado em": "Дата создания",
 "Criança": "Ребёнок",
 "Crianças": "Дети",
 "Criar": "Создать",
 "Criar animada": "Создать анимированный",
 "Criar conta": "Создать аккаунт",
 "Criar do zero": "Создать с нуля",
 "Criar documento, planilha ou apresentação": "Создать документ, таблицу или презентацию",
 "Criar em outro app": "Создать в другом приложении",
 "Criar escritório": "Создать офис",
 "Criar fichário": "Создать папку",
 "Criar figurinha": "Создать стикер",
 "Criar grupo": "Создать группу",
 "Criar grupo e convidar pessoas": "Создать группу и пригласить людей",
 "Criar minha chave de API": "Создать мой API-ключ",
 "Criar o cofre": "Создать сейф",
 "Criar o grupo e convidar": "Создать группу и пригласить",
 "Criar os prazos do IR de {ano}": "Создать сроки IR за {ano}",
 "Criar uma meta (viagem, reserva, carro...)": "Создать цель (поездка, резерв, машина...)",
 "Criar uma senha nova": "Создать новый пароль",
 "Criar {n} tarefa(s)": "Создать задачи: {n}",
 "Criação do Estado de MS": "День образования штата MS",
 "Crie a mudança e o app já monta a lista de transferências (luz, água, internet...). Depois cadastre as caixas por cômodo, as vistorias e o cronograma dos dias.": "Создайте переезд, и приложение само составит список переоформлений (свет, вода, интернет...). Затем добавьте коробки по комнатам, осмотры и план по дням.",
 "Crie a pasta de cada cliente, convide o cliente pelo link (ele só vê a pasta dele) e troquem documentos nos dois sentidos: notas, guias, folha, extratos, contratos.": "Создайте папку для каждого клиента, пригласите его по ссылке (он видит только свою папку) и обменивайтесь документами в обе стороны: счета, платёжки, зарплатные ведомости, выписки, договоры.",
 "Crie a turma (ou grupo de mentoria, treino, curso) e, dentro dela, os alunos, a chamada, as notas, os planos de aula, os materiais e as cobranças.": "Создайте класс (или группу менторинга, тренировок, курс), а в нём — учеников, перекличку, оценки, планы уроков, материалы и счета.",
 "Crie a turma e, dentro dela, os alunos, a chamada, as avaliações com notas e os planos de aula.": "Создайте класс, а внутри него учеников, перекличку, оценивание с отметками и планы уроков.",
 "Crie as tarefas da casa (limpar banheiro, trocar roupa de cama...) com a frequência. O app avisa quando estão atrasadas, sem encher o My Planner.": "Создавайте дела по дому (убрать ванную, сменить постельное бельё...) с частотой. Приложение напомнит о просроченных, не загромождая My Planner.",
 "Crie cards com checklist, lista, texto livre ou desenho para esta matéria. Arraste para a direita para excluir e para a esquerda para arquivar.": "Создавайте карточки с чек-листом, списком, текстом или рисунком для этого предмета. Свайп вправо удаляет, влево отправляет в архив.",
 "Crie o escritório, chame a equipe (amigos do app ou convite pelo link) e troquem mensagens e documentos, marquem reuniões e façam reunião de vídeo. Você, que administra, pode gravar as reuniões.": "Создайте офис, пригласите команду (друзей из приложения или по ссылке) и обменивайтесь сообщениями и документами, назначайте встречи и проводите видеовстречи. Как администратор вы можете записывать встречи.",
 "Crie o evento e, dentro dele, a lista de convidados com confirmação de presença, os fornecedores e o cronograma do dia.": "Создайте мероприятие, а внутри него список гостей с подтверждением участия, подрядчиков и программу дня.",
 "Crie o grupo e mande o link: quem entrar recebe data, local, avisos e tudo o que você enviar, e aceita, edita ou recusa.": "Создайте группу и отправьте ссылку: каждый, кто вступит, получит дату, место, уведомления и всё, что вы отправите, и сможет принять, изменить или отклонить.",
 "Crie o grupo e mande o link: quem entrar vê e participa conforme o papel que você escolher. Só quem administra coloca ou tira pessoas.": "Создайте группу и отправьте ссылку: каждый, кто вступит, видит и участвует в соответствии с выбранной вами ролью. Добавлять и удалять людей могут только администраторы.",
 "Crie o grupo e mande o link: quem entrar vê tudo o que está aqui dentro e participa (inclui, edita, põe fotos). Só quem administra coloca ou tira pessoas.": "Создайте группу и отправьте ссылку: каждый, кто вступит, видит всё, что здесь есть, и участвует (добавляет, редактирует, загружает фото). Добавлять и удалять людей могут только администраторы.",
 "Crie sua conta. Seus dados ficam salvos na nuvem e neste dispositivo.": "Создайте аккаунт. Ваши данные сохраняются в облаке и на этом устройстве.",
 "Crie um fichário (ex.: Doutorado, Inglês, Concurso) e dentro dele as matérias e páginas.": "Создайте папку (напр.: Аспирантура, Английский, Экзамен), а в ней — предметы и страницы.",
 "Crie um grupo (turma, pacientes, equipe, convidados, clientes), mande o link de convite e envie compromissos, materiais e avisos. Cada pessoa aceita, edita ou recusa o que recebe.": "Создайте группу (класс, пациенты, команда, гости, клиенты), отправьте ссылку-приглашение и рассылайте встречи, материалы и объявления. Каждый принимает, изменяет или отклоняет полученное.",
 "Crie um perfil com nome e, se for advogado, a OAB.": "Создайте профиль с именем и, если вы юрист, номером OAB.",
 "Criptografado no cofre, só neste dispositivo": "Зашифровано в сейфе, только на этом устройстве",
 "Criptomoedas": "Криптовалюты",
 "Cronograma": "План",
 "Cronograma alimentar, cuidados pessoais com passo a passo e água do dia.": "План питания, уход за собой с пошаговыми инструкциями и вода за день.",
 "Cronograma do dia": "Программа дня",
 "Cronograma físico-financeiro": "Физико-финансовый график",
 "Cronograma físico-financeiro por etapa, diário da obra com antes e depois, profissionais e entregas.": "Физико-финансовый график по этапам, дневник стройки «до и после», мастера и поставки.",
 "Cronômetro de horas": "Таймер рабочих часов",
 "Crédito empresarial": "Бизнес-кредит",
 "Créditos": "Кредиты",
 "Cuida das reservas, da limpeza e das despesas.": "Отвечает за бронирования, уборку и расходы.",
 "Cuidado": "Уход",
 "Cuidado pessoal": "Уход за собой",
 "Cuidados": "Уход",
 "Cupom do mercado": "Чек из магазина",
 "Cupom do mercado (foto)": "Чек из магазина (фото)",
 "Cupom lançado": "Чек внесён",
 "Curitiba": "Куритиба",
 "Curitiba (PR)": "Куритиба (PR)",
 "Curso": "Курс",
 "Cursos": "Курсы",
 "Cursos livres e certificações": "Курсы и сертификаты",
 "Cuscuz": "Кукурузный кускус",
 "CÓDIGO PARA PAGAR": "КОД ДЛЯ ОПЛАТЫ",
 "CÔMODOS": "КОМНАТЫ",
 "Câmera": "Камера",
 "Câmera e galeria": "Камера и галерея",
 "Câmera não liberada": "Нет доступа к камере",
 "Código IBGE do município": "Код IBGE муниципалитета",
 "Código IBGE do município (7 números)": "Код IBGE муниципалитета (7 цифр)",
 "Código NBS (9 números, opcional)": "Код NBS (9 цифр, необязательно)",
 "Código copiado": "Код скопирован",
 "Código da reserva (localizador)": "Код бронирования",
 "Código de barras, linha digitável ou Pix copia e cola (opcional)": "Штрихкод, цифровая строка или Pix «копировать и вставить» (необязательно)",
 "Código de indicação": "Код приглашения",
 "Código de indicação (opcional)": "Код приглашения (необязательно)",
 "Código de quem convidou você": "Код пригласившего вас человека",
 "Código de tributação nacional (6 números)": "Национальный налоговый код (6 цифр)",
 "Código de tributação nacional (6 números, ex.: 171901)": "Национальный налоговый код (6 цифр, напр.: 171901)",
 "Código do amigo": "Код друга",
 "Código do convite": "Код приглашения",
 "Código do procedimento (TUSS ou do plano)": "Код процедуры (TUSS или страховой)",
 "Código errado. Confira e tente de novo.": "Неверный код. Проверьте и попробуйте ещё раз.",
 "Código não encontrado. Confira as letras e os números.": "Код не найден. Проверьте буквы и цифры.",
 "Código não reconhecido. Confira os números (boleto: 47 ou 48 números).": "Код не распознан. Проверьте цифры (boleto: 47 или 48 цифр).",
 "Código: {c}": "Код: {c}",
 "Cópia automática toda semana": "Автоматическая копия каждую неделю",
 "Cópia criada.": "Копия создана.",
 "Cópia de segurança": "Резервная копия",
 "Cópia feita": "Копия создана",
 "Cópia restaurada.": "Копия восстановлена.",
 "Cômodo": "Комната",
 "Cômodo ou quarto": "Комната",
 "Cômodos da casa e as tarefas de cada um.": "Комнаты дома и задачи для каждой.",
 "DAS de {mes} pago": "DAS за {mes} оплачен",
 "DAS de {mes}: vence dia {dia}": "DAS за {mes}: срок {dia}-го числа",
 "DAS do MEI": "DAS для MEI",
 "DECLARAÇÃO DE ATENDIMENTO": "СПРАВКА О ПРИЁМЕ",
 "DICA DO MESTRE ACHADO": "СОВЕТ ОТ MESTRE ACHADO",
 "DPS nº {n}, série {s}": "DPS № {n}, серия {s}",
 "Da galeria ou dos arquivos": "Из галереи или файлов",
 "Da meta de passos": "От цели по шагам",
 "Dados compartilhados": "Общие данные",
 "Dados compartilhados com o grupo": "Данные, общие с группой",
 "Dados compartilhados · seu papel: {p}": "Общие данные · ваша роль: {p}",
 "Dados de saúde que você mesmo registra são tratados só para você e para quem você compartilhar, com o seu consentimento (art. 11, I).": "Данные о здоровье, которые вы вводите сами, обрабатываются только для вас и для тех, с кем вы ими делитесь, с вашего согласия (art. 11, I).",
 "Dados do dispositivo: idioma, país e fuso horário (para datas, feriados e moeda), modelo do dispositivo e o código para avisos no celular.": "Данные устройства: язык, страна и часовой пояс (для дат, праздников и валюты), модель устройства и код для уведомлений на телефоне.",
 "Dados do relógio e de saúde não são usados para publicidade nem repassados a ninguém. Você pode desconectar e revogar a permissão a qualquer momento.": "Данные часов и здоровья не используются для рекламы и никому не передаются. Вы можете отключиться и отозвать разрешение в любой момент.",
 "Dança": "Танцы",
 "Dar ciência": "Подтвердить ознакомление",
 "Dar ciência da operação?": "Подтвердить ознакомление с операцией?",
 "Data": "Дата",
 "Data (embarque ou check-in)": "Дата (вылет или заезд)",
 "Data agendada": "Назначенная дата",
 "Data da aplicação": "Дата введения",
 "Data da compra": "Дата покупки",
 "Data da entrega": "Дата доставки",
 "Data da venda": "Дата продажи",
 "Data de nascimento": "Дата рождения",
 "Data do empréstimo": "Дата займа",
 "Data do pagamento": "Дата оплаты",
 "Data em que foi feita": "Дата проведения",
 "Data sugerida com 2 dias úteis de folga. Confira no sistema oficial.": "Предложенная дата с запасом в 2 рабочих дня. Проверьте в официальной системе.",
 "De": "С",
 "De uma foto": "Из фото",
 "De {de} para {para} ({p}% menor).": "С {de} до {para} (на {p}% меньше).",
 "Declaração": "Декларация",
 "Declaração de atendimento": "Справка о приёме",
 "Declaração para reembolso (PDF)": "Справка для возмещения (PDF)",
 "Declaro que esta empresa é minha ou de cliente que autorizou o acompanhamento.": "Я заявляю, что эта компания принадлежит мне или клиенту, разрешившему отслеживание.",
 "Declaro, para fins de reembolso{conv}, que o(a) paciente {nome}{cpf}{cart} foi atendido(a) por mim em {data}{hora}, em {tipo}.": "Настоящим подтверждаю для целей возмещения{conv}, что пациент(ка) {nome}{cpf}{cart} был(а) принят(а) мной {data}{hora}, вид приёма: {tipo}.",
 "Defina a meta de aulas por dia ou por semana em Editar.": "Задайте цель по урокам в день или в неделю в разделе «Изменить».",
 "Defina a meta de páginas por dia em Editar.": "Задайте цель страниц в день в разделе «Изменить».",
 "Defina um horário": "Укажите время",
 "Defina um horário para usar pausas.": "Укажите время, чтобы использовать перерывы.",
 "Demaquilante ou água micelar": "Средство для снятия макияжа или мицеллярная вода",
 "Demolição": "Демонтаж",
 "Demonstração": "Демо",
 "Dentista": "Стоматолог",
 "Dependentes": "Иждивенцы",
 "Depois": "После",
 "Depois da aula": "После урока",
 "Depois de apagadas, as tarefas não voltam. Digite a senha da sua conta para confirmar.": "Удалённые задачи нельзя восстановить. Введите пароль от аккаунта для подтверждения.",
 "Depois de baixar, abra o arquivo e toque em Instalar. Se o celular pedir, permita instalar apps desta fonte.": "После загрузки откройте файл и нажмите «Установить». Если телефон попросит, разрешите установку приложений из этого источника.",
 "Depois de criar": "После создания",
 "Depois de {nome}. Toque para pular.": "После: {nome}. Нажмите, чтобы пропустить.",
 "Depois é só ajustar horários e o que comer em cada um.": "Потом останется лишь настроить время и что есть в каждый приём пищи.",
 "Desarquivar": "Из архива",
 "Desbloquear": "Разблокировать",
 "Desbloquear com": "Разблокировка с помощью",
 "Desbloquear com biometria": "Разблокировать с помощью биометрии",
 "Desbloquear o My Planner": "Разблокировать My Planner",
 "Desbloqueio do app": "Разблокировка приложения",
 "Descanso": "Отдых",
 "Descartadas": "Отклонённые",
 "Descartar": "Отклонить",
 "Descartar este tempo?": "Отменить это время?",
 "Descobrir lugares em {d}": "Найти места в {d}",
 "Desconectar": "Отключить",
 "Desconectar o {nome}?": "Отключить {nome}?",
 "Desconto": "Скидка",
 "Desconto de {v}": "Скидка {v}",
 "Descontos obtidos": "Полученные скидки",
 "Descrição": "Описание",
 "Descrição (cliente, nota fiscal...)": "Описание (клиент, счёт-фактура...)",
 "Descrição do serviço (sai na nota)": "Описание услуги (будет в счёте)",
 "Descrição que sai na nota": "Описание, которое будет в счёте",
 "Desenhar a assinatura": "Нарисовать подпись",
 "Desenhar com caneta ou dedo": "Рисовать стилусом или пальцем",
 "Desenhe a assinatura e escolha a página e o lugar.": "Нарисуйте подпись и выберите страницу и место.",
 "Desenhe a assinatura primeiro.": "Сначала нарисуйте подпись.",
 "Desenhe com o dedo ou com a caneta (S Pen, Apple Pencil ou caneta de tablet).": "Рисуйте пальцем или стилусом (S Pen, Apple Pencil или стилус для планшета).",
 "Desenhe com o dedo ou com a caneta. Para rolar o quadro, toque em Mover.": "Рисуйте пальцем или стилусом. Чтобы прокрутить доску, нажмите «Перенести».",
 "Desenhe de novo para confirmar.": "Нарисуйте ещё раз для подтверждения.",
 "Desenhe o seu padrão": "Нарисуйте свой ключ",
 "Desenhe pelo menos uma tarja.": "Нарисуйте хотя бы одну полосу.",
 "Desenhe um padrão ligando pelo menos 4 pontos.": "Нарисуйте ключ, соединив не менее 4 точек.",
 "Desenho": "Рисунок",
 "Desenho com caneta ou dedo": "Рисунок пером или пальцем",
 "Desenho incorreto": "Неверный ключ",
 "Desenho padrão": "Графический ключ",
 "Desenho padrão salvo.": "Графический ключ сохранён.",
 "Desenvolvimento": "Жим плечами",
 "Desfazer": "Отменить",
 "Desfazer amizade": "Удалить из друзей",
 "Desligar": "Отключить",
 "Desligar a sincronização?": "Отключить синхронизацию?",
 "Deslize para os lados para ver outros dias (até 60 dias à frente). Toque numa refeição para planejar o cardápio só daquele dia. Arraste para a direita para excluir.": "Листайте в стороны, чтобы увидеть другие дни (до 60 дней вперёд). Нажмите на приём пищи, чтобы спланировать меню только на этот день. Потяните вправо, чтобы удалить.",
 "Desmarcado": "Отменён",
 "Desmarcar como recebida": "Снять отметку о получении",
 "Desmarcar feita hoje": "Снять отметку за сегодня",
 "Desmarcar grupo": "Снять выбор с группы",
 "Desmarcar pagamento": "Отменить оплату",
 "Desodorante": "Дезодорант",
 "Despensa": "Кладовая",
 "Despesa": "Расход",
 "Despesas": "Расходы",
 "Destino": "Пункт назначения",
 "Detalhes": "Подробности",
 "Devolver até": "Вернуть до",
 "Devolver: {i} ({p})": "Вернуть: {i} ({p})",
 "Devolvido": "Возвращено",
 "Devolvidos": "Возвращённые",
 "Dia": "День",
 "Dia a dia": "Повседневное",
 "Dia da mudança": "День переезда",
 "Dia de vencimento do DAS": "День оплаты DAS",
 "Dia do Trabalho": "День труда",
 "Dia do vencimento": "День платежа",
 "Dia em que a fatura fecha": "День закрытия счёта по карте",
 "Dia planejado": "Запланированный день",
 "Dia {d} de {total}": "День {d} из {total}",
 "Diagnóstico": "Диагноз",
 "Dias e horários": "Дни и время",
 "Dias específicos": "Определённые дни",
 "Dias úteis": "Будние дни",
 "Dias: {dias}": "Дни: {dias}",
 "Dicas e observações": "Советы и заметки",
 "Diesel": "Дизель",
 "Diferença": "Разница",
 "Digitado": "Вручную",
 "Digitar": "Ввести",
 "Digitar à mão": "Ввести вручную",
 "Digite a senha do cofre. Ele fecha sozinho depois de 5 minutos sem uso.": "Введите пароль сейфа. Он закроется сам через 5 минут бездействия.",
 "Digite em minutos (90) ou em horas e minutos (1:30 ou 01:30) e toque em OK.": "Введите минуты (90) или часы и минуты (1:30 или 01:30) и нажмите OK.",
 "Digite no formato HH:MM, por exemplo 13:30.": "Введите в формате ЧЧ:ММ, например 13:30.",
 "Digite o código e ganhe 10 dias com todas as abas liberadas. Se não tiver, deixe em branco.": "Введите код и получите 10 дней со всеми открытыми вкладками. Если кода нет, оставьте поле пустым.",
 "Digite o nome da tarefa.": "Введите название задачи.",
 "Dinheiro": "Деньги",
 "Dinheiro e documentos": "Деньги и документы",
 "Direita": "Справа",
 "Direito": "Право",
 "Direito Administrativo": "Административное право",
 "Direito Civil": "Гражданское право",
 "Direito Constitucional": "Конституционное право",
 "Direito Empresarial": "Предпринимательское право",
 "Direito Penal": "Уголовное право",
 "Direito Tributário": "Налоговое право",
 "Direito do Trabalho": "Трудовое право",
 "Direto": "Напрямую",
 "Disciplina": "Предмет",
 "Dispensar": "Скрыть",
 "Dispensar o aviso": "Скрыть уведомление",
 "Dispensar todas": "Скрыть все",
 "Disponibilizada em": "Опубликовано",
 "Disponível no app novo": "Доступно в новом приложении",
 "Distância": "Расстояние",
 "Divida o curso em matérias ou módulos. Em cada uma, marque em que aula parou e crie cards de anotações.": "Разделите курс на предметы или модули. В каждом отмечайте, на каком уроке остановились, и создавайте карточки заметок.",
 "Dividir": "Разделить",
 "Dividir entre (nenhum marcado = todos)": "Делить между (никто не отмечен = все)",
 "Divisão das despesas": "Деление расходов",
 "Diária": "Ночь",
 "Diária padrão": "Стандартная цена за ночь",
 "Diário": "Дневник",
 "Diários municipais": "Муниципальные вестники",
 "Do celular, do Google Drive ou do OneDrive": "С телефона, из Google Drive или OneDrive",
 "Do cliente": "От клиента",
 "Do escritório": "От бюро",
 "Doações": "Пожертвования",
 "Docs": "Док.",
 "Documento": "Документ",
 "Documento (fundo branco)": "Документ (белый фон)",
 "Documento do veículo (CRLV)": "Документ на автомобиль (CRLV)",
 "Documento pessoal": "Личный документ",
 "Documento vence hoje": "Срок документа истекает сегодня",
 "Documento vencendo": "Срок документа истекает",
 "Documento: {o}": "Документ: {o}",
 "Documentos": "Документы",
 "Documentos (contrato, nota, recibo...)": "Документы (договор, счёт, расписка...)",
 "Documentos (passaporte, identidade, carteira de motorista)": "Документы (паспорт, удостоверение, водительские права)",
 "Documentos e autorização das crianças": "Документы и разрешения на детей",
 "Documentos protegidos, exames, histórico de saúde e outros campos com 🔒 são criptografados aqui no aparelho (AES-256) com a senha do cofre. Nem o suporte consegue ler. Sem a senha, esses dados não podem ser recuperados.": "Защищённые документы, анализы, история болезни и другие поля с 🔒 шифруются здесь, на устройстве (AES-256), паролем сейфа. Даже поддержка не может их прочитать. Без пароля эти данные восстановить нельзя.",
 "Documentos, recibos, cadernos e quadros, com várias páginas": "Документы, чеки, тетради и доски, несколько страниц",
 "Documentos, reuniões e gravações são apagados para todos. A conversa continua no Mensagens.": "Документы, встречи и записи будут удалены для всех. Чат останется в «Сообщениях».",
 "Documentário": "Документальный фильм",
 "Doenças, cirurgias e observações": "Болезни, операции и примечания",
 "Dois dedos ou toque duplo para ampliar": "Двумя пальцами или двойным касанием для увеличения",
 "Domingo": "Воскресенье",
 "Dono da obra": "Заказчик",
 "Dose": "Доза",
 "Dose (ex.: 1 cápsula, 5 g)": "Доза (напр.: 1 капсула, 5 г)",
 "Dose única": "Однократная доза",
 "Drama": "Драма",
 "Duplicar": "Дублировать",
 "Duplicar tarefa": "Дублировать задачу",
 "Duração": "Длительность",
 "Duração de cada sessão": "Длительность каждого занятия",
 "Duração {dur}": "Длительность {dur}",
 "Dá para comprar algo de 3 mil em 10 vezes?": "Можно купить что-то за 3 тысячи в 10 платежей?",
 "Débito automático": "Автоплатёж",
 "Débito, Pix ou dinheiro": "Дебет, Pix или наличные",
 "Dê um nome ao cartão.": "Дайте карте название.",
 "Dê um nome ao cuidado.": "Назовите процедуру ухода.",
 "Dê um nome ao cômodo.": "Назовите комнату.",
 "Dê um nome ao fichário.": "Назовите папку.",
 "Dê um nome ao grupo.": "Дайте группе название.",
 "Dê um nome ao suplemento.": "Укажите название добавки.",
 "Dê um nome ao treino.": "Укажите название тренировки.",
 "Dê um nome à conta.": "Дайте счёту название.",
 "Dê um nome à matéria.": "Назовите предмет.",
 "Dê um nome à meta.": "Дайте цели название.",
 "Dê um nome à refeição.": "Назовите приём пищи.",
 "Dê um nome à tarefa.": "Назовите задачу.",
 "E-MAIL (OPCIONAL)": "E-MAIL (НЕОБЯЗАТЕЛЬНО)",
 "E-mail": "E-mail",
 "E-mail (recebe a nota)": "E-mail (получает счёт)",
 "E-mail de contato": "E-mail для связи",
 "E-mail do responsável": "E-mail родителя",
 "E-mail inválido": "Неверный e-mail",
 "E-mail inválido.": "Неверный e-mail.",
 "E-mail ou WhatsApp para resposta (opcional)": "E-mail или WhatsApp для ответа (необязательно)",
 "E-mail para contato (opcional)": "E-mail для связи (необязательно)",
 "E-mail salvo.": "E-mail сохранён.",
 "EM ATRASO": "ПРОСРОЧЕНО",
 "ENTRAR COM UM CÓDIGO": "ВОЙТИ ПО КОДУ",
 "ENVIADOS": "ОТПРАВЛЕННЫЕ",
 "ESCOLHA AS ATIVIDADES": "ВЫБЕРИТЕ УПРАЖНЕНИЯ",
 "ESTA SEMANA": "НА ЭТОЙ НЕДЕЛЕ",
 "EXERCÍCIO FÍSICO": "ФИЗИЧЕСКИЕ УПРАЖНЕНИЯ",
 "Economia": "Экономика",
 "Edita tudo": "Изменяет всё",
 "Edita tudo: etapas, orçamento, diário e entregas.": "Изменяет всё: этапы, смету, дневник и поставки.",
 "Editar": "Изменить",
 "Editar cartão": "Изменить карту",
 "Editar compra": "Изменить покупку",
 "Editar cômodo": "Изменить комнату",
 "Editar desenho": "Изменить рисунок",
 "Editar documento": "Изменить документ",
 "Editar fichário": "Изменить папку",
 "Editar garantia": "Изменить гарантию",
 "Editar matéria": "Изменить предмет",
 "Editar meta": "Изменить цель",
 "Editar perfil": "Изменить профиль",
 "Editar tarefa": "Изменить задачу",
 "Editar {nome}": "Изменить: {nome}",
 "Educação": "Образование",
 "Educação Física": "Физкультура",
 "Efeito de scanner": "Эффект сканера",
 "Ela sai da lista e dos Recebidos da equipe.": "Она исчезнет из списка и из «Входящих» команды.",
 "Ela também fica guardada em \"Minhas figurinhas\" para mandar de novo.": "Он также сохраняется в \"Мои стикеры\", чтобы отправить его снова.",
 "Ela vem da aba Empréstimos & Financiamentos. Marque aqui como paga ou abra a aba para ver o contrato.": "Он пришёл из вкладки «Кредиты и займы». Отметьте здесь как оплаченный или откройте вкладку, чтобы посмотреть договор.",
 "Ela vem da aba Notas Fiscais. Marque como recebida quando o dinheiro entrar.": "Он пришёл из вкладки «Счета-фактуры». Отметьте как полученный, когда поступят деньги.",
 "Eleitorais": "Избирательные",
 "Eletrodoméstico": "Бытовая техника",
 "Eletrodomésticos": "Бытовая техника",
 "Eletrodomésticos, eletrônicos e móveis: nota fiscal, assistência técnica e aviso 15 dias antes de a garantia acabar.": "Бытовая техника, электроника и мебель: чек, сервисный центр и напоминание за 15 дней до окончания гарантии.",
 "Eletrônico": "Электроника",
 "Elétrica": "Электрика",
 "Elétrico": "Электро",
 "Em Editar, cole o link do calendário (iCal) do anúncio. No Airbnb: Calendário › Disponibilidade › Conectar calendários › Exportar calendário. No Booking: Tarifas e disponibilidade › Sincronizar calendários.": "В разделе «Изменить» вставьте ссылку на календарь (iCal) объявления. В Airbnb: Календарь › Доступность › Подключить календари › Экспорт календаря. В Booking: Цены и наличие мест › Синхронизация календарей.",
 "Em aberto": "Не оплачено",
 "Em alta": "Популярное",
 "Em andamento": "В работе",
 "Em atraso": "Просрочено",
 "Em branco": "Пустая",
 "Em casa": "Дома",
 "Em cima": "Сверху",
 "Em construção": "В разработке",
 "Em dia. As melhorias chegam sozinhas quando o app abre.": "Всё актуально. Улучшения приходят сами при открытии приложения.",
 "Em limpeza": "На уборке",
 "Em quais páginas": "На каких страницах",
 "Em qual agenda criar os eventos:": "В каком календаре создавать события:",
 "Em qual página e onde": "На какой странице и где",
 "Em tratamento": "На лечении",
 "Em um horário específico": "В определённое время",
 "Em uso: {ia}": "Используется: {ia}",
 "Em {n} dia(s)": "Через {n} дн.",
 "Embaixo": "Снизу",
 "Embaixo à esquerda": "Внизу слева",
 "Emissão": "Дата выдачи",
 "Emissão +": "Выдача +",
 "Emissão: {data}": "Выдан: {data}",
 "Emitida": "Выставлен",
 "Emitida em {data}": "Выставлен {data}",
 "Emitida ou recebida": "Выставлен или получен",
 "Emitidas": "Выставленные",
 "Emitidas: {v} · Recebidas: {r} · {n} nota(s)": "Выставлено: {v} · Получено: {r} · Счетов: {n}",
 "Emitir": "Выставить",
 "Emitir NFS-e": "Выставить NFS-e",
 "Emitir NFS-e pelo Padrão Nacional com o certificado A1, buscar as notas emitidas e recebidas e exportar XML, planilha e PDF.": "Выставляйте NFS-e по Padrão Nacional с сертификатом A1, ищите выставленные и полученные счета и экспортируйте XML, таблицу и PDF.",
 "Emitir a nota de verdade?": "Выставить настоящий счёт?",
 "Emitir no ambiente de teste?": "Выставить в тестовой среде?",
 "Emojis": "Эмодзи",
 "Emojis animados": "Анимированные эмодзи",
 "Emojis animados: Noto, do Google (CC BY 4.0).": "Анимированные эмодзи: Noto от Google (CC BY 4.0).",
 "Emojis, GIFs e figurinhas": "Эмодзи, GIF и стикеры",
 "Empresa": "Компания",
 "Empresa de mudança": "Транспортная компания",
 "Empresa ou pessoa": "Компания или человек",
 "Empresa, hotel ou voo": "Компания, отель или рейс",
 "Empresas": "Компании",
 "Emprestei": "Я дал(а)",
 "Empréstimo": "Заём",
 "Empréstimo entre pessoas": "Заём между людьми",
 "Empréstimo pessoal": "Потребительский кредит",
 "Empréstimos": "Займы",
 "Empréstimos & Financiamentos": "Кредиты и займы",
 "Encaminhada para {nome}.": "Переслано: {nome}.",
 "Encaminhar": "Переслать",
 "Encaminhar para": "Переслать кому",
 "Encerrar e salvar": "Завершить и сохранить",
 "Encontrada para {perfil}": "Найдено для {perfil}",
 "Endereço": "Адрес",
 "Endereço (opcional)": "Адрес (необязательно)",
 "Endereço (se for presencial)": "Адрес (если очно)",
 "Endereço atual": "Текущий адрес",
 "Endereço da escola": "Адрес школы",
 "Endereço da oficina": "Адрес автосервиса",
 "Endereço de quem está com o item": "Адрес того, у кого вещь",
 "Endereço do consultório": "Адрес кабинета",
 "Endereço do imóvel": "Адрес объекта",
 "Endereço do laboratório": "Адрес лаборатории",
 "Endereço do veterinário": "Адрес ветеринара",
 "Endereço no trabalho e na escola": "Адрес на работе и в школе",
 "Endereço nos Correios e entregas": "Адрес на почте и для доставок",
 "Endereço nos bancos e cartões": "Адрес в банках и картах",
 "Endereço novo": "Новый адрес",
 "Endereço ou nome do lugar": "Адрес или название места",
 "Endereço ou terminal": "Адрес или терминал",
 "Energia": "Энергия",
 "Enfermeiro": "Медбрат",
 "Engenharia": "Инженерия",
 "Engenheiro ou arquiteto": "Инженер или архитектор",
 "Enquadre o documento e toque no botão": "Наведите камеру на документ и нажмите кнопку",
 "Enquadre o rosto e toque no botão. 🔄 vira a câmera.": "Поместите лицо в кадр и нажмите кнопку. 🔄 переключает камеру.",
 "Ensino Fundamental": "Основная школа",
 "Ensino Médio e ENEM": "Старшая школа и ENEM",
 "Entendi e concordo em usar o monitor nessas condições.": "Я понимаю и согласен(на) использовать мониторинг на этих условиях.",
 "Entra direto no Planner, com horário, dias e a lista de itens. Se o horário já estiver ocupado, você escolhe: substituir, manter as duas ou cancelar.": "Добавляется прямо в Planner — со временем, днями и списком пунктов. Если это время уже занято, вы выбираете: заменить, оставить оба или отменить.",
 "Entrada": "Доход",
 "Entrada (imóvel novo)": "Въезд (новое жильё)",
 "Entrada de dinheiro": "Поступление денег",
 "Entrando...": "Вход...",
 "Entrar": "Войти",
 "Entrar com CPF e senha": "Войти по CPF и паролю",
 "Entrar com outra conta": "Войти в другой аккаунт",
 "Entrar de novo": "Войти снова",
 "Entrar na chamada": "Присоединиться к звонку",
 "Entrar na reunião": "Присоединиться к встрече",
 "Entrar na sala online": "Войти в онлайн-комнату",
 "Entrar no grupo": "Вступить в группу",
 "Entrar no navegador?": "Войти в браузере?",
 "Entre com seu CPF e sua senha.": "Войдите с помощью CPF и пароля.",
 "Entre com seu e-mail e sua senha.": "Войдите с помощью e-mail и пароля.",
 "Entre na sua conta de novo.": "Войдите в аккаунт снова.",
 "Entre na sua conta para usar as notas fiscais.": "Войдите в аккаунт, чтобы работать со счетами.",
 "Entre no app com o seu e-mail e a senha nova.": "Войдите в приложение с вашим e-mail и новым паролем.",
 "Entrega de material": "Поставка материала",
 "Entrega prevista": "Ожидаемая поставка",
 "Entregas": "Поставки",
 "Entregue": "Сдано",
 "Entrou": "Пришло",
 "Entrou no total da semana.": "Учтено в итоге за неделю.",
 "Enviada": "Отправлено",
 "Enviado": "Отправлено",
 "Enviado para o Planner": "Отправлено в Planner",
 "Enviado pelo cliente": "Отправлено клиентом",
 "Enviado pelo escritório": "Отправлено бюро",
 "Enviado por {quem} no grupo {g}": "Отправил(а) {quem} в группе {g}",
 "Enviando {f} de {n}...": "Отправка {f} из {n}...",
 "Enviando...": "Отправка...",
 "Enviar": "Отправить",
 "Enviar \"{nome}\"": "Отправить «{nome}»",
 "Enviar \"{nome}\" para…": "Отправить «{nome}» в…",
 "Enviar \"{titulo}\" para": "Отправить «{titulo}» в",
 "Enviar ao grupo": "Отправить в группу",
 "Enviar convite": "Отправить приглашение",
 "Enviar convite para {nome}": "Отправить приглашение: {nome}",
 "Enviar convite pelo WhatsApp": "Отправить приглашение в WhatsApp",
 "Enviar documento": "Отправить документ",
 "Enviar instruções ao hóspede": "Отправить инструкции гостю",
 "Enviar o convite": "Отправить приглашение",
 "Enviar ou copiar o código": "Отправить или скопировать код",
 "Enviar ou imprimir a etiqueta": "Отправить или распечатать наклейку",
 "Enviar para Estudos": "Отправить в Учёбу",
 "Enviar para My Planner": "Отправить в My Planner",
 "Enviar para a equipe": "Отправить команде",
 "Enviar para o My Planner": "Отправить в My Planner",
 "Enviar para o Planner": "Отправить в Planner",
 "Enviar para o grupo": "Отправить в группу",
 "Enviar para o grupo de estudos": "Отправить в учебную группу",
 "Enviar para o {nome} os {n} arquivo(s) deste dispositivo": "Отправить в {nome} файлы с этого устройства ({n})",
 "Enviar para um grupo": "Отправить в группу",
 "Enviar para {g}": "Отправить в {g}",
 "Enviar para…": "Отправить в…",
 "Enviar por e-mail": "Отправить по e-mail",
 "Enviar relatório": "Отправить отчёт",
 "Enviar relatório para a equipe": "Отправить отчёт команде",
 "Enviar também as tarefas que já existem (de hoje em diante)": "Отправить и уже существующие задачи (начиная с сегодняшнего дня)",
 "Enviar tarefas do My Planner para a agenda": "Отправлять задачи My Planner в календарь",
 "Envie guias, notas e relatórios para o cliente, ou veja o que ele mandou. Cada documento aceita fotos, PDFs e links.": "Отправляйте клиенту платёжки, счета и отчёты или смотрите, что он прислал. К каждому документу можно прикрепить фото, PDF и ссылки.",
 "Enxaguante": "Ополаскиватель",
 "Episódio": "Эпизод",
 "Equipe": "Команда",
 "Equipe ({n})": "Команда ({n})",
 "Equipe de limpeza": "Команда уборки",
 "Equipe do consultório": "Команда кабинета",
 "Equipe do imóvel (limpeza e co-anfitrião)": "Команда объекта (уборка и со-хозяин)",
 "Erro": "Ошибка",
 "Erro na emissão": "Ошибка при выставлении",
 "Erro: {erro}": "Ошибка: {erro}",
 "Erros registrados neste dispositivo ({n})": "Ошибки на этом устройстве ({n})",
 "Escanear documento": "Сканировать документ",
 "Escanear o verso": "Сканировать оборот",
 "Escanear para PDF": "Сканировать в PDF",
 "Escaneie documentos, recibos, cadernos e quadros: bordas e sombras corrigidas, várias páginas, identidade frente e verso, assinatura e PDF guardado no celular, no Google Drive ou no OneDrive.": "Сканируйте документы, чеки, тетради и доски: исправленные края и тени, несколько страниц, удостоверение с двух сторон, подпись и PDF на телефоне, в Google Drive или OneDrive.",
 "Escaneie, deixe a imagem mais clara, organize em pastas e mande o PDF por WhatsApp, e-mail ou Drive. Com a sua IA ligada, o app lê o texto, resume e responde perguntas sobre o documento.": "Сканируйте, делайте изображение чётче, раскладывайте по папкам и отправляйте PDF через WhatsApp, почту или Drive. Если ваш ИИ включён, приложение читает текст, делает краткое содержание и отвечает на вопросы о документе.",
 "Escola": "Школа",
 "Escolha a aba:": "Выберите вкладку:",
 "Escolha a data do compromisso.": "Выберите дату встречи.",
 "Escolha a imagem.": "Выберите изображение.",
 "Escolha a matéria": "Выберите предмет",
 "Escolha a pasta do celular (ex.: Documentos). O app guarda lá sozinho.": "Выберите папку на телефоне (например, Documents). Приложение будет сохранять туда автоматически.",
 "Escolha a página": "Выберите страницу",
 "Escolha ao menos um tribunal ou marque \"Todos os tribunais\".": "Выберите хотя бы один суд или отметьте «Все суды».",
 "Escolha ao menos uma agenda.": "Выберите хотя бы один календарь.",
 "Escolha o PDF": "Выберите PDF",
 "Escolha o arquivo .pfx (ou .p12) do certificado A1 da empresa e digite a senha dele. Ele fica criptografado no seu cofre.": "Выберите файл .pfx (или .p12) сертификата A1 компании и введите его пароль. Он хранится в зашифрованном виде в вашем сейфе.",
 "Escolha o arquivo .xml da NFS-e, NF-e ou CT-e.": "Выберите файл .xml NFS-e, NF-e или CT-e.",
 "Escolha o fichário": "Выберите папку",
 "Escolha o grupo para enviar: {t}": "Выберите группу для отправки: {t}",
 "Escolha os PDFs": "Выберите PDF-файлы",
 "Escolha os arquivos.": "Выберите файлы.",
 "Escolha os feriados que aparecem no Planner e no botão 🎉 Feriados.": "Выберите праздники, которые будут отображаться в Planner и по кнопке 🎉 Праздники.",
 "Escolha para quem enviar.": "Выберите, кому отправить.",
 "Escolha pelo menos um dia.": "Выберите хотя бы один день.",
 "Escolha pelo menos uma página que exista no PDF (ex.: 1-3, 5).": "Выберите хотя бы одну существующую страницу PDF (напр.: 1-3, 5).",
 "Escolha quem participa:": "Выберите участников:",
 "Escolher": "Выбрать",
 "Escolher a imagem": "Выбрать изображение",
 "Escolher a pasta": "Выбрать папку",
 "Escolher agendas": "Выбрать календари",
 "Escolher alimento": "Выбрать продукт",
 "Escolher arquivo": "Выбрать файл",
 "Escolher arquivos": "Выбрать файлы",
 "Escolher arquivos do Drive ou do OneDrive": "Выбрать файлы из Drive или OneDrive",
 "Escolher as imagens e criar o PDF": "Выбрать изображения и создать PDF",
 "Escolher da galeria": "Выбрать из галереи",
 "Escolher da galeria ou arquivo (foto ou PDF)": "Выбрать из галереи или файл (фото или PDF)",
 "Escolher data": "Выбрать дату",
 "Escolher fuso": "Выбрать часовой пояс",
 "Escolher hora": "Выбрать время",
 "Escolher horário": "Выбрать время",
 "Escolher o certificado": "Выбрать сертификат",
 "Escolher outro": "Выбрать другой",
 "Escolher pessoas": "Выбрать людей",
 "Escolher tribunais": "Выбрать суды",
 "Escolher ícone": "Выбрать значок",
 "Esconder da equipe (só administradores)": "Скрыть от команды (только администраторы)",
 "Esconder detalhes": "Скрыть подробности",
 "Esconder o texto completo": "Скрыть полный текст",
 "Escondido de {n} pessoa(s)": "Скрыто от {n} чел.",
 "Escondido de: {n}": "Скрыто от: {n}",
 "Escondidos no Planner.": "Скрыты в Planner.",
 "Escova e pasta de dente": "Зубная щётка и паста",
 "Escovar os dentes": "Почистить зубы",
 "Escreva aqui": "Напишите здесь",
 "Escreva e dê Enter (ex.: lavar a máquina)": "Введите и нажмите Enter (напр.: постирать в машинке)",
 "Escreva em uma ou em todas as páginas.": "Пишите на одной или на всех страницах.",
 "Escreva o motivo em \"Motivo do cancelamento\" na ficha da nota (pelo menos 15 letras) e toque aqui de novo.": "Укажите причину в поле «Причина аннулирования» в карточке счёта (не меньше 15 букв) и нажмите здесь ещё раз.",
 "Escreva o resumo, tópicos, dúvidas...": "Напишите конспект, темы, вопросы...",
 "Escreva o texto da marca d'água.": "Введите текст водяного знака.",
 "Escreva o texto.": "Введите текст.",
 "Escreva o título.": "Введите название.",
 "Escreva ou cole o texto. Linha começando com \"# \" vira título.": "Введите или вставьте текст. Строка, начинающаяся с \"# \", станет заголовком.",
 "Escreva ou cole um texto e gere o PDF.": "Введите или вставьте текст и создайте PDF.",
 "Escritório": "Кабинет",
 "Escritório: documentos e reuniões da equipe. Só o administrador do escritório pode gravar uma reunião, e todos na reunião veem o aviso \"Gravando\" enquanto ela é gravada. A gravação fica nos documentos do escritório, visível só para o administrador até ele liberar para a equipe.": "Кабинет: документы и встречи команды. Записывать встречу может только администратор кабинета, и во время записи все участники видят уведомление «Идёт запись». Запись хранится в документах кабинета и видна только администратору, пока он не откроет к ней доступ команде.",
 "Escuro": "Тёмный",
 "Espanhol": "Испанский",
 "Espaço": "Объект",
 "Espaço livre, dados de cada aba e anexos": "Свободное место, данные каждой вкладки и вложения",
 "Especialidade": "Специализация",
 "Espécie": "Вид",
 "Esquadro": "Угольник",
 "Esqueci a senha": "Забыли пароль",
 "Esquerda": "Слева",
 "Esse código é o seu.": "Это ваш собственный код.",
 "Esse código é o seu. Use o código de quem indicou o app para você.": "Это ваш собственный код. Используйте код того, кто порекомендовал вам приложение.",
 "Esse endereço não respondeu como servidor de notas. Confira e tente de novo.": "Этот адрес не ответил как сервер счетов. Проверьте и попробуйте снова.",
 "Esta aba ainda não está no seu plano.": "Этой вкладки пока нет в вашем плане.",
 "Esta e todas as futuras": "Эту и все будущие",
 "Esta ferramenta precisa ver as páginas do PDF, o que chega com o app novo (versão 0.50). Use o navegador ou instale o APK novo.": "Этому инструменту нужно видеть страницы PDF, это появится в новом приложении (версия 0.50). Используйте браузер или установите новый APK.",
 "Esta imagem foi guardada em outro dispositivo.": "Это изображение сохранено на другом устройстве.",
 "Esta janela pode ser fechada.": "Это окно можно закрыть.",
 "Esta pessoa ainda não preencheu o cartão de contato.": "Этот человек ещё не заполнил карточку контакта.",
 "Esta semana: {a} de {m} aulas ({p}%)": "На этой неделе: {a} из {m} уроков ({p}%)",
 "Esta senha é de outra conta.": "Этот пароль от другого аккаунта.",
 "Esta tarefa não tem horário: \"No início\" e \"Antes do início\" não se aplicam. Use \"Em um horário específico\".": "У этой задачи нет времени: «В начале» и «До начала» не применяются. Используйте «В определённое время».",
 "Esta tarefa se repete. O que excluir?": "Эта задача повторяется. Что удалить?",
 "Esta tela teve um problema": "На этом экране возникла проблема",
 "Estado (UF) do registro": "Штат (UF) регистрации",
 "Estado de Mato Grosso do Sul": "Штат Мату-Гросу-ду-Сул",
 "Estado de São Paulo": "Штат Сан-Паулу",
 "Estado do Paraná": "Штат Парана",
 "Estados": "Штаты",
 "Estaduais": "Суды штатов",
 "Estadual": "Уровня штата",
 "Estas abas aparecem na barra de baixo, nesta ordem. My Planner, Abas e Ajustes ficam sempre. As outras continuam aqui na tela Abas.": "Эти вкладки отображаются на нижней панели в этом порядке. My Planner, Вкладки и Настройки остаются всегда. Остальные доступны здесь, на экране «Вкладки».",
 "Estatística": "Статистика",
 "Este CPF já tem cadastro. Use \"Entrar\".": "Этот CPF уже зарегистрирован. Нажмите «Войти».",
 "Este PDF está no dispositivo onde foi aberto.": "Этот PDF находится на устройстве, где его открыли.",
 "Este PDF está no dispositivo onde foi aberto. Abra por lá, ou abra de novo a cópia guardada no Drive ou no OneDrive.": "Этот PDF находится на устройстве, где его открыли. Откройте его там или заново откройте копию, сохранённую в Drive или OneDrive.",
 "Este PDF está protegido com senha. Tire a senha no programa onde ele foi criado e tente de novo.": "Этот PDF защищён паролем. Снимите пароль в программе, где он был создан, и попробуйте снова.",
 "Este PDF não tem campos de formulário. Use \"Adicionar texto\" para escrever nele.": "В этом PDF нет полей формы. Используйте \"Добавить текст\", чтобы писать на нём.",
 "Este ano": "Этот год",
 "Este dispositivo": "Это устройство",
 "Este dispositivo não consegue abrir o arquivo.": "Это устройство не может открыть файл.",
 "Este dispositivo não consegue compartilhar arquivos.": "Это устройство не может делиться файлами.",
 "Este dispositivo não tem dados de saúde. Dá para digitar à mão.": "На этом устройстве нет данных о здоровье. Их можно ввести вручную.",
 "Este arquivo foi guardado em outro dispositivo.": "Этот файл сохранён на другом устройстве.",
 "Este arquivo foi guardado no celular. Abra pelo app no celular.": "Этот файл сохранён на телефоне. Откройте его в приложении на телефоне.",
 "Este arquivo não é um backup do My Planner.": "Этот файл не является резервной копией My Planner.",
 "Este celular ainda não recebe avisos com o app fechado. Instale o app {v} ou mais novo (APK com os avisos do servidor). Com o app aberto, os avisos já funcionam.": "Этот телефон пока не получает уведомления при закрытом приложении. Установите приложение {v} или новее (APK с уведомлениями сервера). При открытом приложении уведомления уже работают.",
 "Este certificado é de {doc}, diferente do CNPJ/CPF da empresa ({emp}).": "Этот сертификат принадлежит {doc}, а не CNPJ/CPF компании ({emp}).",
 "Este fichário ainda não tem matérias.": "В этой папке пока нет предметов.",
 "Este grupo já está cheio.": "Эта группа уже заполнена.",
 "Este mês": "Этот месяц",
 "Este mês: emitidas {e} · recebidas {r}": "В этом месяце: выставлено {e} · получено {r}",
 "Este mês: {h}": "В этом месяце: {h}",
 "Este navegador": "Этот браузер",
 "Este país só tem feriados nacionais.": "В этой стране есть только государственные праздники.",
 "Esteira": "Беговая дорожка",
 "Esteticista": "Косметолог",
 "Estou usando o My Planner para organizar a agenda, as finanças e muito mais. Baixe o app e, ao criar a sua conta, use o meu código {codigo} para ganhar 10 dias com todas as abas liberadas.": "Я пользуюсь My Planner, чтобы организовать расписание, финансы и многое другое. Скачайте приложение и при создании аккаунта введите мой код {codigo}, чтобы получить 10 дней со всеми открытыми вкладками.",
 "Estratégia": "Стратегия",
 "Estrela": "Звезда",
 "Estudando": "Идёт учёба",
 "Estudar agora": "Учиться сейчас",
 "Estudar {nome}": "Учить {nome}",
 "Estudar: {c}": "Учиться: {c}",
 "Estudo": "Изучение",
 "Estudos": "Учёба",
 "Estudos e exatas": "Учёба и точные науки",
 "Estudos, lazer e viagens": "Учёба, досуг и путешествия",
 "Está em Patrimônio & IR › Recibos dedutíveis. Abra lá para anexar a foto do recibo e o CPF ou CNPJ de quem recebeu.": "Находится в разделе Имущество и подоходный налог › Вычитаемые квитанции. Откройте его там, чтобы прикрепить фото квитанции и CPF или CNPJ получателя.",
 "Está na página \"{titulo}\" e em \"Ver arquivos\".": "Он на странице «{titulo}» и в разделе «Посмотреть файлы».",
 "Etanol": "Этанол",
 "Etapa": "Этап",
 "Etapa do cronograma": "Этап графика",
 "Etapas": "Этапы",
 "Evento": "Мероприятие",
 "Eventos": "Мероприятия",
 "Eventos & Celebrações": "Мероприятия и праздники",
 "Evolução (no cofre)": "Динамика (в сейфе)",
 "Ex.: 08:00 e 20:00": "Напр.: 08:00 и 20:00",
 "Ex.: 08:00, 14:00 e 20:00": "Напр.: 08:00, 14:00 и 20:00",
 "Ex.: 09/2026": "Напр.: 09/2026",
 "Ex.: 1 comprimido": "Напр.: 1 таблетка",
 "Ex.: 1-3, 4-10, 11-": "Напр.: 1-3, 4-10, 11-",
 "Ex.: 1-3, 5, 8-10": "Напр.: 1-3, 5, 8-10",
 "Ex.: 171901 (consultoria), 010101 (programação)": "Напр.: 171901 (консалтинг), 010101 (программирование)",
 "Ex.: 40 sacos de cimento": "Напр.: 40 мешков цемента",
 "Ex.: 4106902 (Curitiba), 5002704 (Campo Grande), 3550308 (São Paulo)": "Напр.: 4106902 (Curitiba), 5002704 (Campo Grande), 3550308 (São Paulo)",
 "Ex.: 8º ano B": "Напр.: 8 «Б»",
 "Ex.: Alongamento lombar, Dieta 1.800 kcal": "Напр.: Растяжка поясницы, Диета 1 800 ккал",
 "Ex.: Aniversário de 30 anos da Ana": "Напр.: 30-летие Анны",
 "Ex.: Apartamento da praia, Suíte 1, Edícula": "Напр.: Квартира у моря, Люкс 1, Флигель",
 "Ex.: Apartamento na Rua X, 100 ações PETR4": "Напр.: Квартира на улице X, 100 акций PETR4",
 "Ex.: Aula de revisão, Consulta de retorno": "Напр.: Урок повторения, Повторный приём",
 "Ex.: Buffet, DJ, decoração, fotógrafo": "Напр.: кейтеринг, диджей, декор, фотограф",
 "Ex.: CONFIDENCIAL, CÓPIA, RASCUNHO": "Напр.: КОНФИДЕНЦИАЛЬНО, КОПИЯ, ЧЕРНОВИК",
 "Ex.: Cardiologista": "Напр.: кардиолог",
 "Ex.: Consultoria mensal": "Напр.: Ежемесячная консультация",
 "Ex.: Costela-de-adão da sala": "Напр.: монстера в гостиной",
 "Ex.: DAS de setembro, Extrato do Itaú": "Напр.: DAS за сентябрь, выписка Itaú",
 "Ex.: Desmontar os móveis do quarto": "Напр.: разобрать мебель в спальне",
 "Ex.: Disponível · Em aula até 18h · Bora viajar!": "Напр.: На связи · На занятиях до 18:00 · В путешествие!",
 "Ex.: Eletricista, loja de material": "Напр.: электрик, строймагазин",
 "Ex.: Entrada dos noivos": "Напр.: выход жениха и невесты",
 "Ex.: Financiamento do carro": "Напр.: Автокредит",
 "Ex.: Fisioterapeuta, Nutricionista, Cardiologista": "Напр.: Физиотерапевт, Диетолог, Кардиолог",
 "Ex.: Furadeira, livro, R$ 200": "Напр.: дрель, книга, 200 R$",
 "Ex.: Hemograma": "Напр.: общий анализ крови",
 "Ex.: IPVA 2027, parcela 1": "Напр.: IPVA 2027, платёж 1",
 "Ex.: Lisboa, Portugal": "Напр.: Лиссабон, Португалия",
 "Ex.: Mala da Ana": "Напр.: чемодан Анны",
 "Ex.: Mensalidade de outubro, material": "Напр.: Плата за октябрь, материалы",
 "Ex.: Netflix, cinema": "Напр.: Netflix, кино",
 "Ex.: Notas de compra de setembro": "Напр.: Счета на покупки за сентябрь",
 "Ex.: Onix 2022": "Напр.: Onix 2022",
 "Ex.: Prova 1, Trabalho em grupo": "Напр.: контрольная 1, групповой проект",
 "Ex.: Prova de matemática": "Напр.: контрольная по математике",
 "Ex.: Pôr do sol no Tejo": "Напр.: Закат над Тежу",
 "Ex.: Reforma da cozinha": "Напр.: ремонт кухни",
 "Ex.: TAP TP 108": "Напр.: TAP TP 108",
 "Ex.: Torre de Belém": "Напр.: Башня Белен",
 "Ex.: Troca da fiação da sala": "Напр.: замена проводки в гостиной",
 "Ex.: V10, antirrábica": "Напр.: V10, от бешенства",
 "Ex.: Visita ao Mosteiro dos Jerónimos": "Напр.: посещение монастыря Жеронимуш",
 "Ex.: cerâmica 30 cm": "Напр.: керамика 30 см",
 "Ex.: kg, pacotes, latas": "Напр.: кг, пачки, банки",
 "Ex.: seg e qua, 07:30": "Напр.: пн и ср, 07:30",
 "Ex.: troquei o arroz por batata doce": "Напр.: заменил рис на батат",
 "Ex.: varanda, sala": "Напр.: балкон, гостиная",
 "Exame": "Анализ",
 "Exame da OAB": "Экзамен OAB",
 "Exames": "Анализы",
 "Excel": "Excel",
 "Excluir": "Удалить",
 "Excluir \"{nome}\"?": "Удалить «{nome}»?",
 "Excluir \"{titulo}\"?": "Удалить «{titulo}»?",
 "Excluir a caixa?": "Удалить блок?",
 "Excluir a compra": "Удалить покупку",
 "Excluir a compra?": "Удалить покупку?",
 "Excluir a meta \"{m}\"?": "Удалить цель \"{m}\"?",
 "Excluir cartão": "Удалить карту",
 "Excluir conta": "Удалить счёт",
 "Excluir cuidado": "Удалить процедуру",
 "Excluir cômodo": "Удалить комнату",
 "Excluir esta página?": "Удалить эту страницу?",
 "Excluir fichário": "Удалить папку",
 "Excluir matéria": "Удалить предмет",
 "Excluir o cartão \"{c}\"?": "Удалить карту \"{c}\"?",
 "Excluir o documento": "Удалить документ",
 "Excluir o fichário {nome}": "Удалить папку {nome}",
 "Excluir página": "Удалить страницу",
 "Excluir refeição": "Удалить приём пищи",
 "Excluir suplemento": "Удалить добавку",
 "Excluir tarefa": "Удалить задачу",
 "Excluir tarefa repetida": "Удалить повторяющуюся задачу",
 "Excluir tarefa?": "Удалить задачу?",
 "Excluir treino": "Удалить тренировку",
 "Excluir {nome}?": "Удалить {nome}?",
 "Excluídas em definitivo 30 dias depois do descarte.": "Удаляются навсегда через 30 дней после удаления в корзину.",
 "Executivo e profissional": "Деловая и профессиональная",
 "Execução do contrato (art. 7º, V), para entregar o serviço; consentimento (art. 7º, I), para câmera, galeria, microfone e localização; cumprimento de obrigação legal (art. 7º, II); e legítimo interesse (art. 7º, IX), para segurança e prevenção de fraudes.": "Исполнение договора (art. 7º, V) — для предоставления услуги; согласие (art. 7º, I) — для камеры, галереи, микрофона и местоположения; выполнение юридической обязанности (art. 7º, II); и законный интерес (art. 7º, IX) — для безопасности и предотвращения мошенничества.",
 "Exemplos: 13:30, 1330, 9:05": "Примеры: 13:30, 1330, 9:05",
 "Exercício": "Тренировка",
 "Exercício físico": "Физические упражнения",
 "Experimente grátis por {n} dias": "Попробуйте бесплатно {n} дн.",
 "Explique o motivo (para cancelar)": "Укажите причину (для аннулирования)",
 "Exportar arquivo": "Экспортировать файл",
 "Exportar para o contador": "Экспорт для бухгалтера",
 "Extrair páginas": "Извлечь страницы",
 "Extras (pet, check-in tardio...)": "Доп. услуги (питомец, поздний заезд...)",
 "Extrato": "Выписка",
 "Extrato bancário": "Банковская выписка",
 "Extrato do banco (foto ou PDF)": "Банковская выписка (фото или PDF)",
 "Extrato importado": "Выписка импортирована",
 "Extrato por foto": "Выписка по фото",
 "FRASE": "СТАТУС",
 "FRÁGIL": "ХРУПКОЕ",
 "Fabricante ou estendida: {n} meses": "Производителя или расширенная: {n} мес.",
 "Facultativo": "Необязательный",
 "Falar com a limpeza": "Связаться с уборщиком",
 "Fale conosco": "Связаться с нами",
 "Falta": "Отсутствует",
 "Falta XML": "Нет XML",
 "Falta ligar o servidor de notas: no computador, dê dois cliques em 13-LIGAR-NOTAS.bat e cole aqui o endereço que ele mostrar.": "Сервер счетов не подключён: на компьютере дважды щёлкните 13-LIGAR-NOTAS.bat и вставьте сюда адрес, который он покажет.",
 "Falta o Health Connect, o app do Google que junta os dados dos relógios e apps de saúde.": "Нет Health Connect — приложения Google, которое собирает данные часов и приложений здоровья.",
 "Faltam": "Осталось",
 "Faltam {ml} ({n} copo(s))": "Осталось {ml} ({n} стак.)",
 "Faltam {n} dia(s) do seu período grátis": "Бесплатный период: осталось дней — {n}",
 "Faltam {n} dias": "Осталось {n} дн.",
 "Faltou": "Не пришёл",
 "Família": "Семья",
 "Fantasia": "Фэнтези",
 "Fatura": "Счёт по карте",
 "Fatura com vencimento em {d}.": "Счёт по карте со сроком оплаты {d}.",
 "Fatura de {mes}": "Счёт за {mes}",
 "Fatura de {mes}: vence {data}": "Счёт за {mes}: оплатить до {data}",
 "Fatura do cartão (foto ou PDF)": "Счёт по карте (фото или PDF)",
 "Fatura importada": "Счёт по карте импортирован",
 "Fatura paga (toque para desfazer)": "Счёт оплачен (нажмите, чтобы отменить)",
 "Fatura {c}": "Счёт {c}",
 "Faturamento em {ano}: {v} de {lim}": "Выручка за {ano}: {v} из {lim}",
 "Faturas dos cartões": "Счета по картам",
 "Fazer agora, passo a passo": "Выполнить сейчас, шаг за шагом",
 "Fazer com este PDF": "Что сделать с этим PDF",
 "Fazer cópia agora": "Создать копию сейчас",
 "Fecha dia {f} · vence dia {v}": "Закрытие {f}-го · оплата до {v}-го",
 "Fecha {f} · vence {v}": "Закрытие {f} · оплата {v}",
 "Fechar": "Закрыть",
 "Fechar o cofre": "Закрыть сейф",
 "Feche e abra o app de novo": "Закройте и снова откройте приложение",
 "Federais": "Федеральные",
 "Feijão": "Фасоль",
 "Feita em {data}": "Выполнено {data}",
 "Feita hoje": "Выполнено сегодня",
 "Feitas": "Выполнены",
 "Feitas (não se repetem) · {n}": "Выполненные (без повтора) · {n}",
 "Feito": "Сделано",
 "Feito!": "Готово!",
 "Feliz aniversário": "С днём рождения",
 "Feminino": "Женский",
 "Feminino e suave": "Женственная и нежная",
 "Feriado escolar": "Школьный выходной",
 "Feriado estadual": "Региональный праздник",
 "Feriado estadual: {nome}": "Праздник штата: {nome}",
 "Feriado municipal": "Городской праздник",
 "Feriado municipal: {nome}": "Муниципальный праздник: {nome}",
 "Feriado nacional": "Государственный праздник",
 "Feriado nacional: {nome}": "Государственный праздник: {nome}",
 "Feriado regional": "Региональный праздник",
 "Feriado regional: {nome}": "Региональный праздник: {nome}",
 "Feriados": "Праздники",
 "Feriados nacionais": "Государственные праздники",
 "Feriados no planner": "Праздники в планере",
 "Feriados, cotações, sugestões da inteligência artificial e leituras automáticas de boletos e notas podem ter erros. Confira antes de usar.": "Праздники, курсы валют, подсказки искусственного интеллекта и автоматическое распознавание квитанций и чеков могут содержать ошибки. Проверяйте перед использованием.",
 "Ferramenta": "Инструмент",
 "Ferramentas": "Инструменты",
 "Ficha de cada planta, replantio e calendário de rega e adubo na agenda.": "Карточка каждого растения, пересадка и календарь полива и подкормки в расписании.",
 "Ficha preenchida": "Карточка заполнена",
 "Fichários, matérias e páginas, cronômetro de estudo e metas por semana.": "Папки, предметы и страницы, таймер занятий и цели на неделю.",
 "Ficção": "Художественная литература",
 "Figurinha": "Стикер",
 "Figurinhas": "Стикеры",
 "Filme": "Фильм",
 "Filme ou série": "Фильм или сериал",
 "Filmes e séries": "Фильмы и сериалы",
 "Filosofia": "Философия",
 "Filtros": "Фильтры",
 "Fim": "Конец",
 "Fim (vazio = uso contínuo)": "Окончание (пусто = постоянный приём)",
 "Fim da garantia": "Окончание гарантии",
 "Fim da garantia:": "Окончание гарантии:",
 "Fim da pausa. Continue: {tarefa}": "Перерыв окончен. Продолжайте: {tarefa}",
 "Fim de semana": "Выходные",
 "Fim previsto": "Плановое окончание",
 "Fina": "Тонкая",
 "Finados": "День поминовения усопших",
 "Finalizador": "Несмываемое средство",
 "Financeiro": "Финансы",
 "Financeiro: {gasto} de {orcado} ({p}%)": "Финансы: {gasto} из {orcado} ({p}%)",
 "Financiamento": "Кредит",
 "Financiamento de veículo": "Автокредит",
 "Financiamento imobiliário": "Ипотека",
 "Financiamentos": "Займы",
 "Financiamentos e empréstimos": "Кредиты и займы",
 "Financiamentos e empréstimos com parcelas, juros, saldo devedor e comprovantes; objetos emprestados com foto e aviso da devolução.": "Кредиты и займы с платежами, процентами, остатком долга и подтверждениями; одолженные вещи с фото и напоминанием о возврате.",
 "Finanças": "Финансы",
 "Finanças {p}": "Финансы {p}",
 "Finanças · {p}": "Финансы · {p}",
 "Fins de semana": "Выходные",
 "Fio dental": "Зубная нить",
 "Flex": "Флекс",
 "Flexão de braço": "Отжимания",
 "Flor": "Цветок",
 "Flutua": "Парит",
 "Foguete": "Ракета",
 "Fogão": "Плита",
 "Foi no cartão de crédito? Lançar como compra no cartão": "Оплачено кредитной картой? Внести как покупку по карте",
 "Foi para {destino}.": "Отправлено: {destino}.",
 "Foi para {destino}. Quer tirar daqui?": "Отправлено: {destino}. Убрать отсюда?",
 "Folha de pagamento": "Зарплатная ведомость",
 "Fone": "Трубка",
 "Fone de ouvido": "Наушники",
 "Fontes: Brasil, calculado no app a partir da portaria federal de feriados e das leis de cada estado. Outros países: base pública Nager.Date (date.nager.at), baixada pela internet e guardada no aparelho.": "Источники: Бразилия — рассчитывается в приложении на основе федерального указа о праздниках и законов каждого штата. Другие страны: открытая база Nager.Date (date.nager.at), загружается из интернета и хранится на устройстве.",
 "Fontes: Brasil, calculado no app a partir da portaria federal de feriados, das leis de cada estado e dos calendários oficiais das capitais. Outros países: base pública Nager.Date (date.nager.at), baixada pela internet e guardada no dispositivo.": "Источники: для Бразилии — рассчитывается в приложении на основе федерального постановления о праздниках, законов каждого штата и официальных календарей столиц. Другие страны: открытая база Nager.Date (date.nager.at), загружаемая из интернета и сохраняемая на устройстве.",
 "Forma": "Способ",
 "Forma das parcelas": "Схема платежей",
 "Forma de pagamento": "Способ оплаты",
 "Forma de pagamento: {f}.": "Способ оплаты: {f}.",
 "Formas": "Фигуры",
 "Formato": "Формат",
 "Formatos": "Форматы",
 "Formatura": "Выпускной",
 "Fornecedor": "Подрядчик",
 "Fornecedores": "Подрядчики",
 "Forte": "Сильная",
 "Foto": "Фото",
 "Foto da galeria": "Фото из галереи",
 "Foto do contato": "Фото контакта",
 "Foto inteira": "Всё фото",
 "Foto ou PDF (lido pela sua IA)": "Фото или PDF (читает ваш ИИ)",
 "Fotografe cada cômodo na vistoria de saída e na de entrada. As fotos protegem você na hora de devolver o imóvel.": "Сфотографируйте каждую комнату при осмотре на выезде и на въезде. Фото защитят вас при сдаче жилья.",
 "Fotografe cada recibo de médico, dentista, escola e previdência assim que pagar. No fim do ano está tudo pronto.": "Фотографируйте каждую квитанцию от врача, стоматолога, школы и пенсионного фонда сразу после оплаты. К концу года всё будет готово.",
 "Fotos": "Фото",
 "Fotos JPG, PNG e outras viram um PDF.": "Фото JPG, PNG и другие превращаются в PDF.",
 "Fotos de {d}": "Фото за {d}",
 "Fotos do espaço pronto": "Фото готового объекта",
 "Fotos e arquivos desta ficha também vão para a pasta do grupo, para quem participa abrir.": "Фото и файлы этой записи также попадают в папку группы, чтобы участники могли их открыть.",
 "Fotos e arquivos ficam guardados só neste dispositivo. Os dados do documento vão para a sua conta, protegidos.": "Фото и файлы хранятся только на этом устройстве. Данные документа сохраняются в вашем аккаунте под защитой.",
 "Fotos e arquivos ficam neste dispositivo (e no seu Drive ou OneDrive, se estiver ligado em Ajustes).": "Фото и файлы хранятся на этом устройстве (и на вашем Drive или OneDrive, если подключено в Настройках).",
 "Fotos e notas": "Фото и заметки",
 "Fotos e vídeos": "Фото и видео",
 "Fotos, arquivos e links": "Фото, файлы и ссылки",
 "Fraldas e lenços": "Подгузники и салфетки",
 "Francês": "Французский",
 "Frango com osso": "Курица с костью",
 "Frango sem osso": "Курица без кости",
 "Frase (opcional, ex.: Bom dia!)": "Фраза (необязательно, напр.: Доброе утро!)",
 "Freelancer & Projetos": "Фриланс и проекты",
 "Freezer": "Морозилка",
 "Freios": "Тормоза",
 "Frente": "Лицевая",
 "Frente do documento": "Лицевая сторона документа",
 "Frente e verso na mesma folha": "Обе стороны на одном листе",
 "Frente pronta": "Лицевая сторона готова",
 "Frequência": "Частота",
 "Frio": "Холодно",
 "Fruta": "Фрукт",
 "Frágil": "Хрупкое",
 "Fundação e estrutura": "Фундамент и каркас",
 "Fundo": "Фон",
 "Fundos e renda fixa": "Фонды и облигации",
 "Fuso": "Пояс",
 "Fuso horário": "Часовой пояс",
 "Fuso horário do destino": "Часовой пояс места назначения",
 "Futebol": "Футбол",
 "Física": "Физика",
 "Físico (obra pronta): {p}%": "Готовность: {p}%",
 "GASTOS POR CATEGORIA": "РАСХОДЫ ПО КАТЕГОРИЯМ",
 "GIF guardado nos seus GIFs.": "GIF сохранён в ваши GIF.",
 "Garagem": "Гараж",
 "Garantia": "Гарантия",
 "Garantia até {data}.": "Гарантия до {data}.",
 "Garantia legal": "Гарантия по закону",
 "Garantia vencendo": "Гарантия истекает",
 "Garantias": "Гарантии",
 "Garrafa de água": "Бутылка для воды",
 "Gasolina": "Бензин",
 "Gasto": "Расход",
 "Gasto até agora": "Потрачено на сегодня",
 "Gasto de {v} lançado. {n} preço(s) guardado(s) para a sua lista de compras.": "Расход {v} внесён. Сохранено цен для списка покупок: {n}.",
 "Gasto neste mês: {v}": "Потрачено в этом месяце: {v}",
 "Gasto: {v}": "Потрачено: {v}",
 "Gastos": "Расходы",
 "Gastos por categoria": "Расходы по категориям",
 "Gato": "Кошка",
 "Geladeira": "Холодильник",
 "Geografia": "География",
 "Gerado por": "Создано программой",
 "Gerando QR Code...": "Создание QR-кода...",
 "Gerar PDF": "Создать PDF",
 "Gerar as cobranças do mês": "Создать счета за месяц",
 "Gerar as parcelas": "Создать платежи",
 "Gerar lista da mala": "Составить список вещей",
 "Gerar pelo cardápio e pela despensa": "Составить по меню и кладовой",
 "Gesso e forro": "Гипс и потолки",
 "Gira todas as páginas ou só as escolhidas.": "Поворачивает все страницы или только выбранные.",
 "Girar": "Повернуть",
 "Google Drive e OneDrive": "Google Drive и OneDrive",
 "Google Drive, OneDrive e agenda do Google: só se você conectar, e só para guardar os seus arquivos e eventos.": "Google Диск, OneDrive и Google Календарь: только если вы их подключите, и только для хранения ваших файлов и событий.",
 "Gorro, cachecol e luvas": "Шапка, шарф и перчатки",
 "Gota": "Капля",
 "Graduação e Pós": "Бакалавриат и магистратура",
 "Grande": "Большой",
 "Gravando": "Идёт запись",
 "Gravar lembretes e anotações por voz quando você pedir. O microfone só liga com o seu toque.": "Записывать напоминания и заметки голосом, когда вы попросите. Микрофон включается только по вашему нажатию.",
 "Gravar reunião": "Записать встречу",
 "Gravação de áudio": "Запись звука",
 "Gravações das reuniões": "Записи встреч",
 "Grossa": "Толстая",
 "Grupo": "Группа",
 "Grupo com convite (turma, equipe, convidados)": "Группа по приглашению (класс, команда, гости)",
 "Grupo criado": "Группа создана",
 "Grupo da família": "Семейная группа",
 "Grupo da mudança (família e ajudantes)": "Группа переезда (семья и помощники)",
 "Grupo da obra (equipe)": "Группа ремонта (бригада)",
 "Grupo da turma (convidar alunos)": "Группа класса (пригласить учеников)",
 "Grupo da viagem (convidar quem vai)": "Группа поездки (пригласить участников)",
 "Grupo de cuidado (família ou profissional)": "Группа ухода (семья или специалист)",
 "Grupo de estudos (convidar colegas)": "Учебная группа (пригласить однокурсников)",
 "Grupo de leitura (convidar)": "Читательская группа (пригласить)",
 "Grupo do cliente": "Группа клиента",
 "Grupo do evento (convidar)": "Группа мероприятия (пригласить)",
 "Grupos": "Группы",
 "Grupos de estudo": "Учебные группы",
 "Grupos de {aba}": "Группы: {aba}",
 "Grupos desta aba: {n}": "Группы этой вкладки: {n}",
 "Grupos e convites": "Группы и приглашения",
 "Grátis no lançamento": "Бесплатно на запуске",
 "Guarda-chuva": "Зонт",
 "Guardada nas suas figurinhas.": "Сохранено в ваши стикеры.",
 "Guardado": "Отложено",
 "Guardado até agora: {v}": "Отложено на сегодня: {v}",
 "Guardado em outro dispositivo": "Сохранено на другом устройстве",
 "Guardado na pasta \"{pasta}\" do celular.": "Сохранено в папке \"{pasta}\" на телефоне.",
 "Guardado no cofre, com criptografia de ponta a ponta.": "Хранится в сейфе со сквозным шифрованием.",
 "Guardado no {nome}.": "Сохранено в {nome}.",
 "Guardado {onde} em {quando}": "Сохранено {onde} {quando}",
 "Guardando...": "Сохранение...",
 "Guardar": "Отложить",
 "Guardar como recibo do IR": "Сохранить как квитанцию для IR",
 "Guardar dinheiro": "Отложить деньги",
 "Guardar e enviar": "Сохранить и отправить",
 "Guardar na meta": "Отложить на цель",
 "Guardar nas minhas figurinhas": "Сохранить в мои стикеры",
 "Guardar nos meus GIFs": "Сохранить в мои GIF",
 "Guardar o PDF {onde}": "Сохранить PDF {onde}",
 "Guardar os PDFs em": "Сохранять PDF в",
 "Guardar os arquivos prontos em": "Сохранять готовые файлы в",
 "Guardar sozinho cada arquivo pronto": "Автоматически сохранять каждый готовый файл",
 "Guarde as prescrições e orientações que você usa sempre. No atendimento, toque em ⋮ › Usar modelo.": "Сохраняйте назначения и рекомендации, которые используете постоянно. В приёме нажмите ⋮ › Использовать шаблон.",
 "Guarde seus documentos num lugar só": "Храните документы в одном месте",
 "Guarde {v} por mês até {d}": "Откладывайте {v} в месяц до {d}",
 "Guardou": "Отложено",
 "Guia de imposto": "Налоговая платёжка",
 "Gás": "Газ",
 "Gênero ou categoria": "Жанр или категория",
 "HISTÓRICO DOS DADOS": "ИСТОРИЯ ДАННЫХ",
 "HOJE": "СЕГОДНЯ",
 "Hall de entrada": "Прихожая",
 "Halteres": "Гантели",
 "Hexágono": "Шестиугольник",
 "Hidratante": "Увлажняющий крем",
 "Hidratante labial": "Бальзам для губ",
 "Hidráulica": "Сантехника",
 "Higiene bucal": "Уход за полостью рта",
 "Higienizar": "Очистить",
 "História": "История",
 "Histórico": "История",
 "Histórico da família, exames protegidos, vacinas, consultas e alarme dos remédios na linha do tempo.": "История болезней семьи, защищённые анализы, прививки, приёмы и будильник для лекарств в хронологии дня.",
 "Hmm...": "Хмм...",
 "Hoje": "Сегодня",
 "Hoje: {a} de {m} aulas ({p}%)": "Сегодня: {a} из {m} уроков ({p}%)",
 "Hoje: {n} página(s)": "Сегодня: {n} стр.",
 "Hora": "Время",
 "Hora da pausa": "Время перерыва",
 "Hora de voltar": "Пора возвращаться",
 "Hora de voltar!": "Пора возвращаться!",
 "Hora do check-in": "Время заезда",
 "Hora do check-out": "Время выезда",
 "Horas": "Часы",
 "Horas de sono": "Часы сна",
 "Horário": "Время",
 "Horário de check-in": "Время заезда",
 "Horário de check-out": "Время выезда",
 "Horário do lembrete": "Время напоминания",
 "Horário inválido": "Неверное время",
 "Horário ocupado": "Время занято",
 "Horários": "Время",
 "Horários (remédio diário)": "Время (ежедневное лекарство)",
 "Hospedados agora": "Сейчас проживают",
 "Hospedagem": "Проживание",
 "Hospital ou pronto-socorro de referência": "Ближайшая больница или травмпункт",
 "Hotel": "Отель",
 "Há uma versão nova do My Planner Web. Recarregue para usar.": "Доступна новая версия My Planner Web. Перезагрузите страницу.",
 "Híbrido": "Гибрид",
 "Hóspede": "Гость",
 "Hóspede ({c})": "Гость ({c})",
 "Hóspedes (máximo)": "Гостей (максимум)",
 "IA ligada": "ИИ подключён",
 "IA não ligada": "ИИ не подключён",
 "IA não ligada. Ligue em Ajustes › Inteligência artificial.": "ИИ не подключён. Подключите в Настройки › Искусственный интеллект.",
 "IPVA": "IPVA",
 "ISS": "ISS",
 "ISS %": "ISS %",
 "ISS retido pelo tomador": "ISS удержан заказчиком",
 "Ida": "Отправление",
 "Identidade": "Удостоверение",
 "Idioma": "Язык",
 "Idiomas": "Языки",
 "Ilimitados": "Без ограничений",
 "Imagem": "Изображение",
 "Imagem escolhida (trocar)": "Изображение выбрано (сменить)",
 "Imagem guardada no {nome}. Toque para abrir.": "Изображение сохранено в {nome}. Нажмите, чтобы открыть.",
 "Imagens para PDF": "Изображения в PDF",
 "Imagens {data}": "Изображения {data}",
 "Imperdíveis": "Обязательно",
 "Imperdível": "Обязательно посетить",
 "Importar": "Импорт",
 "Importar XML de nota": "Импорт XML счёта",
 "Importar arquivo": "Импортировать файл",
 "Importar backup?": "Импортировать резервную копию?",
 "Importar extrato": "Импорт выписки",
 "Importar extrato do banco (OFX ou CSV)": "Импорт банковской выписки (OFX или CSV)",
 "Importar fatura": "Импортировать счёт по карте",
 "Importar fotos": "Импорт фото",
 "Importar reservas do Airbnb, Booking...": "Импорт бронирований из Airbnb, Booking...",
 "Importar {n} lançamento(s)": "Импортировать записи: {n}",
 "Imóveis e espaços": "Объекты и помещения",
 "Imóvel": "Недвижимость",
 "Imóvel inteiro": "Весь объект",
 "Imóvel inteiro ou por cômodo: reservas do Airbnb, Booking ou direto, limpeza no check-out, despesas, ocupação e lucro do mês.": "Весь объект или по комнатам: бронирования из Airbnb, Booking или напрямую, уборка после выезда, расходы, загрузка и прибыль за месяц.",
 "Inclui {v} das notas fiscais emitidas na aba Notas Fiscais.": "Включает {v} из счетов-фактур, выставленных во вкладке «Счета-фактуры».",
 "Independência do Brasil": "День независимости Бразилии",
 "Indicação": "По рекомендации",
 "Indique e ganhe": "Пригласи и получи",
 "Indique o My Planner para amigos e família. Quem criar a conta com o seu código ganha 10 dias com todas as abas liberadas.": "Порекомендуйте My Planner друзьям и родным. Кто создаст аккаунт с вашим кодом, получит 10 дней со всеми открытыми вкладками.",
 "Infantil": "Детская",
 "Informações do PDF": "Сведения о PDF",
 "Informe a descrição e o valor.": "Укажите описание и сумму.",
 "Informe de quantos em quantos dias regar ou adubar.": "Укажите, раз в сколько дней поливать или подкармливать.",
 "Informe o nome do produto.": "Укажите название товара.",
 "Informe o rótulo e o nome.": "Укажите метку и имя.",
 "Informe o total de aulas da matéria em Editar.": "Укажите общее число уроков предмета в разделе «Изменить».",
 "Informe o valor.": "Укажите сумму.",
 "Informe os horários": "Укажите время",
 "Informe quanto quer juntar.": "Укажите, сколько хотите накопить.",
 "Informe seu nome.": "Укажите своё имя.",
 "Informática": "Информатика",
 "Inglês": "Английский",
 "Ingredientes (um por linha)": "Ингредиенты (по одному в строке)",
 "Inscrição municipal (se tiver)": "Муниципальный налоговый номер (если есть)",
 "Inspeção": "Техосмотр",
 "Instalar ou atualizar o Health Connect": "Установить или обновить Health Connect",
 "Instruções, receita, observações...": "Инструкции, рецепт, примечания...",
 "Insumos (papel, sabonete, café)": "Расходники (бумага, мыло, кофе)",
 "Inteligência artificial": "Искусственный интеллект",
 "Inteligência artificial (Claude, ChatGPT ou Gemini): só se você ligar, com a sua própria chave, que fica apenas no dispositivo. O texto da pergunta vai direto para o serviço escolhido.": "Искусственный интеллект (Claude, ChatGPT или Gemini): только если вы его включите, с вашим собственным ключом, который хранится только на устройстве. Текст вопроса отправляется напрямую в выбранный сервис.",
 "Intensidade": "Интенсивность",
 "Internação": "Госпитализация",
 "Internet": "Интернет",
 "Intimação": "Извещение",
 "Intimação com prazo": "Извещение со сроком",
 "Investimento": "Инвестиции",
 "Investimentos": "Инвестиции",
 "Início": "Начало",
 "Início {ini} · Fim {fim} · Duração {dur}": "Начало {ini} · Конец {fim} · Длительность {dur}",
 "Iogurte": "Йогурт",
 "Ir para Ajustes (exportar meus dados)": "В Настройки (экспорт моих данных)",
 "Ir para hoje": "К сегодняшнему дню",
 "Ir para o My Planner Web": "Перейти в My Planner Web",
 "Italiano": "Итальянский",
 "Item": "Пункт",
 "Item da despensa": "Продукт в кладовой",
 "Item protegido: fotos e arquivos ficam criptografados no cofre, só neste dispositivo (não vão para o Drive ou OneDrive).": "Защищённый элемент: фото и файлы шифруются в сейфе и хранятся только на этом устройстве (не попадают в Drive или OneDrive).",
 "Itens": "Вещи",
 "Itens de higiene (xampu, sabonete)": "Средства гигиены (шампунь, мыло)",
 "Jantar": "Ужин",
 "Japonês": "Японский",
 "Jaqueta impermeável": "Непромокаемая куртка",
 "Jogo": "Игра",
 "Jovem e divertido": "Молодёжная и весёлая",
 "Juntar PDFs": "Объединить PDF",
 "Juros": "Проценты",
 "Juros ainda por vir: {v}": "Ещё предстоит процентов: {v}",
 "Juros ao mês": "Ставка в месяц",
 "JÁ RESPONDIDOS": "УЖЕ ОТВЕЧЕНЫ",
 "Já aberta na casa nova": "Уже открыта в новом доме",
 "Já enviado para a turma": "Уже отправлено классу",
 "Já está compacto": "Уже компактный",
 "Já está no Planner": "Уже в Planner",
 "Já está pago": "Уже оплачено",
 "Já há horários deste item no My Planner": "Для этого элемента уже есть время в My Planner",
 "Já pago: {v}": "Уже оплачено: {v}",
 "Já tenho o app: abrir nele": "У меня есть приложение: открыть в нём",
 "Já tenho o app: abrir o convite nele": "У меня есть приложение: открыть приглашение в нём",
 "Já visitei": "Уже был(а)",
 "Kit de primeiros socorros": "Аптечка",
 "Kkkk": "Ахах",
 "Kkkkk": "Ахахах",
 "Km de hoje no painel": "Пробег сегодня по одометру",
 "Km no dia": "Пробег в этот день",
 "Km no painel": "Пробег по одометру",
 "LANÇAMENTOS": "ЗАПИСИ",
 "LINHA DO TEMPO": "ХРОНОЛОГИЯ ДНЯ",
 "Laboratório": "Лаборатория",
 "Lanche": "Перекус",
 "Lanche da manhã": "Второй завтрак",
 "Lanche da tarde": "Полдник",
 "Lanches e água": "Перекусы и вода",
 "Lançamentos": "Операции",
 "Lavanderia": "Прачечная",
 "Lavanderia, insumos, manutenção, contas e taxas. Entram no lucro do mês.": "Прачечная, расходники, обслуживание, счета и сборы. Учитываются в прибыли за месяц.",
 "Lavar o rosto com sabonete facial": "Умыться средством для лица",
 "Lazer": "Досуг",
 "Leg press": "Жим ногами",
 "Legenda": "Подпись",
 "Legislação Específica": "Специальное законодательство",
 "Legumes": "Овощи",
 "Leia hoje para começar uma sequência": "Почитайте сегодня, чтобы начать серию",
 "Leite": "Молоко",
 "Leitura": "Чтение",
 "Leitura automática do texto": "Автоматический разбор текста",
 "Leitura da IA": "Разбор ИИ",
 "Leitura, Cursos & Mídia": "Чтение, курсы и медиа",
 "Lembrete": "Напоминание",
 "Lembrete de hoje": "Напоминание на сегодня",
 "Lembrete de renovação no Planner": "Напоминание о продлении в Planner",
 "Lembrete no Planner": "Напоминание в Planner",
 "Lembrete no planner": "Напоминание в планере",
 "Lembrete pelo WhatsApp": "Напоминание в WhatsApp",
 "Lembrete: começa às {hora}": "Напоминание: начало в {hora}",
 "Lemos todas as mensagens. Se precisar, respondemos pelo seu e-mail.": "Мы читаем все сообщения. При необходимости ответим на ваш e-mail.",
 "Lendo": "Читаю",
 "Lendo a fatura...": "Читаем счёт по карте...",
 "Lendo a página": "Чтение страницы",
 "Lendo o boleto...": "Читаем boleto...",
 "Lendo o cupom...": "Читаем чек...",
 "Lendo o documento...": "Читаем документ...",
 "Lendo o extrato...": "Читаем выписку...",
 "Lendo o relógio...": "Чтение данных часов...",
 "Lendo o texto": "Читаем текст",
 "Ler a fatura": "Прочитать счёт по карте",
 "Ler a publicação inteira": "Читать публикацию полностью",
 "Ler com a minha IA": "Прочитать с моим ИИ",
 "Ler de novo": "Прочитать снова",
 "Ler de novo agora": "Прочитать снова",
 "Ler o texto": "Прочитать текст",
 "Ler o texto completo": "Прочитать полный текст",
 "Ler publicação inteira": "Читать публикацию полностью",
 "Ler sozinho as publicações novas": "Автоматически разбирать новые публикации",
 "Leve": "Лёгкая",
 "Leve (sem perder qualidade)": "Лёгкое (без потери качества)",
 "Li e aceito os termos e a política de privacidade": "Я прочитал(а) и принимаю условия и политику конфиденциальности",
 "Li mais {n} páginas": "Прочитал(а) ещё {n} стр.",
 "Liberada pelo suporte": "Открыто поддержкой",
 "Liberar para a equipe": "Открыть для команды",
 "Liberar para a turma em": "Открыть для класса",
 "Liberar para o grupo": "Открыть для группы",
 "Liberações e créditos são vinculados ao seu CPF. Atualiza ao sincronizar.": "Доступы и кредиты привязаны к вашему CPF. Обновляются при синхронизации.",
 "Libere a câmera para o My Planner nas configurações do celular para ler o QR Code.": "Разрешите My Planner доступ к камере в настройках телефона, чтобы сканировать QR-код.",
 "Libere a câmera para o My Planner nas configurações do celular.": "Разрешите My Planner доступ к камере в настройках телефона.",
 "Libere outras abas em Ajustes › Compras.": "Откройте другие вкладки в Настройки › Покупки.",
 "Licenciamento": "Регистрация ТС",
 "Lidas hoje": "Прочитано сегодня",
 "Lido": "Прочитано",
 "Ligando. Toque para atender.": "Входящий звонок. Нажмите, чтобы ответить.",
 "Ligar": "Позвонить",
 "Ligar certificado": "Подключить сертификат",
 "Ligar para a assistência": "Позвонить в сервис",
 "Ligar para {nome}": "Позвонить: {nome}",
 "Ligue a sua IA em Ajustes › Inteligência artificial (Claude, ChatGPT ou Gemini) para usar esta ferramenta.": "Подключите ИИ в разделе Настройки › Искусственный интеллект (Claude, ChatGPT или Gemini), чтобы пользоваться этим инструментом.",
 "Ligue a sua IA em Ajustes › Inteligência artificial para ler o texto, resumir e perguntar sobre o documento.": "Включите свой ИИ в разделе Настройки › Искусственный интеллект, чтобы читать текст, делать краткое содержание и задавать вопросы о документе.",
 "Ligue a sua IA em Ajustes › Inteligência artificial.": "Подключите свой ИИ в Настройки › Искусственный интеллект.",
 "Ligue o certificado A1 da empresa primeiro.": "Сначала подключите сертификат A1 компании.",
 "Ligue o seu Google Drive ou OneDrive para guardar fotos e arquivos (que passam a abrir em qualquer dispositivo) e para ter cópias de segurança completas.": "Подключите Google Drive или OneDrive, чтобы хранить там фото и файлы (они будут открываться на любом устройстве) и делать полные резервные копии.",
 "Ligue para o grupo trabalhar nos mesmos dados (obra, viagem, turma, imóvel, consultório), cada pessoa com o seu papel.": "Включите, чтобы группа работала с одними и теми же данными (стройка, поездка, класс, недвижимость, кабинет), каждый в своей роли.",
 "Ligue pelo menos 4 pontos.": "Соедините не менее 4 точек.",
 "Limite anual editável em Ajustes › Abas › Aba Finanças. Confira sempre com o seu contador.": "Годовой лимит меняется в Настройки › Вкладки › Вкладка Финансы. Всегда сверяйтесь со своим бухгалтером.",
 "Limite de consultas atingido. Tente de novo em 1 minuto.": "Достигнут лимит запросов. Повторите через 1 минуту.",
 "Limite de energia por dia": "Лимит энергии в день",
 "Limite de faturamento anual do MEI (confira o valor vigente com o seu contador).": "Годовой лимит выручки MEI (уточните действующую сумму у своего бухгалтера).",
 "Limite de mensagens por hoje atingido. Tente amanhã.": "Достигнут лимит сообщений на сегодня. Попробуйте завтра.",
 "Limite diário": "Дневной лимит",
 "Limite livre: {v} de {l}": "Свободный лимит: {v} из {l}",
 "Limite total (opcional)": "Общий лимит (необязательно)",
 "Limpar": "Очистить",
 "Limpar a agenda": "Очистить расписание",
 "Limpar banheiro": "Убрать ванную",
 "Limpar cozinha e louça": "Убрать кухню и помыть посуду",
 "Limpar feitos": "Убрать выполненные",
 "Limpeza": "Уборка",
 "Limpeza após {h}": "Уборка после {h}",
 "Limpeza final": "Финальная уборка",
 "Limpeza · {e}": "Уборка · {e}",
 "Limpeza: {e}": "Уборка: {e}",
 "Limpezas": "Уборки",
 "Linha do tempo, tarefas, energia e alertas.": "Хронология дня, задачи, энергия и напоминания.",
 "Link": "Ссылка",
 "Link (Drive, OneDrive, Dropbox)": "Ссылка (Drive, OneDrive, Dropbox)",
 "Link copiado. Cole onde quiser enviar.": "Ссылка скопирована. Вставьте её, куда нужно отправить.",
 "Link da aula ou reunião online (opcional)": "Ссылка на урок или онлайн-встречу (необязательно)",
 "Link da nota fiscal (Drive ou OneDrive)": "Ссылка на чек (Drive или OneDrive)",
 "Link da pasta no Drive ou OneDrive (opcional)": "Ссылка на папку в Drive или OneDrive (необязательно)",
 "Link da reserva": "Ссылка на бронирование",
 "Link da sala online (Meet, Zoom...)": "Ссылка на онлайн-комнату (Meet, Zoom...)",
 "Link de outro calendário (iCal)": "Ссылка на другой календарь (iCal)",
 "Link do calendário do Airbnb (iCal)": "Ссылка на календарь Airbnb (iCal)",
 "Link do calendário do Booking (iCal)": "Ссылка на календарь Booking (iCal)",
 "Link inválido": "Неверная ссылка",
 "Links de materiais (Drive, vídeos, PDFs), um por linha": "Ссылки на материалы (Drive, видео, PDF), по одной в строке",
 "Links: {n}": "Ссылки: {n}",
 "Lista": "Список",
 "Lista da mala": "Список вещей",
 "Lista de compras": "Список покупок",
 "Lista de exercícios": "Задания",
 "Lista rápida": "Быстрый список",
 "Listas rápidas e caixas que viram tarefa ou vão para outra aba.": "Быстрые списки и блоки, которые становятся задачами или отправляются в другую вкладку.",
 "Literatura": "Литература",
 "Litros": "Литры",
 "Livre": "Свободно",
 "Livro": "Книга",
 "Livros": "Книги",
 "Local": "Место",
 "Local ou endereço": "Место или адрес",
 "Local: {l}": "Место: {l}",
 "Localização (país e fuso horário)": "Местоположение (страна и часовой пояс)",
 "Logo, foto ou rubrica nas páginas.": "Логотип, фото или парафа на страницах.",
 "Loja (opcional)": "Магазин (необязательно)",
 "Lote": "Партия",
 "Lua": "Луна",
 "Lugar": "Место",
 "Lugar para visitar": "Место для посещения",
 "Lugares": "Места",
 "Luz": "Свет",
 "Luz indireta": "Рассеянный свет",
 "Luz, água, gás e internet": "Свет, вода, газ и интернет",
 "Lápis": "Карандаш",
 "Língua Portuguesa": "Португальский язык",
 "MAIS ADIANTE": "ПОЗЖЕ",
 "MAIS USADOS": "ЧАСТО ИСПОЛЬЗУЕМЫЕ",
 "ME ou EPP do Simples": "ME или EPP на Simples",
 "MEI": "MEI",
 "MEI: faturamento em {ano} de {v} (limite {l}).": "MEI: выручка за {ano} — {v} (лимит {l}).",
 "MEMBROS ({n})": "УЧАСТНИКИ ({n})",
 "METAS": "ЦЕЛИ",
 "MS": "MS",
 "Mais": "Ещё",
 "Mais abas": "Ещё вкладки",
 "Mais cidades entram nas próximas versões.": "Больше городов появится в следующих версиях.",
 "Mais emojis": "Больше эмодзи",
 "Mais ferramentas": "Другие инструменты",
 "Mais figurinhas animadas (KLIPY)": "Ещё анимированные стикеры (KLIPY)",
 "Mais opções desta aba chegam nas próximas versões.": "Больше параметров этой вкладки появится в следующих версиях.",
 "Mais uma": "Ещё одну",
 "Mala": "Багаж",
 "Mala ({clima}, {n} dias)": "Багаж ({clima}, дней: {n})",
 "Mamadeiras e leite": "Бутылочки и смесь",
 "Mandamos um código de 6 números no WhatsApp do número {tel}.": "Мы отправили 6-значный код в WhatsApp на номер {tel}.",
 "Mandar as orientações pelo WhatsApp": "Отправить рекомендации в WhatsApp",
 "Mandar de novo": "Отправить ещё раз",
 "Mandar e-mail": "Написать e-mail",
 "Mandar lembrete": "Отправить напоминание",
 "Mandar meu código": "Отправить мой код",
 "Mandar o acerto para o grupo": "Отправить расчёт в группу",
 "Mandar para quem limpa (WhatsApp)": "Отправить уборщику (WhatsApp)",
 "Mandarim": "Китайский (мандарин)",
 "Mande um e-mail pedindo a exclusão, com o CPF da conta. Respondemos em até 15 dias.": "Напишите письмо с просьбой удалить аккаунт и укажите номер документа. Ответим в течение 15 дней.",
 "Manter": "Оставить",
 "Manter ambas": "Оставить оба",
 "Manter ambos": "Оставить оба",
 "Manter aqui também": "Оставить и здесь",
 "Manter tarefas": "Оставить задачи",
 "Manutenção": "ТО",
 "Manutenções": "ТО и ремонт",
 "Mapas (Apple)": "Карты Apple",
 "Marca d'água": "Водяной знак",
 "Marca-texto": "Маркер",
 "Marcado": "Отмечено",
 "Marcado como feito hoje.": "Отмечено как выполненное сегодня.",
 "Marcar como concluída ({dia})": "Отметить выполненной ({dia})",
 "Marcar como devolvido": "Отметить как возвращённое",
 "Marcar como feita hoje": "Отметить выполненным сегодня",
 "Marcar como lido": "Отметить как прочитанное",
 "Marcar como paga": "Отметить как оплаченный",
 "Marcar como pago": "Отметить как оплаченный",
 "Marcar como quitado": "Отметить как погашенный",
 "Marcar como recebida": "Отметить как полученный",
 "Marcar como recebida?": "Отметить как полученный?",
 "Marcar como recebido": "Отметить как полученный",
 "Marcar como visto": "Отметить как просмотренное",
 "Marcar e avisar a equipe": "Назначить и уведомить команду",
 "Marcar esta conta como paga?": "Отметить этот счёт как оплаченный?",
 "Marcar fatura como paga": "Отметить счёт как оплаченный",
 "Marcar grupo": "Выбрать группу",
 "Marcar reunião": "Назначить встречу",
 "Marcenaria": "Столярные работы",
 "Margem": "Поля",
 "Marketing": "Маркетинг",
 "Marque as fotos do diário como Antes ou Depois para montar a galeria.": "Отмечайте фото в дневнике как «До» или «После», чтобы собрать галерею.",
 "Marque os dias em que você estuda e o horário de cada dia. Cada dia vira uma tarefa que se repete toda semana, ligada a este item.": "Отметьте дни, в которые вы занимаетесь, и время для каждого дня. Каждый день станет задачей, которая повторяется каждую неделю и связана с этим элементом.",
 "Marque um ou mais estados.": "Отметьте один или несколько штатов.",
 "Martelo": "Молоток",
 "Masculino": "Мужской",
 "Masculino e minimalista": "Мужественная и минималистичная",
 "Matemática": "Математика",
 "Materiais": "Материалы",
 "Material": "Материал",
 "Matrícula, placa, código ou CNPJ": "Номер, госномер, код или CNPJ",
 "Matéria ou material": "Предмет или материал",
 "Matéria ou módulo": "Предмет или модуль",
 "Matérias": "Предметы",
 "Meia-sombra": "Полутень",
 "Melhorando a imagem...": "Улучшаем изображение...",
 "Melhorias novas já foram baixadas. Leva só alguns segundos e seus dados continuam.": "Новые улучшения уже загружены. Это займёт пару секунд, ваши данные сохранятся.",
 "Membros": "Участники",
 "Menos de 1 minuto": "Меньше 1 минуты",
 "Mensagem": "Сообщение",
 "Mensagem apagada": "Сообщение удалено",
 "Mensagem enviada. Obrigado!": "Сообщение отправлено. Спасибо!",
 "Mensagem ou observações": "Сообщение или примечания",
 "Mensagens": "Сообщения",
 "Mensagens que você envia em Fale conosco.": "Сообщения, которые вы отправляете через «Связаться с нами».",
 "Mensagens: a sua lista de amigos, as conversas, as fotos e os arquivos enviados ficam guardados no servidor para chegar aos outros dispositivos. As chamadas de áudio e vídeo não são gravadas.": "Сообщения: ваш список друзей, чаты, отправленные фото и файлы хранятся на сервере, чтобы доходить до других устройств. Аудио- и видеозвонки не записываются.",
 "Mensalidade de {m}": "Плата за {m}",
 "Mensalidade ou valor por aluno": "Ежемесячная плата или сумма за ученика",
 "Mensalidades, aulas avulsas e materiais. Em ⋮ da turma, \"Gerar as cobranças do mês\" cria uma para cada aluno.": "Ежемесячная плата, разовые уроки и материалы. В ⋮ класса «Создать счета за месяц» создаёт счёт для каждого ученика.",
 "Mercado": "Продукты",
 "Mesa flexora": "Сгибание ног лёжа",
 "Mestre Achado": "Mestre Achado",
 "Mestre de obras": "Прораб",
 "Meta": "Цель",
 "Meta 100% batida": "Цель выполнена на 100%",
 "Meta atingida": "Цель достигнута",
 "Meta atingida!": "Цель достигнута!",
 "Meta da semana: {dur}": "Цель на неделю: {dur}",
 "Meta de aulas": "Цель по урокам",
 "Meta de aulas batida": "Цель по урокам выполнена",
 "Meta de copos por dia": "Цель: стаканов в день",
 "Meta de páginas por dia": "Цель: страниц в день",
 "Meta de páginas, progresso e resumos dos livros, filmes e séries para ver e aulas dos cursos.": "Цель по страницам, прогресс и заметки о книгах, фильмах и сериалах, а также уроки курсов.",
 "Meta diária": "Цель на день",
 "Meta por dia": "Цель на день",
 "Meta por semana:": "Цель на неделю:",
 "Meta {meta} · copo de {copo} · {n} copos": "Цель {meta} · стакан {copo} · {n} стак.",
 "Metas": "Цели",
 "Metodologia Científica": "Методология научных исследований",
 "Meu caderno": "Мой блокнот",
 "Meu cartão de contato": "Моя карточка контакта",
 "Meu plano": "Мой план",
 "Meus GIFs ({n})": "Мои GIF ({n})",
 "Meus PDFs": "Мои PDF",
 "Meus dados": "Мои данные",
 "Meus dados profissionais": "Мои профессиональные данные",
 "Microchip": "Микрочип",
 "Microfone": "Микрофон",
 "Microscópio": "Микроскоп",
 "Militares estaduais": "Военные суды штатов",
 "Minha Casa": "Мой дом",
 "Minha conta": "Мой аккаунт",
 "Minhas anotações do livro": "Мои заметки о книге",
 "Minhas figurinhas": "Мои стикеры",
 "Minutos": "Минуты",
 "Minutos de exercício": "Минуты тренировок",
 "Mirante": "Смотровая площадка",
 "Mirantes": "Смотровые площадки",
 "Modelo": "Модель",
 "Modelo de prescrição": "Шаблон назначения",
 "Modelos": "Шаблоны",
 "Modificado em": "Дата изменения",
 "Modo": "Режим",
 "Modo de preparo": "Способ приготовления",
 "Modo seguro: tarefas automáticas desligadas até abrir o app de novo": "Безопасный режим: автоматические задачи отключены до следующего запуска",
 "Moeda": "Валюта",
 "Moeda: {m}": "Валюта: {m}",
 "Moedas": "Монеты",
 "Momento do evento": "Момент мероприятия",
 "Monitor do Diário de Justiça Eletrônico (DJEN) por nome e OAB.": "Мониторинг Электронного судебного вестника (DJEN) по имени и номеру OAB.",
 "Monitor ou co-professor": "Ассистент или второй преподаватель",
 "Montando o PDF: página {n} de {total}...": "Создаём PDF: страница {n} из {total}...",
 "Montar a mala pelo clima ({n} dias)": "Собрать багаж по погоде ({n} дн.)",
 "Monte o cronograma alimentar para ver o relatório.": "Составьте план питания, чтобы увидеть отчёт.",
 "Monte o roteiro dia a dia. No período da viagem, ele aparece na linha do tempo do My Planner.": "Составьте маршрут по дням. Во время поездки он отображается в хронологии дня My Planner.",
 "Monte seu cronograma alimentar e seus cuidados abaixo. O que for de hoje aparece aqui para marcar.": "Составьте план питания и уход за собой ниже. То, что на сегодня, появится здесь, чтобы отметить.",
 "Monte seu cronograma alimentar, cuidados, treinos e suplementos abaixo. O que for de hoje aparece aqui para marcar.": "Составьте ниже план питания, уход, тренировки и добавки. Всё, что на сегодня, появится здесь для отметки.",
 "Monte seus treinos com atividades prontas: aparelhos da academia, exercícios em casa, caminhada, corrida, yoga, pilates...": "Составляйте тренировки из готовых упражнений: тренажёры, упражнения дома, ходьба, бег, йога, пилатес...",
 "Mostrando as 120 mais recentes.": "Показаны 120 последних.",
 "Mostrando só o roteiro. {n} tarefa(s) do dia escondida(s).": "Показан только маршрут. Скрыто задач дня: {n}.",
 "Mostrar datas, horários, moeda e feriados certos para onde você está. Não usamos o GPS.": "Показывать правильные даты, время, валюту и праздники для вашего местоположения. Мы не используем GPS.",
 "Mostrar menos": "Свернуть",
 "Mostrar só o roteiro durante a viagem": "Показывать только маршрут во время поездки",
 "Motivo do cancelamento": "Причина аннулирования",
 "Moto": "Мотоцикл",
 "Mover": "Перенести",
 "Mover para hoje": "Перенести на сегодня",
 "Mudança": "Переезд",
 "Mudança: {para}": "Переезд: {para}",
 "Mudanças": "Переезды",
 "Mudar e-mail": "Изменить e-mail",
 "Mudar o nome": "Переименовать",
 "Mudar senha": "Изменить пароль",
 "Mudo": "Без звука",
 "Muitas tentativas": "Слишком много попыток",
 "Muitas tentativas erradas. Tente de novo em {s} segundos.": "Слишком много неверных попыток. Повторите через {s} секунд.",
 "Muitas tentativas. Aguarde alguns minutos.": "Слишком много попыток. Подождите несколько минут.",
 "Muito bem: já guardou {v} este mês. Constância vale mais que valor alto.": "Отлично: в этом месяце вы уже отложили {v}. Регулярность важнее крупной суммы.",
 "Multa": "Штраф",
 "Multa e juros": "Пени и проценты",
 "Multa e juros de {v}": "Пени и проценты {v}",
 "Multa e juros estimados: {v}": "Примерные штраф и пени: {v}",
 "Multas e juros pagos": "Уплаченные пени и проценты",
 "Mundo": "Планета",
 "Municipal": "Муниципальный",
 "Município da prestação (IBGE), se for outro": "Муниципалитет оказания услуги (IBGE), если другой",
 "Município da prestação (código IBGE, 7 números)": "Муниципалитет оказания услуги (код IBGE, 7 цифр)",
 "Mural": "Доска объявлений",
 "Museu": "Музей",
 "Museus": "Музеи",
 "My Planner (vira tarefa)": "My Planner (станет задачей)",
 "My Planner bloqueado": "My Planner заблокирован",
 "Máxima": "Максимальная",
 "Média": "Средняя",
 "Média para aprovação": "Проходной балл",
 "Média · repouso {n}": "Средний · в покое {n}",
 "Médico": "Врач",
 "Médico ou clínica": "Врач или клиника",
 "Médio": "Средний",
 "Mês": "Месяц",
 "Mês a mês": "По месяцам",
 "Mês atual": "Текущий месяц",
 "Mês passado": "Прошлый месяц",
 "Móveis e enxoval": "Мебель и текстиль",
 "Móvel": "Мебель",
 "Música": "Музыка",
 "NAS ABAS": "ВО ВКЛАДКАХ",
 "NF-e: a SEFAZ pede 1 hora entre as buscas. Próxima a partir das {h}.": "NF-e: SEFAZ требует 1 час между поисками. Следующий — с {h}.",
 "NF-e: informe a UF da empresa para buscar as notas de produtos.": "NF-e: укажите штат (UF) компании, чтобы искать счета на товары.",
 "NFS-e emitida": "NFS-e выставлен",
 "NFS-e: {m}": "NFS-e: {m}",
 "Na (opcional):": "День недели (необяз.):",
 "Na agenda": "В расписании",
 "Na agenda em {data}": "В расписании на {data}",
 "Na barra": "На панели",
 "Na demonstração não há servidor de notas. Use o app com a sua conta.": "В демо-режиме нет сервера счетов. Используйте приложение со своим аккаунтом.",
 "Na hora": "Сразу",
 "Na hora da pausa aparece um aviso grande na tela, com contagem regressiva.": "Во время перерыва на экране появляется крупное уведомление с обратным отсчётом.",
 "Na linha do tempo, tocar no temporizador também abre esta página.": "В хронологии дня нажатие на таймер тоже открывает эту страницу.",
 "Na pasta \"{pasta}\" do celular. Cada arquivo pronto vai para lá.": "В папке \"{pasta}\" на телефоне. Каждый готовый файл попадает туда.",
 "Na pasta \"{pasta}\" do celular. Cada documento novo vai para lá quando você sai dele.": "В папке \"{pasta}\" на телефоне. Каждый новый документ попадает туда, когда вы из него выходите.",
 "Na prévia de demonstração não há chamadas de verdade.": "В демо-версии настоящих звонков нет.",
 "Na prévia de demonstração não há gravação de verdade.": "В демо-версии настоящей записи нет.",
 "Na prévia de demonstração os arquivos não abrem.": "В демо-версии файлы не открываются.",
 "Na versão das lojas, a compra será pela Google Play ou pela App Store. Por enquanto a chave simula a assinatura para testes.": "В версии из магазинов покупка будет через Google Play или App Store. Пока переключатель имитирует подписку для тестов.",
 "Na versão das lojas, este botão abre a compra da Google Play ou da App Store.": "В версии из магазинов эта кнопка открывает покупку в Google Play или App Store.",
 "Nacional": "Государственный",
 "Nada a gerar": "Нечего создавать",
 "Nada encontrado.": "Ничего не найдено.",
 "Nada entra na agenda de ninguém sem autorização: cada pessoa aceita, edita ou recusa.": "Ничего не попадает в чужое расписание без разрешения: каждый принимает, изменяет или отклоняет.",
 "Nada foi registrado.": "Ничего не записано.",
 "Nada lançado neste mês.": "В этом месяце записей нет.",
 "Nada no mês": "За месяц ничего",
 "Nada no roteiro deste dia.": "На этот день в маршруте ничего нет.",
 "Nada para apagar com esse filtro.": "По этому фильтру удалять нечего.",
 "Nada para comprar": "Покупать нечего",
 "Nada para enviar.": "Нечего отправлять.",
 "Nada planejado para este dia": "На этот день ничего не запланировано",
 "Nada planejado para hoje. Bom dia!": "На сегодня ничего не запланировано. Доброе утро!",
 "Nada por aqui.": "Здесь пока пусто.",
 "Nada recebido ainda.": "Пока ничего не получено.",
 "Nas conversas, cada pessoa vê o seu nome e o que você manda ali. Você pode apagar uma mensagem para todos, sair de um grupo ou bloquear alguém.": "В чатах каждый участник видит ваше имя и то, что вы туда отправляете. Вы можете удалить сообщение у всех, выйти из группы или заблокировать кого-либо.",
 "Nascimento": "Рождение",
 "Natal": "Рождество",
 "Natação": "Плавание",
 "Navegador conectado": "Браузер подключён",
 "Negrito": "Жирный",
 "Negócios": "Бизнес",
 "Nenhum": "Нет",
 "Nenhum XML neste período (ou foram guardados em outro dispositivo).": "Нет XML за этот период (или они сохранены на другом устройстве).",
 "Nenhum amigo para adicionar. Convide pelo WhatsApp ou adicione amigos no Mensagens (código do amigo).": "Некого добавить. Пригласите через WhatsApp или добавьте друзей в «Сообщениях» (код друга).",
 "Nenhum arquivo, imagem ou link nas páginas desta matéria.": "На страницах этого предмета нет файлов, изображений или ссылок.",
 "Nenhum arquivo.": "Нет файлов.",
 "Nenhum atendimento pago neste mês.": "В этом месяце нет оплаченных приёмов.",
 "Nenhum cartão": "Нет карточек",
 "Nenhum comprovante guardado ainda. Ao pagar uma conta, toque nela e anexe a foto, o PDF ou o print do comprovante.": "Сохранённых квитанций пока нет. Оплатив счёт, нажмите на него и прикрепите фото, PDF или скриншот квитанции.",
 "Nenhum cômodo ainda": "Комнат пока нет",
 "Nenhum dia": "Ни одного дня",
 "Nenhum documento ainda.": "Документов пока нет.",
 "Nenhum documento neste filtro.": "Нет документов в этом фильтре.",
 "Nenhum e-mail cadastrado": "E-mail не указан",
 "Nenhum erro registrado. Se o app fechar sozinho ou uma tela der problema, o erro aparece aqui para você mandar para a equipe.": "Ошибок нет. Если приложение закроется само или на экране возникнет проблема, ошибка появится здесь, и её можно будет отправить команде.",
 "Nenhum feriado neste ano.": "В этом году праздников нет.",
 "Nenhum fichário ainda": "Папок пока нет",
 "Nenhum grupo ainda.": "Групп пока нет.",
 "Nenhum item em {nome}": "В «{nome}» ничего нет",
 "Nenhum lançamento encontrado": "Записи не найдены",
 "Nenhum país encontrado.": "Страна не найдена.",
 "Nenhum selecionado": "Ничего не выбрано",
 "Nenhuma (plano gratuito)": "Нет (бесплатный план)",
 "Nenhuma aba encontrada.": "Вкладки не найдены.",
 "Nenhuma aba fixada além do My Planner.": "Кроме My Planner, закреплённых вкладок нет.",
 "Nenhuma aba liberada para receber": "Нет открытых вкладок для получения",
 "Nenhuma agenda encontrada": "Календари не найдены",
 "Nenhuma agenda para trazer": "Нет календарей для импорта",
 "Nenhuma audiência ou prazo encontrado nesta publicação.": "В этой публикации не найдено заседаний или сроков.",
 "Nenhuma caixa arquivada. Arraste uma caixa para a esquerda para arquivar.": "Нет блоков в архиве. Проведите блок влево, чтобы архивировать.",
 "Nenhuma compra encontrada": "Покупки не найдены",
 "Nenhuma compra nesta fatura.": "В этом счёте нет покупок.",
 "Nenhuma conta a pagar cadastrada.": "Счетов к оплате пока нет.",
 "Nenhuma conta a receber cadastrada.": "Счетов к получению пока нет.",
 "Nenhuma conta neste mês. Toque em + para cadastrar (aluguel, luz, cartão...).": "В этом месяце счетов нет. Нажмите +, чтобы добавить (аренда, свет, карта...).",
 "Nenhuma cópia de segurança ainda.": "Резервных копий пока нет.",
 "Nenhuma cópia encontrada.": "Копии не найдены.",
 "Nenhuma garantia ativa. Cadastre com o +.": "Нет активных гарантий. Добавьте через +.",
 "Nenhuma garantia vencida.": "Нет истёкших гарантий.",
 "Nenhuma mensagem ainda. Diga oi! 👋": "Сообщений пока нет. Поздоровайтесь! 👋",
 "Nenhuma nota neste período.": "Нет счетов за этот период.",
 "Nenhuma opção ainda.": "Вариантов пока нет.",
 "Nenhuma publicação nova.": "Новых публикаций нет.",
 "Nenhuma refeição neste dia.": "В этот день нет приёмов пищи.",
 "Nenhuma reunião marcada.": "Нет назначенных встреч.",
 "Nesse ritmo, termina em {d}": "В таком темпе закончите {d}",
 "Nesta fase de lançamento, todas as abas estão liberadas e grátis.": "На этапе запуска все вкладки открыты и бесплатны.",
 "Nesta fase de testes, a senha é redefinida pelo suporte. Escreva para {email} informando seu CPF ou e-mail.": "На этапе тестирования пароль сбрасывает поддержка. Напишите на {email}, указав свой CPF или e-mail.",
 "Nesta fase de testes, a senha é redefinida pelo suporte. Escreva para {email} informando seu CPF.": "На этапе тестирования пароль сбрасывает поддержка. Напишите на {email}, указав свой CPF.",
 "Neve": "Снег",
 "Ninguém deve nada a ninguém.": "Никто никому ничего не должен.",
 "Ninguém entrou ainda. Envie o convite.": "Пока никто не вступил. Отправьте приглашение.",
 "Ninguém usou o seu código ainda.": "Вашим кодом ещё никто не воспользовался.",
 "No Android, o app guarda só o atalho do arquivo escolhido: ele continua onde está (Drive, OneDrive, Downloads) e abre no app do celular. Nada é copiado. Esta opção vale para as fotos tiradas pela câmera.": "На Android приложение хранит только ярлык выбранного файла: он остаётся на месте (Drive, OneDrive, Загрузки) и открывается в приложении телефона. Ничего не копируется. Этот параметр действует для фото, снятых камерой.",
 "No Google Drive ou OneDrive: {n}": "В Google Drive или OneDrive: {n}",
 "No Google Drive, o app só enxerga os arquivos que ele mesmo criou na pasta My Planner. O uso das informações recebidas das APIs do Google segue a Política de Dados do Usuário dos Serviços de API do Google, inclusive as regras de Uso Limitado: nada é vendido, usado para publicidade ou lido por pessoas, salvo com a sua autorização ou por obrigação legal.": "В Google Drive приложение видит только файлы, которые само создало в папке My Planner. Информация, полученная через API Google, используется в соответствии с Правилами в отношении пользовательских данных для сервисов Google API, включая требования об ограниченном использовании: ничего не продаётся, не используется для рекламы и не читается людьми, кроме случаев, когда вы дали на это разрешение или этого требует закон.",
 "No app do seu relógio (Samsung Health, Garmin Connect, Mi Fitness, Zepp, Fitbit, Amazfit, Google Fit...), ligue a opção \"Health Connect\" ou \"Sincronizar com o Health Connect\".": "В приложении ваших часов (Samsung Health, Garmin Connect, Mi Fitness, Zepp, Fitbit, Amazfit, Google Fit...) включите параметр \"Health Connect\" или \"Синхронизация с Health Connect\".",
 "No app novo (versão 0.49), o celular acha as bordas da folha sozinho. Nesta versão, ajuste os 4 cantos com o dedo.": "В новом приложении (версия 0.49) телефон сам находит края листа. В этой версии подгоните 4 угла пальцем.",
 "No centro": "По центру",
 "No computador, abra {url}, toque no botão acima e aponte a câmera para o QR Code da tela.": "На компьютере откройте {url}, нажмите кнопку выше и наведите камеру на QR-код на экране.",
 "No dia (opcional):": "Число (необяз.):",
 "No iPhone, o app abre \"Salvar em Arquivos\" para você escolher a pasta (pode ser o iCloud Drive).": "На iPhone приложение открывает \"Сохранить в Файлы\", чтобы вы выбрали папку (можно iCloud Drive).",
 "No início": "В начале",
 "No modo seguro o app abre sem as tarefas automáticas (avisos, agenda do Google, publicações, mensagens e relógio). Os seus dados não mudam e tudo volta ao normal na próxima vez que abrir.": "В безопасном режиме приложение открывается без автоматических задач (уведомления, Google Календарь, публикации, сообщения и часы). Данные не меняются, и при следующем запуске всё вернётся к обычному режиму.",
 "No navegador, as páginas ficam só enquanto esta página estiver aberta.": "В браузере страницы хранятся, только пока эта страница открыта.",
 "No navegador, cole o link do arquivo do Drive, OneDrive ou Dropbox (em Estudos ou Documentos, opção Link). No celular, o botão de arquivo já mostra o Drive e o OneDrive.": "В браузере вставьте ссылку на файл из Drive, OneDrive или Dropbox (в разделе Учёба или Документы, вариант «Ссылка»). На телефоне кнопка файла уже показывает Drive и OneDrive.",
 "No navegador, o PDF é baixado para o computador.": "В браузере PDF скачивается на компьютер.",
 "No navegador, só dá para guardar imagens pequenas (até 200 KB). Para outros arquivos, adicione um link do Drive, OneDrive ou Dropbox, ou use o app no celular.": "В браузере можно сохранять только небольшие изображения (до 200 КБ). Для других файлов добавьте ссылку из Drive, OneDrive или Dropbox или используйте приложение на телефоне.",
 "No outro app, copie o link do arquivo (Compartilhar › Copiar link) e cole no bloco de link que ficou nesta página.": "В другом приложении скопируйте ссылку на файл (Поделиться › Копировать ссылку) и вставьте её в блок ссылки на этой странице.",
 "No ritmo atual, o ano fecha em {v}.": "При текущем темпе год закроется на {v}.",
 "No seu fuso: {hora}{dia}": "В вашем поясе: {hora}{dia}",
 "Nome": "Название",
 "Nome (cliente ou fornecedor)": "Имя (клиент или поставщик)",
 "Nome (ex.: 8º ano B, Pacientes da clínica, Aniversário da Ana)": "Название (напр.: 8 «Б», Пациенты клиники, День рождения Аны)",
 "Nome (ex.: Almoço)": "Название (напр.: Обед)",
 "Nome (ex.: Aluguel recebido, Cliente X)": "Название (напр.: Полученная аренда, Клиент X)",
 "Nome (ex.: Aluguel, Luz, Internet)": "Название (напр.: Аренда, Свет, Интернет)",
 "Nome (ex.: Doutorado UFPR)": "Название (напр.: Аспирантура UFPR)",
 "Nome (ex.: Nubank, Itaú Visa)": "Название (напр.: Nubank, Itaú Visa)",
 "Nome (ex.: Skincare da noite)": "Название (напр.: Вечерний уход за кожей)",
 "Nome (ex.: Treino A)": "Название (напр.: Тренировка А)",
 "Nome (ex.: Viagem de férias, Reserva de emergência)": "Название (напр.: Отпуск, Резервный фонд)",
 "Nome (ex.: Vitamina C)": "Название (напр.: Витамин C)",
 "Nome (opcional)": "Название (необязательно)",
 "Nome (opcional, ex.: CNH do Walter)": "Название (необязательно, напр.: CNH Вальтера)",
 "Nome (pode editar, ex.: \"Suco de uva\")": "Название (можно изменить, напр.: «Виноградный сок»)",
 "Nome completo": "Полное имя",
 "Nome curto": "Краткое имя",
 "Nome da lista": "Название списка",
 "Nome da matéria": "Название предмета",
 "Nome da obra": "Название объекта",
 "Nome da pasta (ex.: Recibos, Contratos)": "Название папки (например, Чеки, Договоры)",
 "Nome da tarefa": "Название задачи",
 "Nome da tarefa (ex.: Academia)": "Название задачи (напр.: Спортзал)",
 "Nome da tarefa (ex.: Limpar o banheiro)": "Название (напр.: Убрать ванную)",
 "Nome do PDF (opcional)": "Имя PDF (необязательно)",
 "Nome do conselho": "Название совета",
 "Nome do cômodo": "Название комнаты",
 "Nome do documento": "Название документа",
 "Nome do escritório (ex.: Ravasco Contabilidade)": "Название офиса (напр.: Ravasco Contabilidade)",
 "Nome do evento": "Название мероприятия",
 "Nome do grupo (ex.: Família)": "Название группы (напр.: Семья)",
 "Nome do modelo": "Название шаблона",
 "Nome ou modelo": "Название или модель",
 "Nome ou razão social": "Имя или название компании",
 "Nome, subtarefa ou anotação": "Название, подзадача или заметка",
 "Nos grupos, cada pessoa responde pelo que inclui. Quem administra o grupo decide quem participa.": "В группах каждый отвечает за то, что добавляет. Администратор группы решает, кто в ней участвует.",
 "Nossa Senhora Aparecida": "Богоматерь Апаресида",
 "Nossa Senhora da Luz dos Pinhais": "Nossa Senhora da Luz dos Pinhais",
 "Nota cancelada": "Счёт аннулирован",
 "Nota fiscal": "Счёт",
 "Nota fiscal emitida": "Счёт-фактура выставлен",
 "Nota fiscal, certificado de garantia e fotos": "Чек, гарантийный талон и фото",
 "Nota importada": "Счёт импортирован",
 "Notas": "Счета",
 "Notas Fiscais": "Счета-фактуры",
 "Notebook e carregador": "Ноутбук и зарядка",
 "Nova avaliação": "Новое оценивание",
 "Nova caixa (ex.: Compras, Ideias)": "Новый блок (напр.: Покупки, Идеи)",
 "Nova conversa": "Новый чат",
 "Nova garantia": "Новая гарантия",
 "Nova matéria": "Новый предмет",
 "Nova meta": "Новая цель",
 "Nova pasta": "Новая папка",
 "Nova página": "Новая страница",
 "Nova página com esta caixa": "Новая страница с этим блоком",
 "Nova refeição": "Новый приём пищи",
 "Nova tarefa": "Новая задача",
 "Nova tarefa da casa": "Новое дело по дому",
 "Nova tarefa neste cômodo": "Новая задача в этой комнате",
 "Novas": "Новые",
 "Novo": "Создать",
 "Novo alerta:": "Новое оповещение:",
 "Novo cartão": "Новая карта",
 "Novo cartão de crédito": "Новая кредитная карта",
 "Novo cuidado": "Новая процедура",
 "Novo documento": "Новый документ",
 "Novo e-mail": "Новый e-mail",
 "Novo fichário": "Новая папка",
 "Novo grupo": "Новая группа",
 "Novo item": "Новый пункт",
 "Novo perfil": "Новый профиль",
 "Novo suplemento": "Новая добавка",
 "Novo treino": "Новая тренировка",
 "Novo: {nome}": "Новое: {nome}",
 "Novos": "Новые",
 "Num período": "За период",
 "Numere cada caixa e diga o cômodo e o conteúdo. Use a busca para achar onde está cada coisa.": "Пронумеруйте каждую коробку и укажите комнату и содержимое. Используйте поиск, чтобы найти, где что лежит.",
 "Nº": "№",
 "Não": "Нет",
 "Não achei o total no cupom. Tente uma foto mais nítida.": "Не удалось найти итог в чеке. Попробуйте сделать фото чётче.",
 "Não consegue entrar?": "Не получается войти?",
 "Não consegui abrir \"{nome}\". Tente a ferramenta Reparar PDF.": "Не удалось открыть \"{nome}\". Попробуйте инструмент Восстановить PDF.",
 "Não consegui conectar a chamada. Confira a internet e tente de novo.": "Не удалось подключить звонок. Проверьте интернет и попробуйте снова.",
 "Não deu certo: {msg}": "Не получилось: {msg}",
 "Não deu para diminuir mais este PDF ({tam}).": "Не удалось уменьшить этот PDF ещё больше ({tam}).",
 "Não dá para tirar todas as páginas.": "Нельзя удалить все страницы.",
 "Não encontrei texto neste PDF.": "В этом PDF не найден текст.",
 "Não encontrei texto neste documento.": "В этом документе не найден текст.",
 "Não foi possível": "Не удалось",
 "Não foi possível abrir": "Не удалось открыть",
 "Não foi possível abrir o certificado guardado. Ligue o certificado de novo.": "Не удалось открыть сохранённый сертификат. Подключите сертификат заново.",
 "Não foi possível abrir.": "Не удалось открыть.",
 "Não foi possível baixar os feriados deste país. Confira a internet.": "Не удалось загрузить праздники этой страны. Проверьте интернет.",
 "Não foi possível conectar": "Не удалось подключиться",
 "Não foi possível conectar o {nome}": "Не удалось подключить {nome}",
 "Não foi possível consultar o DJEN agora.": "Сейчас не удаётся обратиться к DJEN.",
 "Não foi possível continuar": "Не удалось продолжить",
 "Não foi possível criar um evento na agenda: {msg}": "Не удалось создать событие в календаре: {msg}",
 "Não foi possível entrar.": "Не удалось войти.",
 "Não foi possível enviar": "Не удалось отправить",
 "Não foi possível enviar.": "Не удалось отправить.",
 "Não foi possível guardar: {erro}": "Не удалось сохранить: {erro}",
 "Não foi possível ler o arquivo.": "Не удалось прочитать файл.",
 "Não foi possível ler o calendário. Confira o link em Editar.": "Не удалось прочитать календарь. Проверьте ссылку в разделе «Изменить».",
 "Não foi possível procurar agora. Tenta de novo sozinho mais tarde.": "Сейчас не удаётся выполнить поиск. Повторим автоматически позже.",
 "Não foi possível reiniciar sozinho.": "Не удалось перезапустить автоматически.",
 "Não foi possível sincronizar com a agenda: {msg}": "Не удалось синхронизировать с календарём: {msg}",
 "Não foi possível trocar a foto": "Не удалось сменить фото",
 "Não há garantia de aviso com o app fechado. A verificação ocorre ao abrir o app (a cada 6 horas) ou em \"Verificar agora\".": "Уведомления при закрытом приложении не гарантируются. Проверка выполняется при открытии приложения (раз в 6 часов) или по кнопке «Проверить сейчас».",
 "Não identificado": "Не определён",
 "Não marcada como feita": "Не отмечено как выполненное",
 "Não optante pelo Simples": "Не на Simples",
 "Não se repete": "Не повторяется",
 "Não use o app para atividades ilegais, para guardar conteúdo de terceiros sem autorização ou para tentar acessar dados de outras pessoas.": "Не используйте приложение для незаконной деятельности, для хранения чужого контента без разрешения или для попыток получить доступ к данным других людей.",
 "Não vai": "Не придёт",
 "Não vence": "Бессрочно",
 "Não vendemos seus dados e não usamos o seu conteúdo para publicidade.": "Мы не продаём ваши данные и не используем ваш контент для рекламы.",
 "Não é possível adicionar esta pessoa.": "Невозможно добавить этого человека.",
 "Não é um XML de nota fiscal": "Это не XML счёта",
 "Número": "Номер",
 "Número (opcional)": "Номер (необязательно)",
 "Número da OAB": "Номер OAB",
 "Número da caixa": "Номер коробки",
 "Número da carteirinha": "Номер полиса",
 "Número da guia do convênio": "Номер направления страховой",
 "Número da parcela": "Номер платежа",
 "Número de hóspedes": "Количество гостей",
 "Número de parcelas": "Количество платежей",
 "Número do contrato": "Номер договора",
 "Número do registro": "Регистрационный номер",
 "Número na chamada": "Номер в журнале",
 "Número {n}. O XML ficou guardado na nota. Toque nela para ver o PDF.": "Номер {n}. XML сохранён в счёте. Нажмите на него, чтобы открыть PDF.",
 "Número, órgão emissor e observações ficam criptografados (AES-256) no aparelho antes de ir para a nuvem.": "Номер, орган выдачи и примечания шифруются (AES-256) на устройстве перед отправкой в облако.",
 "Número, órgão emissor, observações, fotos e PDFs ficam criptografados (AES-256) no dispositivo. Os arquivos protegidos ficam só neste dispositivo.": "Номер, орган выдачи, заметки, фото и PDF шифруются (AES-256) на устройстве. Защищённые файлы хранятся только на этом устройстве.",
 "Número: {n}": "Номер: {n}",
 "Números de página": "Номера страниц",
 "O ChatGPT não lê PDF por aqui. Tire uma foto ou um print da página, ou use o Claude ou o Gemini em Ajustes › Inteligência artificial.": "ChatGPT здесь не читает PDF. Сделайте фото или скриншот страницы либо используйте Claude или Gemini в Настройки › Искусственный интеллект.",
 "O DAS vence dia {dia}. Marque como pago em Finanças.": "Срок оплаты DAS — {dia}-е число. Отметьте оплату в разделе Финансы.",
 "O Escritório ainda não foi ligado no servidor. No computador, rode o 29-SERVIDOR-0.45.bat (uma vez só).": "Офис ещё не включён на сервере. На компьютере запустите 29-SERVIDOR-0.45.bat (один раз).",
 "O Mestre Achado cuida do seu dinheiro: contas, cartões e faturas, orçamento por categoria, metas, extrato e cupom pela foto, relatório e MEI.": "Mestre Achado следит за вашими деньгами: платежи, карты и счета по картам, бюджет по категориям, цели, выписка и чек по фото, отчёт и MEI.",
 "O Mestre está pensando...": "Mestre думает...",
 "O My Planner cria a pasta \"My Planner\" no seu Drive e só enxerga o que ele mesmo guardou lá.": "My Planner создаёт папку «My Planner» на вашем Drive и видит только то, что сам туда сохранил.",
 "O My Planner já abriu no computador, com os seus dados.": "My Planner уже открыт на компьютере с вашими данными.",
 "O My Planner lê os dados do relógio pelo {fonte}, onde o relógio e os apps de saúde e de exercício guardam tudo.": "My Planner читает данные часов через {fonte}, где часы и приложения здоровья и фитнеса хранят всё.",
 "O My Planner organiza a sua agenda, tarefas, finanças, documentos e outras áreas da vida. É oferecido por Walter Ravasco da Costa, que é o controlador dos dados pessoais tratados no app.": "My Planner помогает организовать расписание, задачи, финансы, документы и другие сферы жизни. Приложение предоставляет Walter Ravasco da Costa, который является оператором (контролёром) персональных данных, обрабатываемых в приложении.",
 "O My Planner usa só a pasta Aplicativos › My Planner do seu OneDrive.": "My Planner использует только папку Приложения › My Planner в вашем OneDrive.",
 "O PDF e as imagens saem deste dispositivo e da nuvem.": "PDF и изображения будут удалены с этого устройства и из облака.",
 "O PDF passou de 15 MB. Se o WhatsApp ou o e-mail recusar, ligue \"Arquivo menor\".": "PDF больше 15 МБ. Если WhatsApp или почта его не примут, включите \"Файл поменьше\".",
 "O QUE COMER": "ЧТО ЕСТЬ",
 "O QUE OS MEMBROS PODEM": "ЧТО МОГУТ УЧАСТНИКИ",
 "O QUE VOCÊ MANDA": "ЧТО ВЫ ОТПРАВЛЯЕТЕ",
 "O QUE VOCÊ RECEBE": "ЧТО ВЫ ПОЛУЧАЕТЕ",
 "O acesso continua sendo pelo CPF. O e-mail serve para o suporte falar com você.": "Вход по-прежнему по CPF. E-mail нужен, чтобы поддержка могла с вами связаться.",
 "O administrador do grupo poderá enviar compromissos, materiais e avisos. Nada entra na sua agenda sem você aceitar.": "Администратор группы сможет отправлять встречи, материалы и объявления. Ничего не попадёт в ваше расписание без вашего согласия.",
 "O alarme toca de novo a cada 2 minutos (até 4 vezes) enquanto o remédio não for marcado como tomado.": "Будильник звонит снова каждые 2 минуты (до 4 раз), пока лекарство не отмечено как принятое.",
 "O app ajuda a organizar, mas não substitui orientação de médicos, advogados, contadores ou outros profissionais. Confira prazos, valores e datas importantes.": "Приложение помогает навести порядок, но не заменяет консультации врачей, юристов, бухгалтеров и других специалистов. Проверяйте сроки, суммы и важные даты.",
 "O app avisa 3 dias antes e no dia do vencimento, às 9h.": "Приложение напомнит за 3 дня и в день оплаты, в 9:00.",
 "O app consulta o serviço público do CNJ (DJEN) com os nomes e a OAB que você cadastrar. Esses dados são enviados a esse serviço a cada verificação.": "Приложение обращается к публичному сервису CNJ (DJEN) с указанными вами именами и номером OAB. Эти данные передаются сервису при каждой проверке.",
 "O app e o servidor do My Planner consultam o serviço público do CNJ (DJEN) com os nomes e as OABs que você cadastrar e, se você marcar, o Querido Diário (diários oficiais municipais). Esses dados são enviados a esses serviços a cada verificação.": "Приложение и сервер My Planner обращаются к публичному сервису CNJ (DJEN) с именами и номерами OAB, которые вы добавите, и, если вы отметите, к Querido Diário (муниципальные официальные вестники). Эти данные отправляются в эти сервисы при каждой проверке.",
 "O app fechou sozinho {n} vezes seguidas": "Приложение само закрылось {n} раз подряд",
 "O app instalado neste aparelho é a versão {v}. Para fazer chamadas de áudio e vídeo, instale o app 0.35 ou mais novo (APK novo). As mensagens já funcionam.": "На этом устройстве установлена версия приложения {v}. Для аудио- и видеозвонков установите приложение 0.35 или новее (новый APK). Сообщения уже работают.",
 "O app não fechou e os seus dados continuam salvos. Tente de novo ou mande o relatório para a equipe corrigir.": "Приложение не закрылось, данные сохранены. Попробуйте ещё раз или отправьте отчёт, чтобы команда всё исправила.",
 "O app pede o desbloqueio ao abrir e ao voltar do segundo plano.": "Приложение запрашивает разблокировку при открытии и при возврате из фона.",
 "O app pede o desbloqueio ao abrir. Trocar de app ou de tela rapidinho não pede de novo; se o celular ficar travado ou o app ficar fora da tela por mais tempo que o prazo abaixo, pede.": "Приложение запрашивает разблокировку при открытии. Быстрое переключение между приложениями или экранами не требует повторной разблокировки; если телефон заблокирован или приложение остаётся вне экрана дольше указанного ниже времени — потребуется.",
 "O app só lê (passos, distância, calorias, exercício, batimentos e sono) e nunca altera os seus dados de saúde. Os totais de cada dia ficam na sua conta para aparecer também no site e no outro celular.": "Приложение только читает данные (шаги, расстояние, калории, тренировки, пульс и сон) и никогда не изменяет ваши данные о здоровье. Итоги каждого дня хранятся в вашем аккаунте, чтобы отображаться также на сайте и на другом телефоне.",
 "O app volta a pedir a senha para desbloquear.": "Приложение снова будет запрашивать пароль для разблокировки.",
 "O app é feito para maiores de 18 anos. Dados de crianças só podem ser registrados pelos pais ou responsáveis.": "Приложение предназначено для лиц старше 18 лет. Данные детей могут вносить только родители или законные представители.",
 "O arquivo ficou só neste dispositivo. Não foi possível guardar no {nome}: {erro}": "Файл остался только на этом устройстве. Не удалось сохранить в {nome}: {erro}",
 "O arquivo não está mais nesse lugar (foi apagado ou movido).": "Файла больше нет в этом месте (удалён или перемещён).",
 "O arquivo não está mais nesse lugar (foi apagado, movido ou o app dele tirou a permissão). Anexe de novo.": "Файла больше нет в этом месте (удалён, перемещён или его приложение отозвало доступ). Прикрепите заново.",
 "O arquivo passa de 15 MB.": "Файл больше 15 МБ.",
 "O arquivo passa de 15 MB. Ligue \"Arquivo menor\" e tente de novo.": "Файл больше 15 МБ. Включите \"Файл поменьше\" и попробуйте ещё раз.",
 "O arquivo passa de 25 MB.": "Файл больше 25 MB.",
 "O arquivo passa de 50 MB.": "Файл больше 50 МБ.",
 "O arquivo sai deste celular. As cópias que você salvou no Drive, OneDrive ou mandou para alguém continuam lá.": "Файл будет удалён с этого телефона. Копии, сохранённые в Drive, OneDrive или отправленные кому-то, останутся.",
 "O arquivo sai do escritório para todos.": "Файл будет удалён из офиса для всех.",
 "O aviso chega às 9h, e de novo no dia do vencimento.": "Напоминание придёт в 9:00 и ещё раз в день окончания срока.",
 "O banco ainda não foi preparado. Rode o arquivo supabase/schema.sql no Supabase.": "База данных ещё не подготовлена. Выполните файл supabase/schema.sql в Supabase.",
 "O cartão {c} está com {p}% do limite tomado. Evite parcelar coisa nova nele por enquanto.": "Карта {c} использована на {p}% лимита. Пока не оформляйте на ней новые рассрочки.",
 "O celular não avisa o app quando a tela é travada, por isso o app conta o tempo fora. Com 1 minuto, travar o celular e voltar depois pede a biometria; responder uma mensagem rápida, não.": "Телефон не сообщает приложению, когда экран блокируется, поэтому приложение считает время в фоне. При значении 1 минута блокировка телефона и возврат позже потребуют биометрию; быстрый ответ на сообщение — нет.",
 "O celular serve só para confirmar que a conta é sua (código pelo WhatsApp no cadastro e ao trocar de número). Um número por conta.": "Телефон нужен только для подтверждения, что аккаунт ваш (код в WhatsApp при регистрации и при смене номера). Один номер на аккаунт.",
 "O compartilhamento ainda não foi ligado no servidor. No computador, abra a pasta C:\\MyPlanner e dê dois cliques em 12-LIGAR-COMPARTILHAMENTO.bat (uma vez só).": "Общий доступ ещё не включён на сервере. На компьютере откройте папку C:\\MyPlanner и дважды щёлкните 12-LIGAR-COMPARTILHAMENTO.bat (только один раз).",
 "O computador vai abrir o My Planner com a sua conta. Faça isso só em computadores de confiança.": "Компьютер откроет My Planner с вашим аккаунтом. Делайте это только на доверенных компьютерах.",
 "O convite leva o link do app e do APK mais recente. Quem entra pelo link cai direto no escritório.": "Приглашение содержит ссылку на приложение и последний APK. Кто перейдёт по ссылке, сразу попадёт в офис.",
 "O código de indicação vale só nos primeiros 30 dias da conta.": "Код приглашения действует только в первые 30 дней после создания аккаунта.",
 "O desenho fica guardado só neste dispositivo, protegido. A senha continua valendo se você esquecer o desenho.": "Ключ хранится только на этом устройстве в защищённом виде. Если вы забудете ключ, пароль продолжит действовать.",
 "O dinheiro gasto está à frente do andamento da obra.": "Потраченные деньги опережают ход работ.",
 "O documento não tem páginas.": "В документе нет страниц.",
 "O extrato é lido aqui no aparelho. Contas a pagar com o mesmo valor e data próxima recebem baixa automática.": "Выписка обрабатывается прямо на устройстве. Счета к оплате с той же суммой и близкой датой автоматически отмечаются как оплаченные.",
 "O extrato é lido aqui no dispositivo. Contas a pagar com o mesmo valor e data próxima recebem baixa automática. O pagamento da fatura do cartão não conta duas vezes.": "Выписка читается здесь, на устройстве. Платежи к оплате с той же суммой и близкой датой закрываются автоматически. Оплата счёта по карте не учитывается дважды.",
 "O governo recusou a nota": "Налоговая служба отклонила счёт",
 "O governo recusou a nota.": "Налоговая служба отклонила счёт.",
 "O idioma vale para este dispositivo. Os dados que você digitou não são traduzidos.": "Язык применяется к этому устройству. Введённые вами данные не переводятся.",
 "O item vinculado foi apagado ou movido.": "Связанный элемент удалён или перемещён.",
 "O item vinculado foi apagado ou movido. Edite a tarefa para escolher outro.": "Связанный элемент удалён или перемещён. Измените задачу, чтобы выбрать другой.",
 "O link antigo deixa de funcionar.": "Старая ссылка перестанет работать.",
 "O link antigo deixa de funcionar. Quem já está no grupo continua.": "Старая ссылка перестанет работать. Те, кто уже в группе, останутся.",
 "O link deve começar com https://": "Ссылка должна начинаться с https://",
 "O navegador não deixa ler o calendário das plataformas. Importe pelo app no celular.": "Браузер не может читать календари платформ. Импортируйте через приложение на телефоне.",
 "O plano básico e os períodos de teste das abas seguem as regras mostradas em Ajustes > Compras. Benefícios de indicação valem uma vez por conta.": "Базовый тариф и пробные периоды вкладок подчиняются правилам, указанным в разделе Настройки > Покупки. Бонусы за приглашение предоставляются один раз на аккаунт.",
 "O que acontece": "Что происходит",
 "O que apagar": "Что удалить",
 "O que comprou": "Что купили",
 "O que fazer": "Что сделать",
 "O que foi comido:": "Что съедено:",
 "O que foi feito": "Что сделано",
 "O que foi visto": "Что пройдено",
 "O que funcionou, o que ajustar, metodologias, resumos...": "Что сработало, что поправить, методики, конспекты...",
 "O que já foi guardado continua nos lançamentos como investimento.": "То, что уже отложено, остаётся в операциях как инвестиция.",
 "O que levar ou estudar": "Что взять или выучить",
 "O que o app pode usar": "Что может использовать приложение",
 "O que o médico disse": "Что сказал врач",
 "O que os seus grupos enviaram. Compromissos aceitos vão para o My Planner; materiais e avisos vão para as Anotações.": "Что прислали ваши группы. Принятые встречи попадают в My Planner, материалы и объявления — в Заметки.",
 "O que precisa": "Что нужно",
 "O que tem dentro": "Что внутри",
 "O que você emprestou ou pegou emprestado: foto, com quem está e aviso da devolução.": "Что вы дали или взяли взаймы: фото, у кого вещь и напоминание о возврате.",
 "O que é apagado": "Что удаляется",
 "O quê": "Что",
 "O seletor mostra o Google Drive, o OneDrive e o Dropbox quando esses apps estão instalados no celular. O app guarda só o atalho: o arquivo continua onde está e abre no app do celular.": "Если на телефоне установлены Google Drive, OneDrive и Dropbox, выбор покажет их. Приложение хранит только ярлык: файл остаётся на месте и открывается в приложении телефона.",
 "O seletor mostra o Google Drive, o OneDrive e o Dropbox quando esses apps estão instalados no celular. O arquivo escolhido fica guardado neste dispositivo.": "В окне выбора отображаются Google Drive, OneDrive и Dropbox, если эти приложения установлены на телефоне. Выбранный файл сохраняется на этом устройстве.",
 "O servidor ainda não buscou para os seus perfis.": "Сервер ещё не выполнял поиск по вашим профилям.",
 "O servidor ainda não está preparado para as mensagens. Rode o 17-LIGAR-MENSAGENS.bat.": "Сервер ещё не готов к сообщениям. Запустите 17-LIGAR-MENSAGENS.bat.",
 "O servidor ainda não está preparado para indicações. Tente de novo mais tarde.": "Сервер пока не готов к приглашениям. Попробуйте позже.",
 "O servidor ainda não está preparado para o cartão de contato. Rode o 19-LIGAR-CONTATO.bat.": "Сервер ещё не готов к карточкам контактов. Запустите 19-LIGAR-CONTATO.bat.",
 "O servidor ainda não foi preparado para dados compartilhados. No computador, abra a pasta C:\\MyPlanner e dê dois cliques em 15-LIGAR-GRUPOS-COLABORATIVOS.bat (uma vez só).": "Сервер ещё не подготовлен для общих данных. На компьютере откройте папку C:\\MyPlanner и дважды щёлкните 15-LIGAR-GRUPOS-COLABORATIVOS.bat (только один раз).",
 "O servidor ainda não foi preparado para o Drive e o OneDrive (veja COMO RODAR, versão 0.14).": "Сервер ещё не подготовлен для Drive и OneDrive (см. COMO RODAR, версия 0.14).",
 "O servidor ainda não foi preparado para o acesso pela web (rode supabase/migracao-0.6.sql).": "Сервер ещё не подготовлен для веб-доступа (выполните supabase/migracao-0.6.sql).",
 "O servidor ainda não tem a função \"qr-login\". Veja o passo da versão 0.6 no COMO RODAR.": "На сервере ещё нет функции «qr-login». См. шаг версии 0.6 в COMO RODAR.",
 "O servidor de chamadas recusou a chave do LiveKit. No computador do administrador, rode o 30-CONSERTAR-CHAMADAS.bat.": "Сервер звонков отклонил ключ LiveKit. На компьютере администратора запустите 30-CONSERTAR-CHAMADAS.bat.",
 "O servidor de notas respondeu algo inesperado (HTTP {s}). Confira o endereço.": "Сервер счетов ответил неожиданно (HTTP {s}). Проверьте адрес.",
 "O servidor faz a captura automática de 2 em 2 horas, das 08h às 20h (horário de Brasília), mesmo com o app fechado. As publicações capturadas aparecem quando você abre o app. Também dá para usar \"Verificar agora\".": "Сервер автоматически собирает данные каждые 2 часа, с 08:00 до 20:00 (по времени Бразилиа), даже когда приложение закрыто. Собранные публикации появляются, когда вы открываете приложение. Можно также нажать «Проверить сейчас».",
 "O servidor faz a captura automática todos os dias às 08h e 12h (horário de Brasília), mesmo com o app fechado. As publicações capturadas aparecem quando você abre o app. Também dá para usar \"Verificar agora\".": "Сервер выполняет автосбор каждый день в 08:00 и 12:00 (по времени Бразилиа), даже когда приложение закрыто. Собранные публикации появятся, когда вы откроете приложение. Также можно использовать «Проверить сейчас».",
 "O servidor recusou o acesso: na função \"nuvem\" do Supabase, desligue \"Verify JWT\" (o 32-LIGAR-DRIVE-ONEDRIVE.bat já faz isso).": "Сервер отказал в доступе: в функции «nuvem» в Supabase отключите «Verify JWT» (32-LIGAR-DRIVE-ONEDRIVE.bat уже делает это).",
 "O servidor recusou o acesso: na função \"nuvem\" do Supabase, desligue \"Verify JWT\" (o 9-LIGAR-DRIVE-ONEDRIVE.bat já faz isso).": "Сервер отказал в доступе: в функции «nuvem» в Supabase отключите «Verify JWT» (9-LIGAR-DRIVE-ONEDRIVE.bat уже делает это).",
 "O seu papel no grupo não permite incluir aqui.": "Ваша роль в группе не позволяет добавлять здесь.",
 "O site deve começar com https://": "Адрес сайта должен начинаться с https://",
 "O tamanho padrão do copo ({copo}) muda em Ajustar, no quadro da água.": "Стандартный объём стакана ({copo}) меняется в разделе «Изменить» на карточке воды.",
 "O tema muda as cores das abas (os ícones continuam os mesmos) e vale nos modos claro e escuro. Depois você ainda pode trocar a cor de uma aba em Ajustes > Abas.": "Тема меняет цвета вкладок (значки остаются прежними) и действует в светлом и тёмном режимах. Потом вы всё равно сможете изменить цвет отдельной вкладки в разделе Настройки > Вкладки.",
 "O temporizador se enche de cor conforme o tempo da tarefa passa. Tocar nele abre o vínculo da tarefa.": "Таймер заполняется цветом по мере того, как идёт время задачи. Нажатие на него открывает связь задачи.",
 "O teste grátis terminou": "Бесплатный период закончился",
 "O texto": "Текст",
 "O texto do PDF num arquivo .docx para editar.": "Текст PDF в файле .docx для редактирования.",
 "O texto também vai escondido dentro do PDF: dá para buscar e copiar no leitor de PDF.": "Текст также скрыто встроен в PDF: его можно искать и копировать в программе для чтения PDF.",
 "O tom escolhido fica para os próximos emojis.": "Выбранный тон кожи сохранится для следующих эмодзи.",
 "O total aparece no topo do My Planner. Se passar do limite, o raio fica vermelho. Tarefas \"Relaxar\" valem 0.": "Итог отображается вверху My Planner. При превышении лимита молния становится красной. Задачи «Отдых» считаются как 0.",
 "OAB (opcional, para advogados)": "OAB (необязательно, для юристов)",
 "OBS": "ПРИМЕЧАНИЕ",
 "OCR: texto pesquisável": "OCR: текст с поиском",
 "OK": "OK",
 "OU ESCOLHER CÔMODO…": "ИЛИ ВЫБРАТЬ КОМНАТУ…",
 "Objetivos": "Цели",
 "Objeto": "Предмет",
 "Objetos": "Предметы",
 "Objetos e valores": "Вещи и деньги",
 "Obra": "Объект",
 "Obras": "Стройки",
 "Obras & Reformas": "Стройка и ремонт",
 "Obrigado": "Спасибо",
 "Obrigado!": "Спасибо!",
 "Observações": "Примечания",
 "Observações (alergias, ração...)": "Примечания (аллергии, корм...)",
 "Observações (chave Pix, conta para depósito...)": "Примечания (ключ Pix, счёт для перевода...)",
 "Observações (código de barras, chave Pix...)": "Примечания (штрихкод, ключ Pix...)",
 "Observações (dados bancários, PIX...)": "Примечания (банковские данные, PIX...)",
 "Observações (estado do item...)": "Примечания (состояние вещи...)",
 "Observações (garantia, seguro, CET...)": "Примечания (залог, страховка, ПСК...)",
 "Observações (nº de série, modelo...)": "Примечания (серийный номер, модель...)",
 "Observações (onde está o original, categoria da CNH...)": "Примечания (где оригинал, категория прав...)",
 "Observações (recibo de entrega, número...)": "Примечания (квитанция о доставке, номер...)",
 "Observações (restrição alimentar...)": "Примечания (ограничения в питании...)",
 "Ocultar texto (tarja)": "Скрыть текст (закраска)",
 "Ocupado": "Занято",
 "Oficina": "Автосервис",
 "Ofício": "Legal",
 "Oi!": "Привет!",
 "Oi! Tudo certo para sábado?": "Привет! На субботу всё в силе?",
 "Oi, {pessoa}! Ainda estou com o(a) {coisa} que você me emprestou. Quando fica bom para eu devolver?": "Привет, {pessoa}! У меня всё ещё {coisa}, которую ты мне одолжил(а). Когда удобно вернуть?",
 "Oi, {pessoa}! Tudo bem? Passando para lembrar do(a) {coisa} que te emprestei em {data}. Consegue devolver {quando}?": "Привет, {pessoa}! Как дела? Хочу напомнить про {coisa}, которую я одолжил(а) тебе {data}. Сможешь вернуть {quando}?",
 "Oi?!": "Что?!",
 "Olá!": "Привет!",
 "Olá! Eu sou o Mestre Achado. Pergunte sobre os seus gastos, contas, cartões e metas: eu respondo com os seus números.": "Здравствуйте! Я Mestre Achado. Спрашивайте о своих расходах, платежах, картах и целях: я отвечу на основе ваших цифр.",
 "Olá! Passando para lembrar do pagamento de {ref} ({v}), com vencimento em {d}. Obrigado(a)!": "Здравствуйте! Напоминаю об оплате {ref} ({v}) со сроком {d}. Спасибо!",
 "Olá! Preciso de assistência técnica para: {item}": "Здравствуйте! Мне нужен сервисный ремонт для: {item}",
 "Olá, {nome}!": "Привет, {nome}!",
 "Olá, {nome}! Seja bem-vindo(a).": "Здравствуйте, {nome}! Добро пожаловать.",
 "Ombros: girar para trás": "Плечи: вращения назад",
 "Omelete": "Омлет",
 "Onde": "Где",
 "Onde a IA ajuda: Publicações (audiências e prazos), Documentos (preencher a ficha pela foto) e Anotações (transformar uma caixa em tarefas).": "Где помогает ИИ: Публикации (заседания и сроки), Документы (заполнение карточки по фото) и Заметки (превращение блока в задачи).",
 "Onde assistir": "Где смотреть",
 "Onde eu mais gastei este mês?": "На что я больше всего потратил(а) в этом месяце?",
 "Onde fica": "Где находится",
 "Onde guardar fotos e arquivos novos": "Где хранить новые фото и файлы",
 "Onde na página": "Где на странице",
 "Ontem": "Вчера",
 "Organizar": "Упорядочить",
 "Organizar barra": "Настроить панель",
 "Organizar com IA": "Упорядочить с ИИ",
 "Organizar com IA (vira tarefas)": "Упорядочить с ИИ (в задачи)",
 "Organizar páginas": "Упорядочить страницы",
 "Orgulho e vibrante": "Гордость и яркость",
 "Origem": "Источник",
 "Origem da reserva": "Источник бронирования",
 "Original": "Оригинальная",
 "Orquídeas": "Орхидеи",
 "Orçado": "По смете",
 "Orçamento": "Бюджет",
 "Orçamento do mês": "Бюджет на месяц",
 "Orçamento por categoria": "Бюджет по категориям",
 "Orçamento total": "Общий бюджет",
 "Orçamento: {v}": "Бюджет: {v}",
 "Os alertas precisam de um horário.": "Для напоминаний нужно время.",
 "Os anexos que ficam só no dispositivo não aparecem nos outros dispositivos e se perdem se o celular for trocado. Ligue o Google Drive ou o OneDrive em Ajustes para guardar uma cópia.": "Вложения, хранящиеся только на устройстве, не видны на других устройствах и теряются при смене телефона. Подключите Google Drive или OneDrive в Настройках, чтобы хранить копию.",
 "Os arquivos e cópias que já estão lá continuam lá. O My Planner só deixa de guardar coisas novas.": "Файлы и копии, которые уже там, останутся. My Planner просто перестанет сохранять новое.",
 "Os arquivos guardados neste dispositivo também serão apagados.": "Файлы, сохранённые на этом устройстве, тоже будут удалены.",
 "Os arquivos que estão no seu Google Drive, OneDrive ou no celular continuam com você. Registros que a lei obriga a guardar (como os de acesso) podem ficar guardados pelo prazo legal e depois são apagados.": "Файлы в вашем Google Drive, OneDrive или на телефоне остаются у вас. Записи, которые закон обязывает хранить (например, журналы доступа), могут храниться установленный срок, а затем удаляются.",
 "Os avisos do grupo ainda não foram ligados no servidor. No computador, dê dois cliques em 15-LIGAR-GRUPOS-COLABORATIVOS.bat (uma vez só).": "Уведомления группы ещё не включены на сервере. На компьютере дважды щёлкните 15-LIGAR-GRUPOS-COLABORATIVOS.bat (только один раз).",
 "Os avisos estão desligados para o My Planner. Toque em Abrir configurações e ligue as notificações.": "Уведомления для My Planner выключены. Нажмите «Открыть настройки» и включите уведомления.",
 "Os avisos no celular funcionam no app instalado (Android ou iPhone).": "Уведомления на телефоне работают в установленном приложении (Android или iPhone).",
 "Os campos do formulário viram parte da página.": "Поля формы становятся частью страницы.",
 "Os dados atuais serão substituídos pelos do arquivo, aqui e na nuvem.": "Текущие данные будут заменены данными из файла — здесь и в облаке.",
 "Os dados continuam salvos na nuvem.": "Данные остаются сохранёнными в облаке.",
 "Os dados da aba ainda são só seus": "Данные вкладки пока видны только вам",
 "Os dados da aba {aba} passam a ser vistos pela equipe, cada pessoa conforme o papel que você escolher.": "Данные вкладки {aba} станут видны команде, каждому в соответствии с выбранной вами ролью.",
 "Os dados deste grupo ainda não foram liberados. Peça para quem criou o grupo abrir o My Planner atualizado: o app libera sozinho.": "Данные этой группы ещё не открыты. Попросите создателя группы открыть обновлённый My Planner: приложение откроет их само.",
 "Os dados deste grupo ainda não foram liberados. Peça para quem criou o grupo atualizar o My Planner e abrir o grupo: lá aparece o botão para liberar.": "Данные этой группы ещё не открыты. Попросите создателя группы обновить My Planner и открыть группу: там появится кнопка для открытия доступа.",
 "Os dados do cofre são criptografados aqui no dispositivo (AES-256) antes de ir para a nuvem. Nem o suporte consegue ler. Se esquecer a senha do cofre, esses dados não podem ser recuperados.": "Данные сейфа шифруются здесь, на устройстве (AES-256), перед отправкой в облако. Даже поддержка не может их прочитать. Если вы забудете пароль сейфа, эти данные восстановить нельзя.",
 "Os dados ficam guardados enquanto a conta existir. Ao apagar a conta, os dados são apagados, salvo o que a lei obrigar a manter.": "Данные хранятся, пока существует аккаунт. При удалении аккаунта данные удаляются, кроме тех, которые закон обязывает хранить.",
 "Os desenhos não conferem. Comece de novo.": "Ключи не совпадают. Начните заново.",
 "Os dias estão no app ou na fatura do banco. Compras feitas depois do fechamento caem na fatura seguinte.": "Даты есть в приложении или в счёте банка. Покупки после закрытия попадают в следующий счёт.",
 "Os emojis que você usar aparecem aqui.": "Здесь появятся эмодзи, которые вы используете.",
 "Os grupos ainda não foram ligados no servidor. No computador, abra a pasta C:\\MyPlanner e dê dois cliques em 11-LIGAR-GRUPOS.bat (uma vez só).": "Группы ещё не подключены на сервере. На компьютере откройте папку C:\\MyPlanner и дважды щёлкните 11-LIGAR-GRUPOS.bat (только один раз).",
 "Os grupos ainda não foram ligados no servidor. Rode o supabase\\migracao-0.21.sql no Supabase (veja o COMO RODAR).": "Группы ещё не подключены на сервере. Выполните supabase\\migracao-0.21.sql в Supabase (см. COMO RODAR).",
 "Os lugares abrem no Google Maps, no Waze ou no Mapas, como escolhido em Ajustes.": "Места открываются в Google Maps, Waze или Картах, как выбрано в Настройках.",
 "Os membros sempre veem os administradores e só recebem o que foi enviado para eles.": "Участники всегда видят администраторов и получают только то, что отправлено им.",
 "Os outros membros deixam de ver os dados (a cópia some do dispositivo deles). Tudo continua com você.": "Другие участники перестанут видеть данные (копия исчезнет с их устройств). Всё останется у вас.",
 "Os perfis e os resultados ficam na sua conta do My Planner.": "Профили и результаты хранятся в вашем аккаунте My Planner.",
 "Os perfis, as OABs e os tribunais ficam dentro da aba Publicações. A busca automática roda no servidor às 08h e às 12h (horário de Brasília).": "Профили, OAB и суды находятся во вкладке Публикации. Автоматический поиск выполняется на сервере в 08:00 и 12:00 (по времени Бразилиа).",
 "Os preços ficam guardados e aparecem na lista de Compras da aba Alimentação & Despensa como o preço da última compra.": "Цены сохраняются и показываются в списке покупок вкладки «Питание и кладовая» как цена последней покупки.",
 "Os resultados deste perfil também serão apagados.": "Результаты этого профиля тоже будут удалены.",
 "Os termos foram atualizados": "Условия обновлены",
 "Ou digite (ex.: 2 ovos mexidos)": "Или введите (напр.: 2 яйца, болтунья)",
 "Ou escreva o prato": "Или впишите блюдо",
 "Ou escreva o seu": "Или введите свой",
 "Outra": "Другое",
 "Outra aba…": "Другая вкладка…",
 "Outra atividade (digite e dê Enter)": "Другое упражнение (введите и нажмите Enter)",
 "Outro": "Другое",
 "Outro (ml)": "Другой (мл)",
 "Outro valor": "Другая сумма",
 "Outros": "Другое",
 "Outros países": "Другие страны",
 "Outros relógios (Garmin, Samsung, Xiaomi, Amazfit...): no app do relógio, ligue a opção de enviar os dados para o app Saúde (Apple Health).": "Другие часы (Garmin, Samsung, Xiaomi, Amazfit...): в приложении часов включите передачу данных в приложение «Здоровье» (Apple Здоровье).",
 "Ovo": "Яйцо",
 "PAGO, RECEBIDO, CONFIDENCIAL, APROVADO ou o seu texto, com a data.": "ОПЛАЧЕНО, ПОЛУЧЕНО, КОНФИДЕНЦИАЛЬНО, ОДОБРЕНО или ваш текст, с датой.",
 "PARA ACERTAR": "К РАСЧЁТУ",
 "PARA QUEM": "КОМУ",
 "PARA {refeicao}": "НА {refeicao}",
 "PASSO A PASSO": "ШАГ ЗА ШАГОМ",
 "PASSO {n}": "ШАГ {n}",
 "PDF": "PDF",
 "PDF Edit": "PDF Edit",
 "PDF com texto digital: sai na hora no navegador. PDF escaneado (foto): a sua IA lê cada página.": "PDF с цифровым текстом: сразу в браузере. Отсканированный PDF (фото): ваш ИИ читает каждую страницу.",
 "PDF grande": "Большой PDF",
 "PDF guardado na pasta \"{pasta}\" do celular.": "PDF сохранён в папке \"{pasta}\" на телефоне.",
 "PDF guardado no {nome}.": "PDF сохранён в {nome}.",
 "PDF numa página só": "PDF на одной странице",
 "PDF para Word": "PDF в Word",
 "PDF para imagens": "PDF в изображения",
 "PDF para texto": "PDF в текст",
 "PDFs arquivados ({n})": "Архивные PDF ({n})",
 "PDFs juntados {data}": "Объединённые PDF {data}",
 "PEDIDOS RECEBIDOS": "ВХОДЯЩИЕ ЗАПРОСЫ",
 "PIX": "PIX",
 "PIX COPIA E COLA": "PIX «КОПИРОВАТЬ И ВСТАВИТЬ»",
 "PRÓXIMAS FATURAS (JÁ COMPROMETIDO)": "БЛИЖАЙШИЕ СЧЕТА ПО КАРТАМ (УЖЕ ЗАНЯТО)",
 "Paciente": "Пациент",
 "Paciente ou aluno": "Пациент или ученик",
 "Pacientes": "Пациенты",
 "Padrão": "По умолчанию",
 "Padrão da aba": "Как у вкладки",
 "Paga": "Оплачен",
 "Paga (toque para desfazer)": "Оплачен (нажмите, чтобы отменить)",
 "Pagador": "Плательщик",
 "Pagamento já contado": "Платёж уже учтён",
 "Pagar": "Оплатить",
 "Pagar parcela {n}/{t} · {c}": "Оплатить платёж {n}/{t} · {c}",
 "Pagas": "Оплаченные",
 "Pago": "Оплачено",
 "Pago com": "Способ оплаты",
 "Pago: {p} · Falta pagar: {f}": "Оплачено: {p} · Осталось оплатить: {f}",
 "Pagos": "Оплаченные",
 "Pagou {v}? Se teve desconto, multa ou juros, informe o valor pago. Quer guardar o comprovante agora?": "Оплатили {v}? Если была скидка, пени или проценты, укажите уплаченную сумму. Сохранить квитанцию сейчас?",
 "Paguei outro valor (desconto, multa ou juros)": "Я заплатил(а) другую сумму (скидка, пени или проценты)",
 "Paixão de Cristo": "Страстная пятница",
 "Palavras-chave (separe com vírgula)": "Ключевые слова (через запятую)",
 "Para a meta \"{m}\" chegar no prazo, seriam {v} por mês. Vale esticar o prazo ou começar com um valor menor.": "Чтобы цель \"{m}\" была достигнута в срок, нужно {v} в месяц. Лучше продлить срок или начать с меньшей суммы.",
 "Para clareza, firmo o presente.": "В подтверждение чего подписываю настоящий документ.",
 "Para comprar": "Купить",
 "Para continuar, digite a senha do app.": "Чтобы продолжить, введите пароль приложения.",
 "Para conversar, ligue a sua IA em Ajustes › Inteligência artificial (Claude, ChatGPT ou Gemini).": "Чтобы поговорить, подключите свой ИИ в Настройки › Искусственный интеллект (Claude, ChatGPT или Gemini).",
 "Para dividir as despesas, escreva em \"Quem vai\" os nomes separados por vírgula (edite a viagem).": "Чтобы делить расходы, впишите в «Кто идёт» имена через запятую (измените поездку).",
 "Para emitir e buscar notas, ligue uma vez o servidor de notas: no computador, dê dois cliques em 13-LIGAR-NOTAS.bat e cole aqui o endereço que ele mostrar (termina em .netlify.app).": "Чтобы выставлять и искать счета, один раз подключите сервер счетов: на компьютере дважды щёлкните 13-LIGAR-NOTAS.bat и вставьте сюда адрес, который он покажет (заканчивается на .netlify.app).",
 "Para exercer seus direitos, use Fale conosco no app ou escreva para o e-mail abaixo. Respondemos em até 15 dias.": "Чтобы воспользоваться своими правами, напишите через «Связаться с нами» в приложении или на e-mail ниже. Мы ответим в течение 15 дней.",
 "Para fazer chamadas de áudio e vídeo, instale a versão nova do app (0.35). As mensagens já funcionam.": "Для аудио- и видеозвонков установите новую версию приложения (0.35). Сообщения уже работают.",
 "Para fazer o app funcionar: guardar e sincronizar seus dados entre dispositivos, mandar alertas, compartilhar com os grupos que você escolheu e dar suporte.": "Для работы приложения: хранить и синхронизировать ваши данные между устройствами, отправлять напоминания, делиться с выбранными вами группами и оказывать поддержку.",
 "Para guardar os PDFs no {nome}, conecte a sua conta em Ajustes › Google Drive e OneDrive.": "Чтобы сохранять PDF в {nome}, подключите аккаунт в разделе Настройки › Google Drive и OneDrive.",
 "Para hoje": "На сегодня",
 "Para ler foto ou PDF, ligue a sua IA em Ajustes › Inteligência artificial (Claude, ChatGPT ou Gemini). O extrato em OFX ou CSV funciona sem IA.": "Чтобы читать фото или PDF, подключите свой ИИ в Настройки › Искусственный интеллект (Claude, ChatGPT или Gemini). Выписка в OFX или CSV работает без ИИ.",
 "Para ler o relógio automaticamente, instale a versão nova do app (0.33). Enquanto isso, dá para digitar à mão.": "Чтобы читать данные часов автоматически, установите новую версию приложения (0.33). А пока можно вводить данные вручную.",
 "Para ler o relógio, conecte pelo app no celular. Os números aparecem aqui também.": "Чтобы читать данные часов, подключите их в приложении на телефоне. Цифры появятся и здесь.",
 "Para ler o relógio, libere os dados de atividade para o My Planner.": "Чтобы читать данные часов, разрешите My Planner доступ к данным об активности.",
 "Para ler o texto, resumir e perguntar, ligue a sua IA em Ajustes › Inteligência artificial (Claude, ChatGPT ou Gemini).": "Чтобы читать текст, делать краткое содержание и задавать вопросы, включите свой ИИ в разделе Настройки › Искусственный интеллект (Claude, ChatGPT или Gemini).",
 "Para ligar, use o app no celular (Ajustes > Agenda do Google). Depois, tudo aparece aqui também.": "Чтобы включить, используйте приложение на телефоне (Настройки > Google Календарь). После этого всё появится и здесь.",
 "Para ligar, use o app no celular (Ajustes › Configuração geral › Agenda do Google). Depois, tudo aparece aqui também.": "Чтобы включить, используйте приложение на телефоне (Настройки › Общие настройки › Google Календарь). После этого всё появится и здесь.",
 "Para monitorar a OAB, informe o número e a UF.": "Чтобы отслеживать OAB, укажите номер и штат.",
 "Para não perguntar mais, escolha o app em Ajustes › Configuração geral.": "Чтобы больше не спрашивать, выберите приложение в Настройки › Общие настройки.",
 "Para profissionais de saúde: pacientes, evolução no cofre, prescrições com modelos, financeiro, recibo e declaração para reembolso em PDF.": "Для медицинских специалистов: пациенты, динамика в сейфе, назначения по шаблонам, финансы, квитанция и справка для возмещения в PDF.",
 "Para profissionais de saúde: pacientes, evolução, prescrições com modelos, financeiro com convênio, recibo e declaração para reembolso.": "Для медицинских специалистов: пациенты, динамика, назначения по шаблонам, финансы со страховкой, квитанция и справка для возмещения.",
 "Para proteger a sua conta, confirmamos o seu celular uma vez, com um código pelo WhatsApp. Ele só é pedido de novo se você trocar de número.": "Чтобы защитить ваш аккаунт, мы один раз подтверждаем ваш телефон кодом в WhatsApp. Повторно он запрашивается, только если вы смените номер.",
 "Para quem aluga o imóvel ou um cômodo por temporada (Airbnb, Booking ou direto): reservas, limpeza, despesas e o lucro de cada mês.": "Для тех, кто сдаёт жильё или комнату посуточно (Airbnb, Booking или напрямую): бронирования, уборка, расходы и прибыль за каждый месяц.",
 "Para receber a agenda, o local e os avisos do evento no celular, entre no grupo: {link}": "Чтобы получать расписание, место и уведомления события на телефоне, вступите в группу: {link}",
 "Para sincronizar, libere o acesso à agenda para o My Planner nas configurações do celular.": "Для синхронизации разрешите My Planner доступ к календарю в настройках телефона.",
 "Para tirar uma permissão que você já deu ao sistema (câmera, fotos, microfone), use também os ajustes do celular.": "Чтобы отозвать разрешение, уже выданное системе (камера, фото, микрофон), воспользуйтесь также настройками телефона.",
 "Para uma leitura mais completa, ligue a sua IA em Ajustes › Inteligência artificial.": "Для более полного разбора подключите свой ИИ в Настройки › Искусственный интеллект.",
 "Parabéns": "Поздравляю",
 "Parabéns!": "Поздравляю!",
 "Parada": "Без движения",
 "Parar": "Остановить",
 "Parar de compartilhar?": "Прекратить общий доступ?",
 "Parar e salvar": "Остановить и сохранить",
 "Parar gravação": "Остановить запись",
 "Parcela": "Платёж",
 "Parcela de financiamento": "Платёж по займу",
 "Parcela {n}/{t}": "Платёж {n}/{t}",
 "Parcela {n}/{t} · {c}": "Платёж {n}/{t} · {c}",
 "Parcelas": "Платежи",
 "Parcelas a pagar nos próximos meses": "Платежи в ближайшие месяцы",
 "Parcelas recalculadas": "Платежи пересчитаны",
 "Parece que foi impresso e escaneado.": "Будто распечатали и отсканировали.",
 "Parei": "Бросил(а)",
 "Parei na aula": "Остановился на уроке",
 "Parei na aula...": "Остановился на уроке...",
 "Pares de meia": "Пары носков",
 "Parque ou natureza": "Парк или природа",
 "Parques": "Парки",
 "Parte": "Сторона",
 "Partes": "Стороны",
 "Participa": "Участник",
 "Participantes": "Участники",
 "Participação em empresa": "Доля в компании",
 "Passa do limite do MEI: fale com seu contador.": "Превышен лимит MEI: обратитесь к бухгалтеру.",
 "Passaporte": "Паспорт",
 "Passe o dedo sobre o desenho para apagar só aquele pedaço.": "Проведите пальцем по рисунку, чтобы стереть только эту часть.",
 "Passeio": "Экскурсия",
 "Passeios": "Экскурсии",
 "Passo a passo": "Шаг за шагом",
 "Passos": "Шаги",
 "Passos, exercício, calorias, batimentos e sono": "Шаги, тренировки, калории, пульс и сон",
 "Passou do orçamento": "Бюджет превышен",
 "Passou do orçamento em {v}": "Превышение бюджета на {v}",
 "Pasta": "Папка",
 "Patrimônio": "Имущество",
 "Patrimônio & Imposto de Renda": "Имущество и подоходный налог",
 "Patrimônio pelo valor de compra: {v}": "Имущество по цене покупки: {v}",
 "Pausa (s)": "Отдых (с)",
 "Pausa de {m} min": "Перерыв {m} мин",
 "Pausado": "На паузе",
 "Pausar": "Пауза",
 "Pausas": "Перерывы",
 "Pausas de estudo": "Перерывы в учёбе",
 "Pauta (opcional)": "Повестка (необязательно)",
 "Paz": "Мир",
 "Pediatra": "Педиатр",
 "Pedido": "Запрос",
 "Pedido enviado para {nome}. Quando aceitar, vocês já podem conversar.": "Запрос отправлен: {nome}. Когда он будет принят, вы сможете общаться.",
 "Pedido enviado. Quando a pessoa aceitar, vocês já podem conversar.": "Запрос отправлен. Когда его примут, вы сможете общаться.",
 "Pedidos de documentos": "Запросы документов",
 "Pedir de novo depois de": "Запрашивать снова через",
 "Peguei emprestado": "Я взял(а)",
 "Peito de frango": "Куриная грудка",
 "Peixe": "Рыба",
 "Pela última compra: cerca de {v}": "По последней покупке: около {v}",
 "Pelas contas que ainda vencem este mês, vão faltar {v}. Veja o que dá para adiar ou cortar antes de assumir gasto novo.": "С учётом платежей, которые ещё предстоят в этом месяце, не хватит {v}. Посмотрите, что можно отложить или сократить, прежде чем брать новые расходы.",
 "Pendente": "Ожидает ответа",
 "Pensão alimentícia": "Алименты",
 "Pequena": "Маленькая",
 "Pequeno": "Маленький",
 "Percentual de tributos do Simples (para sair na nota)": "Доля налогов Simples (для указания в счёте)",
 "Perguntar ao Mestre": "Спросить Mestre",
 "Perguntar sempre": "Всегда спрашивать",
 "Pergunte ao Mestre...": "Спросите Mestre...",
 "Pergunte sobre o documento (ex.: qual o prazo?)": "Спросите о документе (например: какой срок?)",
 "Permissões": "Разрешения",
 "Personalizado": "Настраиваемый",
 "Perto do limite do orçamento": "Почти достигнут лимит бюджета",
 "Período": "Период",
 "Período da meta": "Период цели",
 "Pescoço: inclinar para os lados": "Шея: наклоны в стороны",
 "Peso": "Вес",
 "Peso na média": "Вес в средней оценке",
 "Pesquisar no mapa": "Искать на карте",
 "Pessoa": "Физ. лицо",
 "Pessoa de contato": "Контактное лицо",
 "Pessoas dos seus grupos veem só o que for compartilhado no grupo.": "Участники ваших групп видят только то, чем поделились в группе.",
 "Pet": "Питомец",
 "Pet & Família": "Питомцы и семья",
 "Pet shop": "Зоомагазин",
 "Pet shop ou clínica": "Зоомагазин или клиника",
 "Pets": "Питомцы",
 "Peça documentos ao cliente com prazo. Ele recebe, anexa e marca como entregue.": "Запрашивайте у клиента документы со сроком. Он получает запрос, прикрепляет файл и отмечает как сданное.",
 "Pijamas": "Пижамы",
 "Pilates": "Пилатес",
 "Pintura": "Покраска",
 "Pix copia e cola": "Pix «копировать и вставить»",
 "Placa": "Госномер",
 "Planejado": "План",
 "Planejado e comido": "План и съеденное",
 "Planilha": "Таблица",
 "Planilha (Excel)": "Таблица (Excel)",
 "Planilha do mês para o Receita Saúde": "Таблица за месяц для Receita Saúde",
 "Planner": "Planner",
 "Plano básico: My Planner + Anotações": "Базовый план: My Planner + Заметки",
 "Plano de aula": "План урока",
 "Plano de saúde": "Медицинская страховка",
 "Planos de aula": "Планы уроков",
 "Planta": "Растение",
 "Plantas": "Растения",
 "Plantas & Jardim": "Растения и сад",
 "Plataforma ou escola": "Платформа или школа",
 "Pneus novos": "Новые шины",
 "Podcast": "Подкаст",
 "Pode confirmar sua presença respondendo esta mensagem?": "Подтвердите, пожалуйста, своё участие ответом на это сообщение.",
 "Polichinelo": "Джампинг джек",
 "Polo ativo": "Истец (активная сторона)",
 "Polo passivo": "Ответчик (пассивная сторона)",
 "Política de privacidade (LGPD)": "Политика конфиденциальности (LGPD)",
 "Política de privacidade, LGPD e permissões": "Политика конфиденциальности, LGPD и разрешения",
 "Política de privacidade, LGPD e termos": "Политика конфиденциальности, LGPD и условия",
 "Ponha aqui as fotos e os vídeos da viagem. No grupo, todos veem e todos podem pôr as suas.": "Добавляйте сюда фото и видео из поездки. В группе их видят все, и каждый может добавить свои.",
 "Ponte de glúteos": "Ягодичный мостик",
 "Ponto facultativo": "Необязательный выходной",
 "Ponto facultativo: {nome}": "Необязательный выходной: {nome}",
 "Ponto turístico": "Достопримечательность",
 "Pontos turísticos": "Достопримечательности",
 "Por dia": "В день",
 "Por faixas": "По диапазонам",
 "Por mês": "В месяц",
 "Por nome": "По названию",
 "Por semana": "В неделю",
 "Portal": "Портал",
 "Portal do Cliente": "Портал клиента",
 "Portal do cliente (convidar o cliente)": "Портал клиента (пригласить клиента)",
 "Português": "Португальский",
 "Porão": "Подвал",
 "Porções": "Порции",
 "Pouco espaço livre: fotos e anexos novos podem não ser salvos. Libere espaço ou guarde os anexos no Google Drive ou OneDrive.": "Мало свободного места: новые фото и вложения могут не сохраниться. Освободите место или храните вложения в Google Drive или OneDrive.",
 "Praia": "Пляж",
 "Prancha": "Планка",
 "Prato do cardápio": "Блюдо из меню",
 "Prato principal": "Основное блюдо",
 "Prazo": "Срок",
 "Prazo (pagamento ou entrega)": "Срок (оплата или сдача)",
 "Prazo até {fim} · fazer em {dia}": "Срок до {fim} · сделать {dia}",
 "Prazo final: {fim}": "Крайний срок: {fim}",
 "Prazo: {d}": "Срок: {d}",
 "Prazo: {t}": "Срок: {t}",
 "Prazos criados": "Сроки созданы",
 "Precisa da sua IA": "Нужен ваш ИИ",
 "Preencha a descrição, o código de tributação nacional (6 números) e o valor.": "Заполните описание, национальный налоговый код (6 цифр) и сумму.",
 "Preenche os campos do PDF e, se quiser, trava.": "Заполняет поля PDF и, если нужно, блокирует их.",
 "Preencher formulário": "Заполнить форму",
 "Preencher pela foto com a minha IA": "Заполнить по фото с моим ИИ",
 "Preencher pela nota fiscal com a minha IA": "Заполнить по чеку с помощью моего ИИ",
 "Preparando a conversa da equipe...": "Подготовка чата команды...",
 "Preparando a página {n} de {total}...": "Готовим страницу {n} из {total}...",
 "Preparando o arquivo": "Подготовка файла",
 "Prescrição, conduta e orientações": "Назначения, тактика и рекомендации",
 "Presente": "Присутствует",
 "Presença": "Посещаемость",
 "Pressione e segure o código para copiar, ou toque em Enviar e escolha \"Copiar\".": "Нажмите и удерживайте код, чтобы скопировать, или нажмите «Отправить» и выберите «Копировать».",
 "Pressione e segure o código para copiar.": "Нажмите и удерживайте код, чтобы скопировать.",
 "Pressione e segure um lançamento para apagar.": "Нажмите и удерживайте запись, чтобы удалить.",
 "Pressione e segure um perfil para removê-lo.": "Нажмите и удерживайте профиль, чтобы удалить его.",
 "Preto e branco": "Чёрно-белый",
 "Previdência privada": "Частная пенсия",
 "Preço ou ingresso": "Цена или билет",
 "Price": "Аннуитет (Price)",
 "Primeira": "Первая",
 "Primeira cota ou cota única do IR": "Первый взнос или единый платёж IR",
 "Primeira parcela na fatura de {mes}, que vence {data}.": "Первый платёж в счёте за {mes}, оплата до {data}.",
 "Prioridade": "Приоритет",
 "Privacidade": "Конфиденциальность",
 "Privacidade e termos": "Конфиденциальность и условия",
 "Privacidade: o texto ou a imagem analisada vai direto deste dispositivo para a empresa da IA escolhida, com a sua chave. O My Planner não guarda cópia.": "Конфиденциальность: анализируемый текст или изображение отправляется с этого устройства напрямую компании выбранного ИИ с вашим ключом. My Planner не хранит копию.",
 "Problema": "Проблема",
 "Problemas, erros e sugestões": "Проблемы, ошибки и предложения",
 "Procedimento": "Процедура",
 "Procedimento: {c}": "Процедура: {c}",
 "Processo": "Дело",
 "Processo Civil": "Гражданский процесс",
 "Processo Penal": "Уголовный процесс",
 "Processo do Trabalho": "Трудовой процесс",
 "Processo não informado": "Номер дела не указан",
 "Proclamação da República": "День провозглашения Республики",
 "Procurando a folha...": "Ищем лист...",
 "Procurando atualização...": "Поиск обновлений...",
 "Procurar aba": "Найти вкладку",
 "Procurar atualização agora": "Проверить обновления сейчас",
 "Procurar documento": "Найти документ",
 "Procurar ferramenta (ex.: juntar, assinar, comprimir)": "Найти инструмент (напр.: объединить, подписать, сжать)",
 "Produto": "Продукт",
 "Produto (ex.: Geladeira)": "Товар (напр.: Холодильник)",
 "Produtos, notas fiscais, assistência técnica e aviso antes de vencer.": "Товары, чеки, сервисные центры и напоминание до окончания срока.",
 "Produção (vale de verdade)": "Рабочая среда (действительно)",
 "Produção restrita (teste)": "Ограниченная среда (тест)",
 "Produção restrita (teste, não vale)": "Ограниченная среда (тест, недействительно)",
 "Produção restrita: ambiente de teste do governo. As notas não valem. Teste tudo aqui antes de mudar para Produção (em Editar).": "Ограниченная среда: тестовая среда правительства. Счета недействительны. Проверьте всё здесь, прежде чем переключиться на рабочую среду (в «Изменить»).",
 "Produção: as notas emitidas valem de verdade e vão para a prefeitura e a Receita.": "Рабочая среда: выставленные счета действительны и уходят в мэрию и Receita.",
 "Produção: vale de verdade": "Рабочая среда: действительно",
 "Professor": "Учитель",
 "Professor & Mentoria": "Учитель и менторинг",
 "Professor(a)": "Учитель",
 "Profissionais": "Мастера",
 "Profissional": "Мастер",
 "Profissional assistente": "Ассистент специалиста",
 "Profissional ou fornecedor": "Мастер или поставщик",
 "Profissional ou local": "Специалист или место",
 "Profissão ou especialidade": "Профессия или специализация",
 "Profissões": "Профессии",
 "Programação": "Программирование",
 "Progresso geral": "Общий прогресс",
 "Projeto e licenças": "Проект и разрешения",
 "Projetos": "Проекты",
 "Prontas": "Готовые",
 "Pronto": "Готово",
 "Pronto! Todas as abas estão liberadas até {data}.": "Готово! Все вкладки открыты до {data}.",
 "Pronto. Bloqueie a tela e espere 1 minuto: o aviso deve aparecer com som.": "Готово. Заблокируйте экран и подождите 1 минуту: оповещение должно появиться со звуком.",
 "Prontuário, evolução e prescrições, sem o financeiro.": "Медкарта, динамика и назначения, без финансов.",
 "Protegendo a chave...": "Защита ключа...",
 "Proteger no cofre": "Защитить в сейфе",
 "Protegido": "Защищён",
 "Protegido no cofre": "Защищено в сейфе",
 "Protegidos pelo cofre: {n}": "Защищено сейфом: {n}",
 "Protetor solar": "Солнцезащитный крем",
 "Protocolo": "Номер протокола",
 "Prova": "Контрольная",
 "Próxima": "Следующая",
 "Próxima até a data": "Следующее до даты",
 "Próxima com quantos km": "Следующее на пробеге",
 "Próxima dose": "Следующая доза",
 "Próxima: {data}": "Следующая: {data}",
 "Próxima: {d} · {v}": "Следующий: {d} · {v}",
 "Próximas": "Предстоящие",
 "Próximo": "Далее",
 "Próximo ano": "Следующий год",
 "Próximo número da DPS": "Следующий номер DPS",
 "Próximos 7 dias": "Следующие 7 дней",
 "Próximos vencimentos ({n})": "Ближайшие сроки ({n})",
 "Publicação": "Публикация",
 "Publicações": "Публикации",
 "Pula": "Прыгает",
 "Pulsa": "Пульсирует",
 "Punho": "Кулак",
 "Puxada frontal": "Тяга верхнего блока",
 "PÁGINAS": "СТРАНИЦЫ",
 "PÔR NA BARRA": "НА ПАНЕЛЬ",
 "Pág. {n}": "Стр. {n}",
 "Página": "Страница",
 "Página 1": "Страница 1",
 "Página 1 de 10": "Страница 1 из 10",
 "Página em branco no fim": "Пустая страница в конце",
 "Página em que estou": "Я на странице",
 "Página escaneada": "Страница отсканирована",
 "Página inteira": "Вся страница",
 "Página {a} de {n}": "Страница {a} из {n}",
 "Página {n}": "Страница {n}",
 "Página {n} de {total}": "Страница {n} из {total}",
 "Página: {titulo}": "Страница: {titulo}",
 "Páginas": "Страницы",
 "Páginas, tamanho, autor, datas e campos.": "Страницы, размер, автор, даты и поля.",
 "Pássaro": "Птица",
 "Pão francês": "Булочка (французская)",
 "Pão integral": "Цельнозерновой хлеб",
 "Pôr a data de hoje": "Поставить сегодняшнюю дату",
 "Pôr as parcelas no My Planner": "Добавить платежи в My Planner",
 "Pôr na barra": "На панель",
 "Pôr no roteiro da viagem": "Добавить в маршрут поездки",
 "Pôr uma foto": "Добавить фото",
 "Quadro": "Доска",
 "Quadro Kanban, cronômetro de horas por cliente e prazos no My Planner.": "Доска Kanban, таймер часов по клиентам и сроки в My Planner.",
 "Quais contas vencem nos próximos dias?": "Какие платежи предстоят в ближайшие дни?",
 "Quais páginas ficam no PDF novo": "Какие страницы войдут в новый PDF",
 "Quais páginas sair": "Какие страницы удалить",
 "Qual IA": "Какой ИИ",
 "Qualidade alta": "Высокое качество",
 "Qualidade boa (menor)": "Хорошее качество (меньше)",
 "Quantidade": "Количество",
 "Quanto cortar de cada lado (% da página)": "Сколько обрезать с каждой стороны (% страницы)",
 "Quanto já tem guardado (opcional)": "Сколько уже отложено (необязательно)",
 "Quanto paga por limpeza": "Оплата за уборку",
 "Quanto preciso guardar por mês para as minhas metas?": "Сколько нужно откладывать в месяц на мои цели?",
 "Quanto quer juntar": "Сколько хотите накопить",
 "Quanto você quer gastar, no máximo, em cada categoria por mês. Deixe em branco para não controlar.": "Сколько вы готовы потратить максимум в каждой категории за месяц. Оставьте пустым, чтобы не контролировать.",
 "Quarta": "Среда",
 "Quarta-feira de Cinzas (até 14h)": "Пепельная среда (до 14:00)",
 "Quarto": "Спальня",
 "Quarto das crianças": "Детская",
 "Quarto de casal": "Спальня",
 "Quarto de hóspedes": "Гостевая комната",
 "Quarto infantil": "Детская",
 "Queijo": "Сыр",
 "Queixa principal": "Основная жалоба",
 "Quem abrir o link baixa o My Planner (ou usa no navegador), entra na conta e passa a fazer parte do grupo.": "Кто откроет ссылку, скачает My Planner (или откроет в браузере), войдёт в аккаунт и станет участником группы.",
 "Quem criar a conta com o seu código já vira seu amigo aqui, sem precisar pedir.": "Тот, кто создаст аккаунт с вашим кодом, сразу станет вашим другом здесь, без запроса.",
 "Quem enviou": "Отправитель",
 "Quem está num grupo do app com você (turma, família, viagem...) já pode conversar sem ser amigo. Segure um amigo para desfazer a amizade ou bloquear.": "Те, кто состоит с вами в группе приложения (класс, семья, поездка...), могут общаться и без дружбы. Удерживайте друга, чтобы удалить его из друзей или заблокировать.",
 "Quem faz a limpeza": "Кто убирает",
 "Quem paga, se não for o paciente (mãe, pai, responsável)": "Кто платит, если не пациент (мать, отец, опекун)",
 "Quem pagou": "Кто заплатил",
 "Quem recebeu (médico, escola...)": "Получатель (врач, школа...)",
 "Quem vai": "Кто идёт",
 "Quem vai limpar": "Кто будет убирать",
 "Quem vê: só quem conversa com você, os seus amigos e quem está num grupo do app com você. Deixe em branco o que não quiser mostrar.": "Кто видит: только те, кто переписывается с вами, ваши друзья и те, кто состоит с вами в группе приложения. Оставьте пустым то, что не хотите показывать.",
 "Quente": "Жарко",
 "Quer escanear mais uma página?": "Отсканировать ещё одну страницу?",
 "Quer guardar o comprovante agora? Foto, PDF ou print do Pix.": "Сохранить квитанцию сейчас? Фото, PDF или скриншот Pix.",
 "Quer mandar um print da tela? Envie por e-mail e anexe a imagem.": "Хотите отправить скриншот? Отправьте письмо по e-mail и прикрепите изображение.",
 "Quer trocar pelos novos ou manter os dois?": "Заменить на новые или оставить оба?",
 "Quero assistir": "Хочу посмотреть",
 "Quero ir": "Хочу сходить",
 "Quero ler": "Хочу прочитать",
 "Quero ver": "Хочу посмотреть",
 "Quilometragem atual": "Текущий пробег",
 "Quilometragem: {km}": "Пробег: {km}",
 "Quinta": "Четверг",
 "Quintal": "Двор",
 "Quitado": "Погашен",
 "Quitados": "Погашенные",
 "Química": "Химия",
 "RECIBO": "КВИТАНЦИЯ",
 "RG / Carteira de identidade": "Удостоверение личности (RG)",
 "RG, CNH, passaporte, contratos e certidões, com aviso antes de vencer e envio com um toque.": "Удостоверение личности, водительское, паспорт, договоры и справки, с напоминанием до истечения срока и отправкой одним касанием.",
 "Raciocínio Lógico": "Логика",
 "Razão social ou nome": "Название компании или имя",
 "Razão social ou nome do consultório": "Название организации или кабинета",
 "Razão social ou nome fantasia": "Название компании или торговая марка",
 "Raça": "Порода",
 "Realizado": "Проведён",
 "Recado": "Сообщение",
 "Recalcular": "Пересчитать",
 "Recalcular as parcelas em aberto": "Пересчитать неоплаченные платежи",
 "Recalcular as parcelas?": "Пересчитать платежи?",
 "Receber": "Получить",
 "Receber de volta: {i} ({p})": "Получить обратно: {i} ({p})",
 "Receber o código no WhatsApp": "Получить код в WhatsApp",
 "Receber parcela {n}/{t} · {c}": "Получить платёж {n}/{t} · {c}",
 "Recebeu um convite?": "Получили приглашение?",
 "Recebeu um código?": "Получили код?",
 "Recebi de {pagador}{doc}, a quantia de {valor}{extenso}, referente a {tipo} realizado(a) em {data}{paciente}.": "Получено от {pagador}{doc} сумма {valor}{extenso} за: {tipo}, проведено {data}{paciente}.",
 "Recebi outro valor": "Я получил(а) другую сумму",
 "Recebida": "Получен",
 "Recebida (toque para desfazer)": "Получен (нажмите, чтобы отменить)",
 "Recebidas": "Полученные",
 "Recebido": "Получено",
 "Recebido: {v}": "Получено: {v}",
 "Recebidos": "Входящие",
 "Recebidos dos grupos": "Полученные из групп",
 "Recebimento": "Поступление",
 "Receita": "Рецепт",
 "Receitas": "Рецепты",
 "Recibo": "Квитанция",
 "Recibo em PDF": "Квитанция в PDF",
 "Recibo emitido": "Квитанция выдана",
 "Recibo guardado": "Квитанция сохранена",
 "Recibos dedutíveis": "Вычитаемые квитанции",
 "Recomendada": "Рекомендуемое",
 "Recomeçar": "Сбросить",
 "Recortar": "Обрезать",
 "Recortar margens": "Обрезать поля",
 "Recortar, girar e os filtros chegam com o app novo (versão 0.49).": "Обрезка, поворот и фильтры появятся в новом приложении (версия 0.49).",
 "Recusada": "Отклонено",
 "Recusado": "Отклонено",
 "Recusar": "Отклонить",
 "Redação": "Сочинение",
 "Refazer": "Переделать",
 "Refeição": "Приём пищи",
 "Refeições, exercícios, cuidados e suplementos marcados para hoje": "Приёмы пищи, упражнения, уход и добавки на сегодня",
 "Referente a": "Назначение",
 "Referência": "Справочное",
 "Reforço": "Ревакцинация",
 "Regar a cada quantos dias": "Поливать раз в сколько дней",
 "Regar hoje": "Полить сегодня",
 "Regar: {p}": "Полив: {p}",
 "Regional": "Региональный",
 "Registra o diário, as etapas e as entregas, sem ver os valores.": "Ведёт дневник, этапы и поставки, не видя сумм.",
 "Registrar venda/serviço do MEI": "Записать продажу/услугу MEI",
 "Registre cada atendimento: a evolução fica no cofre, com criptografia. A prescrição pode vir de um modelo.": "Записывайте каждый приём: динамика хранится в сейфе в зашифрованном виде. Назначение можно взять из шаблона.",
 "Registre compras e vendas de imóveis, veículos e investimentos com os comprovantes. Ajuda muito na hora do imposto.": "Записывайте покупки и продажи недвижимости, транспорта и инвестиций с подтверждающими документами. Это очень помогает при уплате налога.",
 "Registre o que foi diferente do cronograma (trocou um alimento, mudou a refeição). Entra no relatório da semana.": "Запишите, что отличалось от плана (заменили продукт, изменили приём пищи). Это попадёт в недельный отчёт.",
 "Registro": "Запись",
 "Registro clínico": "Медицинская запись",
 "Registro de horas": "Учёт часов",
 "Registro do diário": "Запись в дневнике",
 "Regiões com feriado próprio (marque as suas):": "Регионы со своими праздниками (отметьте свои):",
 "Regras da casa": "Правила дома",
 "Regras da casa:": "Правила дома:",
 "Reguei": "Полил(а)",
 "Reguei hoje": "Полил(а) сегодня",
 "Reiniciar": "Перезапустить",
 "Reiniciar o app": "Перезапустить приложение",
 "Relatório": "Отчёт",
 "Relatório da semana": "Отчёт за неделю",
 "Relatório em PDF ou Excel": "Отчёт в PDF или Excel",
 "Relatório enviado. Obrigado!": "Отчёт отправлен. Спасибо!",
 "Relatórios": "Отчёты",
 "Relatórios do Bem-Estar": "Отчёты: Здоровье",
 "Relatórios gerados ({n})": "Созданные отчёты ({n})",
 "Relaxar": "Отдых",
 "Religião": "Религия",
 "Relógio": "Часы",
 "Relógio e apps de saúde": "Часы и приложения здоровья",
 "Remada baixa": "Тяга нижнего блока",
 "Remover": "Удалить",
 "Remover \"{nome}\"?": "Удалить «{nome}»?",
 "Remover anotações": "Удалить аннотации",
 "Remover este bloco?": "Удалить этот блок?",
 "Remover páginas": "Удалить страницы",
 "Remover vínculo": "Удалить связь",
 "Remover {nome}?": "Удалить {nome}?",
 "Remédio": "Лекарство",
 "Remédio contínuo": "Постоянное лекарство",
 "Remédio na linha do tempo": "Лекарство в хронологии дня",
 "Remédios": "Лекарства",
 "Remédios de uso contínuo": "Постоянные лекарства",
 "Renavam ou chassi": "Renavam или VIN",
 "Renegociado": "Реструктуризирован",
 "Renomear": "Переименовать",
 "Renomear com IA": "Переименовать с ИИ",
 "Renomear ou trocar ícone": "Переименовать или сменить значок",
 "Renomear pasta": "Переименовать папку",
 "Renomear, ícone ou cor": "Название, значок или цвет",
 "Renovar: {nome}": "Продлить: {nome}",
 "Reorganiza o arquivo por dentro. Ajuda pouco em PDFs com fotos.": "Перестраивает файл изнутри. Мало помогает для PDF с фото.",
 "Reparar PDF": "Восстановить PDF",
 "Repelente": "Репеллент",
 "Repete": "Повтор",
 "Repetir a cada quantos dias": "Повторять раз в сколько дней",
 "Repetições": "Повторы",
 "Repita a senha": "Повторите пароль",
 "Repita a senha do cofre": "Повторите пароль сейфа",
 "Repita a senha nova": "Повторите новый пароль",
 "Replantio": "Пересадка",
 "Replantios": "Пересадки",
 "Repor papel higiênico, sabonete e café": "Пополнить туалетную бумагу, мыло и кофе",
 "Representatividade": "Представленность",
 "Reserva": "Бронирование",
 "Reservas": "Бронирования",
 "Reservas, limpeza, receitas e despesas na aba Aluguel & Hospedagem": "Бронирования, уборка, доходы и расходы во вкладке «Аренда и размещение»",
 "Respirar fundo 5 vezes": "Сделать 5 глубоких вдохов",
 "Respondendo a {nome}": "Ответ для {nome}",
 "Responder": "Ответить",
 "Responsável": "Ответственный",
 "Responsável (imobiliária, vistoriador)": "Ответственный (агентство, инспектор)",
 "Resposta da SEFAZ": "Ответ SEFAZ",
 "Resta {tempo}": "Осталось {tempo}",
 "Restam {ml} = {n} copo(s) de {copo}": "Осталось {ml} = {n} стакан(ов) по {copo}",
 "Restaurante": "Ресторан",
 "Restaurantes": "Рестораны",
 "Restaurar": "Восстановить",
 "Restaurar esta cópia?": "Восстановить эту копию?",
 "Restaurar troca TODOS os dados atuais pelos da cópia, aqui e na sua conta.": "Восстановление заменит ВСЕ текущие данные данными из копии, здесь и в вашем аккаунте.",
 "Restaurar uma cópia": "Восстановить копию",
 "Resultado": "Результат",
 "Resultado nas vendas: {v}": "Итог по продажам: {v}",
 "Resumir": "Кратко",
 "Resumir e perguntar": "Пересказ и вопросы",
 "Resumo": "Сводка",
 "Resumo (falta o XML completo)": "Сводка (нет полного XML)",
 "Resumo da manhã": "Утренняя сводка",
 "Resumo da pasta": "Сводка по папке",
 "Resumo e opinião": "Краткое содержание и мнение",
 "Resumo, gastos por categoria, contas, faturas, metas e todos os lançamentos. Bom para mandar ao contador ou guardar para o IR.": "Сводка, расходы по категориям, платежи, счета по картам, цели и все операции. Удобно отправить бухгалтеру или сохранить для IR.",
 "Retirar": "Снять",
 "Retirar da meta": "Снять с цели",
 "Retorno": "Повторный приём",
 "Reunião": "Собрание",
 "Reunião agora": "Встреча сейчас",
 "Reunião de equipe": "Встреча команды",
 "Reuniões": "Встречи",
 "Revestimento e pisos": "Облицовка и полы",
 "Revisão": "ТО",
 "Revolução Constitucionalista": "Конституционалистская революция",
 "Rico em matéria orgânica": "Богатый органикой",
 "Rodízio de pneus": "Перестановка шин",
 "Roedor": "Грызун",
 "Romance": "Роман",
 "Rosca direta": "Подъём штанги на бицепс",
 "Rota": "Маршрут",
 "Rota passando pelos {n} lugares que faltam": "Маршрут через {n} оставшихся мест",
 "Rotas e mapas": "Маршруты и карты",
 "Roteiro": "Маршрут",
 "Roteiro por dia que entra na linha do tempo durante a viagem, mala pelo clima, reservas e fusos.": "Маршрут по дням в хронологии дня во время поездки, багаж по погоде, бронирования и часовые пояса.",
 "Rotina": "Распорядок",
 "Rotinas com passo a passo: skincare, alongamento, cabelo... Toque em \"+ Cuidado\" para escolher um modelo ou criar o seu.": "Пошаговые процедуры: уход за кожей, растяжка, волосы... Нажмите «+ Уход», чтобы выбрать шаблон или создать свой.",
 "Roupa": "Одежда",
 "Roupa social": "Деловая одежда",
 "Roupas de banho": "Купальники",
 "Roupas extras das crianças": "Запасная одежда для детей",
 "Roupas íntimas": "Нижнее бельё",
 "Rua": "Улица",
 "Rua, número, bairro, cidade (ou o nome do lugar)": "Улица, дом, район, город (или название места)",
 "Régua": "Линейка",
 "Réptil": "Рептилия",
 "Rótulo (ex.: Meu nome, Empresa do cliente)": "Метка (напр.: Моё имя, Компания клиента)",
 "SAC": "Дифференцированные (SAC)",
 "SEM HORÁRIO": "БЕЗ ВРЕМЕНИ",
 "SEU MÊS EM NÚMEROS": "ВАШ МЕСЯЦ В ЦИФРАХ",
 "SEU TREINO": "ВАША ТРЕНИРОВКА",
 "SEUS GRUPOS DO APP": "ВАШИ ГРУППЫ В ПРИЛОЖЕНИИ",
 "SP": "SP",
 "SUBTAREFA": "ПОДЗАДАЧА",
 "SUBTAREFAS": "ПОДЗАДАЧИ",
 "SUPLEMENTAÇÃO": "ДОБАВКИ",
 "Sabonete facial": "Средство для умывания",
 "Sabão para lavar roupa": "Средство для стирки",
 "Sacada": "Балкон",
 "Sai só da lista deste app. A cópia guardada no Drive, no OneDrive ou na pasta do celular continua lá.": "Удаляется только из списка этого приложения. Копия в Drive, OneDrive или в папке телефона останется.",
 "Sai só da lista. O arquivo continua onde foi salvo.": "Убирается только из списка. Файл остаётся там, где сохранён.",
 "Sair": "Выйти",
 "Sair da conta?": "Выйти из аккаунта?",
 "Sair do escritório": "Выйти из офиса",
 "Sair do escritório?": "Выйти из офиса?",
 "Sair do grupo": "Выйти из группы",
 "Sair do grupo?": "Выйти из группы?",
 "Sair sem baixar": "Выйти без скачивания",
 "Saiu": "Ушло",
 "Sala": "Гостиная",
 "Sala de estar": "Гостиная",
 "Sala de jantar": "Столовая",
 "Sala virtual": "Виртуальный зал",
 "Salada": "Салат",
 "Saldo": "Остаток",
 "Saldo depois desta parcela": "Остаток после этого платежа",
 "Saldo devedor: {v}": "Остаток долга: {v}",
 "Saldo do mês": "Баланс месяца",
 "Salvar": "Сохранить",
 "Salvar backup do My Planner": "Сохранить резервную копию My Planner",
 "Salvar cuidado": "Сохранить процедуру",
 "Salvar cômodo": "Сохранить комнату",
 "Salvar e colocar no My Planner": "Сохранить и добавить в My Planner",
 "Salvar e sincronizar": "Сохранить и синхронизировать",
 "Salvar e testar": "Сохранить и проверить",
 "Salvar endereço": "Сохранить адрес",
 "Salvar no My Planner": "Сохранить в My Planner",
 "Salvar refeição": "Сохранить приём пищи",
 "Salvar suplemento": "Сохранить добавку",
 "Salvar tarefa": "Сохранить задачу",
 "Salvar treino": "Сохранить тренировку",
 "Sanduíche natural": "Лёгкий сэндвич",
 "Santo Antônio": "Святой Антоний",
 "Sapato confortável": "Удобная обувь",
 "Saudade": "Скучаю",
 "Saída (imóvel antigo)": "Выезд (старое жильё)",
 "Saída de praia": "Пляжная накидка",
 "Saúde": "Здоровье",
 "Saúde & Prontuário": "Здоровье и медкарта",
 "Saúde (médicos, dentistas, exames, plano)": "Здоровье (врачи, стоматологи, анализы, страховка)",
 "Saúde e bem-estar": "Здоровье и самочувствие",
 "Scanner": "Сканер",
 "Scanner PDF": "PDF-сканер",
 "Sci-Fi": "Фантастика",
 "Se alguma coisa não responder, reinicie o app. Os seus dados estão salvos.": "Если что-то не отвечает, перезапустите приложение. Данные сохранены.",
 "Se der tempo": "Если будет время",
 "Se esta política mudar de forma importante, o app avisa e pede o seu aceite de novo.": "Если эта политика существенно изменится, приложение сообщит об этом и снова попросит вашего согласия.",
 "Se este aviso apareceu, os alertas dos compromissos estão funcionando.": "Если это оповещение появилось, оповещения о встречах работают.",
 "Se existir uma conta com {email}, enviamos um link para criar uma senha nova. Confira também o spam.": "Если аккаунт с адресом {email} существует, мы отправили ссылку для создания нового пароля. Проверьте также папку «Спам».",
 "Se o alerta atrasar ou não aparecer: nas configurações do app, deixe as notificações ligadas, a bateria \"sem restrição\" e permita \"Alarmes e lembretes\".": "Если оповещение запаздывает или не появляется: в настройках приложения оставьте уведомления включёнными, батарею — «Без ограничений» и разрешите «Будильники и напоминания».",
 "Se o relógio estiver conectado, os números dele entram por cima dos digitados quando ele tiver o dado.": "Если часы подключены, их данные заменяют введённые вручную, когда данные есть.",
 "Se você conectar o relógio: totais de cada dia de passos, distância, calorias, exercício, batimentos e sono, lidos do Health Connect (Android) ou do app Saúde (iPhone). O app só lê e nunca altera esses dados.": "Если вы подключите часы: дневные итоги шагов, расстояния, калорий, тренировок, пульса и сна, считанные из Health Connect (Android) или приложения «Здоровье» (iPhone). Приложение только читает и никогда не изменяет эти данные.",
 "Se você já usou esta aba, nada foi apagado: tudo volta como estava ao assinar.": "Если вы уже пользовались этой вкладкой, ничего не удалено: после оформления подписки всё вернётся как было.",
 "Secretária ou recepção": "Секретарь или ресепшен",
 "Seg a sex": "Пн–пт",
 "Seguir": "Далее",
 "Segunda": "Понедельник",
 "Segurança": "Безопасность",
 "Segure e arraste para mudar a ordem. ↻ gira, ⧉ duplica e ✕ tira a página.": "Удерживайте и перетаскивайте, чтобы менять порядок. ↻ поворачивает, ⧉ дублирует, ✕ удаляет страницу.",
 "Segure um GIF numa conversa e toque em \"Guardar\" para ele aparecer aqui.": "Удерживайте GIF в чате и нажмите \"Сохранить\", чтобы он появился здесь.",
 "Segure um cômodo para mudar de lugar. Com o cômodo aberto, segure uma tarefa e solte em outro cômodo para levá-la.": "Удерживайте комнату, чтобы переместить её. В открытой комнате удерживайте задачу и отпустите над другой комнатой, чтобы перенести её.",
 "Segure um fichário, uma matéria ou uma página para mudar a ordem. Solte uma matéria em outro fichário para levá-la para lá.": "Удерживайте папку, предмет или страницу, чтобы изменить порядок. Отпустите предмет над другой папкой, чтобы перенести его туда.",
 "Segure uma conversa para silenciar ou arquivar. Arquivada continua recebendo e enviando, mas sem aviso.": "Удерживайте чат, чтобы отключить уведомления или архивировать его. Архивированный чат продолжает получать и отправлять сообщения, но без уведомлений.",
 "Seguro": "Страховка",
 "Seguro da casa": "Страховка жилья",
 "Seguro viagem": "Туристическая страховка",
 "Selecionar": "Выбрать",
 "Sem": "Нет",
 "Sem alerta": "Без напоминания",
 "Sem categoria": "Без категории",
 "Sem comprovante": "Без подтверждения",
 "Sem conexão com o servidor de notas. Confira a internet e o endereço do servidor.": "Нет связи с сервером счетов. Проверьте интернет и адрес сервера.",
 "Sem conexão com o servidor. Confira a internet.": "Нет связи с сервером. Проверьте интернет.",
 "Sem conexão com os GIFs agora.": "Сейчас нет подключения к GIF.",
 "Sem cômodo": "Без комнаты",
 "Sem data de fim": "Без даты окончания",
 "Sem exercícios": "Нет упражнений",
 "Sem fatura em {mes}": "Нет счёта за {mes}",
 "Sem fim": "Без конца",
 "Sem horário": "Без времени",
 "Sem internet ou servidor ainda não preparado.": "Нет интернета или сервер ещё не готов.",
 "Sem internet. Envia quando voltar.": "Нет интернета. Отправится, когда связь появится.",
 "Sem internet. Tente de novo.": "Нет интернета. Попробуйте снова.",
 "Sem isso, a tarja só cobre: o texto por baixo continua no arquivo e dá para copiar.": "Без этого полоса только закрывает: текст под ней остаётся в файле, и его можно скопировать.",
 "Sem itens": "Нет пунктов",
 "Sem juros": "Без процентов",
 "Sem limite": "Без лимита",
 "Sem link de calendário": "Нет ссылки на календарь",
 "Sem margem": "Без полей",
 "Sem nome": "Без имени",
 "Sem número na primeira página (capa)": "Без номера на первой странице (обложка)",
 "Sem pasta": "Без папки",
 "Sem pausas": "Без перерывов",
 "Sem permissão": "Нет разрешения",
 "Sem prazo": "Без срока",
 "Sem recibo": "Без квитанции",
 "Sem tarefas": "Нет задач",
 "Sem texto.": "Нет текста.",
 "Sem tomador identificado": "Заказчик не определён",
 "Sem título": "Без названия",
 "Sem validade": "Без срока",
 "Semana": "Неделя",
 "Semana completa": "Вся неделя",
 "Semana de {de} a {ate}": "Неделя с {de} по {ate}",
 "Semanal": "Еженедельно",
 "Semanal · dias úteis": "Еженедельно · будние дни",
 "Semanal · todos os dias": "Еженедельно · каждый день",
 "Semanal · {dias}": "Еженедельно · {dias}",
 "Sempre aparecem, junto com os pontos facultativos (Carnaval, Quarta-feira de Cinzas e Corpus Christi).": "Отображаются всегда, вместе с необязательными выходными (Карнавал, Пепельная среда и Праздник Тела и Крови Христовых).",
 "Senha": "Пароль",
 "Senha (8 caracteres ou mais)": "Пароль (8 символов или больше)",
 "Senha alterada.": "Пароль изменён.",
 "Senha atual": "Текущий пароль",
 "Senha atual do cofre": "Текущий пароль сейфа",
 "Senha da conta": "Пароль аккаунта",
 "Senha do certificado": "Пароль сертификата",
 "Senha do cofre": "Пароль сейфа",
 "Senha do cofre alterada.": "Пароль сейфа изменён.",
 "Senha do cofre incorreta.": "Неверный пароль сейфа.",
 "Senha incorreta": "Неверный пароль",
 "Senha incorreta.": "Неверный пароль.",
 "Senha nova (8 caracteres ou mais)": "Новый пароль (не менее 8 символов)",
 "Senha nova do cofre (6 caracteres ou mais)": "Новый пароль сейфа (не менее 6 символов)",
 "Senha, biometria, bloqueio e privacidade": "Пароль, биометрия, блокировка и конфиденциальность",
 "Senha, e-mail e formas de desbloquear": "Пароль, e-mail и способы разблокировки",
 "Separar informes de rendimentos (bancos, empregador, corretoras)": "Собрать справки о доходах (банки, работодатель, брокеры)",
 "Servidor de notas": "Сервер счетов",
 "Servidor não configurado (lib/config.ts).": "Сервер не настроен (lib/config.ts).",
 "Servidor não configurado.": "Сервер не настроен.",
 "Servidor não configurado: faltam os dados do Supabase em lib/config.ts.": "Сервер не настроен: в lib/config.ts нет данных Supabase.",
 "Serviço": "Услуга",
 "Serviço não prestado": "Услуга не оказана",
 "Serviços": "Услуги",
 "Será excluída em 1 dia": "Будет удалена через 1 день",
 "Será excluída em {n} dias": "Будет удалена через {n} дн.",
 "Será excluída hoje": "Будет удалена сегодня",
 "Sessão": "Сеанс",
 "Seu acesso ainda precisa ser liberado. Tente entrar em alguns instantes.": "Ваш доступ ещё должен быть подтверждён. Попробуйте войти через несколько минут.",
 "Seu código": "Ваш код",
 "Seu código de amigo": "Ваш код друга",
 "Seu código para amigos ganharem 10 dias com todas as abas": "Ваш код, по которому друзья получат 10 дней со всеми вкладками",
 "Seu nome": "Ваше имя",
 "Seu papel: {p}": "Ваша роль: {p}",
 "Seu papel: {p}. {d}": "Ваша роль: {p}. {d}",
 "Seu scanner de bolso": "Ваш карманный сканер",
 "Seus dados continuam salvos na nuvem.": "Ваши данные остаются сохранёнными в облаке.",
 "Seus dados na nuvem do My Planner": "Ваши данные в облаке My Planner",
 "Seus dados são seus: não vendemos e não usamos para publicidade. Você pode exportar ou apagar tudo quando quiser.": "Ваши данные принадлежат вам: мы их не продаём и не используем для рекламы. Вы можете экспортировать или удалить всё в любой момент.",
 "Seus {n} meses grátis terminaram": "Ваши бесплатные месяцы ({n}) закончились",
 "Sexta": "Пятница",
 "Sextou": "Пятница",
 "Sextou!": "Ура, пятница!",
 "Shampoo": "Шампунь",
 "Show ou passeio": "Шоу или экскурсия",
 "Silenciar avisos": "Отключить уведомления",
 "Sim": "Да",
 "Simples Nacional": "Simples Nacional",
 "Sincronizado em {data}": "Синхронизировано {data}",
 "Sincronizando pelo dispositivo {nome}": "Синхронизация через устройство {nome}",
 "Sincronizando...": "Синхронизация...",
 "Sincronizar agora": "Синхронизировать сейчас",
 "Sincronização parada: confirme sua senha. Nada se perde.": "Синхронизация остановлена: подтвердите пароль. Ничего не потеряется.",
 "Site da assistência": "Сайт сервиса",
 "Site da assistência (https://...)": "Сайт сервиса (https://...)",
 "Site ou ingresso online": "Сайт или билет онлайн",
 "Situação": "Статус",
 "Situação agora": "Текущее состояние",
 "Skincare da manhã": "Утренний уход за кожей",
 "Skincare da noite": "Вечерний уход за кожей",
 "Slides": "Слайды",
 "Smileys e pessoas": "Смайлики и люди",
 "Sobremesa": "Десерт",
 "Sobrou no mês": "Осталось за месяц",
 "Sociologia": "Социология",
 "Sofá": "Диван",
 "Sol": "Солнце",
 "Sol pleno": "Полное солнце",
 "Solo ou substrato": "Почва или субстрат",
 "Solte numa matéria para mover a página para lá:": "Отпустите над предметом, чтобы перенести туда страницу:",
 "Soma a garantia legal e a do fabricante. Confira no termo de garantia. Avisa 15 e 3 dias antes.": "Суммирует гарантию по закону и гарантию производителя. Сверьтесь с гарантийным талоном. Напоминает за 15 и 3 дня.",
 "Sombra": "Тень",
 "Somente esta tarefa": "Только эту задачу",
 "Sono": "Сон",
 "Sono da noite": "Ночной сон",
 "Sopa": "Суп",
 "Sou MEI": "Я MEI",
 "Status": "Статус",
 "Sua conexão com a nuvem venceu (acontece quando o app fica muito tempo sem abrir ou a senha foi trocada em outro dispositivo). Nada se perde: o que está aqui é enviado assim que você confirmar.": "Срок подключения к облаку истёк (так бывает, если приложение долго не открывали или пароль сменили на другом устройстве). Ничего не потеряется: всё, что здесь есть, будет отправлено, как только вы подтвердите.",
 "Sua equipe num lugar só: conversa, documentos, reuniões de vídeo com gravação e convite pelo link.": "Ваша команда в одном месте: чат, документы, видеовстречи с записью и приглашение по ссылке.",
 "Sua rotina em um só lugar": "Ваш распорядок в одном месте",
 "Sua senha": "Ваш пароль",
 "Suas abas": "Ваши вкладки",
 "Substituir": "Заменить",
 "Substrato usado": "Использованный субстрат",
 "Subtarefa {n}": "Подзадача {n}",
 "Suco": "Сок",
 "Sugerir nome": "Предложить имя",
 "Sugestão": "Предложение",
 "Sugestões de {categoria}": "Предложения: {categoria}",
 "Supabase: guarda a conta e os dados sincronizados, como operador. Os servidores podem ficar fora do Brasil, com as garantias do art. 33 da LGPD.": "Supabase: хранит аккаунт и синхронизированные данные в качестве обработчика. Серверы могут находиться за пределами Бразилии, с гарантиями art. 33 LGPD.",
 "Superiores": "Высшие",
 "Supino reto": "Жим лёжа",
 "Suplemento": "Добавка",
 "Suspense": "Триллер",
 "Suíte": "Спальня с ванной",
 "Sábado": "Суббота",
 "São Paulo": "Сан-Паулу",
 "São Paulo (SP)": "Сан-Паулу (SP)",
 "São mais de 60 arquivos. Use \"A cada N páginas\".": "Это больше 60 файлов. Используйте \"Каждые N страниц\".",
 "Série": "Сериал",
 "Série da DPS": "Серия DPS",
 "Série e turma": "Класс",
 "Séries": "Подходы",
 "Sérum": "Сыворотка",
 "Símbolos": "Символы",
 "Só a equipe do escritório vê. Até 50 MB por arquivo.": "Видит только команда офиса. До 50 МБ на файл.",
 "Só acompanha": "Только просмотр",
 "Só acompanha, sem valores": "Только просмотр, без сумм",
 "Só administradores": "Только администраторы",
 "Só em {data}": "Только {data}",
 "Só leitura": "Только чтение",
 "Só mandar para a aba Estudos (sem escolher página)": "Просто отправить во вкладку «Учёба» (без выбора страницы)",
 "Só neste dispositivo": "Только на этом устройстве",
 "Só neste dispositivo: {n}": "Только на этом устройстве: {n}",
 "Só o código": "Только код",
 "Só o dia {data}": "Только в день {data}",
 "Só os dados (texto)": "Только данные (текст)",
 "Só os totais das Finanças vão para a sua IA. Não é recomendação de investimento.": "В ваш ИИ передаются только итоговые суммы Финансов. Это не инвестиционная рекомендация.",
 "Só seu: estudos, estratégias pedagógicas e o que funcionou ou não em cada aula. Os alunos não veem.": "Только для вас: учёба, педагогические стратегии и что сработало или нет на каждом уроке. Ученики этого не видят.",
 "Só um celular sincroniza com a agenda. Para passar para este, toque abaixo.": "С календарём синхронизируется только один телефон. Чтобы переключиться на этот, нажмите ниже.",
 "Só uma vez": "Один раз",
 "Só uma vez (abrir a ficha da tarefa)": "Только один раз (открыть карточку задачи)",
 "Só áudio": "Только аудио",
 "Sótão": "Чердак",
 "TAREFAS DA CASA": "ДЕЛА ПО ДОМУ",
 "TELEFONE (OPCIONAL)": "ТЕЛЕФОН (НЕОБЯЗАТЕЛЬНО)",
 "TRAZER PARA O MY PLANNER": "ИМПОРТ В MY PLANNER",
 "TV por assinatura": "Платное ТВ",
 "Tabela": "Таблица",
 "Talvez": "Возможно",
 "Tamanho": "Размер",
 "Tamanho da foto": "Размер фото",
 "Tamanho da página": "Размер страницы",
 "Tamanho das páginas": "Размер страниц",
 "Tamanho do arquivo": "Размер файла",
 "Tamanho do copo": "Объём стакана",
 "Também procurar nos Diários Oficiais dos municípios": "Искать также в официальных вестниках муниципалитетов",
 "Também serão excluídos {n} item(ns) dentro dele.": "Также будут удалены вложенные элементы: {n}.",
 "Tapioca": "Тапиока (лепёшка)",
 "Tarefa": "Задача",
 "Tarefa da casa": "Дело по дому",
 "Tarefa de casa": "Домашнее задание",
 "Tarefa duplicada": "Задача продублирована",
 "Tarefa ou entrega": "Задача или сдача",
 "Tarefa para {nome}": "Задача для {nome}",
 "Tarefas da casa": "Дела по дому",
 "Tarefas e itens de todas as abas": "Задачи и элементы всех вкладок",
 "Tarefas novas do My Planner vão para: {agenda}": "Новые задачи My Planner попадают в: {agenda}",
 "Tarefas que se repetem e passam do período continuam nos outros dias; só os dias escolhidos saem.": "Повторяющиеся задачи, выходящие за пределы периода, остаются в другие дни; удаляются только выбранные дни.",
 "Tarjas pretas sobre CPF, valores e nomes. Apaga de verdade.": "Чёрные полосы поверх CPF, сумм и имён. Удаляет по-настоящему.",
 "Tartaruga": "Черепаха",
 "Taxa de limpeza": "Плата за уборку",
 "Taxa de limpeza cobrada do hóspede": "Плата за уборку с гостя",
 "Taxas e anúncios": "Комиссии и объявления",
 "Te amo": "Люблю тебя",
 "Tecnologia": "Технологии",
 "Tela cheia": "Во весь экран",
 "Teleconsulta": "Онлайн-консультация",
 "Telefone": "Телефон",
 "Telefone da assistência": "Телефон сервиса",
 "Telefone da empresa": "Телефон компании",
 "Telefone da escola": "Телефон школы",
 "Telefone da limpeza": "Телефон уборщика",
 "Telefone de emergência": "Экстренный телефон",
 "Telefone do veterinário": "Телефон ветеринара",
 "Telhado": "Кровля",
 "Tem anexos": "Есть вложения",
 "Tem certeza?": "Вы уверены?",
 "Tem {n} conta(s) em atraso somando {v}. Pague primeiro as que cobram juros mais altos, como o cartão e o cheque especial.": "У вас {n} просроченных платежей на сумму {v}. Сначала оплатите те, где самые высокие проценты, например карту и овердрафт.",
 "Tema": "Тема",
 "Tempo de preparo": "Время приготовления",
 "Temporada": "Сезон",
 "Temporizador (direita)": "Таймер (справа)",
 "Tenta consertar um PDF que não abre direito.": "Пытается исправить PDF, который плохо открывается.",
 "Tentar de novo": "Повторить",
 "Tente uma foto mais nítida, com a página inteira.": "Попробуйте сделать фото чётче, со всей страницей.",
 "Termina às {hora}": "Окончание в {hora}",
 "Terminar até": "Закончить до",
 "Terminei em": "Дата окончания",
 "Terminou": "Завершена",
 "Terminou em {data}. Nada foi apagado: tudo volta como estava ao assinar.": "Закончился {data}. Ничего не удалено: после оформления подписки всё вернётся как было.",
 "Termos de uso": "Условия использования",
 "Termos de uso e privacidade": "Условия использования и конфиденциальность",
 "Terror": "Ужасы",
 "Terça": "Вторник",
 "Testando...": "Проверка...",
 "Testar alerta (1 minuto)": "Проверить оповещение (1 минута)",
 "Testar aviso": "Проверить уведомление",
 "Teste de alerta do Planner": "Тест оповещения Planner",
 "Teste grátis até {data} ({n} dia(s))": "Бесплатно до {data} (дней: {n})",
 "Teste grátis: {n} dia(s)": "Бесплатный период: {n} дн.",
 "Teste terminado": "Пробный период окончен",
 "Teste terminou em {data}": "Пробный период окончен {data}",
 "Teste: aviso feito pelo próprio celular.": "Тест: уведомление создано самим телефоном.",
 "Texto": "Текст",
 "Texto completo": "Полный текст",
 "Texto copiado. Cole onde quiser enviar.": "Текст скопирован. Вставьте его, куда нужно отправить.",
 "Texto do documento": "Текст документа",
 "Texto extra do convite (traje, presentes...)": "Доп. текст приглашения (дресс-код, подарки...)",
 "Texto livre": "Свободный текст",
 "Texto ou recado": "Текст или объявление",
 "Texto para PDF": "Текст в PDF",
 "Texto {data}": "Текст {data}",
 "Tipo": "Тип",
 "Tipo sanguíneo": "Группа крови",
 "Tira as páginas que você não quer.": "Удаляет ненужные страницы.",
 "Tira autor, programas, comandos escondidos e anexos.": "Удаляет автора, программы, скрытые команды и вложения.",
 "Tira comentários, destaques e desenhos de outros programas.": "Удаляет комментарии, выделения и рисунки из других программ.",
 "Tira o texto do PDF (arquivo .txt).": "Извлекает текст из PDF (файл .txt).",
 "Tiradentes": "Тирадентис",
 "Tirar": "Убрать",
 "Tirar a assinatura": "Убрать подпись",
 "Tirar a foto": "Удалить фото",
 "Tirar a foto agora": "Сделать фото сейчас",
 "Tirar admin": "Снять админа",
 "Tirar alarmes do My Planner": "Убрать будильники из My Planner",
 "Tirar arquivos anexados": "Удалить вложенные файлы",
 "Tirar comentários, destaques e links": "Удалить комментарии, выделения и ссылки",
 "Tirar da agenda": "Убрать из расписания",
 "Tirar da barra": "Убрать с панели",
 "Tirar daqui": "Убрать отсюда",
 "Tirar das minhas figurinhas?": "Убрать из моих стикеров?",
 "Tirar de administrador": "Снять права администратора",
 "Tirar do escritório": "Удалить из офиса",
 "Tirar dos meus GIFs?": "Убрать из моих GIF?",
 "Tirar este copo": "Убрать этот стакан",
 "Tirar foto": "Сделать фото",
 "Tirar fotos de boletos, cupons e documentos e escolher fotos e vídeos da galeria.": "Фотографировать квитанции, чеки и документы, а также выбирать фото и видео из галереи.",
 "Tirar o desenho padrão?": "Убрать графический ключ?",
 "Tirar o lixo": "Вынести мусор",
 "Tire a foto e a sua IA preenche a ficha": "Сделайте фото, и ваш ИИ заполнит карточку",
 "Titular (de quem é o documento)": "Владелец (чей это документ)",
 "Titular: {nome}": "Владелец: {nome}",
 "Toalha de praia": "Пляжное полотенце",
 "Tocar os pés": "Дотянуться до стоп",
 "Toda a agenda": "Всё расписание",
 "Toda semana": "Каждую неделю",
 "Todas": "Все",
 "Todas (passadas, esta e futuras)": "Все (прошлые, эту и будущие)",
 "Todas ({n})": "Все ({n})",
 "Todas as abas liberadas até {data}.": "Все вкладки открыты до {data}.",
 "Todas as capitais. Marque uma ou mais cidades.": "Все столицы. Отметьте один или несколько городов.",
 "Todas as ferramentas de PDF: juntar, dividir, organizar, assinar, carimbo, tarja, números de página, formulários, comprimir, converter, OCR e IA. Guarda no celular, no Google Drive ou no OneDrive.": "Все инструменты для PDF: объединение, разделение, упорядочивание, подпись, штамп, закраска, номера страниц, формы, сжатие, конвертация, OCR и ИИ. Сохраняет на телефон, в Google Drive или OneDrive.",
 "Todas as ferramentas ficam na tela da aba.": "Все инструменты находятся на экране вкладки.",
 "Todas as fotos da viagem ficam aqui: as que você puser no álbum e as do roteiro, dos lugares e das reservas.": "Все фото поездки собраны здесь: добавленные вами в альбом, а также из маршрута, мест и бронирований.",
 "Todas as plantas estão regadas.": "Все растения политы.",
 "Todas as páginas, uma embaixo da outra.": "Все страницы одна под другой.",
 "Todo ano": "Каждый год",
 "Todo dia": "Каждый день",
 "Todo dia no horário escolhido: quantas tarefas o dia tem, a primeira e a energia total.": "Каждый день в выбранное время: сколько задач на день, первая из них и общая энергия.",
 "Todo mês": "Каждый месяц",
 "Todo mês · dia {d}": "Каждый месяц · {d}-го числа",
 "Todo o histórico": "Вся история",
 "Todos": "Все",
 "Todos ({n})": "Все ({n})",
 "Todos do grupo": "Вся группа",
 "Todos do grupo veem": "Видно всей группе",
 "Todos na reunião veem o aviso \"Gravando\". O arquivo vai para os Documentos do escritório, visível só para você até você liberar para a equipe.": "Все участники встречи видят уведомление «Идёт запись». Файл попадёт в «Документы» офиса и будет виден только вам, пока вы не откроете его для команды.",
 "Todos os cuidados": "Весь уход",
 "Todos os dias": "Каждый день",
 "Todos os suplementos": "Все добавки",
 "Todos os treinos": "Все тренировки",
 "Todos os tribunais": "Все суды",
 "Todos presentes": "Все на месте",
 "Todos saem do grupo. O que cada pessoa já aceitou continua na agenda dela.": "Все выходят из группы. То, что каждый уже принял, останется в его расписании.",
 "Todos trabalham nos mesmos dados, cada um conforme o papel. Toque no papel de cada pessoa em Membros para trocar.": "Все работают с одними и теми же данными, каждый в своей роли. Нажмите на роль человека в разделе «Участники», чтобы её изменить.",
 "Tomador": "Заказчик",
 "Tomador (quem contratou)": "Заказчик (кто заказал)",
 "Tomadores": "Заказчики",
 "Tomei": "Я взял(а)",
 "Toque aqui ou no + para criar uma tarefa": "Нажмите здесь или на +, чтобы создать задачу",
 "Toque em \"Apagar minha conta e todos os dados\" e confirme.": "Нажмите «Удалить мой аккаунт и все данные» и подтвердите.",
 "Toque em + › Novo cartão de crédito e informe os dias de fechamento e de vencimento.": "Нажмите + › Новая кредитная карта и укажите дни закрытия и оплаты.",
 "Toque em Ajustes e depois em Segurança.": "Нажмите «Настройки», затем «Безопасность».",
 "Toque em Conectar e, na tela da Apple, ligue os itens que o My Planner pode ler.": "Нажмите «Подключить» и на экране Apple включите пункты, которые может читать My Planner.",
 "Toque em Conectar e, na tela do Health Connect, permita que o My Planner leia os dados.": "Нажмите «Подключить» и на экране Health Connect разрешите My Planner читать данные.",
 "Toque em quem NÃO deve ver esta ficha (e o que está dentro dela). Ex.: o presente surpresa.": "Нажмите на тех, кто НЕ должен видеть эту карточку (и её содержимое). Напр.: подарок-сюрприз.",
 "Toque em uma aba para abrir. As bloqueadas mostram como assinar.": "Нажмите на вкладку, чтобы открыть. Заблокированные покажут, как оформить подписку.",
 "Toque em uma aba para abrir. Cada aba extra pode ser testada de graça por 10 dias.": "Нажмите на вкладку, чтобы открыть. Каждую доп. вкладку можно бесплатно попробовать 10 дней.",
 "Toque em uma aba para abrir. Toque em 📌 para pôr ou tirar a aba da barra de baixo. Cada aba extra pode ser testada de graça por 10 dias.": "Нажмите на вкладку, чтобы открыть. Нажмите 📌, чтобы добавить вкладку на нижнюю панель или убрать её. Каждую дополнительную вкладку можно бесплатно попробовать 10 дней.",
 "Toque em uma área para abrir. As bloqueadas mostram como assinar.": "Нажмите на раздел, чтобы открыть. Заблокированные покажут, как оформить подписку.",
 "Toque no desenho para continuar desenhando.": "Нажмите на рисунок, чтобы продолжить рисовать.",
 "Toque no que este grupo vai compartilhar. Tudo o que está dentro (roteiro, fotos, reservas...) vai junto e todos participam.": "Нажмите на то, чем будет делиться эта группа. Всё внутри (маршрут, фото, бронирования...) передаётся вместе, и все участвуют.",
 "Toque nos PDFs na ordem em que devem ficar.": "Нажимайте на PDF в нужном порядке.",
 "Toque num copo para mudar o volume; segure o + para um copo de outro tamanho.": "Нажмите на стакан, чтобы изменить объём; удерживайте +, чтобы добавить стакан другого объёма.",
 "Toque num feriado para adicioná-lo ao Planner.": "Нажмите на праздник, чтобы добавить его в Planner.",
 "Toque num lançamento para trocar a categoria, guardar o recibo no IR ou apagar.": "Нажмите на операцию, чтобы сменить категорию, сохранить квитанцию для IR или удалить.",
 "Toque num lançamento para trocar a categoria. Pressione e segure para apagar.": "Нажмите на запись, чтобы сменить категорию. Нажмите и удерживайте, чтобы удалить.",
 "Toque num perfil para editar. Pressione e segure para removê-lo.": "Нажмите на профиль, чтобы изменить. Нажмите и удерживайте, чтобы удалить.",
 "Toque num texto, desenho ou checklist e arraste para qualquer lugar da folha.": "Нажмите на текст, рисунок или чек-лист и перетащите в любое место листа.",
 "Toque numa página para recortar, girar ou mudar o filtro. Segure e arraste para mudar a ordem.": "Нажмите на страницу, чтобы обрезать, повернуть или сменить фильтр. Удерживайте и перетаскивайте, чтобы изменить порядок.",
 "Toque numa tarefa para copiar ou mover para hoje.": "Нажмите на задачу, чтобы скопировать или перенести её на сегодня.",
 "Toque onde quer a checklist.": "Нажмите там, где нужен чек-лист.",
 "Toque onde quer escrever.": "Нажмите там, где хотите писать.",
 "Toque para abrir": "Нажмите, чтобы открыть",
 "Toque para abrir no app do celular. Arraste para a direita para tirar da lista.": "Нажмите, чтобы открыть в приложении телефона. Проведите вправо, чтобы убрать из списка.",
 "Toque para abrir, segure para mudar o nome. Arraste para a esquerda para arquivar ou para a direita para excluir.": "Нажмите, чтобы открыть, удерживайте, чтобы переименовать. Смахните влево, чтобы архивировать, или вправо, чтобы удалить.",
 "Toque para abrir. Arraste para a direita para tirar da lista.": "Нажмите, чтобы открыть. Проведите вправо, чтобы убрать из списка.",
 "Toque para aceitar ou recusar.": "Нажмите, чтобы принять или отклонить.",
 "Toque para aceitar, editar ou recusar.": "Нажмите, чтобы принять, изменить или отклонить.",
 "Toque para aplicar agora. Ou ela entra sozinha ao reabrir o app.": "Нажмите, чтобы применить сейчас. Или оно применится само при повторном запуске приложения.",
 "Toque para baixar e instalar por cima. Seus dados continuam.": "Нажмите, чтобы скачать и установить поверх. Ваши данные сохранятся.",
 "Toque para conversar": "Нажмите, чтобы написать",
 "Toque para enviar o emoji animado": "Нажмите, чтобы отправить анимированный эмодзи",
 "Toque para enviar. Segure para guardar ou tirar das suas.": "Нажмите, чтобы отправить. Удерживайте, чтобы сохранить или убрать из ваших.",
 "Toque para escolher": "Нажмите, чтобы выбрать",
 "Toque para fechar": "Нажмите, чтобы закрыть",
 "Toque para gerar um novo QR Code": "Нажмите, чтобы создать новый QR-код",
 "Tornar admin": "Сделать админом",
 "Tornar administrador": "Сделать администратором",
 "Tosa": "Стрижка",
 "Totais por alimento": "Итого по продуктам",
 "Total": "Итого",
 "Total bruto": "Итого брутто",
 "Total das reservas: {v}": "Итого по бронированиям: {v}",
 "Total de aulas": "Всего уроков",
 "Total de capítulos": "Всего глав",
 "Total de módulos": "Всего модулей",
 "Total de páginas": "Всего страниц",
 "Total de recibos: {v}": "Итого по квитанциям: {v}",
 "Total: {n}. Cada aba pode ter até {lim} de texto (fotos e arquivos não contam: ficam no dispositivo ou no seu Drive).": "Всего: {n}. В каждой вкладке может быть до {lim} текста (фото и файлы не считаются: они на устройстве или в вашем Drive).",
 "Total: {v}": "Итого: {v}",
 "Trabalhando...": "Обработка...",
 "Trabalho": "Трудовые",
 "Traga os compromissos da sua agenda do Google para o My Planner e edite por aqui: as mudanças voltam para a agenda.": "Перенесите события из Google Календаря в My Planner и редактируйте их здесь: изменения вернутся в календарь.",
 "Trans": "Транс",
 "Transferir: {s}": "Переоформить: {s}",
 "Transferência": "Переоформление",
 "Transferências": "Переоформления",
 "Transporte": "Транспорт",
 "Tratamento": "Лечение",
 "Travar depois de preencher": "Заблокировать после заполнения",
 "Trazer todas para hoje": "Перенести все на сегодня",
 "Trazer tudo para hoje?": "Перенести всё на сегодня?",
 "Trecho ou ideia": "Цитата или мысль",
 "Treino": "Тренировка",
 "Trem ou ônibus": "Поезд или автобус",
 "Treme": "Трясётся",
 "Tribunais": "Суды",
 "Trilha": "Поход",
 "Triste": "Грусть",
 "Triângulo": "Треугольник",
 "Troca de óleo": "Замена масла",
 "Troca de óleo, rodízio de pneus, revisões por km, IPVA, licenciamento e seguro.": "Замена масла, перестановка шин, ТО по пробегу, IPVA, регистрация и страховка.",
 "Trocador portátil": "Переносной пеленальный коврик",
 "Trocar": "Сменить",
 "Trocar a categoria": "Сменить категорию",
 "Trocar a foto": "Сменить фото",
 "Trocar a pasta": "Сменить папку",
 "Trocar a senha do cofre": "Сменить пароль сейфа",
 "Trocar número": "Сменить номер",
 "Trocar o certificado": "Сменить сертификат",
 "Trocar o código": "Сменить код",
 "Trocar o código?": "Сменить код?",
 "Trocar o desenho": "Сменить ключ",
 "Trocar o emoji": "Сменить эмодзи",
 "Trocar o modelo": "Сменить модель",
 "Trocar o número": "Сменить номер",
 "Trocar o número do celular": "Сменить номер телефона",
 "Trocar por:": "Заменить на:",
 "Trocar roupa de cama e toalhas": "Сменить постельное бельё и полотенца",
 "Tríceps na polia": "Разгибание рук на блоке",
 "Tubo de ensaio": "Пробирка",
 "Tudo": "Всё",
 "Tudo certo": "Всё в порядке",
 "Tudo em dia por aqui. Lance os gastos do dia a dia para eu enxergar para onde o dinheiro vai.": "Здесь всё в порядке. Вносите повседневные расходы, чтобы я видел, куда уходят деньги.",
 "Tudo já fica salvo na sua conta. O arquivo é uma cópia extra que você guarda onde quiser.": "Всё уже сохраняется в вашем аккаунте. Файл — это дополнительная копия, которую вы храните где угодно.",
 "Tudo o que está dentro de \"{nome}\" passa a ser visto pelo grupo, cada pessoa conforme o papel que você escolher (quem entra começa com o papel mais limitado).": "Всё, что находится в \"{nome}\", станет видно группе, каждому в соответствии с выбранной вами ролью (новые участники начинают с самой ограниченной роли).",
 "Tudo! Já comprei os ingressos.": "Да! Я уже купил билеты.",
 "Turma": "Класс",
 "Turma (opcional)": "Класс (необязательно)",
 "Turmas": "Классы",
 "Turmas e grupos (aulas, mentoria, treino): alunos, chamada, notas, planos, materiais, cobranças e o seu caderno.": "Классы и группы (уроки, менторинг, тренировки): ученики, перекличка, оценки, планы, материалы, счета и ваш блокнот.",
 "Turmas, alunos, chamada, notas e planos de aula.": "Классы, ученики, перекличка, оценки и планы уроков.",
 "Turmas, pacientes, equipes e convidados": "Классы, пациенты, команды и гости",
 "Técnico": "Техническая",
 "Título": "Название",
 "Título (ex.: Capítulo 3)": "Заголовок (напр.: Глава 3)",
 "Título (opcional)": "Название (необязательно)",
 "Título da caixa": "Название блока",
 "Título de eleitor": "Удостоверение избирателя",
 "Título, autor, assunto e palavras-chave.": "Название, автор, тема и ключевые слова.",
 "Tô chegando": "Уже еду",
 "Tônico": "Тоник",
 "UF": "UF",
 "Uau": "Вау",
 "Uhuul!": "Ура!",
 "Um PDF novo só com as páginas escolhidas.": "Новый PDF только с выбранными страницами.",
 "Um texto clarinho na diagonal de todas as páginas.": "Светлый текст по диагонали на всех страницах.",
 "Uma pasta para cada cliente: vocês trocam documentos nos dois sentidos e cada cliente só vê a pasta dele.": "Папка для каждого клиента: вы обмениваетесь документами в обе стороны, и каждый клиент видит только свою папку.",
 "Uma página por arquivo": "Одна страница на файл",
 "Uma página por arquivo, a cada N páginas ou por faixas.": "Одна страница на файл, каждые N страниц или по диапазонам.",
 "Unicórnio": "Единорог",
 "Unidade": "Единица",
 "Universal": "Универсальный",
 "União": "Единство",
 "Usa a conta Google que já está no celular. Nenhuma senha do Google é pedida pelo My Planner.": "Используется аккаунт Google, который уже есть на телефоне. My Planner никогда не запрашивает пароль Google.",
 "Usado: {u} · livre: {v} · limite {l}": "Использовано: {u} · свободно: {v} · лимит {l}",
 "Usar": "Применить",
 "Usar \"{nome}\"": "Использовать «{nome}»",
 "Usar biometria": "Использовать биометрию",
 "Usar desenho padrão": "Использовать графический ключ",
 "Usar este celular": "Использовать этот телефон",
 "Usar este nome": "Использовать это имя",
 "Usar modelo: {m}": "Использовать шаблон: {m}",
 "Usar no navegador (My Planner Web)": "Открыть в браузере (My Planner Web)",
 "Usar o arquivo já anexado ({nome})": "Использовать уже прикреплённый файл ({nome})",
 "Usar o código": "Применить код",
 "Usar senha": "Использовать пароль",
 "Usar {ia}": "Использовать {ia}",
 "Use a senha nova da próxima vez que entrar, aqui e no My Planner Web.": "Используйте новый пароль при следующем входе — здесь и в My Planner Web.",
 "Use a senha para desbloquear.": "Используйте пароль для разблокировки.",
 "Use a sua própria IA para ler publicações, documentos e anotações e sugerir agendamentos. Você sempre confirma antes de qualquer coisa entrar no Planner.": "Используйте свой ИИ, чтобы читать публикации, документы и заметки и предлагать записи в расписание. Вы всегда подтверждаете, прежде чем что-либо попадёт в Planner.",
 "Use este código ao criar a sua conta e ganhe 10 dias com todas as abas liberadas.": "Введите этот код при создании аккаунта и получите 10 дней со всеми открытыми вкладками.",
 "Use o extrato em OFX (o mais indicado) ou CSV, baixado no app ou site do seu banco.": "Используйте выписку в формате OFX (лучший вариант) или CSV, скачанную в приложении или на сайте вашего банка.",
 "Use o seu planner no computador, sincronizado com o celular.": "Пользуйтесь планером на компьютере с синхронизацией с телефоном.",
 "Use um link https do Google Drive, Google Docs, OneDrive ou SharePoint.": "Используйте https-ссылку Google Drive, Google Docs, OneDrive или SharePoint.",
 "Uso": "Использование",
 "Uso próprio": "Для себя",
 "VRBO": "VRBO",
 "Vacina": "Прививка",
 "Vacina {nome}: {pet}": "Прививка {nome}: {pet}",
 "Vacina: {nome}": "Прививка: {nome}",
 "Vacinas": "Прививки",
 "Vacinas e remédios dos pets, pet shop e a rotina da escola e da saúde das crianças.": "Прививки и лекарства питомцев, зоомагазин, школа и здоровье детей.",
 "Vai na viagem": "Едет в поездку",
 "Vale até {d}": "Действителен до {d}",
 "Vale para Estudos e Documentos. Na nuvem, o arquivo abre em qualquer dispositivo e no My Planner Web (até 15 MB por arquivo).": "Для разделов Учёба и Документы. В облаке файл открывается на любом устройстве и в My Planner Web (до 15 МБ на файл).",
 "Vale quantos pontos": "Максимум баллов",
 "Vale só para você. No máximo um aviso a cada 3 minutos por pessoa, mesmo que ela inclua várias coisas.": "Действует только для вас. Не больше одного уведомления раз в 3 минуты от каждого человека, даже если он добавит несколько вещей.",
 "Vale uma vez, nos primeiros 30 dias da sua conta.": "Действует один раз, в первые 30 дней вашего аккаунта.",
 "Validade": "Действителен до",
 "Validade do certificado A1": "Срок действия сертификата A1",
 "Validade: {data}": "Действителен до: {data}",
 "Valor": "Сумма",
 "Valor ({m})": "Сумма ({m})",
 "Valor a pagar": "Сумма к оплате",
 "Valor combinado": "Договорная сумма",
 "Valor combinado por atendimento": "Согласованная сумма за приём",
 "Valor da hora": "Ставка в час",
 "Valor da parcela (1ª)": "Сумма платежа (1-го)",
 "Valor da venda": "Цена продажи",
 "Valor de costume": "Обычная сумма",
 "Valor do atendimento: {v}{pago}.": "Стоимость приёма: {v}{pago}.",
 "Valor emprestado ou financiado": "Сумма займа или кредита",
 "Valor final definido pela Google Play ou pela App Store, já na moeda do seu país.": "Итоговая цена устанавливается Google Play или App Store, уже в валюте вашей страны.",
 "Valor maior que o guardado nesta meta.": "Сумма больше, чем отложено на эту цель.",
 "Valor padrão da consulta ou sessão": "Стандартная цена приёма или сеанса",
 "Valor pago": "Уплаченная сумма",
 "Valor pago (com multa ou desconto)": "Уплаченная сумма (со штрафом или скидкой)",
 "Valor pago (opcional)": "Уплаченная сумма (необязательно)",
 "Valor pago: {v}": "Уплачено: {v}",
 "Valor que este aluno paga (se for diferente)": "Сколько платит этот ученик (если иначе)",
 "Valor recebido": "Полученная сумма",
 "Valor recebido: {v}": "Получено: {v}",
 "Valor total da compra": "Общая сумма покупки",
 "Valores e dados clínicos só aparecem para quem o papel permitir. Você pode desligar quando quiser: os dados continuam com você.": "Суммы и клинические данные видны только тем, чья роль это позволяет. Отключить можно в любой момент: данные останутся у вас.",
 "Valores para conferir com o seu contador. As regras de dedução mudam a cada ano.": "Суммы для сверки с вашим бухгалтером. Правила вычетов меняются каждый год.",
 "Vamos conversar pelo My Planner? Me adicione como amigo com o código {codigo} (aba Mensagens > Amigos).": "Пообщаемся в My Planner? Добавьте меня в друзья по коду {codigo} (вкладка Сообщения > Друзья).",
 "Vaso": "Горшок",
 "Veja os planos em Ajustes › Compras.": "Планы — в Настройки › Покупки.",
 "Vem da aba Empréstimos & Financiamentos": "Из вкладки «Кредиты и займы»",
 "Vence em {data}.": "Истекает {data}.",
 "Vence em {fim} (data informada na publicação).": "Срок истекает {fim} (дата указана в публикации).",
 "Vence em {n} dia(s)": "Истекает через {n} дн.",
 "Vence hoje": "Истекает сегодня",
 "Vence {data}": "Срок {data}",
 "Vencendo": "Истекают",
 "Venceu há {n} dia(s)": "Истекла {n} дн. назад",
 "Vencidas": "Истёкшие",
 "Vencidos": "Просрочены",
 "Vencimento": "Срок оплаты",
 "Vencimento (guias e boletos)": "Срок оплаты (платёжки и boleto)",
 "Vencimento da 1ª parcela": "Срок 1-го платежа",
 "Vencimentos": "Платежи по срокам",
 "Venda": "Продажа",
 "Venda/serviço do MEI": "Продажа/услуга MEI",
 "Vendidos": "Проданные",
 "Ver": "Открыть",
 "Ver a lista de membros": "Видеть список участников",
 "Ver a rota": "Показать маршрут",
 "Ver arquivos": "Посмотреть файлы",
 "Ver detalhes do erro": "Подробности ошибки",
 "Ver e editar": "Просмотр и правка",
 "Ver em Compras": "Смотреть в Покупках",
 "Ver mais": "Показать ещё",
 "Ver mais páginas": "Показать ещё страницы",
 "Ver no My Planner": "Открыть в My Planner",
 "Ver o dia": "Открыть день",
 "Ver os feriados do ano": "Праздники года",
 "Ver participantes": "Участники",
 "Ver páginas": "Смотреть страницы",
 "Ver todos": "Показать все",
 "Ver todos ({n})": "Показать все ({n})",
 "Ver {nome}": "Открыть {nome}",
 "Verificar agora": "Проверить сейчас",
 "Vermífugo": "Глистогонное",
 "Vermífugo ou remédio": "Глистогонное или лекарство",
 "Vermífugos e remédios": "Глистогонные и лекарства",
 "Verso": "Оборот",
 "Verso do documento": "Оборотная сторона документа",
 "Versão do PDF": "Версия PDF",
 "Versão instalada": "Установленная версия",
 "Versão {versao} disponível": "Доступна версия {versao}",
 "Versão {v}": "Версия {v}",
 "Veterinário": "Ветеринар",
 "Veterinário ou clínica": "Ветеринар или клиника",
 "Veículo": "Транспорт",
 "Veículo e acessórios": "Транспорт и аксессуары",
 "Veículos": "Транспорт",
 "Veículos & Manutenção": "Транспорт и ТО",
 "Vi mais um episódio": "Посмотрел(а) ещё серию",
 "Viagem": "Поездка",
 "Viagens": "Поездки",
 "Viagens & Lazer": "Путешествия и досуг",
 "Viagens e lugares": "Путешествия и места",
 "Vida noturna": "Ночная жизнь",
 "Vidros e esquadrias": "Окна и рамы",
 "Vigente": "Действует",
 "Vigentes": "Действующие",
 "Virar": "Перевернуть",
 "Virar a câmera": "Сменить камеру",
 "Virar tarefa (levar à assistência)": "Сделать задачей (отнести в сервис)",
 "Visita domiciliar": "Визит на дом",
 "Visitados": "Посещённые",
 "Visto": "Просмотрено",
 "Vistoria": "Осмотр",
 "Vistoria: {i}": "Осмотр: {i}",
 "Vistorias": "Осмотры",
 "Visualizar feriados": "Просмотр праздников",
 "Vitamina": "Витамин",
 "Vitamina D": "Витамин D",
 "Vitaminas, whey, creatina... com a frequência de cada um. O que for de hoje aparece em \"Hoje\" para marcar.": "Витамины, протеин, креатин... с частотой для каждого. Всё, что на сегодня, появится в разделе «Сегодня» для отметки.",
 "Você": "Вы",
 "Você aceitou os termos em {data}.": "Вы приняли условия {data}.",
 "Você ainda não tem amigos no app. Adicione pelo código.": "У вас пока нет друзей в приложении. Добавьте по коду.",
 "Você ainda não tem fichários. Crie um na aba Estudos.": "У вас ещё нет папок. Создайте папку во вкладке «Учёба».",
 "Você deixa de ver a conversa, os documentos e as reuniões.": "Вы больше не будете видеть чат, документы и встречи.",
 "Você deve: {v}": "Вы должны: {v}",
 "Você entrou no grupo": "Вы вступили в группу",
 "Você entrou no grupo \"{nome}\".": "Вы вступили в группу «{nome}».",
 "Você está convidado(a) para: {evento}": "Приглашаем вас на: {evento}",
 "Você foi convidado para o My Planner": "Вас пригласили в My Planner",
 "Você foi convidado para o grupo": "Вас пригласили в группу",
 "Você juntou {v} para \"{m}\".": "Вы накопили {v} на \"{m}\".",
 "Você já tem todas as abas.": "У вас уже есть все вкладки.",
 "Você já usou um código de indicação nesta conta.": "В этом аккаунте уже использован код приглашения.",
 "Você ligou": "Исходящий звонок",
 "Você mesmo pode apagar a conta a qualquer momento, pelo app no celular ou pelo site:": "Вы можете удалить аккаунт в любой момент в приложении на телефоне или на сайте:",
 "Você não tem permissão para isso neste grupo.": "У вас нет прав на это в этой группе.",
 "Você não vê os outros membros deste grupo.": "Вы не видите других участников этой группы.",
 "Você pode apagar a conta a qualquer momento em Ajustes > Segurança. Isso apaga para sempre os dados na nuvem e no dispositivo.": "Вы можете удалить аккаунт в любой момент в разделе Настройки > Безопасность. Это навсегда удалит данные в облаке и на устройстве.",
 "Você pode: confirmar se tratamos seus dados, acessar, corrigir, pedir a portabilidade (exportar o arquivo em Ajustes > Configuração geral), pedir a exclusão, saber com quem compartilhamos, revogar o consentimento e reclamar na ANPD.": "Вы можете: узнать, обрабатываем ли мы ваши данные, получить к ним доступ, исправить их, запросить перенос (экспортировать файл в разделе Настройки > Общие настройки), запросить удаление, узнать, с кем мы ими делимся, отозвать согласие и подать жалобу в ANPD.",
 "Você recebe (líquido)": "Вы получаете (чистыми)",
 "Você é responsável pela sua senha e pelo que é feito na sua conta. Use dados verdadeiros no cadastro.": "Вы несёте ответственность за свой пароль и за действия в вашем аккаунте. Указывайте при регистрации достоверные данные.",
 "Volta": "Возвращение",
 "Volta ou check-out": "Возвращение или выезд",
 "Volta às {hora}": "Возврат в {hora}",
 "Voltar": "Назад",
 "Voltar ao cardápio da semana neste dia": "Вернуть недельное меню в этот день",
 "Voltar ao cálculo": "Назад к расчёту",
 "Voltar ao foco": "Вернуться к фокусу",
 "Voltar ao padrão": "Вернуть по умолчанию",
 "Voltar ao planejado": "Вернуть к плану",
 "Voltar para Anotações": "Назад к заметкам",
 "Voltar para as cores do My Planner": "Вернуть цвета My Planner",
 "Voltar para novas": "Назад к новым",
 "Voltar para o QR Code": "Назад к QR-коду",
 "Volte para o app My Planner no celular. A tela de Ajustes atualiza sozinha.": "Вернитесь в приложение My Planner на телефоне. Экран настроек обновится сам.",
 "Voo": "Рейс",
 "Voos, hotéis, carro e passeios num lugar só, com o código e o comprovante.": "Рейсы, отели, авто и экскурсии в одном месте, с кодом и подтверждением.",
 "Vá em Ajustes e toque em \"Conectar navegador\".": "Перейдите в Настройки и нажмите «Подключить браузер».",
 "Vá em Ajustes › Configuração geral e toque em \"Conectar navegador\".": "Перейдите в Настройки › Общие настройки и нажмите «Подключить браузер».",
 "Várias páginas por folha": "Несколько страниц на листе",
 "Vários PDFs num só, na ordem que você escolher.": "Несколько PDF в одном, в выбранном вами порядке.",
 "Vê as aulas e os materiais liberados.": "Видит открытые уроки и материалы.",
 "Vê as etapas e registra o diário.": "Видит этапы и ведёт дневник.",
 "Vê e altera tudo, inclusive os valores.": "Видит и изменяет всё, включая суммы.",
 "Vê e envia os documentos da própria pasta e responde aos pedidos.": "Видит и отправляет документы своей папки и отвечает на запросы.",
 "Vê o andamento, sem os valores e sem alterar.": "Видит ход работ, без сумм и без изменений.",
 "Vê os check-ins e check-outs e marca a limpeza feita, sem valores.": "Видит заезды и выезды и отмечает выполненную уборку, без сумм.",
 "Vê tudo e lança gastos, lugares, roteiro e mala.": "Видит всё и вносит расходы, места, маршрут и багаж.",
 "Vê tudo, inclui, edita, comenta e põe fotos. Só não coloca nem tira pessoas do grupo.": "Видит всё, добавляет, редактирует, комментирует и загружает фото. Только не может добавлять и удалять людей из группы.",
 "Vê tudo, inclusive os valores, sem alterar.": "Видит всё, включая суммы, без изменений.",
 "Vídeo": "Видео",
 "Vínculo": "Связь",
 "Vínculo perdido": "Связь потеряна",
 "WhatsApp da assistência": "WhatsApp сервиса",
 "Whey": "Сывороточный протеин",
 "Wi-Fi (rede e senha)": "Wi-Fi (сеть и пароль)",
 "Yoga": "Йога",
 "Zumbi e Consciência Negra": "День Зумби и чёрного самосознания",
 "Zzz": "Zzz",
 "a cada {n} dias": "каждые {n} дн.",
 "a pagar": "к оплате",
 "a receber": "к получению",
 "a receber {v}": "к получению {v}",
 "a reserva": "бронирования",
 "a última execução falhou; avise o suporte": "последний запуск завершился ошибкой; сообщите в поддержку",
 "abr": "апр.",
 "abril": "апрель",
 "acabou": "закончилось",
 "achatado": "сглажено",
 "administra": "администратор",
 "ago": "авг.",
 "agosto": "август",
 "ajustado": "изменено",
 "algo novo": "что-то новое",
 "alterou": "изменил(а)",
 "amanhã": "завтра",
 "anual": "ежегодно",
 "apagou": "удалил(а)",
 "aplicada em {d}": "сделана {d}",
 "app {v} · atualização {p} de {data}": "приложение {v} · обновление {p} от {data}",
 "assinado": "подписано",
 "atrasada": "просрочено",
 "atrasada há {n} dia(s)": "просрочено на {n} дн.",
 "até": "до",
 "até {data}": "до {data}",
 "até {d}": "до {d}",
 "aula {a} de {n}": "урок {a} из {n}",
 "avisos silenciados": "уведомления отключены",
 "caixa": "блок",
 "colher(es)": "ложк.",
 "coluna": "столбец",
 "com anexos": "с вложениями",
 "com imagem": "с изображением",
 "com tarjas": "с закраской",
 "com texto": "с текстом",
 "com {p}": "у {p}",
 "como planejado": "по плану",
 "comprado em {data}": "куплено {data}",
 "comprado em {d} por {v}": "куплено {d} за {v}",
 "comprimido": "сжато",
 "comprovante": "подтверждение",
 "concha(s)": "полов.",
 "confirmados": "придут",
 "consulta recusada": "запрос отклонён",
 "contratado": "нанят",
 "contínuo": "постоянно",
 "copo(s)": "стак.",
 "corridos": "календарных",
 "criou o grupo": "создал(а) группу",
 "de": "из",
 "de Anotações": "из Заметок",
 "de {meta} passos": "из {meta} шагов",
 "de {n}": "из {n}",
 "de {p}": "от {p}",
 "dentro / fora do planejado": "по плану / вне плана",
 "desconto {v}": "скидка {v}",
 "desfazer": "отменить",
 "destino": "место назначения",
 "deve {v}": "должен {v}",
 "devolvido em {d}": "возвращено {d}",
 "dez": "дек.",
 "dezembro": "декабрь",
 "dia": "день",
 "dias": "дн.",
 "dias com a meta batida": "дней с выполненной целью",
 "dias com a meta de passos": "дней с целью по шагам",
 "digital": "отпечаток пальца",
 "diária média": "средняя цена за ночь",
 "do cliente": "от клиента",
 "do escritório": "от бюро",
 "dom": "вс",
 "domingo": "воскресенье",
 "e mais {n}": "и ещё {n}",
 "em aberto": "не оплачен",
 "em atraso": "просрочен",
 "em {n} dias": "через {n} дн.",
 "emitida": "выставлен",
 "entregue": "сдано",
 "entrou no escritório": "присоединился(-ась) к офису",
 "enviado": "отправлено",
 "escaneado": "скан",
 "escolha": "выбрать",
 "este": "этот",
 "este dispositivo": "это устройство",
 "este item": "этот пункт",
 "exercícios concluídos": "упражнений выполнено",
 "falta {v}": "осталось {v}",
 "faltam {km}": "осталось {km}",
 "fatia(s)": "ломт.",
 "faturamento": "выручка",
 "feita em {d}": "сделано {d}",
 "feito {dur}": "выполнено {dur}",
 "fev": "февр.",
 "fevereiro": "февраль",
 "frequência {p}%": "посещаемость {p}%",
 "gasto {v}": "потрачено {v}",
 "girado": "повёрнуто",
 "guardado": "сохранено",
 "higienizado": "очищено",
 "hoje": "сегодня",
 "hora fixa no dia": "фиксированное время дня",
 "há {n} dias": "{n} дн. назад",
 "iPhone ou computador: {link}": "iPhone или компьютер: {link}",
 "incluiu": "добавил(а)",
 "jan": "янв.",
 "janeiro": "январь",
 "jul": "июл.",
 "julho": "июль",
 "jun": "июн.",
 "junho": "июнь",
 "já importado": "уже импортировано",
 "liberar em {d}": "открыть {d}",
 "ligou o compartilhamento": "включил(а) общий доступ",
 "linha": "строка",
 "lucro líquido": "чистая прибыль",
 "mai": "мая",
 "maio": "май",
 "mar": "мар.",
 "marca d'água": "водяной знак",
 "marcada por {nome}": "назначил(а) {nome}",
 "março": "март",
 "menos de 1 ano": "меньше 1 года",
 "mensalidade": "ежемесячная плата",
 "meta batida!": "цель достигнута!",
 "metadados": "метаданные",
 "min": "мин",
 "min antes": "мин до",
 "min antes do início": "мин до начала",
 "min · {de} às {ate}": "мин · с {de} до {ate}",
 "multa e juros {v}": "пени и проценты {v}",
 "média {m}": "среднее {m}",
 "mês(es)": "мес.",
 "na nuvem": "в облаке",
 "na pasta \"{pasta}\"": "в папке \"{pasta}\"",
 "na pasta escolhida": "в выбранной папке",
 "neste dispositivo": "на этом устройстве",
 "neste celular": "на этом телефоне",
 "no Planner": "в планере",
 "no {nome}": "в {nome}",
 "nos próximos dias": "в ближайшие дни",
 "nov": "нояб.",
 "novembro": "ноябрь",
 "numerado": "пронумеровано",
 "nunca verificado": "ни разу не проверялось",
 "não vão": "не придут",
 "o documento mudou depois disso: guarde de novo": "документ изменился после этого: сохраните снова",
 "ocupação": "загрузка",
 "ontem": "вчера",
 "organizado": "упорядочено",
 "orçando": "обсуждается",
 "out": "окт.",
 "outubro": "октябрь",
 "paga": "оплачен",
 "paga em {d}": "оплачен {d}",
 "pago": "оплачено",
 "pago em {d}": "оплачено {d}",
 "pago por {p}": "оплатил(а) {p}",
 "pagou {v}": "заплатил(а) {v}",
 "parcela {a} de {n}": "платёж {a} из {n}",
 "parece já lançado": "похоже, уже внесено",
 "parte {n}": "часть {n}",
 "passos por dia (média)": "шагов в день (в среднем)",
 "passou {km}": "превышено на {km}",
 "pausa {p}": "отдых {p}",
 "pausado": "на паузе",
 "peso {n}": "вес {n}",
 "pesquisável": "с поиском",
 "por dia": "в день",
 "por dia (média)": "в день (в среднем)",
 "por dia disponível": "за доступный день",
 "por semana": "в неделю",
 "por {p}": "от {p}",
 "porção(ões)": "порц.",
 "preenchido": "заполнено",
 "primeira às {hora}: {tarefa}": "первая в {hora}: {tarefa}",
 "produção": "рабочая",
 "próxima em {data}": "следующее {data}",
 "próxima rega {d}": "следующий полив {d}",
 "publicação": "публикация",
 "página de estudo": "страница учёбы",
 "página única": "одна страница",
 "páginas": "стр.",
 "páginas {p}": "страницы {p}",
 "qua": "ср",
 "quarta": "среда",
 "quarta-feira": "среда",
 "qui": "чт",
 "quinta": "четверг",
 "quinta-feira": "четверг",
 "quitada": "погашен",
 "recebe {v}": "получает {v}",
 "recebida": "получен",
 "reconhecimento facial": "распознавание лица",
 "recortado": "обрезано",
 "refeições feitas": "приёмов пищи",
 "rega a cada {n} dias": "полив каждые {n} дн.",
 "regar hoje": "полить сегодня",
 "reparado": "восстановлено",
 "retorno {d}": "повторный приём {d}",
 "saldo {v}": "баланс {v}",
 "seg": "пн",
 "segunda": "понедельник",
 "segunda-feira": "понедельник",
 "sem anotações": "без аннотаций",
 "sem as páginas {p}": "без страниц {p}",
 "sem cliente": "без клиента",
 "sem dias previstos": "нет запланированных дней",
 "sem horário": "без времени",
 "sem meta": "без цели",
 "sem resposta": "нет ответа",
 "sem tempo": "нет времени",
 "semana(s)": "нед.",
 "set": "сент.",
 "setembro": "сентябрь",
 "seu@email.com": "vy@email.com",
 "sex": "пт",
 "sexta": "пятница",
 "sexta-feira": "пятница",
 "sáb": "сб",
 "sábado": "суббота",
 "talvez": "возможно",
 "tarefa da casa": "домашнее дело",
 "tarefa: {t}": "задание: {t}",
 "taxas e despesas": "комиссии и расходы",
 "ter": "вт",
 "termina em {d}": "заканчивается {d}",
 "terça": "вторник",
 "terça-feira": "вторник",
 "teste": "тест",
 "todas": "все",
 "todo ano em {d}": "каждый год {d}",
 "todo dia {d}": "каждый месяц {d}-го",
 "todos": "все",
 "toque para abrir": "нажмите, чтобы открыть",
 "toque para pausar": "нажмите для паузы",
 "toque para ver o contato": "нажмите, чтобы открыть контакт",
 "toque para voltar a hoje": "нажмите, чтобы вернуться к сегодня",
 "treinos concluídos": "тренировок выполнено",
 "uma vez em {d}": "однократно {d}",
 "unidade(s)": "шт.",
 "vale {n}": "макс. {n}",
 "vence em {n} dias": "истекает через {n} дн.",
 "vence {d}": "срок {d}",
 "venceu em {data}": "истекла {data}",
 "vencido": "просрочено",
 "vendido com ganho de {v}": "продано с прибылью {v}",
 "vendido com perda de {v}": "продано с убытком {v}",
 "verificado {quando}": "проверено {quando}",
 "você": "вы",
 "você administra": "вы админ",
 "xícara(s)": "чашк.",
 "{aba} bloqueada": "{aba}: заблокировано",
 "{aba} está bloqueada": "Вкладка {aba} заблокирована",
 "{aba}, em \"Anotações recebidas\"": "{aba}, в «Полученных заметках»",
 "{a} aula(s) feita(s)": "Пройдено уроков: {a}",
 "{a} de {n} aulas": "{a} из {n} уроков",
 "{c} chegou a {p}% do orçamento ({g} de {l}).": "{c}: достигнуто {p}% бюджета ({g} из {l}).",
 "{c} confirmados de {n} convidados": "Подтвердили {c} из {n} гостей",
 "{c} está em {p}% do orçamento do mês. Ainda faltam {dias} dia(s) para o mês acabar.": "{c}: {p}% бюджета месяца. До конца месяца осталось дней: {dias}.",
 "{c} já está {v} acima do mês passado inteiro. Confira se foi algo fora do comum.": "{c}: уже на {v} больше, чем за весь прошлый месяц. Проверьте, не было ли чего-то необычного.",
 "{c} já passou do orçamento: {g} de {l}. Segure esse gasto até o mês virar.": "{c}: бюджет уже превышен: {g} из {l}. Придержите эти расходы до нового месяца.",
 "{c} passou do orçamento: {g} de {l}.": "{c}: бюджет превышен: {g} из {l}.",
 "{de} paga {v} para {para}": "{de} → {para}: {v}",
 "{de} às {ate}": "с {de} до {ate}",
 "{dia}, {d} de {mes} de {a}": "{dia}, {d} {mes} {a} г.",
 "{dia}, {d} {mes}": "{dia}, {d} {mes}",
 "{dia}, {d}/{m}": "{dia}, {d}.{m}",
 "{dur} na semana": "{dur} за неделю",
 "{dur} registrados": "записано: {dur}",
 "{d}/{n} notas": "Отметок: {d}/{n}",
 "{feito} de {meta}": "{feito} из {meta}",
 "{fonte} · {data}": "{fonte} · {data}",
 "{f} de {n} feitas": "Сделано {f} из {n}",
 "{f}/{n} transferências feitas": "Переоформлено: {f}/{n}",
 "{hora} em {fuso}": "{hora} ({fuso})",
 "{h} este mês": "{h} в этом месяце",
 "{h} h": "{h} ч",
 "{h} h {m} min": "{h} ч {m} мин",
 "{h} no seu relógio": "{h} по вашим часам",
 "{ia} conectado. {n} modelo(s) disponível(is) na sua conta.": "{ia} подключён. Доступно моделей в вашем аккаунте: {n}.",
 "{ia}: chave de API inválida ou sem permissão.": "{ia}: неверный API-ключ или нет доступа.",
 "{ia}: limite de uso atingido. Confira o saldo ou o limite da sua conta de API.": "{ia}: достигнут лимит использования. Проверьте баланс или лимит своего API-аккаунта.",
 "{item}: em {n} dias ({data}).": "{item}: через {n} дн. ({data}).",
 "{item}: hoje ({data}).": "{item}: сегодня ({data}).",
 "{item}: termina em {n} dias ({data}).": "{item}: истекает через {n} дн. ({data}).",
 "{item}: vence em {n} dias ({data}).": "{item}: истекает через {n} дн. ({data}).",
 "{item}: vence hoje ({data}).": "{item}: истекает сегодня ({data}).",
 "{item}: venceu em {data} e ainda não foi marcado como feito.": "{item}: срок истёк {data}, но ещё не отмечено как выполненное.",
 "{livre} livres de {total}": "Свободно {livre} из {total}",
 "{m} min": "{m} мин",
 "{nome} agora é seu amigo. Já podem conversar.": "{nome} теперь ваш друг. Можно общаться.",
 "{nome} conectado!": "{nome} подключён!",
 "{nome} ligou": "{nome} звонил(а)",
 "{novas} nova(s), {atualizadas} atualizada(s), {enviadas} enviada(s), {removidas} removida(s)": "Новых: {novas}, обновлено: {atualizadas}, отправлено: {enviadas}, удалено: {removidas}",
 "{n} ITEM(NS)": "ПОЗИЦИЙ: {n}",
 "{n} aba(s) no seu plano · cores e opções de cada uma": "Вкладок в вашем плане: {n} · цвета и параметры каждой",
 "{n} aba(s) para comprar": "Вкладок для покупки: {n}",
 "{n} adicionada(s)": "Добавлено: {n}",
 "{n} alerta(s) agendado(s) neste celular para os próximos dias.": "Запланировано оповещений на этом телефоне на ближайшие дни: {n}.",
 "{n} aluno(s)": "Учеников: {n}",
 "{n} anexo(s)": "Вложений: {n}",
 "{n} ano(s)": "{n} г.",
 "{n} arquivo(s)": "{n} файл(ов)",
 "{n} atendimento(s)": "Приёмов: {n}",
 "{n} atrasada(s)": "Просрочено: {n}",
 "{n} atrasado(s)": "Просрочено: {n}",
 "{n} caixa(s)": "Коробок: {n}",
 "{n} caixa(s) frágil(eis)": "Хрупких коробок: {n}",
 "{n} caixa(s) · {a} já aberta(s) na casa nova": "Коробок: {n} · уже открыто в новом доме: {a}",
 "{n} cancelada(s).": "Аннулировано: {n}.",
 "{n} cartão(ões) abertos": "Открытых карточек: {n}",
 "{n} cobrança(s) criada(s) com vencimento em {d}.": "Создано счетов: {n}, срок оплаты {d}.",
 "{n} com vencimento": "Со сроком оплаты: {n}",
 "{n} compra(s) no cartão {c}. As parcelas futuras já aparecem nas próximas faturas.": "Покупок по карте {c}: {n}. Будущие платежи уже видны в следующих счетах.",
 "{n} conta(s) marcada(s) como paga(s) automaticamente.": "Автоматически отмечено как оплаченные счета: {n}.",
 "{n} copo(s), {ml} de {meta}": "{n} стак., {ml} из {meta}",
 "{n} de {meta} copos": "{n} из {meta} стаканов",
 "{n} de {total}": "{n} из {total}",
 "{n} de {total} dias": "{n} из {total} дн.",
 "{n} de {total} hoje": "{n} из {total} сегодня",
 "{n} de {t} item(ns) com preço, dos cupons lidos em Finanças.": "{n} из {t} позиций с ценой, из чеков, прочитанных в Финансах.",
 "{n} dia(s)": "{n} дн.",
 "{n} dia(s) seguido(s) lendo": "{n} дн. подряд с чтением",
 "{n} dia(s) tirado(s) de tarefas que se repetem": "Убрано дней из повторяющихся задач: {n}",
 "{n} dias": "{n} дн.",
 "{n} dias grátis": "{n} дн. бесплатно",
 "{n} dias grátis para testar": "{n} дн. бесплатного теста",
 "{n} dias {tipo}: publicada em {pub}, contagem a partir de {ini}, vence em {fim}.": "{n} {tipo} дн.: опубликовано {pub}, отсчёт с {ini}, срок истекает {fim}.",
 "{n} documento(s)": "Документов: {n}",
 "{n} em atraso": "Просрочено: {n}",
 "{n} etapa(s) atrasada(s)": "Просроченных этапов: {n}",
 "{n} exclusão(ões) esperando o celular sincronizar.": "Удалений, ожидающих синхронизации телефона: {n}.",
 "{n} falta(s)": "Пропусков: {n}",
 "{n} ficha(s) no grupo. Escolha o papel de cada pessoa em Membros.": "Записей в группе: {n}. Выберите роль каждого человека в разделе «Участники».",
 "{n} foto(s) e vídeo(s) da viagem, de todos do grupo. Fotos do roteiro, dos lugares e das reservas também aparecem aqui.": "Фото и видео из поездки от всей группы: {n}. Фото из маршрута, мест и бронирований тоже появляются здесь.",
 "{n} item(ns) adicionado(s).": "Добавлено элементов: {n}.",
 "{n} item(ns) com outras pessoas": "Вещей у других: {n}",
 "{n} item(ns) no Planner.": "{n} пункт(ов) в Planner.",
 "{n} lançamento(s) encontrado(s)": "Найдено записей: {n}",
 "{n} lançamento(s) novo(s).": "Новых записей: {n}.",
 "{n} lembrete(s) colocado(s) no My Planner.": "Напоминаний добавлено в My Planner: {n}.",
 "{n} livro(s) lido(s) este ano": "Прочитано книг в этом году: {n}",
 "{n} marcado(s)": "Отмечено: {n}",
 "{n} matéria(s)": "Предметов: {n}",
 "{n} membro(s) · abrir a conversa do grupo": "Участников: {n} · открыть групповой чат",
 "{n} meses grátis a partir da criação da conta; depois {preco} por ano.": "{n} мес. бесплатно с момента создания аккаунта; затем {preco} в год.",
 "{n} min": "{n} мин",
 "{n} min antes": "за {n} мин",
 "{n} módulo(s)": "Модулей: {n}",
 "{n} noite(s)": "Ночей: {n}",
 "{n} nota(s) nova(s).": "Новых счетов: {n}.",
 "{n} nota(s) sem XML neste dispositivo ficaram de fora.": "Счетов без XML на этом устройстве пропущено: {n}.",
 "{n} nota(s) · emitidas {e} · recebidas {r}": "Счетов: {n} · выставлено {e} · получено {r}",
 "{n} nova(s)": "Новых: {n}",
 "{n} novo(s) do cliente": "Новых от клиента: {n}",
 "{n} novo(s) para aceitar, editar ou recusar.": "{n} новых: примите, измените или отклоните.",
 "{n} parcela(s) colocada(s) no My Planner.": "Добавлено платежей в My Planner: {n}.",
 "{n} parcela(s) em aberto refeitas. As pagas ficaram como estavam.": "Пересчитано неоплаченных платежей: {n}. Оплаченные остались без изменений.",
 "{n} parcela(s) em atraso": "Просроченных платежей: {n}",
 "{n} parcela(s) em atraso: {v}": "Просроченных платежей: {n} · {v}",
 "{n} participantes · toque para ver": "Участников: {n} · нажмите, чтобы посмотреть",
 "{n} passo(s)": "Шагов: {n}",
 "{n} pausa(s)": "Перерывов: {n}",
 "{n} pedido(s) de amizade": "Запросов в друзья: {n}",
 "{n} pedido(s) em aberto": "Открытых запросов: {n}",
 "{n} pessoa(s)": "{n} чел.",
 "{n} pessoa(s) já entraram com o seu código.": "Уже присоединились по вашему коду: {n}",
 "{n} pessoas": "{n} чел.",
 "{n} por folha": "{n} на лист",
 "{n} porções": "Порций: {n}",
 "{n} publicação(ões) nova(s).": "Новых публикаций: {n}.",
 "{n} publicações novas": "Новых публикаций: {n}",
 "{n} página(s)": "Страниц: {n}",
 "{n} página(s) · {r} revisada(s)": "Страниц: {n} · повторено: {r}",
 "{n} páginas": "{n} стр.",
 "{n} recebido(s) dos seus grupos": "Получено из ваших групп: {n}",
 "{n} recebido(s) para responder": "Ждут ответа: {n}",
 "{n} refeição(ões), com o cardápio daquele dia": "{n} приём(ов) пищи с меню на тот день",
 "{n} reserva(s) nova(s) ou alterada(s).": "Новых или изменённых бронирований: {n}.",
 "{n} resultado(s) em todas as publicações": "Результатов во всех публикациях: {n}",
 "{n} selecionado(s): {lista}": "Выбрано {n}: {lista}",
 "{n} tarefa(s)": "Задач: {n}",
 "{n} tarefa(s) apagada(s) por inteiro": "Полностью удалено задач: {n}",
 "{n} tarefa(s) criada(s)": "Создано задач: {n}",
 "{n} tarefa(s) da casa saíram do My Planner e agora ficam só em Minha Casa. Para levar uma delas ao Planner, abra a tarefa e toque em \"Enviar para o My Planner\".": "Дела по дому ({n}) убраны из My Planner и теперь есть только в разделе «Мой дом». Чтобы вернуть дело в Planner, откройте его и нажмите «Отправить в My Planner».",
 "{n} tarefa(s) de ontem sem concluir": "Невыполненных задач со вчера: {n}",
 "{n} tarefa(s) dos últimos dias sem concluir": "Невыполненных задач за последние дни: {n}",
 "{n} tarefa(s) hoje": "Задач на сегодня: {n}",
 "{n} tarefa(s) pendente(s) vão para a lista de hoje.": "Незавершённые задачи ({n}) перейдут в список на сегодня.",
 "{n} tarjas no documento": "Закрашенных областей в документе: {n}",
 "{n} treino(s), cada um nos dias dele": "{n} тренировк(и), каждая в свои дни",
 "{n} tribunais": "Судов: {n}",
 "{n}x de {v}": "{n} × {v}",
 "{n}º alerta": "Напоминание {n}",
 "{n}× {item}": "{n}× {item}",
 "{ok} enviado(s), {falhas} com erro. Tente de novo mais tarde.": "Отправлено: {ok}, с ошибкой: {falhas}. Попробуйте позже.",
 "{ok} enviado(s).": "Отправлено: {ok}.",
 "{o} de {d} noites ocupadas. Reservas que passam de um mês para outro são divididas pelas noites.": "Занято ночей: {o} из {d}. Бронирования на стыке месяцев делятся по ночам.",
 "{preco} por ano": "{preco} в год",
 "{p} de {t} parcelas pagas ({pct}%)": "Оплачено {p} из {t} платежей ({pct}%)",
 "{p} presentes · {f} faltas": "{p} присутств. · {f} пропусков",
 "{p}% da meta de {m} páginas": "{p}% от цели в {m} стр.",
 "{p}% feito": "Выполнено {p}%",
 "{p}% ocupado no mês": "Загрузка за месяц: {p}%",
 "{p}% pronta": "Готово на {p}%",
 "{p}/{t} pagas": "Оплачено {p}/{t}",
 "{quem} convidou você para o grupo \"{grupo}\" no My Planner. Toque no link para entrar (o app é gratuito para começar): {link}\nCódigo do convite: {codigo}": "{quem} приглашает вас в группу «{grupo}» в My Planner. Нажмите на ссылку, чтобы вступить (начать можно бесплатно): {link}\nКод приглашения: {codigo}",
 "{quem} e outros incluíram {n} itens no grupo.": "{quem} и другие добавили в группу элементов: {n}.",
 "{quem} incluiu {item} no grupo.": "{quem} добавил(а) в группу: {item}.",
 "{servico} do veículo": "{servico} транспорта",
 "{s} de {a}": "{s} из {a}",
 "{tarefa}: volte às {hora}": "{tarefa}: вернитесь в {hora}",
 "{tipo}: {p}": "{tipo}: {p}",
 "{titulo} (cópia)": "{titulo} (копия)",
 "{uso} usados de {total} reservados para o site": "Использовано {uso} из {total}, зарезервированных для сайта",
 "{v} · atualização de {data}": "{v} · обновление от {data}",
 "{v}/hora": "{v}/час",
 "À direita": "Справа",
 "À vista": "Единовременно",
 "Às": "В",
 "Às {hora}": "В {hora}",
 "ÁGUA": "ВОДА",
 "Ácido": "Кислый",
 "Água": "Вода",
 "Água hoje": "Вода сегодня",
 "Área externa": "Двор",
 "Áreas": "Разделы",
 "Áudio": "Аудио",
 "É um auxílio e não substitui o acompanhamento das intimações nos canais oficiais. Prazos devem ser conferidos no sistema oficial.": "Это вспомогательный инструмент, он не заменяет отслеживание извещений по официальным каналам. Сроки нужно проверять в официальной системе.",
 "Ética Profissional": "Профессиональная этика",
 "Ícone e aba": "Значок и вкладка",
 "Óculos de sol": "Солнцезащитные очки",
 "Órgão emissor (ex.: DETRAN-MS, Polícia Federal)": "Кем выдан (напр.: DETRAN-MS, Федеральная полиция)",
 "Órgão emissor: {nome}": "Кем выдан: {nome}",
 "Ômega 3": "Омега-3",
 "Última": "Последняя",
 "Última adubação": "Последняя подкормка",
 "Última aplicação": "Последнее введение",
 "Última busca do servidor para você: {quando}": "Последний поиск сервера для вас: {quando}",
 "Última cópia de segurança: {data}": "Последняя резервная копия: {data}",
 "Última rega": "Последний полив",
 "Última sincronização: {quando}": "Последняя синхронизация: {quando}",
 "Última: {data}": "Последняя: {data}",
 "Último dia para entregar a declaração do IR": "Последний день подачи декларации IR",
 "Último erro: {m}": "Последняя ошибка: {m}",
 "Últimos 30 dias": "Последние 30 дней",
 "Últimos 7 dias": "Последние 7 дней",
 "íris": "радужка",
 "última vez em {data}": "последний раз {data}",
 "último em {d}": "последний {d}",
 "úteis": "рабочих",
 "★ é a cor do My Planner. A escolha vale para todas as conversas deste dispositivo e da sua conta.": "★ — цвет My Planner. Выбор действует для всех чатов на этом устройстве и в вашем аккаунте.",
 "🎥 {nome} está ligando (vídeo)": "🎥 {nome} звонит (видео)",
 "📆 Conectar a agenda deste celular": "📆 Подключить календарь этого телефона",
 "📞 {nome} está ligando (áudio)": "📞 {nome} звонит (аудио)",
 "Link bloqueado por segurança.": "Ссылка заблокирована в целях безопасности.",
 "Este arquivo não é uma imagem válida.": "Этот файл не является изображением.",
 "A busca automática do servidor acompanha os 5 primeiros perfis. Os outros entram quando você toca em \"Verificar agora\".": "Автоматический поиск на сервере отслеживает первые 5 профилей. Остальные проверяются, когда вы нажимаете «Проверить сейчас».",
 "Esta tela mostra a linha do tempo da viagem, com as atividades e os lugares que têm dia marcado. Para adicionar ou editar as informações completas de um lugar, use a aba Lugares.": "На этом экране показана хронология поездки с занятиями и местами, у которых указан день. Чтобы добавить или изменить полные данные места, откройте вкладку «Места».",
 "Para a viagem {d}": "Для поездки {d}",
 "sem nome": "без названия",
 "Foi para a viagem {d}.": "Перенесено в поездку {d}.",
 "Orçamento total (se não for detalhar)": "Общий бюджет (если не расписывать)",
 "Monte o roteiro dia a dia. Os lugares com dia marcado entram aqui sozinhos. No período da viagem, o roteiro aparece na linha do tempo do My Planner.": "Составьте маршрут по дням. Места с указанным днём попадают сюда сами. Во время поездки маршрут отображается в хронологии My Planner.",
 "Marque o dia e o horário no lugar para ele aparecer sozinho no Roteiro.": "Укажите у места день и время, чтобы оно само появилось в маршруте.",
 "No roteiro": "В маршруте",
 "\"{nome}\" está no roteiro de {data}. Para mudar o dia ou o horário, edite o lugar.": "«{nome}» в маршруте на {data}. Чтобы изменить день или время, отредактируйте место.",
 "Para o roteiro desta viagem": "Для маршрута этой поездки",
 "Orçamento e gastos": "Бюджет и расходы",
 "Parada (cidade)": "Остановка (город)",
 "Item da categoria": "Пункт категории",
 "Orçamento da viagem inteira": "Бюджет всей поездки",
 "Orçamento geral da viagem": "Общий бюджет поездки",
 "Previsto {p} · gasto {g}": "План {p} · потрачено {g}",
 "Aqui ficam os custos da viagem que não são de uma parada (ex.: passagens, seguro). Cada parada tem o seu orçamento.": "Здесь расходы поездки, не относящиеся к остановке (напр.: билеты, страховка). У каждой остановки свой бюджет.",
 "Coloque quanto pretende gastar em cada categoria. Ao lançar os gastos, o app mostra quanto já foi usado.": "Укажите, сколько планируете потратить в каждой категории. При вводе расходов приложение показывает, сколько уже использовано.",
 "Orçamento por parada": "Бюджет по остановкам",
 "Vai passar por mais de uma cidade? Cadastre as paradas (aba Paradas): cada uma ganha o seu orçamento e os gastos daquelas datas entram nela sozinhos.": "Будете в нескольких городах? Добавьте остановки (вкладка «Остановки»): у каждой будет свой бюджет, а расходы за эти даты попадут в неё сами.",
 "Coloque o valor do gasto.": "Укажите сумму расхода.",
 "Orçamento de {c}": "Бюджет: {c}",
 "Lançar um gasto nesta parada": "Добавить расход на этой остановке",
 "Lançar gasto": "Добавить расход",
 "Orçamento e gastos da parada": "Бюджет и расходы остановки",
 "Gastos lançados ({n})": "Внесённые расходы ({n})",
 "Para corrigir ou apagar um gasto, use a aba Orçamento e gastos da viagem.": "Чтобы исправить или удалить расход, откройте вкладку «Бюджет и расходы» поездки.",
 "Paradas": "Остановки",
 "Cidade ou lugar": "Город или место",
 "Ex.: Porto": "Напр.: Порту",
 "Chegada": "Прибытие",
 "Saída": "Отъезд",
 "Onde vai ficar": "Где остановитесь",
 "gasto {g} de {p}": "потрачено {g} из {p}",
 "Vai passar por mais de uma cidade? Cadastre cada parada com as datas. Cada uma ganha o seu orçamento (hospedagem, refeições, transporte...) e os gastos daquelas datas entram nela sozinhos.": "Будете в нескольких городах? Добавьте каждую остановку с датами. У каждой будет свой бюджет (проживание, питание, транспорт...), а расходы за эти даты попадут в неё сами.",
 "Café da tarde": "Полдник",
 "Outros / Lanches": "Другое / Перекусы",
 "Gasto {v}": "Потрачено {v}",
 "Gasto {g} de {p} · {a} acima": "Потрачено {g} из {p} · превышение {a}",
 "Gasto {g} de {p}": "Потрачено {g} из {p}",
 "Tirar \"{nome}\" do orçamento?": "Убрать «{nome}» из бюджета?",
 "Os gastos já lançados nela continuam na lista de gastos.": "Уже внесённые в неё расходы останутся в списке расходов.",
 "Previsto para {nome}": "План для {nome}",
 "Tirar {nome}": "Убрать {nome}",
 "Nome do item (ex.: Jantar especial)": "Название пункта (напр.: Праздничный ужин)",
 "Adicionar item": "Добавить пункт",
 "Detalhar em itens": "Расписать по пунктам",
 "Nova categoria (ex.: Seguro, Presentes)": "Новая категория (напр.: Страховка, Подарки)",
 "Voltar às categorias sugeridas?": "Вернуть предложенные категории?",
 "Os valores previstos desta lista serão apagados. Os gastos lançados continuam.": "Плановые суммы этого списка будут удалены. Внесённые расходы сохранятся.",
 "Voltar às categorias sugeridas": "Вернуть предложенные категории",
 "Previsto": "План",
 "Ainda pode gastar": "Ещё можно потратить",
 "Passou do previsto": "Сверх плана",
 "Não foi possível buscar o câmbio": "Не удалось получить курс",
 "Sem internet ou a moeda {m} não está na tabela. Edite a viagem e coloque o câmbio à mão.": "Нет интернета или валюты {m} нет в таблице. Отредактируйте поездку и введите курс вручную.",
 "Câmbio de {m} ainda não definido": "Курс {m} ещё не задан",
 "Câmbio de hoje": "Курс сегодня",
 "Atualizado em {d}": "Обновлено {d}",
 "Valor em {m}": "Сумма в {m}",
 "Moeda do destino": "Валюта места назначения",
 "Câmbio: quanto vale 1 da moeda do destino na sua moeda": "Курс: сколько стоит 1 единица валюты назначения в вашей валюте",
 "Sem dia marcado": "День не указан",
 "Valor na moeda do destino": "Сумма в валюте назначения",
 "Tirar só desta lista ou excluir de vez?": "Убрать только из этого списка или удалить совсем?",
 "Excluir de vez": "Удалить совсем",
 "Relatório da viagem (PDF)": "Отчёт о поездке (PDF)",
 "Planilha da viagem (Excel)": "Таблица поездки (Excel)",
 "Geral da viagem": "Вся поездка",
 "Viagem {d}": "Поездка {d}",
 "Quem vai: {p}": "Кто едет: {p}",
 "Outros gastos": "Прочие расходы",
 "Orçamento · {n}": "Бюджет · {n}",
 "Código": "Код",
 "Pagou": "Заплатил",
 "Permissão internacional para dirigir": "Международное водительское удостоверение",
 "Vacina (certificado)": "Вакцина (сертификат)",
 "Autorização de viagem de menor": "Разрешение на выезд ребенка",
 "Vence antes da volta": "Истекает до возвращения",
 "Vence menos de 6 meses depois da volta (muitos países não aceitam)": "Истекает менее чем через 6 месяцев после возвращения (многие страны не принимают)",
 "A lista básica já está aqui.": "Базовый список уже здесь.",
 "{n} documento(s) com validade que pode atrapalhar a viagem": "Документов со сроком, который может помешать поездке: {n}",
 "Lista básica: passaporte de cada um e seguro viagem": "Базовый список: паспорт для каждого и туристическая страховка",
 "Lista básica: identidade de cada um": "Базовый список: удостоверение личности для каждого",
 "Ponha a validade de cada documento: o app avisa antes de vencer e confere se o passaporte vale por 6 meses depois da volta. As fotos dos documentos ficam protegidas no cofre.": "Укажите срок действия каждого документа: приложение предупредит до его истечения и проверит, действует ли паспорт 6 месяцев после возвращения. Фото документов защищены в сейфе.",
 "De quem": "Чей",
 "Número (protegido no cofre)": "Номер (защищен в сейфе)",
 "Está em mãos": "На руках",
 "Válido até {d}": "Действителен до {d}",
 "Passaporte, visto, seguro viagem, vacina, autorização de menor... com a validade e a foto. Marque quando estiver em mãos.": "Паспорт, виза, страховка, вакцина, разрешение для ребенка... со сроком действия и фото. Отметьте, когда документ будет на руках.",
 "acerto entre os viajantes (não entra no orçamento)": "расчёт между путешественниками (не входит в бюджет)",
 "Só gastos": "Только расходы",
 "Acertos": "Расчёты",
 "Marcar como pago?": "Отметить как оплачено?",
 "{de} já pagou {v} para {para}?": "{de} уже заплатил(а) {v} для {para}?",
 "Já pagou": "Уже заплатил(а)",
 "Acerto: {de} pagou {para}": "Расчёт: {de} заплатил(а) {para}",
 "Conferir minhas assinaturas": "Проверить мои подписки",
 "Gerenciar ou cancelar assinaturas na loja": "Управлять подписками или отменить в магазине",
 "Restaurar compras": "Восстановить покупки",
 "Procurando...": "Поиск...",
 "{n} assinatura(s) encontrada(s) e liberada(s).": "Найдено и открыто подписок: {n}.",
 "Assinatura anual, renova sozinha. Cancele quando quiser nas assinaturas da loja, até 24 horas antes da renovação.": "Годовая подписка, продлевается автоматически. Отменить можно в подписках магазина не позднее чем за 24 часа до продления.",
 "Assinaturas da loja": "Подписки магазина",
 "Gerenciar assinaturas (App Store)": "Управлять подписками (App Store)",
 "Gerenciar assinaturas (Google Play)": "Управлять подписками (Google Play)",
 "A assinatura é feita no app do celular (Google Play ou App Store) e vale também aqui no site.": "Подписка оформляется в приложении на телефоне (Google Play или App Store) и действует и здесь на сайте.",
 "Esta assinatura ainda não está disponível na loja. Tente de novo mais tarde.": "Эта подписка пока недоступна в магазине. Попробуйте позже.",
 "Assinatura feita": "Подписка оформлена",
 "Já assinei no celular: conferir": "Я уже подписался на телефоне: проверить",
 "Nenhuma assinatura encontrada nesta conta da loja.": "В этом аккаунте магазина подписок не найдено.",
 "Confira a internet e tente de novo. Nada foi cobrado.": "Проверьте интернет и попробуйте снова. Деньги не списаны.",
 "{aba} liberada. Vale também nos seus outros dispositivos e no site.": "{aba} открыта. Действует и на других устройствах, и на сайте.",
 "Para assinar, atualize o My Planner pela Google Play ou pela App Store.": "Чтобы подписаться, обновите My Planner в Google Play или App Store.",
 "Assinada, renova em {data}": "Подписка, продление {data}",
 "Não deu para assinar agora": "Не удалось оформить подписку",
 "Assinar por {preco} por ano": "Подписаться за {preco} в год",
 "\"{nome}\" foi para o Mural, em Conquistas.": "«{nome}» перенесено на Доску, в раздел «Достижения».",
 "\"{nome}\" já faz parte da sua rotina. Foi para o Mural, em Conquistas.": "«{nome}» уже стало частью вашей жизни. Перенесено на Доску, в раздел «Достижения».",
 "\"{nome}\" voltou para o lugar.": "«{nome}» возвращено на место.",
 "1 ano": "1 год",
 "1 mês": "1 месяц",
 "A IA não achou o valor no comprovante.": "ИИ не нашёл сумму в чеке.",
 "A cada {n} dias": "Каждые {n} дн.",
 "A carta está vazia": "Письмо пустое",
 "A carta fica trancada até {d}. Até lá não dá para reler nem editar. Para mudar algo, escreva outra carta.": "Письмо будет заперто до {d}. До этого его нельзя перечитать или изменить. Чтобы что-то поменять, напишите другое письмо.",
 "A lixeira está vazia.": "Корзина пуста.",
 "A mesma do app e do celular": "Тот же, что в приложении и на телефоне",
 "A mesma forma de desbloqueio do app e do celular": "Тот же способ разблокировки, что в приложении и на телефоне",
 "A senha do diário precisa ter 6 caracteres ou mais.": "Пароль дневника должен содержать не менее 6 символов.",
 "A senha precisa ter 6 caracteres ou mais.": "Пароль должен содержать не менее 6 символов.",
 "A turma ainda não tem grupo": "У класса пока нет группы",
 "AS 4 BOLINHAS DE COR": "4 ЦВЕТНЫХ КРУЖКА",
 "Aberta em {d}": "Открыто {d}",
 "Abra a aba para poder restaurar": "Откройте вкладку, чтобы восстановить",
 "Abra o diário primeiro": "Сначала откройте дневник",
 "Abre com a biometria, o reconhecimento facial ou a senha do app. A senha do diário só é pedida na primeira vez em cada aparelho.": "Открывается по биометрии, распознаванию лица или паролю приложения. Пароль дневника запрашивается только в первый раз на каждом устройстве.",
 "Abre em {d}": "Откроется {d}",
 "Abrir carta para o futuro": "Открыть письмо в будущее",
 "Abrir em {aba}": "Открыть в {aba}",
 "Abrir o Diário": "Открыть Дневник",
 "Abrir o diário": "Открыть дневник",
 "Abrir {aba}": "Открыть {aba}",
 "Acompanha o imóvel, as reservas, a ocupação, as despesas e o lucro, sem alterar nada.": "Следит за объектом, бронированиями, заполняемостью, расходами и прибылью, ничего не изменяя.",
 "Adicionar foto": "Добавить фото",
 "Apaga tudo o que está no quadro desta página.": "Стирает всё, что нарисовано на этой странице.",
 "Apagar o desenho?": "Удалить рисунок?",
 "Apagar o diário": "Удалить дневник",
 "Apagar para todos?": "Удалить для всех?",
 "Aplicar a todas as páginas desta matéria": "Применить ко всем страницам этого предмета",
 "Aplicar a todas as páginas desta pasta": "Применить ко всем страницам этой папки",
 "Apostilas, listas, slides, vídeos, links e recados. Pelo ⋮ › Enviar para a turma, cada aluno recebe no app dele.": "Пособия, списки, слайды, видео, ссылки и объявления. Через ⋮ › Отправить классу каждый ученик получит их в своём приложении.",
 "Aquarela": "Акварель",
 "Aqui aparece, sem custo, o que os grupos compartilharam com você. Para usar a aba com os seus próprios dados, assine a aba.": "Здесь бесплатно показано то, чем группы поделились с вами. Чтобы использовать вкладку со своими данными, оформите на неё подписку.",
 "Arquivados": "В архиве",
 "Arraste para a direita para excluir, ou para a esquerda para arquivar.": "Проведите вправо, чтобы удалить, или влево, чтобы архивировать.",
 "As cobranças desta aula extra já existem.": "Счета за это дополнительное занятие уже созданы.",
 "As notas vão só para cada aluno. Para isso, o nome da pessoa no grupo precisa ser igual ao nome do aluno ou do responsável no cadastro.": "Оценки получает только каждый ученик лично. Для этого имя человека в группе должно совпадать с именем ученика или родителя в карточке.",
 "Atestado": "Справка",
 "Atestados": "Справки",
 "Até quando (opcional)": "До какого числа (необязательно)",
 "Até {d}": "До {d}",
 "Aula extra": "Доп. занятие",
 "Aula extra (fora dos dias de aula)": "Доп. занятие (вне учебных дней)",
 "Aula extra de {d}": "Доп. занятие {d}",
 "Avaliação de {d}": "Оценка от {d}",
 "Avaliação salva": "Оценка сохранена",
 "Avançar": "Далее",
 "Aviso da revisão do mês": "Напоминание об итогах месяца",
 "Aviso no último dia do mês: \"Que tal revisar o seu mês? ✨\"": "Напоминание в последний день месяца: \"Как насчёт подвести итоги месяца? ✨\"",
 "Aviso sem nenhum conteúdo do diário: \"Como foi o seu dia? ✍️\"": "Напоминание без содержимого дневника: \"Как прошёл ваш день? ✍️\"",
 "Avulsa": "Разовый",
 "Avulsas": "Разовые",
 "Azul": "Синий",
 "Baixar na App Store": "Загрузить в App Store",
 "Baixar na Google Play": "Загрузить в Google Play",
 "Baixe o My Planner na loja: Android {android} · iPhone {iphone}": "Скачайте My Planner в магазине: Android {android} · iPhone {iphone}",
 "Biometria, reconhecimento facial ou a senha do app. A senha do diário fica guardada para a primeira vez em cada aparelho.": "Биометрия, распознавание лица или пароль приложения. Пароль дневника сохраняется для первого входа на каждом устройстве.",
 "Branco": "Белый",
 "Buscando o clima…": "Загружаем погоду…",
 "Básicas": "Основные",
 "COMO ESTOU": "КАК Я СЕБЯ ЧУВСТВУЮ",
 "COMO O DIÁRIO ABRE": "КАК ОТКРЫВАЕТСЯ ДНЕВНИК",
 "COR DA FOLHA": "ЦВЕТ ЛИСТА",
 "Caixinha no My Planner": "Блок в My Planner",
 "Caixinha {m}": "Блок {m}",
 "Carta de {d}": "Письмо от {d}",
 "Carta guardada": "Письмо сохранено",
 "Carta para o futuro": "Письмо в будущее",
 "Carta trancada": "Письмо заперто",
 "Cartas abertas podem ser lidas, mas não editadas.": "Открытые письма можно читать, но нельзя изменять.",
 "Cartas para o Futuro": "Письма в будущее",
 "Cartões arquivados": "Архивные карточки",
 "Chegou uma carta da {nome} de {tempo} atrás 💌": "Пришло письмо от {nome}, написанное {tempo} назад 💌",
 "Chegou! Toque para abrir 💌": "Пришло! Нажмите, чтобы открыть 💌",
 "Cinza-escuro": "Тёмно-серый",
 "Clara (segue o tema)": "Светлая (по теме)",
 "Claras e pastel (boas para folha escura)": "Светлые и пастельные (для тёмного листа)",
 "Clima (toque para preencher)": "Погода (нажмите, чтобы заполнить)",
 "Clima automático": "Автоматическая погода",
 "Clima do dia": "Погода дня",
 "Cobrar a aula extra": "Выставить счёт за доп. занятие",
 "Cobrar a aula extra dos presentes": "Выставить счёт присутствовавшим на доп. занятии",
 "Cobrar a turma toda": "Выставить счёт всему классу",
 "Cole um link que comece com https://": "Вставьте ссылку, начинающуюся с https://",
 "Coloque o valor da aula extra na turma (Editar).": "Укажите стоимость доп. занятия в классе (Изменить).",
 "Coloque o valor.": "Укажите сумму.",
 "Colunas": "Столбцы",
 "Com a sua IA ligada (Ajustes › Inteligência artificial), o app lê o valor, a data e a descrição pela foto.": "Если ваш ИИ подключён (Настройки › Искусственный интеллект), приложение считает сумму, дату и описание с фото.",
 "Como cuidei de mim hoje?": "Как я заботилась о себе сегодня?",
 "Como foi o seu dia? ✍️": "Как прошёл ваш день? ✍️",
 "Compartilhar este projeto (convidar)": "Поделиться этим проектом (пригласить)",
 "Compartilhar o texto": "Поделиться текстом",
 "Completa": "Полная",
 "Comprovante (foto, PDF ou print)": "Чек (фото, PDF или скриншот)",
 "Comprovante anexado": "Чек прикреплён",
 "Comprovante de pagamento (foto ou PDF)": "Подтверждение оплаты (фото или PDF)",
 "Concluído: hábito formado": "Завершено: привычка сформирована",
 "Concluídos": "Завершённые",
 "Configurar o Diário": "Настроить Дневник",
 "Confirmar pagamento": "Подтвердить оплату",
 "Confirmar recebimento": "Подтвердить получение",
 "Conquistas": "Достижения",
 "Contas arquivadas": "Архивные счета",
 "Continuar escrevendo": "Продолжить писать",
 "Copiado ✓": "Скопировано ✓",
 "Copiar código": "Копировать код",
 "Copiar link": "Копировать ссылку",
 "Cor atual": "Текущий цвет",
 "Cor {n}": "Цвет {n}",
 "Creme": "Кремовый",
 "Criada em {d}": "Создано {d}",
 "Criar as cobranças": "Создать счета",
 "Criar o grupo da turma": "Создать группу класса",
 "Criar o meu diário": "Создать мой дневник",
 "Crie a senha do diário (6 ou mais)": "Придумайте пароль дневника (6 или более)",
 "Crie o grupo da turma e mande o convite aos alunos. Depois, o envio vai direto para eles.": "Создайте группу класса и отправьте приглашение ученикам. После этого материалы будут приходить прямо им.",
 "Crie sua primeira meta, objetivo ou sonho com o botão + abaixo.": "Создайте первую цель, задачу или мечту кнопкой + ниже.",
 "Crie um projeto, convide quem participa e divida os passos. Cada pessoa marca o que fez.": "Создайте проект, пригласите участников и распределите шаги. Каждый отмечает, что сделал.",
 "Crie uma senha nova para começar.": "Придумайте новый пароль, чтобы начать.",
 "Cuidados arquivados": "Архивный уход",
 "Cuidados pessoais do dia feitos (Bem-Estar)": "Уход за собой на сегодня выполнен (Здоровье)",
 "Curto prazo": "Краткосрочные",
 "Custos": "Расходы",
 "Céu estrelado": "Звёздное небо",
 "Círculo": "Круг",
 "Cômodos arquivados": "Архивные комнаты",
 "DIAS CUMPRIDOS": "ВЫПОЛНЕННЫЕ ДНИ",
 "Data (opcional)": "Дата (необязательно)",
 "De {d}": "От {d}",
 "Desafixar do topo": "Открепить сверху",
 "Desenho mais fraco ou mais forte": "Рисунок слабее или сильнее",
 "Desfazer \"Concluído\" ({d})": "Отменить «Готово» ({d})",
 "Desligado": "Выключено",
 "Desmarcar": "Снять отметку",
 "Desmarcar como paga?": "Снять отметку об оплате?",
 "Desmarcar como recebida?": "Снять отметку о получении?",
 "Desmarque o que você não usa: some da tela e deixa a aba mais simples. Dá para mudar depois em Ajustes › Abas › {aba} › Partes desta aba.": "Снимите отметку с того, чем не пользуетесь: это исчезнет с экрана, и вкладка станет проще. Изменить можно позже в Настройки › Вкладки › {aba} › Разделы этой вкладки.",
 "Dias da semana": "Дни недели",
 "Dias de aula": "Учебные дни",
 "Dias de aula: {d}": "Учебные дни: {d}",
 "Dias escritos": "Дни с записями",
 "Dica: desenhe a forma à mão e segure o dedo no fim do traço para ela ficar perfeita.": "Совет: нарисуйте фигуру от руки и задержите палец в конце линии, чтобы она стала ровной.",
 "Ditado": "Диктовка",
 "Ditar (falar para escrever)": "Диктовать (говорить, чтобы писать)",
 "Diário apagado": "Дневник удалён",
 "Diário protegido": "Дневник защищён",
 "Dom": "Вс",
 "Dê um nome a ele na pasta Hábitos.": "Дайте ей название в папке «Привычки».",
 "EVOLUÇÃO": "ДИНАМИКА",
 "Editada em {d}": "Изменено {d}",
 "Ela abre em {d} ({n} dias). Até lá não dá para reler nem editar.": "Оно откроется {d} (через {n} дн.). До этого его нельзя перечитать или изменить.",
 "Ela abre em {d}. Você vai receber um aviso nesse dia.": "Оно откроется {d}. В этот день вы получите уведомление.",
 "Ela fica guardada com a data de hoje para comparar depois.": "Она сохраняется с сегодняшней датой, чтобы потом сравнить.",
 "Enorme": "Огромный",
 "Enviado ao paciente": "Отправлено пациенту",
 "Enviado em": "Отправлено",
 "Enviar \"{t}\" para todos do grupo {g}?": "Отправить «{t}» всем в группе {g}?",
 "Enviar a nota para cada aluno": "Отправить оценку каждому ученику",
 "Enviar as notas": "Отправить оценки",
 "Enviar o arquivo: {nome}": "Отправить файл: {nome}",
 "Enviar o recado para a turma": "Отправить объявление классу",
 "Enviar o título para outra aba": "Отправить заголовок в другую вкладку",
 "Enviar para a turma": "Отправить классу",
 "Enviar para outra aba": "Отправить в другую вкладку",
 "Escolha a cor desta bolinha": "Выберите цвет этого кружка",
 "Escolha uma data no futuro": "Выберите дату в будущем",
 "Escolher qualquer cor": "Выбрать любой цвет",
 "Esconder a barra": "Скрыть панель",
 "Escreva a frase": "Напишите фразу",
 "Escreva a que se refere a cobrança.": "Напишите, за что этот счёт.",
 "Escreva alguma coisa antes de guardar.": "Напишите что-нибудь перед сохранением.",
 "Escreva alguma coisa antes de salvar.": "Напишите что-нибудь перед сохранением.",
 "Escreva hoje, abra no futuro": "Напишите сегодня, откройте в будущем",
 "Escreva o que você quer mudar a partir de hoje": "Напишите, что вы хотите изменить с сегодняшнего дня",
 "Escreva para você do futuro. A carta fica trancada até o dia de abrir.": "Напишите себе в будущее. Письмо будет заперто до дня открытия.",
 "Escrever uma carta": "Написать письмо",
 "Escrita em {e} · abre em {a}": "Написано {e} · откроется {a}",
 "Escuras (boas para folha clara)": "Тёмные (для светлого листа)",
 "Esperado": "Ожидалось",
 "Esperado: {e} · Feito: {f} · Faltou: {fa}": "Ожидалось: {e} · Сделано: {f} · Не хватило: {fa}",
 "Esqueceu a senha do diário?": "Забыли пароль дневника?",
 "Esqueci a senha do diário": "Я забыл пароль дневника",
 "Esta semana": "Эта неделя",
 "Este lançamento vem de outra parte do app e não se apaga aqui.": "Эта запись создана в другом разделе приложения и здесь не удаляется.",
 "Estudo: {h}": "Учёба: {h}",
 "Esvaziar": "Очистить",
 "Esvaziar a lixeira": "Очистить корзину",
 "Esvaziar a lixeira?": "Очистить корзину?",
 "Ex.: Comer uma fruta por dia": "Напр.: Съедать один фрукт в день",
 "Ex.: Exercícios para casa, Atestado de 2 dias": "Напр.: Домашние упражнения, Справка на 2 дня",
 "Ex.: Reservar a pousada": "Напр.: Забронировать гостиницу",
 "Ex.: Viagem em família, juntar para a festa": "Напр.: Семейная поездка, накопить на праздник",
 "Excluir de vez?": "Удалить навсегда?",
 "Excluir esta avaliação?": "Удалить эту оценку?",
 "Excluir este bloco?": "Удалить этот блок?",
 "Excluir este desenho?": "Удалить этот рисунок?",
 "Excluir este item?": "Удалить этот элемент?",
 "Excluir {n} item(ns)?": "Удалить элементы ({n})?",
 "Exportar como imagem": "Экспорт в изображение",
 "Exportar em PDF": "Экспорт в PDF",
 "FOTOS": "ФОТО",
 "FRASE DO DIA": "ФРАЗА ДНЯ",
 "FREQUÊNCIA": "ЧАСТОТА",
 "Falta o valor": "Не указана сумма",
 "Feriado": "Праздник",
 "Feriado: {f}": "Праздник: {f}",
 "Fica 30 dias na lixeira.": "Хранится в корзине 30 дней.",
 "Ficam 30 dias na lixeira.": "Хранятся в корзине 30 дней.",
 "Fichários arquivados": "Архивные папки",
 "Fixar no topo": "Закрепить сверху",
 "Floral": "Цветочный",
 "Folha": "Лист",
 "Folha, tema e cores das páginas com escrita": "Лист, тема и цвета страниц с записями",
 "Folhas e plantas": "Листья и растения",
 "Foto adicionada": "Фото добавлено",
 "Foto do sonho": "Фото мечты",
 "Fotos do dia": "Фото дня",
 "Frase": "Фраза",
 "Frase do dia (aparece no topo do Meu Dia)": "Фраза дня (отображается вверху «Моего дня»)",
 "Frases, textos, vídeos e fotos que motivam": "Фразы, тексты, видео и фото, которые мотивируют",
 "Geométrico": "Геометрический",
 "Gerar": "Создать",
 "Gravar lembretes e anotações por voz e ditar textos (🎤) quando você pedir. O microfone só liga com o seu toque, e o áudio do ditado não é guardado.": "Записывать напоминания и заметки голосом и диктовать тексты (🎤) по вашему запросу. Микрофон включается только по вашему нажатию, а аудио диктовки не сохраняется.",
 "Guardar e trancar": "Сохранить и запереть",
 "Guardar e trancar?": "Сохранить и запереть?",
 "Guarde aqui o que te motiva: frases, textos seus, vídeos e fotos.": "Храните здесь то, что вас мотивирует: фразы, свои тексты, видео и фото.",
 "Guarde bem esta senha: sem ela o diário não pode ser recuperado.": "Хорошо запомните этот пароль: без него дневник восстановить нельзя.",
 "Hoje é feriado: {f}. Registrar mesmo assim?": "Сегодня праздник: {f}. Всё равно записать?",
 "Humor do mês": "Настроение за месяц",
 "Humor do período": "Настроение за период",
 "HÁBITOS LIGADOS": "СВЯЗАННЫЕ ПРИВЫЧКИ",
 "Há itens grandes na seleção. Eles só podem ser excluídos um por um, com confirmação e senha.": "В выборке есть большие элементы. Их можно удалить только по одному, с подтверждением и паролем.",
 "Há um ano": "Год назад",
 "Há um mês": "Месяц назад",
 "Hábito": "Привычка",
 "Hábito criado": "Привычка создана",
 "Hábitos": "Привычки",
 "Hábitos cumpridos": "Выполненные привычки",
 "Hábitos cumpridos: {f} de {n}": "Выполнено привычек: {f} из {n}",
 "Hábitos formados": "Сформированные привычки",
 "INSPIRAÇÃO": "ВДОХНОВЕНИЕ",
 "Imagem adicionada": "Изображение добавлено",
 "Imagem não encontrada": "Изображение не найдено",
 "Incrível": "Потрясающе",
 "Informação nutricional": "Пищевая ценность",
 "Inserir": "Вставить",
 "Inspiração": "Вдохновение",
 "Item para o paciente": "Материал для пациента",
 "Itens grandes só se excluem um por um.": "Большие элементы удаляются только по одному.",
 "Junte fotos do que você quer viver. Segure e arraste para organizar.": "Собирайте фото того, что хотите прожить. Удерживайте и перетаскивайте, чтобы упорядочить.",
 "LIGAR A UM SONHO DO PROJETO DE VIDA (OPCIONAL)": "СВЯЗАТЬ С МЕЧТОЙ ИЗ ЖИЗНЕННОГО ПЛАНА (НЕОБЯЗАТЕЛЬНО)",
 "LIGAR A UMA META (OPCIONAL)": "СВЯЗАТЬ С ЦЕЛЬЮ (НЕОБЯЗАТЕЛЬНО)",
 "LINKS DE VÍDEO": "ССЫЛКИ НА ВИДЕО",
 "Lance as notas antes de enviar.": "Выставьте оценки перед отправкой.",
 "Lançamentos arquivados": "Архивные записи",
 "Legenda (opcional)": "Подпись (необязательно)",
 "Lembrete diário": "Ежедневное напоминание",
 "Lendo o comprovante...": "Читаем чек...",
 "Ler o comprovante com a minha IA": "Распознать чек моим ИИ",
 "Ligado": "Включено",
 "Ligar um texto de motivação (Inspiração)": "Привязать мотивирующий текст (Вдохновение)",
 "Lilás": "Сиреневый",
 "Limpar a folha inteira?": "Очистить весь лист?",
 "Linha reta": "Прямая линия",
 "Linhas": "Линии",
 "Link do vídeo (YouTube, Instagram...)": "Ссылка на видео (YouTube, Instagram...)",
 "Lisa": "Чистый",
 "Liste os passos do projeto e diga quem faz cada um.": "Перечислите шаги проекта и укажите, кто выполняет каждый.",
 "Lixeira": "Корзина",
 "Longo prazo": "Долгосрочные",
 "MARCAR SOZINHO PELO BEM-ESTAR (OPCIONAL)": "ОТМЕЧАТЬ АВТОМАТИЧЕСКИ ЧЕРЕЗ «ЗДОРОВЬЕ» (НЕОБЯЗАТЕЛЬНО)",
 "META OU SONHO LIGADO (OPCIONAL)": "СВЯЗАННАЯ ЦЕЛЬ ИЛИ МЕЧТА (НЕОБЯЗАТЕЛЬНО)",
 "Mais opções": "Ещё",
 "Mal": "Плохо",
 "Mandar ao paciente pelo WhatsApp": "Отправить пациенту в WhatsApp",
 "Marque o que fez em cada dia": "Отмечайте, что сделали в каждый день",
 "Marque os dias de aula na turma (Editar) para a chamada mostrar só esses dias.": "Отметьте учебные дни в классе (Изменить), чтобы в перекличке были только эти дни.",
 "Matérias arquivadas": "Архивные предметы",
 "Mensalidade": "Ежемесячная оплата",
 "Meta de água do Bem-Estar": "Цель по воде из «Здоровья»",
 "Metas arquivadas": "Архивные цели",
 "Metas e sonhos concluídos": "Достигнутые цели и мечты",
 "Metas em andamento": "Цели в процессе",
 "Metas que avançaram": "Цели с прогрессом",
 "Metas, objetivos e sonhos, com passos e prazos": "Цели, задачи и мечты с шагами и сроками",
 "Meu Dia": "Мой день",
 "Meu Dia com página livre, projeto de vida, hábitos, quadro dos sonhos, roda da vida, cartas para o futuro e conquistas. Protegido com senha.": "«Мой день» со свободной страницей, жизненный план, привычки, доска мечты, колесо жизни, письма в будущее и достижения. Защищено паролем.",
 "Minimalista": "Минимализм",
 "Mostrar as contas antes do vencimento": "Показывать счета до срока оплаты",
 "Mostrar datas, horários, moeda e feriados certos para onde você está. A localização aproximada do celular só é usada quando você pede o clima do dia no Diário, e não fica guardada.": "Показывать даты, время, валюту и праздники для вашего региона. Приблизительное местоположение телефона используется только когда вы запрашиваете погоду дня в Дневнике и не сохраняется.",
 "Muito bem": "Очень хорошо",
 "Muito mal": "Очень плохо",
 "Mural de fotos dos seus sonhos": "Доска с фото ваших мечт",
 "Mural, relatório e revisão do mês": "Доска, отчёт и итоги месяца",
 "Médio prazo": "Среднесрочные",
 "N dias cumpridos no mês": "N выполненных дней в месяце",
 "N dias seguidos": "N дней подряд",
 "NESTE DIA": "В ЭТОТ ДЕНЬ",
 "Nada a enviar": "Нечего отправить",
 "Nenhum estudo registrado nesta semana.": "На этой неделе занятий не записано.",
 "Nenhum hábito ainda. Ex.: \"Comer uma fruta por dia\", \"Beber 2 L de água\", \"Não pular o café da manhã\".": "Привычек пока нет. Напр.: «Съедать один фрукт в день», «Пить 2 л воды», «Не пропускать завтрак».",
 "Nenhum no período.": "За этот период ничего.",
 "Nenhuma": "Нет",
 "Nenhuma carta ainda.": "Писем пока нет.",
 "Nenhuma foto ainda.": "Фото пока нет.",
 "Neutras e opacas": "Нейтральные и матовые",
 "Ninguém encontrado no grupo": "В группе никто не найден",
 "No computador: {link}": "На компьютере: {link}",
 "No navegador, a senha do diário é pedida sempre.": "В браузере пароль дневника запрашивается всегда.",
 "No último dia do mês: \"Que tal revisar o seu mês? ✨\"": "В последний день месяца: \"Как насчёт подвести итоги месяца? ✨\"",
 "Nome da página (opcional)": "Название страницы (необязательно)",
 "Nome de quem faz este passo": "Имя того, кто выполняет этот шаг",
 "Nome do vídeo (opcional)": "Название видео (необязательно)",
 "Normal": "Обычный",
 "Nota de 0 a 10 para cada área da vida": "Оценка от 0 до 10 для каждой сферы жизни",
 "Nota: {a}": "Оценка: {a}",
 "Nova caixa": "Новый блок",
 "Nova carta": "Новое письмо",
 "Nova meta, objetivo ou sonho": "Новая цель, задача или мечта",
 "Nova senha (6 caracteres ou mais)": "Новый пароль (6 символов или более)",
 "Nova área (ex.: Espiritualidade)": "Новая сфера (напр.: Духовность)",
 "Novo cômodo": "Новая комната",
 "Novo hábito": "Новая привычка",
 "Não dá para excluir em grupo": "Нельзя удалить группой",
 "Não enviados": "Не отправлено",
 "Não estão no grupo (ou com outro nome): {l}": "Нет в группе (или под другим именем): {l}",
 "Não foi possível exportar": "Не удалось экспортировать",
 "Não foi possível ouvir agora ({erro}).": "Сейчас не удаётся распознать речь ({erro}).",
 "Não pede a senha do diário. É a única parte que pode ser compartilhada.": "Не запрашивает пароль дневника. Это единственный раздел, которым можно поделиться.",
 "Não é dia de aula desta turma. A chamada fica como reposição ou aula extra.": "У этого класса сегодня нет занятий. Перекличка будет записана как отработка или доп. занятие.",
 "O app avisa {n} dia(s) antes e no dia do vencimento, às 9h. Dá para mudar em Ajustes › Abas › Finanças.": "Приложение напомнит за {n} дн. и в день оплаты, в 9:00. Изменить можно в Настройки › Вкладки › Финансы.",
 "O clima automático usa a localização do celular. Sem permissão, ele fica para preencher aqui.": "Автоматическая погода использует местоположение телефона. Без разрешения её можно заполнить здесь.",
 "O conteúdo desta carta não foi encontrado.": "Содержимое этого письма не найдено.",
 "O ditado chega com a versão nova do app. Atualize o My Planner pela loja (ou instale o APK novo) para usar o microfone.": "Диктовка появится в новой версии приложения. Обновите My Planner в магазине (или установите новый APK), чтобы пользоваться микрофоном.",
 "O diário pede a senha sempre que você entra nele, mesmo com o app desbloqueado.": "Дневник запрашивает пароль при каждом входе, даже если приложение разблокировано.",
 "O diário só abre com essa senha, sempre.": "Дневник открывается только с этим паролем, всегда.",
 "O diário é criptografado: sem a senha, ninguém consegue abrir, nem o suporte. Se quiser, dá para apagar o diário e começar um novo (os Projetos em Grupo continuam).": "Дневник зашифрован: без пароля его не откроет никто, даже поддержка. При желании можно удалить дневник и начать новый (Групповые проекты сохранятся).",
 "O que aprendi hoje?": "Что я узнала сегодня?",
 "O que este mês te ensinou? O que quer levar para o próximo?": "Чему вас научил этот месяц? Что вы хотите взять в следующий?",
 "O que fica desmarcado some da tela. Os dados continuam guardados.": "То, с чего снята отметка, исчезнет с экрана. Данные сохраняются.",
 "O que foi bom hoje?": "Что было хорошего сегодня?",
 "O que foi excluído nos últimos 30 dias": "То, что было удалено за последние 30 дней",
 "O que quero melhorar amanhã?": "Что я хочу улучшить завтра?",
 "O que quero mudar agora": "Что я хочу изменить сейчас",
 "O que você escreveu nesta carta vai se perder.": "Всё, что вы написали в этом письме, будет потеряно.",
 "O que você quer fazer com o arquivo?": "Что вы хотите сделать с файлом?",
 "Objetivo": "Задача",
 "Oculta": "Скрытая",
 "Orientação": "Рекомендация",
 "Orientações, receitas, atestados e materiais para entregar ao paciente, com arquivos. Só o que está aqui é enviado: o prontuário nunca sai por esta pasta.": "Рекомендации, рецепты, справки и материалы для пациента, с файлами. Отправляется только то, что здесь: медицинская карта никогда не покидает эту папку.",
 "Os dias com página escrita ficam marcados. Toque num dia para abrir.": "Дни с записями отмечены. Нажмите на день, чтобы открыть.",
 "Os itens saem de vez e não podem mais ser restaurados.": "Элементы удаляются навсегда и больше не могут быть восстановлены.",
 "Outra data": "Другая дата",
 "Outras moedas": "Другие валюты",
 "Ouvindo…": "Слушаю…",
 "PASSOS": "ШАГИ",
 "PDF com seus dados e assinatura": "PDF с вашими данными и подписью",
 "POR DIA": "ПО ДНЯМ",
 "POR MATÉRIA": "ПО ПРЕДМЕТАМ",
 "PROGRESSO": "ПРОГРЕСС",
 "Paciente: {nome}": "Пациент: {nome}",
 "Para o paciente": "Для пациента",
 "Para trocar a forma de abrir, entre no Diário com a senha dele e volte aqui.": "Чтобы сменить способ открытия, войдите в Дневник с его паролем и вернитесь сюда.",
 "Para {nome} de {tempo} depois": "Для {nome} через {tempo}",
 "Parar o ditado": "Остановить диктовку",
 "Parcelado": "В рассрочку",
 "Partes desta aba": "Разделы этой вкладки",
 "Passo": "Шаг",
 "Pastas arquivadas": "Архивные папки",
 "Pastas arquivadas ({n})": "Архивные папки ({n})",
 "Pautada": "В линейку",
 "Pautada com margem": "В линейку с полями",
 "Pedido de exame": "Направление на анализы",
 "Pelo que sou grata hoje?": "За что я благодарна сегодня?",
 "Permita o microfone e o reconhecimento de fala para o My Planner nos ajustes do celular.": "Разрешите My Planner доступ к микрофону и распознаванию речи в настройках телефона.",
 "Personalizar: tipo, cor e tema da folha e cores das bolinhas, só para esta aba": "Настроить: тип, цвет и тему листа и цвета кружков, только для этой вкладки",
 "Pontilhada": "В точку",
 "Posto": "АЗС",
 "Preenche o clima do Meu Dia pela localização do celular.": "Заполняет погоду в «Моём дне» по местоположению телефона.",
 "Preencher pela foto do comprovante": "Заполнить по фото чека",
 "Primeira vez neste aparelho: digite a senha do diário.": "Первый раз на этом устройстве: введите пароль дневника.",
 "Projeto": "Проект",
 "Projeto de Vida": "Жизненный план",
 "Projetos com amigos e família (compartilhados)": "Проекты с друзьями и семьёй (общие)",
 "Projetos em Grupo": "Групповые проекты",
 "Proprietário / Locador": "Владелец / Арендодатель",
 "Páginas arquivadas": "Архивные страницы",
 "Páginas desta aba": "Страницы этой вкладки",
 "QUANDO ELA ABRE": "КОГДА ОНО ОТКРОЕТСЯ",
 "Qua": "Ср",
 "Quadriculada": "В клетку",
 "Quadro dos Sonhos": "Доска мечты",
 "Quais partes você vai usar?": "Какие разделы вы будете использовать?",
 "Quando você concluir uma meta ou formar um hábito, ele aparece aqui para celebrar. 🎉": "Когда вы достигнете цели или сформируете привычку, это появится здесь, чтобы отпраздновать. 🎉",
 "Quanto você pagou?": "Сколько вы заплатили?",
 "Quanto você recebeu?": "Сколько вы получили?",
 "Que tal revisar o seu mês? ✨": "Как насчёт подвести итоги месяца? ✨",
 "Quem faz": "Кто выполняет",
 "Quem fez o meu dia melhor?": "Кто сделал мой день лучше?",
 "Quer guardar o comprovante agora?": "Сохранить чек сейчас?",
 "Qui": "Чт",
 "REFLEXÃO DO MÊS": "ИТОГИ МЕСЯЦА",
 "Recebeu {v} a mais": "Получено на {v} больше",
 "Recebeu {v} a menos": "Получено на {v} меньше",
 "Receita médica": "Рецепт врача",
 "Receitas médicas": "Рецепты врача",
 "Recolher": "Свернуть",
 "Refeições arquivadas": "Архивные приёмы пищи",
 "Refeições do cronograma feitas (Bem-Estar)": "Приёмы пищи по плану выполнены (Здоровье)",
 "Referente a (ex.: material, passeio, inscrição)": "За что (напр.: материалы, экскурсия, запись)",
 "Registrar": "Записать",
 "Relacionamentos": "Отношения",
 "Relatório de estudos": "Отчёт об учёбе",
 "Relatório de realizações": "Отчёт о достижениях",
 "Relatório em PDF": "Отчёт в PDF",
 "Renomear, adicionar ou tirar áreas": "Переименовать, добавить или убрать сферы",
 "Reposição": "Отработка",
 "Restaurado": "Восстановлено",
 "Resumida": "Краткая",
 "Resumida: só uma linha com o total. Completa: mostra os itens do dia. Oculta: não aparece. Nada desta aba vira tarefa sozinho.": "Краткая: только одна строка с итогом. Полная: показывает элементы дня. Скрытая: не отображается. Ничего из этой вкладки не становится задачей само.",
 "Resumo de {nome}": "Сводка: {nome}",
 "Resumo do dia": "Сводка дня",
 "Retângulo": "Прямоугольник",
 "Revisar antes": "Сначала проверить",
 "Revisão do mês": "Итоги месяца",
 "Roda da Vida": "Колесо жизни",
 "Rosa": "Розовый",
 "Sair sem guardar?": "Выйти без сохранения?",
 "Salvar avaliação de hoje": "Сохранить сегодняшнюю оценку",
 "Salvar ou enviar": "Сохранить или отправить",
 "Seg": "Пн",
 "Segure e arraste as pastas para mudar a ordem. Arraste para a esquerda para arquivar.": "Удерживайте и перетаскивайте папки, чтобы изменить порядок. Проведите влево, чтобы архивировать.",
 "Sem chamada neste dia: cobra todos os alunos.": "В этот день нет переклички: счёт выставляется всем ученикам.",
 "Sem ideia do que escrever? Toque numa pergunta:": "Не знаете, что написать? Нажмите на вопрос:",
 "Sem registros de humor.": "Нет записей о настроении.",
 "Sem tema": "Без темы",
 "Semana de {d}": "Неделя {d}",
 "Senha atual do diário": "Текущий пароль дневника",
 "Senha do diário": "Пароль дневника",
 "Senha do diário incorreta.": "Неверный пароль дневника.",
 "Senha do diário trocada": "Пароль дневника изменён",
 "Senha própria só do diário": "Отдельный пароль только для дневника",
 "Sequência dos hábitos": "Серии привычек",
 "Seta": "Стрелка",
 "Seu diário, só seu": "Ваш дневник — только ваш",
 "Seu texto de motivação": "Ваш мотивирующий текст",
 "Sex": "Пт",
 "Sonho": "Мечта",
 "Suplementos arquivados": "Архивные добавки",
 "Sáb": "Сб",
 "Só abre com a senha do diário.": "Открывается только с паролем дневника.",
 "TEMA DECORATIVO": "ДЕКОРАТИВНАЯ ТЕМА",
 "TIPO DE FOLHA": "ТИП ЛИСТА",
 "Tarefas arquivadas": "Архивные задачи",
 "Ter": "Вт",
 "Texto para o paciente": "Текст для пациента",
 "Tipo, cor e tema da folha": "Тип, цвет и тема листа",
 "Tirar a área \"{a}\"?": "Убрать сферу «{a}»?",
 "Tirar da frase do dia": "Убрать из фразы дня",
 "Tirar do arquivo": "Вернуть из архива",
 "Tirar esta foto do quadro?": "Убрать это фото с доски?",
 "Tirar esta pergunta?": "Убрать этот вопрос?",
 "Tirar este vídeo?": "Убрать это видео?",
 "Todo dia às {h}: \"Como foi o seu dia? ✍️\"": "Каждый день в {h}: \"Как прошёл ваш день? ✍️\"",
 "Todos os alunos já têm uma cobrança com esta referência.": "У всех учеников уже есть счёт с этим назначением.",
 "Toque de novo para \"Outros\" (dispensado, atestado...): não conta como falta nem como aula.": "Нажмите ещё раз для «Другое» (освобождён, справка...): не считается ни пропуском, ни занятием.",
 "Toque no círculo para marcar o que fez hoje. Os hábitos não vão para o My Planner sozinhos: use Enviar, no menu ⋮.": "Нажмите на кружок, чтобы отметить, что сделали сегодня. Привычки не попадают в My Planner сами: используйте «Отправить» в меню ⋮.",
 "Toque num dia para marcar ou desmarcar.": "Нажмите на день, чтобы отметить или снять отметку.",
 "Toque numa bolinha para trocar a cor. Na página, segurar a bolinha faz o mesmo.": "Нажмите на кружок, чтобы сменить цвет. На странице то же самое делает удержание кружка.",
 "Toque para abrir. Arraste para a esquerda para arquivar ou duplicar, ou para a direita para excluir.": "Нажмите, чтобы открыть. Проведите влево, чтобы архивировать или дублировать, или вправо, чтобы удалить.",
 "Treino do dia feito (Bem-Estar)": "Тренировка дня выполнена (Здоровье)",
 "Treinos arquivados": "Архивные тренировки",
 "Trocar a senha do diário": "Сменить пароль дневника",
 "Tudo o que você escrever no diário fica criptografado neste dispositivo antes de ir para a sua conta. Ninguém mais consegue ler, nem o suporte.": "Всё, что вы пишете в дневнике, шифруется на этом устройстве до отправки в ваш аккаунт. Никто другой не сможет это прочитать, даже поддержка.",
 "Tudo o que você exclui fica aqui por 30 dias. Depois disso sai de vez.": "Всё, что вы удаляете, хранится здесь 30 дней. После этого удаляется навсегда.",
 "Título (ex.: Ter uma boa alimentação)": "Название (напр.: Правильно питаться)",
 "Uma cobrança avulsa para cada um dos {n} aluno(s). Para cobrar só um aluno, toque em +.": "Разовый счёт для каждого из учеников ({n}). Чтобы выставить счёт только одному ученику, нажмите +.",
 "Uma senha própria, só do diário": "Отдельный пароль, только для дневника",
 "Usar a senha do diário": "Использовать пароль дневника",
 "Usar como frase do dia": "Сделать фразой дня",
 "Usar este valor": "Использовать эту сумму",
 "Usar o padrão do app": "Использовать стандарт приложения",
 "Vale para os valores de todas as abas (Finanças, aluguel, mensalidades...).": "Применяется к суммам во всех вкладках (Финансы, аренда, ежемесячные платежи...).",
 "Vale para todas as páginas com escrita (Estudos, Anotações, Diário, Documentos...). Cada aba pode ter o próprio padrão em Ajustes › Abas, e cada página pode mudar a folha no ⋮ › Folha.": "Применяется ко всем страницам с записями (Учёба, Заметки, Дневник, Документы...). У каждой вкладки может быть свой стандарт в Настройки › Вкладки, а каждая страница может сменить лист через ⋮ › Лист.",
 "Valor da aula extra (por aluno)": "Стоимость доп. занятия (с ученика)",
 "Valor por aluno": "Сумма с ученика",
 "Valor previsto: {v}": "Ожидаемая сумма: {v}",
 "Vencimento: {d}": "Срок оплаты: {d}",
 "Ver o comprovante": "Посмотреть чек",
 "Verde": "Зелёный",
 "Visualizar": "Просмотр",
 "Você está como convidado": "Вы в роли гостя",
 "Voltar a acompanhar este hábito": "Снова отслеживать эту привычку",
 "Voltar ao início da folha": "Вернуться к началу листа",
 "Voltar ao padrão inicial (folha pautada; preto, azul, vermelho e verde)": "Вернуть исходные настройки (лист в линейку; чёрный, синий, красный и зелёный)",
 "Voltar para a nova avaliação": "Вернуться к новой оценке",
 "Vídeos": "Видео",
 "X vezes por semana": "X раз в неделю",
 "abre em {n} dias": "откроется через {n} дн.",
 "agradável": "приятно",
 "arquivo": "архив",
 "aula extra": "доп. занятие",
 "calor": "жарко",
 "chuva": "дождь",
 "concluído": "готово",
 "céu limpo": "ясно",
 "de {n} planejados": "из {n} запланированных",
 "dentro de {p}": "в течение {p}",
 "enviado em {d}": "отправлено {d}",
 "estudados na semana": "изучено за неделю",
 "excluído em {d}": "удалено {d}",
 "falta 1 dia": "остался 1 день",
 "faltam {n} dias": "осталось дней: {n}",
 "feito {dur} na semana": "выполнено {dur} за неделю",
 "fresco": "прохладно",
 "frio": "холодно",
 "garoa": "морось",
 "hoje não está planejado": "сегодня не запланировано",
 "hábito formado ✨": "привычка сформирована ✨",
 "incorreta": "неверный",
 "neblina": "туман",
 "neve": "снег",
 "nublado": "облачно",
 "não enviado": "не отправлено",
 "parcela {k}/{n}": "платёж {k}/{n}",
 "passou há {n} dias": "прошло {n} дн.",
 "pelo Bem-Estar": "через «Здоровье»",
 "poucas nuvens": "малооблачно",
 "reposição": "отработка",
 "sai de vez em {n} dia(s)": "удалится навсегда через {n} дн.",
 "sem registros": "нет записей",
 "tempestade": "гроза",
 "tracejado: {d}": "пунктир: {d}",
 "ver mais": "показать больше",
 "ver menos": "показать меньше",
 "{aluno}: {n} de {max}": "{aluno}: {n} из {max}",
 "{d} é feriado: {f}. Registrar mesmo assim?": "{d} — праздник: {f}. Всё равно записать?",
 "{f} de {n} passos feitos": "Выполнено шагов: {f} из {n}",
 "{f}/{n} passos": "{f}/{n} шагов",
 "{nome} daqui a 1 ano": "{nome} через 1 год",
 "{nome} daqui a 10 anos": "{nome} через 10 лет",
 "{nome} daqui a 6 meses": "{nome} через 6 месяцев",
 "{n} aluno(s) recebem só a própria nota de \"{a}\".": "Учеников: {n} — каждый получит только свою оценку за «{a}».",
 "{n} aluno(s) receberam a nota.": "Учеников получили оценку: {n}.",
 "{n} aluno(s) · {v} cada": "Учеников: {n} · по {v}",
 "{n} anos": "{n} лет",
 "{n} dia(s) antes": "за {n} дн.",
 "{n} dia(s) cumprido(s) no mês": "{n} дн. выполнено в месяце",
 "{n} dia(s) registrado(s) · média {e}": "Записано дней: {n} · в среднем {e}",
 "{n} dia(s) registrado(s), média {m} de 6": "Записано дней: {n}, в среднем {m} из 6",
 "{n} dia(s) seguido(s)": "{n} дн. подряд",
 "{n} dispensada(s) hoje": "Освобождено сегодня: {n}",
 "{n} meses": "{n} мес.",
 "{n} outro(s)": "ещё {n}",
 "{n} selecionado(s)": "Выбрано: {n}",
 "{n} tarefa(s) concluída(s) no My Planner": "Задач выполнено в My Planner: {n}",
 "{n} vez(es) por semana": "{n} раз(а) в неделю",
 "{n}x": "{n}x",
 "Água: {a} de {m} ml": "Вода: {a} из {m} мл",
 "ÚLTIMAS 8 SEMANAS": "ПОСЛЕДНИЕ 8 НЕДЕЛЬ",
 "Última parcela em {d}": "Последний платёж {d}",
 "é hoje!": "сегодня!",
 "A mesma do app": "Такой же, как в приложении",
 "Abrir com o código": "Открыть с кодом",
 "Ainda não criado": "Ещё не создан",
 "Ao criar, o app mostra um código de recuperação para você guardar.": "При создании приложение покажет код восстановления — сохраните его.",
 "Apagar o diário e começar de novo": "Удалить дневник и начать заново",
 "Biometria ou código do dispositivo": "Биометрия или код устройства",
 "Biometria, PIN do dispositivo ou a senha do app. Não precisa criar outra senha.": "Биометрия, PIN устройства или пароль приложения. Создавать другой пароль не нужно.",
 "Bloquear o app": "Заблокировать приложение",
 "Cadastre digital, rosto ou um código de bloqueio no dispositivo para usar.": "Добавьте на устройстве отпечаток, лицо или код блокировки, чтобы использовать эту функцию.",
 "Com a biometria ligada, ela aparece primeiro. Se falhar, a mesma janela oferece o código/PIN/padrão do dispositivo; a senha do app continua valendo.": "Если биометрия включена, она появляется первой. Если не получилось, в том же окне можно ввести код/PIN/графический ключ устройства; пароль приложения тоже действует.",
 "Com ele você recupera o diário se esquecer a senha ou trocar de dispositivo.": "С ним вы восстановите дневник, если забудете пароль или смените устройство.",
 "Com este código você recupera o diário se esquecer a senha ou trocar de dispositivo. Guarde em lugar seguro e não mostre a ninguém.": "С этим кодом вы восстановите дневник, если забудете пароль или смените устройство. Храните его в надёжном месте и никому не показывайте.",
 "Como funciona a Roda da Vida": "Как работает Колесо жизни",
 "Como o diário abre": "Как открывается дневник",
 "Crie a senha que vai abrir o diário.": "Создайте пароль, которым будет открываться дневник.",
 "Crie o PIN do diário (4 a 6 números)": "Создайте PIN дневника (от 4 до 6 цифр)",
 "Crie o diário de novo para começar.": "Создайте дневник заново, чтобы начать.",
 "Código aceito. Crie uma senha nova para o diário.": "Код принят. Создайте новый пароль для дневника.",
 "Código de recuperação": "Код восстановления",
 "Código de recuperação (ex.: ABCD-EFGH-...)": "Код восстановления (напр.: ABCD-EFGH-...)",
 "Código de recuperação incorreto.": "Неверный код восстановления.",
 "Cômodos": "Комнаты",
 "Depois de 1 minuto": "Через 1 минуту",
 "Depois de {n} minutos": "Через {n} мин.",
 "Desenhe o padrão do diário": "Нарисуйте графический ключ дневника",
 "Dias no mês": "Дней в месяце",
 "Dias seguidos": "Дней подряд",
 "Digite o seu PIN": "Введите PIN",
 "Diário ainda não criado": "Дневник ещё не создан",
 "Dê uma nota de 0 a 10 para como você se sente hoje em cada área da vida. O desenho mostra onde a sua vida está equilibrada e onde precisa de atenção. Salve a avaliação e repita de tempos em tempos (por exemplo, todo mês) para comparar e ver a sua evolução. Você pode renomear, adicionar ou tirar áreas.": "Оцените от 0 до 10, как вы себя чувствуете сегодня в каждой сфере жизни. Диаграмма показывает, где ваша жизнь в равновесии, а где требует внимания. Сохраните оценку и повторяйте её время от времени (например, каждый месяц), чтобы сравнивать и видеть свой прогресс. Сферы можно переименовать, добавить или убрать.",
 "Entre na aba Diário para criar o seu diário.": "Перейдите на вкладку «Дневник», чтобы создать дневник.",
 "Entre no Diário (com a senha dele ou o desbloqueio do app) e volte aqui.": "Войдите в Дневник (по его паролю или разблокировке приложения) и вернитесь сюда.",
 "Esconder a senha": "Скрыть пароль",
 "Gerar novo código": "Создать новый код",
 "Gerar um código de recuperação novo?": "Создать новый код восстановления?",
 "Guarde este código": "Сохраните этот код",
 "Já guardei": "Уже сохранил(а)",
 "Ligar um hábito que já existe": "Связать с существующей привычкой",
 "Mostrar a senha": "Показать пароль",
 "Mudar como o diário abre": "Изменить способ открытия дневника",
 "My Planner · Código de recuperação do Diário": "My Planner · Код восстановления Дневника",
 "Não foi possível abrir com a chave deste dispositivo. Use a senha do diário ou o código de recuperação.": "Не удалось открыть ключом этого устройства. Используйте пароль дневника или код восстановления.",
 "O Caps Lock parece estar ligado.": "Похоже, включён Caps Lock.",
 "O PIN fica guardado só neste dispositivo, protegido. A senha continua valendo se você esquecer o PIN.": "PIN хранится только на этом устройстве в защищённом виде. Если вы забудете PIN, пароль продолжит действовать.",
 "O PIN precisa ter de 4 a 6 números.": "PIN должен содержать от 4 до 6 цифр.",
 "O código anterior deixa de valer. Por segurança, o código não fica guardado no app: só dá para ver na hora em que é gerado.": "Предыдущий код перестанет действовать. В целях безопасности код не хранится в приложении: его можно увидеть только в момент создания.",
 "O código não fica guardado em lugar nenhum que o suporte possa ver. Sem a senha e sem o código, o diário não pode ser recuperado.": "Код нигде не хранится там, где его могла бы увидеть поддержка. Без пароля и без кода дневник восстановить невозможно.",
 "O diário agora abre só com a senha dele.": "Теперь дневник открывается только его паролем.",
 "O reconhecimento de rosto deste dispositivo não pode ser usado por apps. Use a digital ou o código/PIN do dispositivo.": "Распознавание лица на этом устройстве недоступно для приложений. Используйте отпечаток или код/PIN устройства.",
 "O tempo conta a partir do momento em que o app sai da tela (outro app, tela inicial ou tela apagada). Puxar as notificações, a janela da biometria, um pedido de permissão ou escolher uma foto ou arquivo não contam.": "Время отсчитывается с момента, когда приложение уходит с экрана (другое приложение, главный экран или выключенный экран). Шторка уведомлений, окно биометрии, запрос разрешения или выбор фото либо файла не считаются.",
 "Os PINs não conferem.": "PIN-коды не совпадают.",
 "PIN": "PIN",
 "PIN (4 a 6 números)": "PIN (от 4 до 6 цифр)",
 "PIN (só números, 4 a 6)": "PIN (только цифры, от 4 до 6)",
 "PIN do diário": "PIN дневника",
 "PIN incorreto": "Неверный PIN",
 "PIN salvo.": "PIN сохранён.",
 "Padrão do app": "По умолчанию в приложении",
 "Para apagar, confirme com a senha do app, biometria ou PIN do dispositivo. Isso apaga o Meu Dia, metas, hábitos, cartas e fotos do diário. Projetos em Grupo continuam.": "Чтобы удалить, подтвердите паролем приложения, биометрией или PIN устройства. Будут удалены «Мой день», цели, привычки, письма и фото дневника. Групповые проекты сохранятся.",
 "Para continuar, digite a senha do app ou use a biometria/o código do dispositivo.": "Чтобы продолжить, введите пароль приложения или используйте биометрию/код устройства.",
 "Para recuperar o diário se esquecer a senha ou trocar de dispositivo.": "Чтобы восстановить дневник, если вы забудете пароль или смените устройство.",
 "Pastas": "Папки",
 "Pedir a senha de novo": "Снова запрашивать пароль",
 "Personalizada": "Свой вариант",
 "Primeira vez neste dispositivo: digite a senha do diário ou use o código de recuperação.": "Первый вход на этом устройстве: введите пароль дневника или используйте код восстановления.",
 "Primeira vez neste dispositivo: digite o código de recuperação do diário.": "Первый вход на этом устройстве: введите код восстановления дневника.",
 "Reconhecimento de rosto": "Распознавание лица",
 "Repita o PIN": "Повторите PIN",
 "Salvar a senha nova": "Сохранить новый пароль",
 "Salvar em arquivo / no Drive": "Сохранить в файл / на Drive",
 "Salvar o código de recuperação": "Сохранить код восстановления",
 "Senha (letras e números)": "Пароль (буквы и цифры)",
 "Senha do app": "Пароль приложения",
 "Senha nova do diário": "Новый пароль дневника",
 "Senha própria": "Собственный пароль",
 "Senha própria do diário": "Собственный пароль дневника",
 "Tarefas": "Задачи",
 "Trocar o PIN": "Сменить PIN",
 "Usar a senha": "Использовать пароль",
 "Usar o PIN": "Использовать PIN",
 "Usar o código de recuperação": "Использовать код восстановления",
 "Usar o desbloqueio do app": "Использовать разблокировку приложения",
 "Use a biometria ou o código/PIN/padrão do dispositivo.": "Используйте биометрию или код/PIN/графический ключ устройства.",
 "Use o código de recuperação que apareceu quando o diário foi criado. Sem a senha e sem o código, ninguém consegue abrir o diário, nem o suporte.": "Используйте код восстановления, который появился при создании дневника. Без пароля и без кода никто не сможет открыть дневник, даже поддержка.",
 "Voltar a usar só a senha?": "Снова использовать только пароль?",
 "incorreto": "неверно",
 "1 h": "1 ч",
 "12 horas (2:30 PM)": "12 часов (2:30 PM)",
 "15 min": "15 мин",
 "24 horas (14:30)": "24 часа (14:30)",
 "30 min": "30 мин",
 "A lixeira tem itens grandes. Confirme com a senha do app, a biometria ou o código do dispositivo.": "В корзине есть крупные элементы. Подтвердите паролем приложения, биометрией или кодом устройства.",
 "A semana começa na": "Неделя начинается с",
 "Abra o Diário primeiro": "Сначала откройте Дневник",
 "Abrir configurações do celular": "Открыть настройки телефона",
 "Agenda e mapas": "Календарь и карты",
 "Agora: {m}": "Сейчас: {m}",
 "Ajuda e sobre": "Справка и о приложении",
 "Alarme (som)": "Будильник (звук)",
 "Alarme ou vibração das pausas": "Будильник или вибрация для перерывов",
 "Apaga para sempre a conta e todos os dados na nuvem e neste dispositivo. Pede a sua senha antes.": "Навсегда удаляет аккаунт и все данные в облаке и на этом устройстве. Перед этим запрашивается ваш пароль.",
 "Apagar todas ({n})": "Удалить все ({n})",
 "Apagar {n} selecionada(s)": "Удалить выбранные ({n})",
 "Aparência": "Внешний вид",
 "App das rotas": "Приложение для маршрутов",
 "Ardósia": "Сланец",
 "Arrastar para a direita": "Смахнуть вправо",
 "Arrastar para a esquerda": "Смахнуть влево",
 "As contas de Finanças aparecem no My Planner com essa antecedência.": "Счета из Финансов появляются в My Planner с таким опережением.",
 "Atualizações e sobre": "Обновления и о приложении",
 "Avisar antes do vencimento": "Напоминать до срока оплаты",
 "Aviso marcado": "Напоминание установлено",
 "Aviso no começo e no fim de cada pausa": "Уведомление в начале и в конце каждого перерыва",
 "Avisos desta aba": "Уведомления этой вкладки",
 "Avisos e alarmes": "Уведомления и будильники",
 "Avisos silenciosos": "Беззвучные уведомления",
 "Avisos: som e vibração": "Уведомления: звук и вибрация",
 "Avisos: só som": "Уведомления: только звук",
 "Avisos: só vibração": "Уведомления: только вибрация",
 "Azul elétrico": "Электрик-синий",
 "Azul-aço": "Стальной синий",
 "Azul-bebê": "Нежно-голубой",
 "Azul-marinho": "Тёмно-синий",
 "Baixar meus dados": "Скачать мои данные",
 "Baixar todos os meus dados": "Скачать все мои данные",
 "Baixar todos os meus dados e excluir a conta (LGPD)": "Скачать все мои данные и удалить аккаунт (LGPD)",
 "Biometria": "Биометрия",
 "Bissexual": "Бисексуальный",
 "Brilhante": "Яркий",
 "Buscar abas": "Поиск вкладок",
 "Buscar nos ajustes": "Поиск в настройках",
 "Cancelar aviso": "Отменить напоминание",
 "Cinza-chumbo": "Свинцово-серый",
 "Cofre": "Сейф",
 "Coloque pelo menos uma matéria.": "Добавьте хотя бы один предмет.",
 "Como usar": "Как пользоваться",
 "Conexões": "Подключения",
 "Cor da aba": "Цвет вкладки",
 "Cor de destaque": "Акцентный цвет",
 "Crie uma matéria primeiro": "Сначала создайте предмет",
 "Cítrico": "Цитрус",
 "Cópia de segurança em arquivo": "Резервная копия в файл",
 "Dados de paciente e prontuário. Confirme com a senha do app, a biometria ou o código do dispositivo.": "Данные пациента и медкарта. Подтвердите паролем приложения, биометрией или кодом устройства.",
 "Desligadas": "Выключены",
 "Digite a senha da sua conta para confirmar.": "Введите пароль от аккаунта для подтверждения.",
 "Duração padrão de uma tarefa nova": "Длительность новой задачи по умолчанию",
 "Editar sessão": "Изменить занятие",
 "Ela se repete sem data de fim: aparecem as vezes até {data}. Com todas marcadas, sai a tarefa inteira.": "Она повторяется без даты окончания: показаны повторы до {data}. Если отметить все, будет удалена вся задача.",
 "Em atividade": "Идёт занятие",
 "Em pausa": "На паузе",
 "Emoji da pausa": "Эмодзи перерыва",
 "Encerrar": "Завершить",
 "Encerrar a sessão?": "Завершить занятие?",
 "Entra no modo seleção, para escolher vários itens de uma vez.": "Включает режим выбора, чтобы выбрать сразу несколько элементов.",
 "Escolha um horário no futuro.": "Выберите время в будущем.",
 "Escolher a matéria": "Выбрать предмет",
 "Esconde os valores em dinheiro (R$ •••)": "Скрывает денежные суммы (R$ •••)",
 "Esconder o CPF": "Скрыть CPF",
 "Esconder os valores": "Скрыть суммы",
 "Esta e as próximas": "Эту и следующие",
 "Esta tarefa se repete. Onde aplicar a mudança?": "Эта задача повторяется. К чему применить изменение?",
 "Este item tem muita coisa dentro. Confirme com a senha do app, a biometria ou o código do dispositivo.": "В этом элементе очень много содержимого. Подтвердите паролем приложения, биометрией или кодом устройства.",
 "Exclui o item (pede confirmação). Depois dá para desfazer ou restaurar pela Lixeira.": "Удаляет элемент (с подтверждением). Потом можно отменить или восстановить из Корзины.",
 "Excluir minha conta": "Удалить мой аккаунт",
 "Ficha protegida": "Защищённая карточка",
 "Formato da hora": "Формат времени",
 "Foto do Quadro dos Sonhos": "Фото Доски мечты",
 "Geral": "Общие",
 "Gestos": "Жесты",
 "Google Drive, OneDrive e arquivo de cópia": "Google Drive, OneDrive и файл резервной копии",
 "Grafite": "Графит",
 "Guardar em": "Сохранить в",
 "Hábito do Diário": "Привычка Дневника",
 "Idioma e moeda": "Язык и валюта",
 "Inspiração do Diário": "Вдохновение для Дневника",
 "Intenso": "Насыщенный",
 "Item arquivado": "Элемент перемещён в архив",
 "Item excluído": "Элемент удалён",
 "Lavanda": "Лаванда",
 "Ligadas": "Включены",
 "Limite de energia": "Лимит энергии",
 "Lésbica": "Лесбийский",
 "Marque as vezes que vão ser apagadas.": "Отметьте повторы, которые нужно удалить.",
 "Matéria": "Предмет",
 "Me avise em…": "Напомнить через…",
 "Menta": "Мята",
 "Menu ⋮": "Меню ⋮",
 "Meta do Diário": "Цель Дневника",
 "Modo discreto": "Скрытый режим",
 "Monte a sessão uma vez (matérias, tempo de cada uma e pausas) e repita nos outros dias tocando em Começar. O tempo estudado entra sozinho na meta.": "Соберите занятие один раз (предметы, время на каждый и перерывы) и повторяйте его в другие дни, нажимая «Старт». Время учёбы само засчитывается в цель.",
 "Mostra Arquivar e Duplicar.": "Показывает «В архив» и «Дублировать».",
 "Mostrar feriados no topo": "Показывать праздники вверху",
 "Mostrar os valores": "Показать суммы",
 "Muda a ordem dos itens.": "Меняет порядок элементов.",
 "Muda só a cor do My Planner. A cor de destaque do app fica em Ajustes > Aparência. Cada tarefa pode ter uma cor própria na ficha.": "Меняет только цвет My Planner. Акцентный цвет приложения — в Настройки > Внешний вид. У каждой задачи может быть свой цвет в её карточке.",
 "Nada encontrado nos ajustes.": "В настройках ничего не найдено.",
 "Nenhuma sessão salva ainda.": "Сохранённых занятий пока нет.",
 "Neon": "Неон",
 "Nesse horário o app não toca nem vibra. Os avisos continuam chegando, em silêncio.": "В это время приложение не звонит и не вибрирует. Уведомления продолжают приходить беззвучно.",
 "No menu ⋮ de qualquer item: o celular avisa na hora escolhida, sem criar tarefa no My Planner.": "В меню ⋮ любого элемента: телефон напомнит в выбранное время, не создавая задачу в My Planner.",
 "Nome (ex.: Sessão do mestrado)": "Название (напр.: Занятие по магистратуре)",
 "Nova sessão": "Новое занятие",
 "Nuvem e cópias de segurança": "Облако и резервные копии",
 "Não perturbe": "Не беспокоить",
 "Não perturbe {de}–{ate}": "Не беспокоить {de}–{ate}",
 "Não-binário": "Небинарный",
 "O botão 🎉 Feriados no topo do My Planner. O país e a lista de feriados ficam em Ajustes > Feriados.": "Кнопка 🎉 Праздники вверху My Planner. Страна и список праздников — в Настройки > Праздники.",
 "O celular avisa às {h}.": "Телефон напомнит в {h}.",
 "O que sai do Diário fica cifrado na lixeira. Entre no Diário e depois volte aqui para restaurar.": "Удалённое из Дневника хранится в Корзине в зашифрованном виде. Откройте Дневник и вернитесь сюда, чтобы восстановить.",
 "O que sair fica na Lixeira por 30 dias. Digite a senha da sua conta para confirmar.": "Удалённое хранится в Корзине 30 дней. Введите пароль от аккаунта для подтверждения.",
 "O que saiu fica na Lixeira por 30 dias.": "Удалённое хранится в Корзине 30 дней.",
 "O tema muda as cores das abas, a cor de destaque e um toque leve no fundo, nos modos claro e escuro. Para trocar a cor de uma aba só, vá em Ajustes > Abas.": "Тема меняет цвета вкладок, акцентный цвет и лёгкий оттенок фона в светлом и тёмном режимах. Чтобы изменить цвет только одной вкладки, откройте Настройки > Вкладки.",
 "O tempo estudado até agora entra na meta.": "Время учёбы на данный момент засчитывается в цель.",
 "Oliva": "Оливковый",
 "Orgulho": "Прайд",
 "Os avisos funcionam no app instalado, com as notificações ligadas.": "Уведомления работают в установленном приложении при включённых уведомлениях.",
 "Os gestos do app": "Жесты приложения",
 "Outro (escolher a hora)": "Другое (выбрать время)",
 "Pansexual": "Пансексуальный",
 "Para ligar, use o app no celular (Ajustes › Agenda e mapas › Agenda do Google). Depois, tudo aparece aqui também.": "Чтобы подключить, используйте приложение на телефоне (Настройки › Календарь и карты › Google Календарь). После этого всё появится и здесь.",
 "Para não perguntar mais, escolha o app em Ajustes › Agenda e mapas.": "Чтобы больше не спрашивать, выберите приложение в Настройки › Календарь и карты.",
 "Pausa": "Перерыв",
 "Petróleo": "Петроль",
 "Pink elétrico": "Электрик-розовый",
 "Preto total": "Глубокий чёрный",
 "Progresso": "Прогресс",
 "Pêssego": "Персик",
 "Quantos dias antes as contas aparecem fica em Ajustes > Avisos e alarmes.": "Сколько дней заранее показывать счета — в Настройки > Уведомления и будильники.",
 "Rosa-chá": "Пыльная роза",
 "Roxo-profundo": "Тёмно-фиолетовый",
 "Segurança e dados": "Безопасность и данные",
 "Segurar e arrastar": "Удерживать и перетащить",
 "Segurar e soltar": "Удерживать и отпустить",
 "Selecionar todas": "Выбрать все",
 "Semana começa na {dia}": "Неделя начинается с: {dia}",
 "Sessão de estudo": "Учебное занятие",
 "Sessão encerrada": "Занятие завершено",
 "Sessão pausada": "Занятие на паузе",
 "Som e vibração": "Звук и вибрация",
 "Suave": "Мягкий",
 "Só esta semana": "Только эта неделя",
 "Só hoje": "Только сегодня",
 "Só neste dia ({data})": "Только в этот день ({data})",
 "Tamanho das caixas": "Размер ячеек",
 "Tamanho do texto": "Размер текста",
 "Tarefa nova": "Новая задача",
 "Tela inicial": "Главный экран",
 "Tema e cor de destaque": "Тема и акцентный цвет",
 "Testar alerta": "Проверить сигнал",
 "Testar alerta, \"Não perturbe\" e as configurações do celular ficam em Ajustes > Avisos e alarmes.": "Проверка сигнала, «Не беспокоить» и настройки телефона — в Настройки > Уведомления и будильники.",
 "Testar e conferir": "Проверка и контроль",
 "Todas as opções do item: editar, mover, compartilhar, arquivar, excluir...": "Все действия с элементом: изменить, переместить, поделиться, архивировать, удалить...",
 "Toque numa cor do tema {tema} para usar nos botões, no botão + e no item selecionado.": "Нажмите на цвет темы «{tema}», чтобы использовать его для кнопок, кнопки + и выбранного элемента.",
 "Total: {dur}": "Всего: {dur}",
 "Tropical": "Тропики",
 "Turquesa": "Бирюзовый",
 "Um arquivo com todos os seus dados do My Planner, para guardar ou levar para outro lugar (portabilidade, LGPD).": "Файл со всеми вашими данными My Planner, чтобы сохранить или перенести в другое место (переносимость данных, LGPD).",
 "Usar no computador, pelo navegador": "Использовать на компьютере, в браузере",
 "Usar o padrão": "По умолчанию",
 "Usar o padrão ({emoji})": "По умолчанию ({emoji})",
 "Use o app no celular para baixar o arquivo.": "Чтобы скачать файл, используйте приложение на телефоне.",
 "Vale para todas as abas. Cada aba pode ter o seu em Ajustes > Abas.": "Действует для всех вкладок. У каждой вкладки может быть свой в Настройки > Вкладки.",
 "Valem para as tarefas com pausas. Cada tarefa pode mudar o alarme e o emoji na própria ficha.": "Действуют для задач с перерывами. В карточке каждой задачи можно изменить будильник и эмодзи.",
 "Ver lista": "Показать список",
 "Ver o CPF inteiro": "Показать CPF полностью",
 "Verde-floresta": "Лесной зелёный",
 "Verde-água": "Цвет морской волны",
 "Vibração": "Вибрация",
 "Vinho": "Бордовый",
 "Você pediu para ser avisado agora.": "Вы просили напомнить сейчас.",
 "Você pode: confirmar se tratamos seus dados, acessar, corrigir, pedir a portabilidade (baixar os seus dados em Ajustes > Meus dados), pedir a exclusão, saber com quem compartilhamos, revogar o consentimento e reclamar na ANPD.": "Вы можете: узнать, обрабатываем ли мы ваши данные, получить к ним доступ, исправить их, запросить перенос (скачать данные в Настройки > Мои данные), запросить удаление, узнать, с кем мы ими делимся, отозвать согласие и подать жалобу в ANPD.",
 "Voltar ao filtro": "Назад к фильтру",
 "Voltar à lista": "Назад к списку",
 "Vá em Ajustes › My Planner Web e toque em \"Conectar navegador\".": "Перейдите в Настройки › My Planner Web и нажмите «Подключить браузер».",
 "atividade {n} de {total}": "активность {n} из {total}",
 "matéria {n} de {t}": "предмет {n} из {t}",
 "padrão": "по умолчанию",
 "pausa em {n} min": "перерыв через {n} мин",
 "pausa {n} de {total}": "перерыв {n} из {total}",
 "termina em {n} min": "закончится через {n} мин",
 "todas as vezes": "все повторы",
 "troca em {n} min": "смена через {n} мин",
 "volta em {n} min": "продолжение через {n} мин",
 "{nome} · {n} dia(s)": "{nome} · дней: {n}",
 "{n} de {total} vezes": "{n} из {total} раз",
 "{n} itens arquivados": "Перемещено в архив: {n}",
 "{n} itens excluídos": "Удалено: {n}",
 "{n} marcada(s)": "Отмечено: {n}",
 "{n} vezes": "{n} раз(а)",
 "{rotulo}: {feito} min / {total}": "{rotulo}: {feito} мин / {total}",
 "📔 Diário": "📔 Дневник",
 "Agendados": "Запланировано",
 "Atrasado": "Просрочено",
 "Atrasado: {v}": "Просрочено: {v}",
 "Atualizar o a receber": "Обновить сумму к получению",
 "Até (fim do contrato, se houver)": "До (окончание контракта, если есть)",
 "Clínica": "Клиника",
 "Conta cada dia com chamada feita ou com plano de aula marcado como \"Aula dada\".": "Учитывает каждый день с отмеченной посещаемостью или с планом урока, отмеченным как \"Урок проведён\".",
 "Data do recebimento": "Дата получения",
 "Data prevista do pagamento": "Ожидаемая дата оплаты",
 "Desmarcar como recebido": "Снять отметку о получении",
 "Dia do pagamento": "День оплаты",
 "Diferença: {v} (juros/multa)": "Разница: {v} (проценты/штраф)",
 "Diferença: {v} (taxas/descontos)": "Разница: {v} (комиссии/вычеты)",
 "Escolas, universidades e cursos que pagam você. Com salário fixo, o app gera o a receber de todo mês; por hora-aula, soma as aulas dadas nas turmas ligadas à instituição.": "Школы, университеты и курсы, которые вам платят. При фиксированной зарплате приложение создаёт сумму к получению каждый месяц; при почасовой оплате суммирует проведённые уроки в группах, связанных с учреждением.",
 "Escolha o tipo de pagamento (Editar) para o app calcular o que você tem a receber.": "Выберите тип оплаты (Изменить), чтобы приложение рассчитало, что вам причитается.",
 "Este valor vem da parte \"Onde trabalho\" da aba {aba}. Marque aqui como recebido ou abra a aba para ver a instituição.": "Эта сумма из раздела \"Где я работаю\" вкладки {aba}. Отметьте здесь как полученную или откройте вкладку, чтобы увидеть учреждение.",
 "Ex.: Colégio Estadual, Universidade Federal": "Напр.: Школа № 5, Государственный университет",
 "Ex.: Hospital Santa Casa, Clínica Vida": "Напр.: Городская больница, Клиника «Вита»",
 "Ex.: Salário de outubro, 13º, férias": "Напр.: Зарплата за октябрь, 13-я зарплата, отпускные",
 "Feitos": "Выполнено",
 "Horas-aula de cada aula": "Академических часов в каждом уроке",
 "Hospitais e clínicas que pagam você. Com salário fixo, o app gera o a receber de todo mês; por plantão ou atendimento, marque os feitos e o app calcula.": "Больницы и клиники, которые вам платят. При фиксированной зарплате приложение создаёт сумму к получению каждый месяц; при оплате за смену или приём отмечайте выполненные, и приложение посчитает.",
 "Hospital": "Больница",
 "Instituição": "Учреждение",
 "Instituição (Onde trabalho)": "Учреждение (Где я работаю)",
 "Ligue as turmas a esta instituição (na turma, Editar › Instituição) para o app somar as aulas dadas.": "Свяжите группы с этим учреждением (в группе: Изменить › Учреждение), чтобы приложение суммировало проведённые уроки.",
 "Marque cada plantão ou atendimento como feito: o app soma e calcula o valor do mês.": "Отмечайте каждую смену или приём как выполненные: приложение суммирует и рассчитает сумму за месяц.",
 "Marque cada plantão ou atendimento feito nesta instituição. O app soma e calcula o valor a receber do mês.": "Отмечайте каждую смену или приём, выполненные в этом учреждении. Приложение суммирует и рассчитает сумму к получению за месяц.",
 "Nome da instituição": "Название учреждения",
 "O que a instituição tem a pagar a você, mês a mês. Marque como recebido quando o dinheiro entrar: vai junto para a aba Finanças.": "Что учреждение должно вам заплатить, месяц за месяцем. Отметьте как полученное, когда деньги поступят: запись попадёт и во вкладку Финансы.",
 "Onde trabalho": "Где я работаю",
 "Plantão": "Смена",
 "Plantão ou atendimento": "Смена или приём",
 "Plantões e atendimentos": "Смены и приёмы",
 "Por atendimento ou procedimento": "За приём или процедуру",
 "Por hora-aula": "Почасовая (за ак. час)",
 "Por plantão": "За смену",
 "Previsto: {v}": "Ожидается: {v}",
 "Previsão do mês: {v}": "Прогноз на месяц: {v}",
 "Quantidade (aulas, plantões ou atendimentos)": "Количество (уроки, смены или приёмы)",
 "Recebe no mês seguinte ao trabalhado": "Оплата в месяце, следующем за отработанным",
 "Receber: {t}": "Получить: {t}",
 "Recebimentos": "Поступления",
 "Salário": "Зарплата",
 "Salário (valor do mês)": "Зарплата (сумма за месяц)",
 "Salário fixo": "Фиксированная зарплата",
 "Telefone (RH ou financeiro)": "Телефон (отдел кадров или бухгалтерия)",
 "Tipo de pagamento": "Тип оплаты",
 "Universidade": "Университет",
 "Valor da hora-aula": "Стоимость ак. часа",
 "Valor de cada um (se for diferente)": "Стоимость каждого (если отличается)",
 "Valor do plantão": "Стоимость смены",
 "Valor por atendimento ou procedimento": "Стоимость приёма или процедуры",
 "Valor previsto": "Ожидаемая сумма",
 "feito": "выполнено",
 "recebido em {d}": "получено {d}",
 "{n} aula(s) dada(s)": "Проведено уроков: {n}",
 "{n} hora(s)-aula": "Ак. часов: {n}",
 "{n} plantão(ões)": "Смен: {n}",
 "Abas do My Planner Anne": "Вкладки My Planner Anne",
 "Acesso ao Não perturbe": "Доступ к режиму \"Не беспокоить\"",
 "Alarme dos remédios (mesmo no silencioso)": "Будильник лекарств (даже в беззвучном режиме)",
 "Algodão-doce": "Сахарная вата",
 "Aplicar tema": "Применить тему",
 "As cores próprias de cada tema: floral rosado, folhas verdes, céu azul...": "Собственные цвета каждой темы: розовые цветы, зелёные листья, голубое небо...",
 "Assim ficam as letras no app.": "Так выглядит текст в приложении.",
 "Automática": "Автоматически",
 "Baht tailandês": "Тайский бат",
 "Boliviano": "Боливиано",
 "Bolívar venezuelano": "Венесуэльский боливар",
 "Botão": "Кнопка",
 "Buscar moeda": "Найти валюту",
 "Cor do desenho": "Цвет рисунка",
 "Coroa dinamarquesa": "Датская крона",
 "Coroa norueguesa": "Норвежская крона",
 "Coroa sueca": "Шведская крона",
 "Coroa tcheca": "Чешская крона",
 "Crepúsculo": "Сумерки",
 "Crescente": "Нарастающая",
 "Curta": "Короткая",
 "Despesas em outra moeda (fora do lucro): {v}": "Расходы в другой валюте (вне прибыли): {v}",
 "Dirham dos Emirados Árabes Unidos": "Дирхам ОАЭ",
 "Dirham marroquino": "Марокканский дирхам",
 "Do seu país": "Вашей страны",
 "Dong vietnamita": "Вьетнамский донг",
 "Dupla": "Двойная",
 "Dólar americano": "Доллар США",
 "Dólar australiano": "Австралийский доллар",
 "Dólar canadense": "Канадский доллар",
 "Dólar de Hong Kong": "Гонконгский доллар",
 "Dólar de Singapura": "Сингапурский доллар",
 "Dólar neozelandês": "Новозеландский доллар",
 "Envia todos os itens desta lista, inclusive os novos que forem criados depois.": "Отправляет все элементы этого списка, включая новые, созданные позже.",
 "Enviar todos para a equipe": "Отправить всё команде",
 "Escolha se o alarme deste remédio deve tocar mesmo com o celular no silencioso.": "Выберите, должен ли будильник этого лекарства звонить, даже если телефон в беззвучном режиме.",
 "Euro": "Евро",
 "Exemplo": "Пример",
 "Falta uma resposta": "Не хватает одного ответа",
 "Folha, tema e cores da caneta e das letras": "Лист, тема и цвета ручки и текста",
 "Franco suíço": "Швейцарский франк",
 "Guarani paraguaio": "Парагвайский гуарани",
 "Hryvnia ucraniana": "Украинская гривна",
 "Iene japonês": "Японская иена",
 "Kwanza angolano": "Ангольская кванза",
 "Libra egípcia": "Египетский фунт",
 "Libra esterlina": "Фунт стерлингов",
 "Lira turca": "Турецкая лира",
 "Longa": "Длинная",
 "Mais usadas": "Популярные",
 "Metical moçambicano": "Мозамбикский метикал",
 "Na página, segurar a bolinha faz o mesmo.": "На странице удержание кружка делает то же самое.",
 "Naira nigeriana": "Нигерийская найра",
 "Nenhuma moeda encontrada": "Валюта не найдена",
 "No Android, para o alarme do remédio tocar com o \"Não perturbe\" ligado, o celular precisa permitir o acesso ao \"Não perturbe\" para o My Planner. Toque em \"Abrir configurações\", procure o My Planner na lista e ligue a permissão.": "На Android, чтобы будильник лекарства звонил при включённом режиме \"Не беспокоить\", телефон должен разрешить My Planner доступ к режиму \"Не беспокоить\". Нажмите \"Открыть настройки\", найдите My Planner в списке и включите разрешение.",
 "No My Planner": "В My Planner",
 "No iPhone, o silencioso do celular pode impedir o alarme. Deixe o celular no modo normal.": "На iPhone беззвучный режим может помешать будильнику. Оставьте телефон в обычном режиме.",
 "No iPhone, o ▶ mostra uma ideia de cada tipo. Os avisos de verdade usam a vibração padrão do iPhone.": "На iPhone ▶ даёт представление о каждом типе. Настоящие уведомления используют стандартную вибрацию iPhone.",
 "Novo dólar taiwanês": "Новый тайваньский доллар",
 "Novo shekel israelense": "Новый израильский шекель",
 "Ouvir/Sentir": "Прослушать/Почувствовать",
 "Peso argentino": "Аргентинское песо",
 "Peso chileno": "Чилийское песо",
 "Peso colombiano": "Колумбийское песо",
 "Peso filipino": "Филиппинское песо",
 "Peso mexicano": "Мексиканское песо",
 "Peso uruguaio": "Уругвайское песо",
 "Política de privacidade": "Политика конфиденциальности",
 "Pronto. Bloqueie a tela e espere 1 minuto: o aviso deve aparecer em silêncio.": "Готово. Заблокируйте экран и подождите 1 минуту: уведомление должно прийти беззвучно.",
 "Pronto. Bloqueie a tela e espere 1 minuto: o aviso deve aparecer vibrando, sem som.": "Готово. Заблокируйте экран и подождите 1 минуту: уведомление должно прийти с вибрацией, без звука.",
 "Páginas e canetas": "Страницы и ручки",
 "Pôr do sol": "Закат",
 "Rand sul-africano": "Южноафриканский рэнд",
 "Real brasileiro": "Бразильский реал",
 "Ringgit malaio": "Малайзийский ринггит",
 "Riyal saudita": "Саудовский риял",
 "Rublo russo": "Российский рубль",
 "Rupia indiana": "Индийская рупия",
 "Rupia indonésia": "Индонезийская рупия",
 "Rupia paquistanesa": "Пакистанская рупия",
 "Se o My Planner não aparecer na lista, essa permissão chega na próxima versão do app (atualize pela loja).": "Если My Planner нет в списке, это разрешение появится в следующей версии приложения (обновите его в магазине).",
 "Sentir": "Почувствовать",
 "Sol peruano": "Перуанский соль",
 "São as cores rápidas da caneta e das letras nas páginas. A primeira é a cor padrão ao abrir uma página. Toque numa bolinha para trocar a cor dela.": "Это быстрые цвета ручки и текста на страницах. Первый — цвет по умолчанию при открытии страницы. Нажмите на кружок, чтобы изменить его цвет.",
 "Taka bengali": "Бангладешская така",
 "Teste grátis por {n} dias": "Бесплатный пробный период: {n} дн.",
 "Tipo de vibração": "Тип вибрации",
 "Tirar do My Planner": "Убрать из My Planner",
 "Tocar mesmo no silencioso e no Não perturbe": "Звонить даже в беззвучном режиме и в режиме \"Не беспокоить\"",
 "Tocar só se o celular estiver no normal": "Звонить, только если телефон в обычном режиме",
 "Todos os itens desta lista aparecem no My Planner, inclusive os novos.": "Все элементы этого списка отображаются в My Planner, включая новые.",
 "Vaga-lume": "Светлячок",
 "Vale para todos os avisos que vibram (Vibração e Som e vibração).": "Действует для всех уведомлений с вибрацией (Вибрация; Звук и вибрация).",
 "Won sul-coreano": "Южнокорейская вона",
 "Xelim queniano": "Кенийский шиллинг",
 "Yuan chinês": "Китайский юань",
 "Zloty polonês": "Польский злотый",
 "🔕🔇 O alarme deste remédio deve tocar mesmo com o celular no silencioso?": "🔕🔇 Должен ли будильник этого лекарства звонить, даже если телефон в беззвучном режиме?",
 "A galeria de fotos chega na próxima versão do app. Por enquanto, use Arquivos ou Tirar foto.": "Галерея фото появится в следующей версии приложения. Пока используйте «Файлы» или «Сделать фото».",
 "Abrir o fichário do grupo": "Открыть папку группы",
 "Arrastar a barra": "Перетащить полосу",
 "Assim que o fichário for compartilhado, ele aparece aqui.": "Как только папкой поделятся, она появится здесь.",
 "Buscar ícone pelo nome (ex.: livro, casa, café)": "Искать значок по названию (напр.: книга, дом, кофе)",
 "Com a aba Estudos você cria seus fichários, usa o cronômetro, acompanha seu relatório e muito mais. ✨": "На вкладке «Учёба» вы создаёте свои папки, пользуетесь секундомером, следите за отчётом и многое другое. ✨",
 "Com a aba {aba} você cria o que é seu e usa todos os recursos. ✨": "На вкладке «{aba}» вы создаёте своё и пользуетесь всеми функциями. ✨",
 "Conhecer a aba": "Познакомиться с вкладкой",
 "Crie um fichário em Estudos e volte aqui.": "Создайте папку в разделе «Учёба» и вернитесь сюда.",
 "Em sessão": "Идёт занятие",
 "Encerrar e salvar o cronômetro e começar a sessão?": "Остановить и сохранить секундомер и начать занятие?",
 "Encerrar e salvar o cronômetro e continuar a sessão?": "Остановить и сохранить секундомер и продолжить занятие?",
 "Enquadre e toque no botão": "Наведите камеру и нажмите кнопку",
 "Escolha o fichário que os colegas vão ver na tela (só para ler).": "Выберите папку, которую участники увидят на экране (только для чтения).",
 "Esconder": "Скрыть",
 "Este arquivo está guardado só no dispositivo ou no Drive de quem compartilhou, por isso não aparece aqui.": "Этот файл хранится только на устройстве или в Drive того, кто им поделился, поэтому здесь он не отображается.",
 "Fichário do grupo": "Папка группы",
 "Guia passo a passo do app e de cada aba": "Пошаговое руководство по приложению и каждой вкладке",
 "Há um cronômetro em andamento.": "Секундомер уже запущен.",
 "Há uma sessão em andamento.": "Сейчас идёт занятие.",
 "Inserir imagem": "Вставить изображение",
 "Mais ícones": "Больше значков",
 "Nenhum ícone com esse nome. Tente outra palavra ou escolha numa categoria.": "Значков с таким названием нет. Попробуйте другое слово или выберите категорию.",
 "Nenhuma matéria neste fichário ainda.": "В этой папке пока нет предметов.",
 "Nenhuma página nesta matéria ainda.": "В этом предмете пока нет страниц.",
 "No grupo de estudos, imagens e PDFs abrem aqui na tela. Este tipo de arquivo não tem visualização dentro do app.": "В учебной группе изображения и PDF открываются прямо здесь, на экране. Для этого типа файлов просмотр в приложении недоступен.",
 "Não deu para mostrar agora. Confira a internet e tente de novo.": "Не удалось показать сейчас. Проверьте подключение к интернету и попробуйте снова.",
 "O compartilhamento de fichários ainda está sendo preparado. Volte daqui a pouco.": "Совместный доступ к папкам ещё готовится. Загляните чуть позже.",
 "O fichário deste grupo está em outro dispositivo seu. Ele continua compartilhado a partir de lá.": "Папка этой группы находится на другом вашем устройстве. Доступ к ней по-прежнему открыт оттуда.",
 "OK = Conhecer a aba · Cancelar = Agora não": "OK = Познакомиться с вкладкой · Отмена = Не сейчас",
 "Os colegas deixam de ver o fichário. Tudo continua com você.": "Участники больше не увидят папку. Всё остаётся у вас.",
 "Os colegas veem este fichário na tela, só para ler: não editam, não baixam, não imprimem e não compartilham. As suas metas, o cronômetro e as páginas revisadas continuam só seus.": "Участники видят эту папку на экране только для чтения: не редактируют, не скачивают, не печатают и не делятся. Ваши цели, секундомер и повторённые страницы остаются только вашими.",
 "Para ver PDFs aqui na tela, instale a versão mais nova do app pela loja.": "Чтобы просматривать PDF здесь, установите последнюю версию приложения из магазина.",
 "Parar de compartilhar": "Закрыть доступ",
 "Pausar a sessão": "Приостановить занятие",
 "Pausar a sessão e estudar só esta?": "Приостановить занятие и заниматься только этим?",
 "Página em branco.": "Пустая страница.",
 "Quer estudar com tudo isso?": "Хотите учиться со всем этим?",
 "Quer usar tudo isso?": "Хотите пользоваться всем этим?",
 "Selecionar todos": "Выбрать все",
 "Trocar fichário": "Сменить папку",
 "Você está participando do grupo de {nome}": "Вы участвуете в группе {nome}",
 "Você vê na tela o que foi compartilhado neste grupo, para ler e acompanhar.": "Вы видите на экране то, чем поделились в этой группе, чтобы читать и следить.",
 "abacate, fruta": "авокадо, фрукт",
 "academia, musculação, treino, peso": "спортзал, качалка, тренировка, вес",
 "acampamento, camping": "кемпинг, поход, палатка",
 "alfinete, fixar, importante": "булавка, закрепить, важное",
 "almoço, arroz, prato": "обед, рис, тарелка",
 "alvo, meta, objetivo, foco": "мишень, цель, задача, фокус",
 "aniversário, bolo": "день рождения, торт",
 "anotação, nota, lista, escrever": "заметка, запись, список, писать",
 "arco-íris": "радуга",
 "avião, viagem, voo": "самолёт, путешествие, полёт",
 "balança, direito, justiça, lei, processo": "весы, право, правосудие, закон, дело",
 "balde, limpeza": "ведро, уборка",
 "banana, fruta": "банан, фрукт",
 "banheira, banho, banheiro": "ванна, купание, ванная",
 "barbear, barba, lâmina": "бритьё, борода, лезвие",
 "bicicleta, pedalar, bike": "велосипед, кататься, байк",
 "bolo, doce, sobremesa": "торт, сладкое, десерт",
 "brilho, mágica": "блеск, магия",
 "cabelo, cabeleireiro, corte": "волосы, парикмахер, стрижка",
 "cachorro, cão, pet": "собака, пёс, питомец",
 "caderno": "тетрадь",
 "caderno, fichário, amarelo": "тетрадь, папка, жёлтый",
 "café, xícara, pausa": "кофе, чашка, перерыв",
 "caixa, pacote, mudança, entrega": "коробка, посылка, переезд, доставка",
 "calendário, agenda, data": "календарь, ежедневник, дата",
 "cama, quarto": "кровать, спальня",
 "caminhada, caminhar, andar": "прогулка, ходьба, идти",
 "camisa, gravata, roupa, trabalho": "рубашка, галстук, одежда, работа",
 "carne, churrasco": "мясо, шашлык, барбекю",
 "carrinho, mercado, compras, supermercado": "тележка, магазин, покупки, супермаркет",
 "carro, dirigir, veículo": "машина, вождение, автомобиль",
 "certo, feito, visto": "галочка, сделано, отмечено",
 "cesto, roupa, lavanderia, lavar roupa": "корзина, одежда, прачечная, стирка",
 "chave de fenda, ferramenta, conserto": "отвёртка, инструмент, ремонт",
 "chave, senha": "ключ, пароль",
 "chocolate, doce": "шоколад, сладкое",
 "chuveiro, banho": "душ, мытьё",
 "chá, xícara": "чай, чашка",
 "compras, sacolas, shopping": "покупки, пакеты, торговый центр",
 "computador, monitor, tela": "компьютер, монитор, экран",
 "computador, notebook, informática": "компьютер, ноутбук, информатика",
 "coração amarelo": "жёлтое сердце",
 "coração azul": "синее сердце",
 "coração branco": "белое сердце",
 "coração laranja": "оранжевое сердце",
 "coração roxo": "фиолетовое сердце",
 "coração verde": "зелёное сердце",
 "coração, amor, saúde, vermelho": "сердце, любовь, здоровье, красный",
 "corrida, correr": "бег, бегать",
 "creme, hidratante, pele, skincare": "крем, увлажнение, кожа, уход за кожей",
 "croissant, pão, café da manhã": "круассан, хлеб, завтрак",
 "câmera, foto, fotografia": "камера, фото, фотография",
 "cérebro, mente, memória, pensar": "мозг, разум, память, думать",
 "dado, jogo de tabuleiro": "кубик, настольная игра",
 "dente, dentista": "зуб, стоматолог",
 "despertador, relógio, alarme, acordar": "будильник, часы, сигнал, проснуться",
 "diamante, joia": "бриллиант, украшение",
 "dinheiro, pagar, conta, pagamento": "деньги, платить, счёт, оплата",
 "dormir, sono, descanso": "спать, сон, отдых",
 "e-mail, mensagem, carta": "e-mail, сообщение, письмо",
 "escada": "лестница",
 "escova de dentes, dentes": "зубная щётка, зубы",
 "escrever, redação, caneta": "писать, сочинение, ручка",
 "esponja, lavar louça": "губка, мыть посуду",
 "esquadro, régua, geometria, desenho técnico": "угольник, линейка, геометрия, черчение",
 "estrela brilhante, destaque": "сияющая звезда, выделить",
 "estrela, favorito": "звезда, избранное",
 "etiqueta, marcador": "ярлык, метка",
 "extintor, segurança, incêndio": "огнетушитель, безопасность, пожар",
 "falar, idioma, inglês, conversa": "говорить, язык, английский, разговор",
 "feito, concluído, certo": "готово, выполнено, верно",
 "ferramenta, conserto, manutenção": "инструмент, ремонт, обслуживание",
 "festa, comemoração": "праздник, вечеринка",
 "filme, cinema, série": "фильм, кино, сериал",
 "fogo, urgente, sequência": "огонь, срочно, серия",
 "folha, natureza, erva, chá": "лист, природа, трава, чай",
 "fone de ouvido, áudio, música, podcast": "наушники, аудио, музыка, подкаст",
 "formatura, capelo, faculdade, diploma, universidade": "выпускной, шапочка, вуз, диплом, университет",
 "força, braço, músculo": "сила, рука, мышцы",
 "frango, coxa": "курица, окорочок",
 "frigideira, cozinhar, ovo, cozinha": "сковорода, готовить, яйцо, кухня",
 "futebol, bola, esporte": "футбол, мяч, спорт",
 "gato, pet": "кот, кошка, питомец",
 "gelo, geladeira, congelador": "лёд, холодильник, морозилка",
 "gráfico, planilha, finanças, relatório": "график, таблица, финансы, отчёт",
 "ingresso, show, evento": "билет, концерт, мероприятие",
 "jogo, videogame, game": "игра, видеоигра, гейминг",
 "lancha, barco": "катер, лодка",
 "leite, copo": "молоко, стакан",
 "letras, alfabeto, português": "буквы, алфавит, русский язык",
 "link, corrente": "ссылка, цепь",
 "livro aberto, leitura, ler": "открытая книга, чтение, читать",
 "livro azul, caderno": "синяя книга, тетрадь",
 "livro laranja, caderno": "оранжевая книга, тетрадь",
 "livro verde, caderno": "зелёная книга, тетрадь",
 "livro vermelho, caderno": "красная книга, тетрадь",
 "livros, estudo, estudar, biblioteca": "книги, учёба, учиться, библиотека",
 "lixo, lixeira": "мусор, корзина",
 "lua, noite": "луна, ночь",
 "lâmpada, ideia, luz": "лампочка, идея, свет",
 "macarrão, massa": "макароны, паста",
 "maleta, trabalho, escritório, negócios": "портфель, работа, офис, бизнес",
 "massagem, relaxar": "массаж, расслабиться",
 "maçã, fruta": "яблоко, фрукт",
 "microfone, cantar, karaokê, palestra": "микрофон, петь, караоке, лекция",
 "microscópio, ciência, biologia": "микроскоп, наука, биология",
 "mochila, escola, filhos": "рюкзак, школа, дети",
 "montanha, trilha": "гора, тропа, поход",
 "mundo, planeta, geografia": "мир, планета, география",
 "médico, consulta, exame, saúde": "врач, приём, анализ, здоровье",
 "música, nota musical": "музыка, нота",
 "natação, nadar, piscina": "плавание, плавать, бассейн",
 "olho, visão, oftalmologista": "глаз, зрение, офтальмолог",
 "oração, orar, gratidão, igreja": "молитва, молиться, благодарность, церковь",
 "ovo": "яйцо",
 "pastas, arquivo, fichário, divisórias": "папки, архив, скоросшиватель, разделители",
 "peixe": "рыба",
 "pescaria, pescar": "рыбалка, ловить рыбу",
 "pessoas, reunião, equipe, grupo": "люди, встреча, команда, группа",
 "piano, teclado musical": "пианино, синтезатор",
 "pintura, arte, desenho": "живопись, искусство, рисунок",
 "pipa": "воздушный змей",
 "pipoca, cinema": "попкорн, кино",
 "pizza": "пицца",
 "planta, vaso, regar": "растение, горшок, поливать",
 "porta, entrada": "дверь, вход",
 "praia, férias": "пляж, отпуск",
 "prato, refeição, louça, jantar": "тарелка, еда, посуда, ужин",
 "prédio, história, governo, tribunal": "здание, история, правительство, суд",
 "pão, padaria": "хлеб, пекарня",
 "pé, podólogo": "стопа, подолог",
 "pôr do sol, amanhecer": "закат, рассвет",
 "quebra-cabeça, peça": "пазл, головоломка, деталь",
 "queijo": "сыр",
 "raio, energia, rápido": "молния, энергия, быстро",
 "refrigerante, suco, bebida": "газировка, сок, напиток",
 "remédio, medicamento, vitamina, farmácia": "лекарство, препарат, витамин, аптека",
 "sabão, sabonete, lavar": "мыло, мыть",
 "salada, dieta, verdura": "салат, диета, зелень",
 "sanduíche, lanche": "бутерброд, перекус",
 "sino, aviso, lembrete": "колокольчик, уведомление, напоминание",
 "skate": "скейтборд",
 "sofá, sala": "диван, гостиная",
 "sol, manhã, dia": "солнце, утро, день",
 "spa, sauna, autocuidado": "спа, сауна, забота о себе",
 "teatro, máscaras": "театр, маски",
 "telefone, ligação, ligar": "телефон, звонок, позвонить",
 "tigela, cereal, sopa, mingau": "миска, хлопья, суп, каша",
 "trevo, sorte": "клевер, удача",
 "troféu, conquista, prêmio": "кубок, достижение, награда",
 "tubo de ensaio, química, laboratório": "пробирка, химия, лаборатория",
 "tênis, esporte": "теннис, спорт",
 "unha, manicure": "ноготь, маникюр",
 "vassoura, limpeza, faxina, varrer": "метла, уборка, чистота, подметать",
 "violão, guitarra": "гитара, акустическая гитара",
 "yoga, meditação, alongamento": "йога, медитация, растяжка",
 "{n} selecionada": "Выбрано: {n}",
 "{n} selecionadas": "Выбрано: {n}",
 "{n} selecionado": "Выбрано: {n}",
 "{n} selecionados": "Выбрано: {n}",
 "ábaco, matemática, contas, cálculo, contabilidade": "счёты, математика, счёт, вычисления, бухгалтерия",
 "água, gota, hidratar": "вода, капля, пить воду",
 "árvore, jardim, quintal": "дерево, сад, двор",
 "ônibus, transporte": "автобус, транспорт",
 "1 dia antes": "За 1 день",
 "1 dia depois": "Через 1 день",
 "A assinatura é feita no app do celular, pela loja de apps, e vale também aqui no site.": "Подписка оформляется в приложении на телефоне через магазин приложений и действует также здесь, на сайте.",
 "A chave está incompleta (curta demais). Copie de novo pelo botão de copiar da página da chave.": "Ключ неполный (слишком короткий). Скопируйте его снова кнопкой копирования на странице ключа.",
 "A chave tem caracteres que não fazem parte de uma chave. Copie de novo, só a chave, sem texto em volta.": "В ключе есть символы, которые не относятся к ключу. Скопируйте снова только ключ, без окружающего текста.",
 "A galeria chega na próxima atualização do app.": "Галерея появится в следующем обновлении приложения.",
 "ALERTAS": "ОПОВЕЩЕНИЯ",
 "Abra uma aba paga e comece o teste grátis. Depois volte aqui.": "Откройте платную вкладку и начните бесплатный пробный период. Затем вернитесь сюда.",
 "Abrir a barra do editor": "Открыть панель редактора",
 "Agora é horário do Não perturbe do app: o aviso chega em até 5 segundos, sem som nem vibração.": "Сейчас в приложении действует режим «Не беспокоить»: уведомление придёт в течение 5 секунд, без звука и вибрации.",
 "Aguardando confirmação": "Ожидает подтверждения",
 "Aguardando envio ao My Planner": "Ожидает отправки в My Planner",
 "Alertas de cada fatura": "Оповещения по каждому счёту",
 "Alertas do fim da garantia": "Оповещения об окончании гарантии",
 "Alertas do vencimento": "Оповещения о сроке",
 "Alertas: {campo}": "Оповещения: {campo}",
 "Alvorada": "Рассвет",
 "Ao abrir esta aba, o app pede o mesmo desbloqueio do app (senha, biometria ou PIN). Dá para mudar em Ajustes > Abas.": "При открытии этой вкладки приложение запрашивает ту же разблокировку, что и для входа в приложение (пароль, биометрия или PIN). Это можно изменить в разделе Настройки > Вкладки.",
 "Ao tocar num arquivo anexado, ele abre no app do celular que você escolher (se o celular perguntar, \"Apenas uma vez\" ou \"Sempre\"). O que você editar lá fica salvo no próprio arquivo.": "При нажатии на вложенный файл он открывается в выбранном вами приложении на телефоне (если телефон спросит — «Только сейчас» или «Всегда»). Всё, что вы там измените, сохранится в самом файле.",
 "App instalado": "Приложение установлено",
 "Apple Watch: já grava tudo no app Saúde do celular. Não precisa fazer nada.": "Apple Watch: уже записывают всё в приложение «Здоровье» на телефоне. Ничего делать не нужно.",
 "Arquivados e fixados": "Архивные и закреплённые",
 "Arquivo para ler e guardar, organizado por aba. Gerado em {data}.": "Файл для чтения и хранения, упорядоченный по вкладкам. Создан {data}.",
 "As notificações do My Planner estão desligadas no celular.": "Уведомления My Planner отключены на телефоне.",
 "Atualização automática disponível no app instalado.": "Автообновление доступно в установленном приложении.",
 "Aurora": "Аврора",
 "Avisos: alarme (som)": "Уведомления: будильник (звук)",
 "Baixar o app": "Скачать приложение",
 "Baixar o arquivo técnico": "Скачать технический файл",
 "Baixar para ler (PDF)": "Скачать для чтения (PDF)",
 "Barra do editor (caneta, marca-texto, texto)": "Панель редактора (ручка, маркер, текст)",
 "Brisa": "Бриз",
 "Campainha": "Звонок",
 "Canal": "Канал",
 "Cole a chave antes de testar.": "Вставьте ключ перед проверкой.",
 "Começa em": "Начинается",
 "Como avisar": "Как уведомлять",
 "Confira a chave": "Проверьте ключ",
 "Conta de teste de compras": "Тестовый аккаунт для покупок",
 "Conta vencida": "Просроченный счёт",
 "Copie a chave na hora (ela só aparece uma vez). Começa com \"sk-\".": "Скопируйте ключ сразу (он показывается только один раз). Он начинается с «sk-».",
 "Copie a chave na hora (ela só aparece uma vez). Começa com \"sk-ant-\".": "Скопируйте ключ сразу (он показывается только один раз). Он начинается с «sk-ant-».",
 "Cristal": "Хрусталь",
 "Daqui a 1 hora": "Через 1 час",
 "Daqui a 1 semana": "Через 1 неделю",
 "Daqui a 3 dias": "Через 3 дня",
 "Depois de 5 min fora": "Через 5 мин вне вкладки",
 "Depois de 5 minutos fora": "Через 5 минут вне вкладки",
 "Desligar a senha desta aba": "Отключить пароль этой вкладки",
 "Detalhes técnicos": "Технические сведения",
 "Dia {n} de {t}": "День {n} из {t}",
 "Dica: a chave é como uma senha. Não mande por mensagem nem publique. Se vazar, apague-a no site e crie outra.": "Совет: ключ — как пароль. Не отправляйте его в сообщениях и не публикуйте. Если он утёк, удалите его на сайте и создайте новый.",
 "Documento vencido": "Просроченный документ",
 "Ela abre em {d}.": "Откроется {d}.",
 "Ela abre em {d}. Você vai receber avisos: {quando}.": "Откроется {d}. Вы получите уведомления: {quando}.",
 "Ela abre em {d}. Você vai receber um aviso: {quando}.": "Откроется {d}. Вы получите уведомление: {quando}.",
 "Em \"API keys\", toque em \"Create key\" (Criar chave) e dê um nome, por exemplo \"My Planner\".": "В разделе «API keys» нажмите «Create key» (Создать ключ) и задайте имя, например «My Planner».",
 "Em \"Billing\" (Cobrança), adicione um cartão e alguns dólares de crédito. A assinatura ChatGPT Plus não vale aqui.": "В разделе «Billing» (Оплата) добавьте карту и несколько долларов на баланс. Подписка ChatGPT Plus здесь не действует.",
 "Em \"Billing\" (Cobrança), compre créditos. A assinatura Claude Pro não vale aqui.": "В разделе «Billing» (Оплата) купите кредиты. Подписка Claude Pro здесь не действует.",
 "Em breve": "Скоро",
 "Entre com a mesma conta do ChatGPT ou crie uma.": "Войдите с тем же аккаунтом, что и в ChatGPT, или создайте новый.",
 "Entre com a sua conta Google (a mesma do Gmail serve).": "Войдите в свой аккаунт Google (подойдёт тот же, что для Gmail).",
 "Entre ou crie uma conta (pode ser o mesmo e-mail do Claude).": "Войдите или создайте аккаунт (можно с той же почтой, что и в Claude).",
 "Enviados para o My Planner": "Отправлено в My Planner",
 "Enviar agora": "Отправить сейчас",
 "Escolha hoje ou uma data futura.": "Выберите сегодня или будущую дату.",
 "Escolhas lembradas": "Запомненные варианты",
 "Escolher a data": "Выбрать дату",
 "Escolher células": "Выбрать ячейки",
 "Escolher quando": "Выбрать время",
 "Espessura": "Толщина",
 "Esquecer": "Забыть",
 "Esta chave é de outro serviço ({servico}). Aqui funcionam só chaves do Claude, do ChatGPT ou do Gemini.": "Этот ключ от другого сервиса ({servico}). Здесь работают только ключи Claude, ChatGPT или Gemini.",
 "Esta chave é do {ia}, não do {escolhida}.": "Это ключ {ia}, а не {escolhida}.",
 "Esta conta vê o app como uma conta nova, sem nenhuma aba liberada, para conferir os cadeados, o teste grátis e a compra. As outras contas não mudam.": "Этот аккаунт видит приложение как новый аккаунт — без открытых вкладок, чтобы проверить замки, бесплатный пробный период и покупку. Другие аккаунты не меняются.",
 "Esta ferramenta precisa ver as páginas do PDF, o que chega com o app novo (versão 0.50). Use o navegador ou atualize o My Planner pela loja.": "Этому инструменту нужно видеть страницы PDF, это появится в новой версии приложения (0.50). Используйте браузер или обновите My Planner через магазин.",
 "Esta não parece uma chave do {ia}. As chaves do {ia} começam com {ini}.": "Это не похоже на ключ {ia}. Ключи {ia} начинаются с {ini}.",
 "Este aviso está em \"Desligado\": nada vai tocar.": "Это уведомление в режиме «Выключено»: звука не будет.",
 "Este celular ainda não recebe avisos com o app fechado. Atualize o My Planner pela loja (versão {v} ou mais nova). Com o app aberto, os avisos já funcionam.": "Этот телефон пока не получает уведомления при закрытом приложении. Обновите My Planner через магазин (версия {v} или новее). При открытом приложении уведомления уже работают.",
 "Este tipo de aviso está desligado nas configurações de notificação do celular.": "Этот тип уведомлений отключён в настройках уведомлений телефона.",
 "Estudado": "Изучено",
 "Estudado: {dur}": "Изучено: {dur}",
 "Faltou: {dur}": "Не хватило: {dur}",
 "Fazer os testes terminarem agora": "Завершить пробные периоды сейчас",
 "Fechar a barra do editor": "Закрыть панель редактора",
 "Fichário": "Папка",
 "Figurinhas e emojis": "Стикеры и эмодзи",
 "Garantia terminou": "Гарантия закончилась",
 "Gerando…": "Создание…",
 "Guarda documentos, exames e histórico de saúde com uma senha só dele. Nem o suporte consegue ler. Se você esquecer a senha, não há como recuperar.": "Хранит документы, анализы и историю здоровья под отдельным паролем. Даже поддержка не может их прочитать. Если вы забудете пароль, восстановить его невозможно.",
 "Harpa": "Арфа",
 "Horas por dia": "Часов в день",
 "Identificação": "Идентификация",
 "Isso parece um link ou um e-mail, não uma chave. Copie a chave inteira na página de chaves de API.": "Это похоже на ссылку или адрес почты, а не на ключ. Скопируйте ключ целиком на странице API-ключей.",
 "Isto só aparece no My Planner se você enviar. Quer enviar agora?": "Это появится в My Planner, только если вы отправите. Отправить сейчас?",
 "Já dá para confirmar {titulo}?": "Уже можно подтвердить {titulo}?",
 "Lembrar minha escolha nesta aba": "Запомнить мой выбор для этой вкладки",
 "Lembrete para confirmar: {data}": "Напоминание о подтверждении: {data}",
 "Marimba": "Маримба",
 "Marque pelo menos um dia da semana no plano.": "Отметьте в плане хотя бы один день недели.",
 "Me lembre de confirmar": "Напомнить подтвердить",
 "Me lembre depois": "Напомнить позже",
 "Menos": "Меньше",
 "Meta somada": "Общая цель",
 "Meta somada: {dur}": "Общая цель: {dur}",
 "Meus dados - My Planner {data}": "Мои данные - My Planner {data}",
 "Meus dados do My Planner": "Мои данные My Planner",
 "Mostrar a barra": "Показать панель",
 "Mudar senha do diário": "Сменить пароль дневника",
 "Na primeira vez, aceite os termos de uso.": "При первом входе примите условия использования.",
 "Na versão das lojas, a compra será pela loja de apps do celular. Por enquanto a chave simula a assinatura para testes.": "В версии из магазинов покупка будет проходить через магазин приложений на телефоне. Пока ключ имитирует подписку для тестирования.",
 "Nada de outras abas vai sozinho para o My Planner. Estes itens têm data e ainda não foram enviados.": "Ничто из других вкладок не попадает в My Planner само. У этих элементов есть дата, и они ещё не отправлены.",
 "Nenhum estudo registrado neste mês.": "В этом месяце занятий не записано.",
 "Nenhum item aguardando envio.": "Нет элементов, ожидающих отправки.",
 "Nenhum teste começado": "Пробные периоды не начаты",
 "Nesta tela não há nada para adicionar.": "На этом экране нечего добавить.",
 "No dia": "В тот же день",
 "Nova nota rápida": "Новая быстрая заметка",
 "Nova página do dia": "Новая страница дня",
 "Não deu certo": "Не получилось",
 "Não entram: o conteúdo do Diário e os campos do cofre (ficam protegidos pela senha), fotos e arquivos anexados. Para restaurar os dados no app, use o arquivo técnico.": "Не входят: содержимое Дневника и поля сейфа (они защищены паролем), фото и вложенные файлы. Чтобы восстановить данные в приложении, используйте технический файл.",
 "Não foi possível gerar o PDF.": "Не удалось создать PDF.",
 "Não foi possível testar agora. Tente de novo em alguns segundos.": "Сейчас не удалось проверить. Повторите через несколько секунд.",
 "Não lembrar": "Не запоминать",
 "Não, obrigada": "Нет, спасибо",
 "O Diário é protegido pela senha dele e não entra neste arquivo.": "Дневник защищён собственным паролем и не входит в этот файл.",
 "O app abre \"Salvar em Arquivos\" para você escolher a pasta (pode ser o iCloud Drive).": "Приложение откроет «Сохранить в Файлы», чтобы вы выбрали папку (можно iCloud Drive).",
 "O app guarda só o atalho do arquivo escolhido: ele continua onde está (Drive, OneDrive, Downloads) e abre no app do celular. Nada é copiado. Esta opção vale para as fotos tiradas pela câmera.": "Приложение сохраняет только ярлык выбранного файла: он остаётся на своём месте (Drive, OneDrive, Загрузки) и открывается в приложении на телефоне. Ничего не копируется. Этот вариант действует для фото, снятых камерой.",
 "O app instalado neste dispositivo é a versão {v}. Para fazer chamadas de áudio e vídeo, atualize o My Planner pela loja (versão 0.35 ou mais nova). As mensagens já funcionam.": "На этом устройстве установлена версия приложения {v}. Для аудио- и видеозвонков обновите My Planner через магазин (версия 0.35 или новее). Сообщения уже работают.",
 "O aviso vai chegar em silêncio, direto na lista de notificações: ligue os alertas do My Planner nas configurações do celular.": "Уведомление придёт беззвучно, прямо в список уведомлений: включите оповещения My Planner в настройках телефона.",
 "O aviso vai chegar sem som: o som deste tipo de aviso foi desligado nas configurações do celular.": "Уведомление придёт без звука: звук для этого типа уведомлений отключён в настройках телефона.",
 "O aviso vai chegar, mas o som das notificações do My Planner está desligado no celular.": "Уведомление придёт, но звук уведомлений My Planner на телефоне отключён.",
 "O convite leva o link para baixar o app. Quem entra pelo link cai direto no escritório.": "В приглашении есть ссылка для скачивания приложения. Тот, кто входит по ссылке, сразу попадает в офис.",
 "O ditado chega com a versão nova do app. Atualize o My Planner pela loja para usar o microfone.": "Диктовка появится в новой версии приложения. Обновите My Planner через магазин, чтобы пользоваться микрофоном.",
 "O mesmo desbloqueio do app: senha, biometria ou PIN. Pede uma vez ao entrar; dentro da aba não pede de novo. Abrir a galeria, a câmera ou os arquivos não conta como sair. Itens grandes continuam pedindo a senha para excluir.": "Та же разблокировка, что и для приложения: пароль, биометрия или PIN. Запрашивается один раз при входе; внутри вкладки повторно не запрашивается. Открытие галереи, камеры или файлов не считается выходом. Для удаления крупных элементов пароль по-прежнему запрашивается.",
 "O modo silencioso do celular pode impedir o alarme. Deixe o celular no modo normal.": "Беззвучный режим телефона может помешать будильнику. Оставьте телефон в обычном режиме.",
 "O plano fica só em Estudos (não vai para o My Planner).": "План остаётся только в разделе «Учёба» (не переносится в My Planner).",
 "Opcional: prazo, horas por dia e dias da semana.": "Необязательно: срок, часы в день и дни недели.",
 "Os avisos do celular funcionam no app instalado.": "Уведомления на телефоне работают в установленном приложении.",
 "Os avisos no celular funcionam no app instalado.": "Уведомления на телефоне работают в установленном приложении.",
 "Os testes começados terminaram. Abra a aba para ver \"O teste grátis terminou\".": "Начатые пробные периоды завершены. Откройте вкладку, чтобы увидеть «Бесплатный пробный период закончился».",
 "Outros dados": "Другие данные",
 "Ouvir": "Прослушать",
 "Pacote em uso": "Используемый пакет",
 "Para assinar, atualize o My Planner pela loja de apps do celular.": "Чтобы оформить подписку, обновите My Planner через магазин приложений на телефоне.",
 "Para ler (PDF): organizado por aba, com títulos e datas. Abre em qualquer dispositivo ou computador.": "Для чтения (PDF): упорядочен по вкладкам, с заголовками и датами. Открывается на любом устройстве или компьютере.",
 "Para o alarme do remédio tocar com o \"Não perturbe\" ligado, o celular precisa permitir o acesso ao \"Não perturbe\" para o My Planner. Toque em \"Abrir configurações\", procure o My Planner na lista e ligue a permissão.": "Чтобы будильник о лекарстве звонил при включённом режиме «Не беспокоить», телефон должен разрешить My Planner доступ к режиму «Не беспокоить». Нажмите «Открыть настройки», найдите My Planner в списке и включите разрешение.",
 "Passo a passo para criar a chave": "Пошаговая инструкция по созданию ключа",
 "Pedir de novo": "Спросить снова",
 "Pedir senha ao abrir esta aba": "Запрашивать пароль при открытии этой вкладки",
 "Plano com período": "План на период",
 "Plano começa em {d}": "План начинается {d}",
 "Por matéria": "По предметам",
 "Prolongar": "Продлить",
 "Pronto: o aviso chega em até 5 segundos, com som. Se não tocar, confira se o celular está no silencioso.": "Готово: уведомление придёт в течение 5 секунд, со звуком. Если звука нет, проверьте, не включён ли на телефоне беззвучный режим.",
 "Pronto: o aviso chega em até 5 segundos, só vibrando.": "Готово: уведомление придёт в течение 5 секунд, только с вибрацией.",
 "Publicado em": "Опубликовано",
 "Pulso": "Пульс",
 "Quando o app bloquear": "Когда приложение блокируется",
 "Quer proteger esta aba com senha?": "Защитить эту вкладку паролем?",
 "Recolher ou arrastar a barra": "Свернуть или перетащить панель",
 "Recomeçar os testes grátis": "Перезапустить бесплатные пробные периоды",
 "Recomeçar os testes grátis?": "Перезапустить бесплатные пробные периоды?",
 "Rolar a folha para os lados": "Прокручивать лист в стороны",
 "Se você conectar o relógio: totais de cada dia de passos, distância, calorias, exercício, batimentos e sono, lidos do Health Connect ou do app Saúde do celular. O app só lê e nunca altera esses dados.": "Если вы подключите часы: дневные итоги шагов, расстояния, калорий, тренировок, пульса и сна, считанные из Health Connect или приложения «Здоровье» на телефоне. Приложение только читает эти данные и никогда их не изменяет.",
 "Sem internet ou a conexão caiu. Confira o Wi-Fi ou os dados móveis e tente de novo.": "Нет интернета или соединение прервалось. Проверьте Wi-Fi или мобильные данные и повторите попытку.",
 "Senha desta aba": "Пароль этой вкладки",
 "Seu plano terminou": "Ваш план завершён",
 "Sino": "Колокол",
 "Som do alarme": "Звук будильника",
 "Soma a garantia legal e a do fabricante. Confira no termo de garantia.": "Суммирует гарантию по закону и гарантию производителя. Проверьте в гарантийном талоне.",
 "São dois arquivos com os seus dados do My Planner (portabilidade, LGPD):": "Это два файла с вашими данными My Planner (переносимость данных, LGPD):",
 "Só quando o app bloquear": "Только когда приложение блокируется",
 "Tamanho da borracha": "Размер ластика",
 "Tamanho da letra": "Размер шрифта",
 "Tempo": "Время",
 "Termina em": "Заканчивается",
 "Testar": "Проверить",
 "Texto de exemplo": "Пример текста",
 "Toca nos avisos em \"Alarme (som)\". \"Som e vibração\" usa o som de notificação do celular.": "Звучит для уведомлений в режиме «Будильник (звук)». «Звук и вибрация» использует звук уведомлений телефона.",
 "Toda vez que sair": "Каждый раз при выходе",
 "Toda vez que sair da aba": "Каждый раз при выходе из вкладки",
 "Todas as abas voltam a \"{n} dias grátis para testar\", como numa conta nova. As assinaturas simuladas são desligadas.": "Все вкладки вернутся к «{n} дней бесплатно для проверки», как в новом аккаунте. Имитированные подписки отключаются.",
 "Todos os fichários": "Все папки",
 "Toque em \"Create API key\" (Criar chave de API). Se pedir um projeto, escolha o que aparecer ou crie um novo.": "Нажмите «Create API key» (Создать ключ API). Если попросят проект, выберите предложенный или создайте новый.",
 "Toque em \"Criar minha chave de API\" acima. Abre a plataforma da OpenAI (não é o site do ChatGPT).": "Нажмите «Создать мой ключ API» выше. Откроется платформа OpenAI (это не сайт ChatGPT).",
 "Toque em \"Criar minha chave de API\" acima. Abre o Console da Anthropic (não é o site do Claude).": "Нажмите «Создать мой ключ API» выше. Откроется Console Anthropic (это не сайт Claude).",
 "Toque em \"Criar minha chave de API\" acima. Abre o Google AI Studio.": "Нажмите «Создать мой ключ API» выше. Откроется Google AI Studio.",
 "Toque em Conectar e, na tela do app Saúde, ligue os itens que o My Planner pode ler.": "Нажмите «Подключить» и на экране приложения «Здоровье» включите данные, которые может читать My Planner.",
 "Toque no ícone de copiar ao lado da chave. Ela começa com \"AIza\" ou \"AQ.\".": "Нажмите значок копирования рядом с ключом. Ключ начинается с «AIza» или «AQ.».",
 "Toque numa célula da tabela (ou em \"Escolher células\") para mudar o tamanho da letra dela.": "Нажмите на ячейку таблицы (или «Выбрать ячейки»), чтобы изменить размер её шрифта.",
 "Transparência": "Прозрачность",
 "Técnico (para restaurar): cópia completa que só o My Planner lê. Para usar, vá em Ajustes › Nuvem e cópias de segurança › Importar arquivo.": "Технический (для восстановления): полная копия, которую читает только My Planner. Чтобы использовать её, откройте Настройки › Облако и резервные копии › Импортировать файл.",
 "Uma carta da {nome} abre em {n} dias 💌": "Письмо от {nome} откроется через {n} дн. 💌",
 "Usa a senha do app": "Использует пароль приложения",
 "Usar no {ia}": "Использовать в {ia}",
 "Use o app no celular para baixar o arquivo técnico.": "Чтобы скачать технический файл, используйте приложение на телефоне.",
 "Valor final definido pela loja de apps, já na moeda do seu país.": "Итоговая цена устанавливается магазином приложений, сразу в валюте вашей страны.",
 "Você ainda não enviou {titulo} para o My Planner.": "Вы ещё не отправили {titulo} в My Planner.",
 "Volte aqui, cole no campo abaixo e toque em \"Salvar e testar\".": "Вернитесь сюда, вставьте ключ в поле ниже и нажмите «Сохранить и проверить».",
 "Volte em \"API keys\" e toque em \"Create new secret key\" (Criar chave).": "Вернитесь в «API keys» и нажмите «Create new secret key» (Создать ключ).",
 "atualização automática": "автообновление",
 "erro desconhecido": "неизвестная ошибка",
 "estudados no mês": "изучено за месяц",
 "faltou {dur}": "не хватило {dur}",
 "hoje {feito} de {meta}": "сегодня {feito} из {meta}",
 "hoje é folga": "сегодня выходной",
 "login do Google (não é chave de API)": "вход в Google (это не ключ API)",
 "meta cumprida": "цель выполнена",
 "o que veio com a instalação": "то, что было при установке",
 "outro": "другое",
 "provisório": "временно",
 "superou {dur}": "больше на {dur}",
 "token de login (não é chave de API)": "токен входа (это не ключ API)",
 "{ia} demorou demais para responder. Tente de novo em instantes.": "{ia} слишком долго не отвечал. Повторите попытку через мгновение.",
 "{ia} está fora do ar ou sobrecarregado agora. Não é problema da sua chave: tente de novo mais tarde.": "{ia} сейчас недоступен или перегружен. Дело не в вашем ключе: повторите попытку позже.",
 "{ia} respondeu ao teste com o modelo {modelo}. Já pode usar nas abas.": "{ia} ответил на проверку с моделью {modelo}. Теперь можно пользоваться во вкладках.",
 "{ia} se recusou a ler este conteúdo (filtro de segurança da empresa).": "{ia} отказался читать этот контент (фильтр безопасности компании).",
 "{ia}: a chave existe, mas não tem permissão para usar a IA. Crie uma chave nova na página indicada no passo a passo.": "{ia}: ключ существует, но у него нет разрешения на использование ИИ. Создайте новый ключ на странице, указанной в пошаговой инструкции.",
 "{ia}: chave inválida. Confira se copiou a chave inteira ou crie uma nova.": "{ia}: недействительный ключ. Проверьте, скопирован ли ключ целиком, или создайте новый.",
 "{ia}: esta chave foi bloqueada pela empresa porque apareceu publicada na internet. Apague-a e crie outra.": "{ia}: этот ключ заблокирован компанией, потому что он был опубликован в интернете. Удалите его и создайте новый.",
 "{ia}: limite de uso atingido. Espere alguns minutos (ou até amanhã, no plano gratuito) e tente de novo.": "{ia}: достигнут лимит использования. Подождите несколько минут (или до завтра на бесплатном тарифе) и повторите попытку.",
 "{ia}: o modelo escolhido não está disponível para a sua conta. Escolha outro em \"Modelo\".": "{ia}: выбранная модель недоступна для вашего аккаунта. Выберите другую в поле «Модель».",
 "{ia}: o serviço não está disponível na sua região ou para este tipo de conta.": "{ia}: сервис недоступен в вашем регионе или для этого типа аккаунта.",
 "{ia}: sua conta de API está sem saldo ou sem forma de pagamento. Adicione créditos no site da empresa.": "{ia}: на вашем аккаунте API нет средств или способа оплаты. Пополните баланс на сайте компании.",
 "{item}: a garantia termina hoje ({data}).": "{item}: гарантия заканчивается сегодня ({data}).",
 "{item}: a garantia terminou em {data}.": "{item}: гарантия закончилась {data}.",
 "{item}: venceu em {data}.": "{item}: срок истёк {data}.",
 "{mes} de {ano}": "{mes} {ano}",
 "{nome} protegida com senha": "{nome}: защищено паролем",
 "{nome}: encerrar o plano ou prolongar com uma nova data final? Nada é apagado.": "{nome}: завершить план или продлить с новой датой окончания? Ничего не удаляется.",
 "{n} dias antes": "За {n} дн.",
 "{n} dias de estudo no plano · {dur} por dia": "Дней учёбы в плане: {n} · {dur} в день",
 "{n} dias de plano": "Дней в плане: {n}",
 "{n} dias depois": "Через {n} дн.",
 "{n} item(ns) aguardando envio ao My Planner": "Элементов, ожидающих отправки в My Planner: {n}",
 "{n} itens aguardando envio": "Ожидают отправки: {n}",
 "{quando} às {hora}": "{quando} в {hora}",
 "ÚLTIMOS 6 MESES": "ПОСЛЕДНИЕ 6 МЕСЯЦЕВ",
 "Abra o My Planner Anne e entre com o seu CPF ou e-mail e a sua senha.": "Откройте My Planner Anne и войдите с помощью CPF или эл. почты и пароля.",
 "Anexo": "Вложение",
 "Assédio ou ameaça": "Травля или угрозы",
 "Bloquear {nome}": "Заблокировать {nome}",
 "Conte mais (opcional)": "Расскажите подробнее (необязательно)",
 "Conteúdo impróprio": "Неприемлемый контент",
 "Conteúdo ofensivo e usuários abusivos não são tolerados. As denúncias são analisadas pela nossa equipe em até 24 horas.": "Оскорбительный контент и пользователи, нарушающие правила, недопустимы. Наша команда рассматривает жалобы в течение 24 часов.",
 "Denunciar": "Пожаловаться",
 "Denunciar contato": "Пожаловаться на контакт",
 "Denunciar grupo": "Пожаловаться на группу",
 "Denunciar mensagem": "Пожаловаться на сообщение",
 "Denúncia enviada": "Жалоба отправлена",
 "Denúncias que você faz nas Mensagens: o motivo, quem foi denunciado e o trecho da mensagem denunciada. Só a equipe do My Planner lê, para analisar o caso.": "Жалобы, которые вы отправляете в Сообщениях: причина, на кого пожаловались, и фрагмент сообщения, на которое пожаловались. Их читает только команда My Planner, чтобы рассмотреть случай.",
 "Enviar denúncia": "Отправить жалобу",
 "Mande um e-mail pedindo a exclusão, com o CPF ou o e-mail da conta. Respondemos em até 15 dias.": "Отправьте письмо с просьбой об удалении, указав CPF или эл. почту аккаунта. Мы ответим в течение 15 дней.",
 "Não toleramos conteúdo ofensivo, ilegal ou impróprio nem usuários abusivos nas Mensagens e nos grupos. Qualquer pessoa pode denunciar uma mensagem, um contato ou um grupo (segure a mensagem ou toque em ⋮ > Denunciar) e bloquear quem quiser. As denúncias são analisadas pela nossa equipe em até 24 horas: o conteúdo pode ser removido e quem o enviou pode ter a conta suspensa ou encerrada.": "Мы не допускаем оскорбительный, незаконный или неприемлемый контент и пользователей, нарушающих правила, в Сообщениях и группах. Любой может пожаловаться на сообщение, контакт или группу (удерживайте сообщение или нажмите ⋮ > Пожаловаться) и заблокировать кого угодно. Наша команда рассматривает жалобы в течение 24 часов: контент может быть удалён, а аккаунт отправителя — приостановлен или закрыт.",
 "Obrigado. Nossa equipe vai analisar em até 24 horas.": "Спасибо. Наша команда рассмотрит жалобу в течение 24 часов.",
 "Para contas que entram com CPF, a senha nova é criada pelo nosso suporte, depois de confirmar que a conta é sua. Escreva para {email} informando o seu CPF ou o e-mail cadastrado.": "Для аккаунтов со входом по CPF новый пароль создаёт наша поддержка после подтверждения, что аккаунт ваш. Напишите на {email}, указав ваш CPF или зарегистрированную эл. почту.",
 "Por que você está denunciando? A pessoa denunciada não fica sabendo quem denunciou.": "Почему вы жалуетесь? Человек не узнает, кто на него пожаловался.",
 "Spam": "Спам",
 "{nome} não pode mais conversar com você.": "{nome} больше не может переписываться с вами.",
 "{nome}\nVale até {d}. Ele fica criptografado no seu cofre, só neste dispositivo e na sua cópia da nuvem.": "{nome}\nДействителен до {d}. Он хранится в зашифрованном виде в вашем сейфе, только на этом устройстве и в вашей копии в облаке.",
 "1. No computador, abra {url} e escolha Entrar com QR Code.": "1. На компьютере откройте {url} и выберите «Войти по QR-коду».",
 "2. Aqui, toque em Conectar navegador e aponte a câmera para o QR Code do computador.": "2. Здесь нажмите «Подключить браузер» и наведите камеру на QR-код на компьютере.",
 "Abandonados": "Брошенные",
 "Bloquear o computador": "Блокировать компьютер",
 "Cheguei na página...": "Я на странице...",
 "Computador conectado": "Подключённый компьютер",
 "Computador desconectado": "Компьютер отключён",
 "Conectado em {d}": "Подключён {d}",
 "Crie o grupo e mande o link: quem entrar vê o material do livro e acompanha a leitura. Quem administra inclui, edita e põe fotos, e pode liberar isso para quem também usa a aba. Só quem administra coloca ou tira pessoas.": "Создайте группу и отправьте ссылку: участники видят материалы книги и следят за чтением. Администраторы добавляют, редактируют и загружают фото и могут разрешить это тем, кто тоже пользуется вкладкой. Добавлять и удалять людей могут только администраторы.",
 "Depois de {n} minutos parado": "После {n} мин бездействия",
 "Desconectar o computador?": "Отключить компьютер?",
 "Difícil demais": "Слишком сложно",
 "Editar livro": "Изменить книгу",
 "Entrar com o QR Code": "Войти по QR-коду",
 "Escreva (ex.: filosofia)": "Введите (напр.: философия)",
 "Este computador": "Этот компьютер",
 "Este computador foi desconectado (pelo celular ou porque outro computador entrou). Para usar de novo, entre com o QR Code.": "Этот компьютер отключён (с телефона или потому что вошёл другой компьютер). Чтобы пользоваться снова, войдите по QR-коду.",
 "Já existe um computador conectado": "Уже подключён компьютер",
 "Já existe um computador conectado. Trocar para este? O outro será desconectado.": "Уже подключён компьютер. Переключиться на этот? Другой будет отключён.",
 "Navegador": "Браузер",
 "Nenhum computador conectado": "Нет подключённого компьютера",
 "Novo livro": "Новая книга",
 "Não gostei": "Не понравилось",
 "Não, abandonei": "Нет, бросил(а)",
 "O My Planner fecha no computador. Para usar de novo, é só conectar pelo QR Code.": "My Planner закроется на компьютере. Чтобы пользоваться снова, подключитесь по QR-коду.",
 "O QR Code muda a cada 3 minutos e só vale uma vez. Em computador compartilhado, use Ajustes › Sair deste computador ao terminar.": "QR-код меняется каждые 3 минуты и действует один раз. На общем компьютере по окончании используйте Настройки › Выйти с этого компьютера.",
 "Os seus dados continuam salvos na nuvem e no celular. Para entrar de novo, use o QR Code.": "Ваши данные остаются в облаке и на телефоне. Чтобы войти снова, используйте QR-код.",
 "Parei em": "Остановился(ась)",
 "Perdi o interesse": "Потерял(а) интерес",
 "Por que parei": "Почему я остановился(ась)",
 "Páginas e meta": "Страницы и цель",
 "Quero voltar a ler?": "Хочу вернуться к чтению?",
 "Sair deste computador": "Выйти с этого компьютера",
 "Sair deste computador?": "Выйти с этого компьютера?",
 "Se quiser, escreva com as suas palavras": "Если хотите, напишите своими словами",
 "Sem mexer no mouse ou no teclado por esse tempo, o My Planner bloqueia. Para voltar, digite a senha da conta (ou entre com o QR Code de novo).": "Если столько времени не пользоваться мышью и клавиатурой, My Planner блокируется. Чтобы вернуться, введите пароль аккаунта (или снова войдите по QR-коду).",
 "Sem tempo": "Нет времени",
 "Sim, depois": "Да, позже",
 "Só um computador pode ficar conectado por vez.": "Одновременно может быть подключён только один компьютер.",
 "A foto ou o PDF do certificado vai em \"Fotos, arquivos e links\": marque como Certificado.": "Фото или PDF сертификата добавьте в «Фото, файлы и ссылки» и отметьте как «Сертификат».",
 "ABNT copiada": "ABNT скопировано",
 "APA copiada": "APA скопировано",
 "Ano inválido": "Неверный год",
 "Ano ou data de publicação": "Год или дата публикации",
 "Assisti em": "Посмотрел(а)",
 "Buscando os dados...": "Ищу данные...",
 "Calculado pelos módulos": "Рассчитано по модулям",
 "Carga horária (horas)": "Объём (часы)",
 "Certificado": "Сертификат",
 "Certificado emitido em": "Сертификат выдан",
 "Cheguei na aula": "Я на уроке",
 "Cheguei na aula...": "Я на уроке...",
 "Cheguei na temporada": "Я на сезоне",
 "Cheguei no episódio": "Я на серии",
 "Citação copiada": "Цитата скопирована",
 "Colocar em pasta": "Добавить в папку",
 "Coloque livros, filmes ou cursos nesta pasta para montar a lista.": "Добавьте в папку книги, фильмы или курсы, чтобы составить список.",
 "Comentário": "Комментарий",
 "Copiar ABNT": "Копировать ABNT",
 "Copiar APA": "Копировать APA",
 "Copiar citação (ABNT)": "Копировать цитату (ABNT)",
 "Copiar citação (APA)": "Копировать цитату (APA)",
 "Crie cards com checklist, lista, texto livre ou desenho para esta matéria. Arraste para a direita para excluir e para a esquerda para Arquivar ou Duplicar.": "Создавайте карточки с чек-листом, списком, текстом или рисунком для этого предмета. Смахните вправо, чтобы удалить, и влево, чтобы архивировать или дублировать.",
 "Crie o grupo e mande o link: quem entrar vê a lista e acompanha. Quem administra inclui, edita e põe fotos, e pode liberar isso para quem também usa a aba. Só quem administra coloca ou tira pessoas.": "Создайте группу и отправьте ссылку: участники видят список и следят за ним. Администраторы добавляют, редактируют и загружают фото и могут разрешить это тем, кто тоже пользуется вкладкой. Добавлять и удалять людей могут только администраторы.",
 "Crie o grupo e mande o link: quem entrar vê o material do curso e acompanha. Quem administra inclui, edita e põe fotos, e pode liberar isso para quem também usa a aba. Só quem administra coloca ou tira pessoas.": "Создайте группу и отправьте ссылку: участники видят материалы курса и следят за ним. Администраторы добавляют, редактируют и загружают фото и могут разрешить это тем, кто тоже пользуется вкладкой. Добавлять и удалять людей могут только администраторы.",
 "Crie uma pasta primeiro, na parte 📁 Pastas desta aba.": "Сначала создайте папку в разделе 📁 Папки этой вкладки.",
 "DOI (artigos)": "DOI (статьи)",
 "Data de acesso": "Дата обращения",
 "Deixar avulsas": "Оставить отдельно",
 "Descrição (objetivo)": "Описание (цель)",
 "Digite o ano com 4 números (ex.: {a}).": "Введите год 4 цифрами (напр.: {a}).",
 "Direção": "Режиссёр",
 "Editar pasta": "Изменить папку",
 "Editora": "Издательство",
 "Edição": "Издание",
 "Em 1 mês": "Через 1 месяц",
 "Em {n} meses": "Через {n} мес.",
 "Episódios por temporada (opcional)": "Серий в сезоне (необязательно)",
 "Escreva o trecho na anotação para copiar a citação.": "Напишите отрывок в заметке, чтобы скопировать цитату.",
 "Este item já está em todas as pastas.": "Этот элемент уже во всех папках.",
 "Ex.: 10.1590/...": "Напр.: 10.1590/...",
 "Ex.: TCC — Ética e Direito": "Напр.: Диплом — Этика и право",
 "Ex.: {a}": "Напр.: {a}",
 "Fazendo": "Прохожу",
 "Grupo de filmes e séries": "Группа фильмов и сериалов",
 "Grupo de leitura": "Читательская группа",
 "Grupo do curso": "Группа курса",
 "ISBN": "ISBN",
 "Ideia minha": "Моя мысль",
 "Instrutor": "Преподаватель",
 "Itens da pasta": "Элементы папки",
 "Junte livros, filmes e cursos numa pasta (ex.: \"TCC\", \"Só romances\"). O mesmo item pode estar em várias pastas.": "Собирайте книги, фильмы и курсы в папку (напр.: «Диплом», «Только романы»). Один элемент может быть в нескольких папках.",
 "Link (material online)": "Ссылка (онлайн-материал)",
 "Lista copiada": "Список скопирован",
 "Lista de referências": "Список литературы",
 "Mais de um autor: separe com ponto e vírgula (;).": "Несколько авторов: разделите точкой с запятой (;).",
 "Módulo": "Модуль",
 "Nada novo": "Ничего нового",
 "No ⋮ de um livro, filme ou curso, toque em \"Colocar em pasta\".": "В ⋮ книги, фильма или курса нажмите «Добавить в папку».",
 "Nome da pasta": "Название папки",
 "Não achei dados novos para completar a ficha.": "Новых данных для заполнения не найдено.",
 "Não foi possível preencher": "Не удалось заполнить",
 "O módulo não tem cards de anotações.": "В модуле нет карточек заметок.",
 "Organizador": "Составитель",
 "Os dados vêm da ficha do livro (Editar › Referência).": "Данные берутся из карточки книги (Изменить › Библиография).",
 "Os livros, filmes e cursos da pasta NÃO são apagados: continuam na aba.": "Книги, фильмы и курсы из папки НЕ удаляются: они остаются во вкладке.",
 "Os {n} card(s) de anotações deste módulo também vão para a lixeira.": "{n} карточек заметок этого модуля тоже попадут в корзину.",
 "Pasta vazia": "Пустая папка",
 "Preencha o título (e o que mais tiver) na ficha.": "Заполните название (и что ещё есть) в карточке.",
 "Preencher pelo DOI": "Заполнить по DOI",
 "Preencher pelo link": "Заполнить по ссылке",
 "Produtora ou país": "Студия или страна",
 "Quero fazer": "Хочу пройти",
 "Quero voltar?": "Хочу вернуться?",
 "Referência vazia": "Пустая ссылка",
 "Referências": "Литература",
 "Se deixar avulsas, elas continuam somando no total do curso.": "Если оставить отдельно, они всё равно учитываются в курсе.",
 "Subtítulo": "Подзаголовок",
 "Tirar da pasta": "Убрать из папки",
 "Total de episódios (opcional)": "Всего серий (необязательно)",
 "Total de temporadas (opcional)": "Всего сезонов (необязательно)",
 "Tradutor": "Переводчик",
 "Trecho (citação)": "Отрывок (цитата)",
 "Trecho vazio": "Пустой отрывок",
 "Você já assistiu {n} aula(s). Colocar em qual módulo?": "Вы уже посмотрели {n} урок(ов). В какой модуль их поместить?",
 "Volume": "Том",
 "{n} item(ns)": "{n} эл.",
 "{n} referência(s) em ordem alfabética.": "{n} источник(ов) по алфавиту.",
 "Ícone": "Значок",
 "ASSISTIDOS POR DIA": "ПРОСМОТРЕНО ПО ДНЯМ",
 "ASSISTIDOS POR MÊS": "ПРОСМОТРЕНО ПО МЕСЯЦАМ",
 "AULAS POR DIA": "УРОКИ ПО ДНЯМ",
 "AULAS POR MÊS": "УРОКИ ПО МЕСЯЦАМ",
 "Apagar a meta": "Удалить цель",
 "Assisti {a} · Estou assistindo {b} · Parei {c} · Quero assistir {d}": "Посмотрел(а) {a} · Смотрю {b} · Бросил(а) {c} · Хочу {d}",
 "Aulas": "Уроки",
 "CURSOS": "КУРСЫ",
 "Concluí {a} · Fazendo {b} · Parei {c}": "Окончил(а) {a} · Прохожу {b} · Бросил(а) {c}",
 "Datas": "Даты",
 "Datas escolhidas": "Выбранные даты",
 "Datas à escolha": "Свои даты",
 "Definir meta de {ano}": "Цель на {ano}",
 "Definir meta do ano": "Поставить цель на год",
 "FILMES E SÉRIES": "ФИЛЬМЫ И СЕРИАЛЫ",
 "Faltam {f} curso(s): dá cerca de {m} por mês": "Осталось {f}: примерно {m} в месяц",
 "Faltam {f} livro(s): dá cerca de {m} por mês": "Осталось {f}: примерно {m} в месяц",
 "Faltam {f} título(s): dá cerca de {m} por mês": "Осталось {f}: примерно {m} в месяц",
 "Gênero": "Жанр",
 "Incluir lista de referências no PDF": "Добавить список литературы в PDF",
 "LIVROS": "КНИГИ",
 "Li {a} livro(s) · Parei {b} · Estou lendo {c}": "Прочитал(а) {a} · Бросил(а) {b} · Читаю {c}",
 "Meta de {ano}": "Цель на {ano}",
 "Meta de {ano}: usar a de {antes} ({n})?": "Цель на {ano}: как в {antes} ({n})?",
 "Meta do ano cumprida": "Цель года выполнена",
 "Mudar": "Изменить",
 "Nada neste período.": "За этот период ничего.",
 "Nota": "Оценка",
 "O PDF não leva as suas anotações, resumos e comentários.": "В PDF нет ваших заметок, кратких содержаний и комментариев.",
 "POR ITEM": "ПО ПУНКТАМ",
 "Plataforma": "Платформа",
 "PÁGINAS POR DIA": "СТРАНИЦЫ ПО ДНЯМ",
 "PÁGINAS POR MÊS": "СТРАНИЦЫ ПО МЕСЯЦАМ",
 "Quantos no ano?": "Сколько за год?",
 "Quero ler {a} · Abandonei {b}": "Хочу прочитать {a} · Бросил(а) {b}",
 "Relatório de leitura e mídia": "Отчёт о чтении и медиа",
 "concluídos no período": "завершено за период",
 "cursos concluídos no período": "курсов окончено за период",
 "livros lidos no período": "книг прочитано за период",
 "pág. {a} de {n}": "стр. {a} из {n}",
 "títulos assistidos no período": "просмотрено за период",
 "{a} aula(s) assistida(s) no período · {h} hora(s) de cursos concluídos": "{a} урок(ов) за период · {h} ч окончённых курсов",
 "{a} de {n} aulas ({p}%)": "{a} из {n} уроков ({p}%)",
 "{a} de {n} curso(s) concluído(s) em {ano}": "{a} из {n} курсов в {ano}",
 "{a} de {n} livro(s) em {ano}": "{a} из {n} книг в {ano}",
 "{a} de {n} título(s) assistido(s) em {ano}": "{a} из {n} просмотрено в {ano}",
 "{n} item(ns) sem data de mudança de situação: usei a data de criação.": "{n} эл. без даты смены статуса: взята дата создания.",
 "{p} página(s) lida(s) em {d} dia(s) · melhor sequência: {s} dia(s)": "{p} стр. за {d} дн. · лучшая серия: {s} дн.",
 "{p}% lido · falta {f}%": "прочитано {p}% · осталось {f}%",
 "Esta aba pede senha. Desbloqueie a aba primeiro e o guia continua daqui.": "Эта вкладка защищена паролем. Сначала разблокируйте её — руководство продолжится отсюда.",
 "Abrir esta aba": "Открыть вкладку",
 "Mostrar na tela": "Показать на экране",
 "Não achei este ponto na tela agora. Confira se a tela certa está aberta e tente de novo.": "Сейчас не нашёл это место на экране. Проверьте, что открыт нужный экран, и попробуйте снова.",
 "Primeiros passos": "Первые шаги",
 "Buscar no guia": "Поиск по руководству",
 "Entendi": "Понятно",
 "{n} de {total} passos feitos": "Выполнено {n} из {total}",
 "Já fiz": "Готово",
 "Guia em construção": "Руководство готовится",
 "Limpar marcações": "Сбросить отметки",
 "Este ponto ainda não está marcado no app.": "Это место ещё не отмечено в приложении.",
 "Dicas e atalhos": "Советы и быстрые действия",
 "Gestos do app": "Жесты приложения",
 "Procurando na tela…": "Ищу на экране…",
 "Guia das abas": "Руководство по вкладкам",
 "Voltar ao guia": "Назад к руководству",
 "Para que serve": "Для чего это",
 "Disponível no app do celular.": "Доступно в приложении на телефоне.",
 "Nada encontrado no guia.": "В руководстве ничего не найдено.",
 "Recursos que valem para todas as abas": "Функции для всех вкладок",
 "Perguntas comuns": "Частые вопросы",
 "Ligar e desligar partes": "Включить и выключить части",
 "Entrada cancelada. Este computador não foi conectado.": "Вход отменён. Этот компьютер не подключён.",
 "Alterações ainda não enviadas": "Изменения ещё не отправлены",
 "Algumas alterações ainda não foram enviadas para o servidor (sem internet?). Se sair agora, elas se perdem. Sair mesmo assim?": "Некоторые изменения ещё не отправлены на сервер (нет интернета?). Если выйти сейчас, они пропадут. Всё равно выйти?",
 "Sair mesmo assim": "Всё равно выйти",
 "O seu papel no grupo não permite mudar aqui.": "Ваша роль в группе не позволяет вносить здесь изменения.",
 "Não foi possível consultar o DOI agora (sem internet?). Tente de novo.": "Сейчас не удалось проверить DOI (нет интернета?). Попробуйте ещё раз.",
 "DOI inválido.": "Неверный DOI.",
 "DOI não encontrado.": "DOI не найден.",
 "O site não deixou ler os dados daqui (no navegador do computador isso é comum). Tente pelo app no celular, use o DOI, ou digite os campos.": "Сайт не позволил прочитать данные отсюда (в браузере на компьютере это обычно). Попробуйте приложение на телефоне, используйте DOI или заполните поля вручную.",
 "Atualizando...": "Обновление...",
 "Banco de dados (Supabase, plano grátis)": "База данных (Supabase, бесплатный план)",
 "Cadeado (HTTPS) até": "Замок HTTPS до",
 "Dados das abas: {d}": "Данные вкладок: {d}",
 "Disco": "Диск",
 "Esta conta não tem acesso a estas informações.": "У этой учётной записи нет доступа к этим данным.",
 "Ligado há": "Работает",
 "Livre: {l} · site: {s}": "Свободно: {l} · сайт: {s}",
 "Maiores tabelas": "Самые большие таблицы",
 "Memória em uso": "Используемая память",
 "O servidor ainda não mandou o relatório. Ele manda a cada 10 minutos depois do 53-SERVIDOR-0.78.bat.": "Сервер ещё не прислал отчёт. Он присылает его каждые 10 минут после 53-SERVIDOR-0.78.bat.",
 "O servidor ainda não tem esta função. Rode o 53-SERVIDOR-0.78.bat no computador.": "На сервере ещё нет этой функции. Запустите 53-SERVIDOR-0.78.bat на компьютере.",
 "O sistema do servidor pede reinício (atualização de segurança instalada).": "Система сервера просит перезагрузку (установлено обновление безопасности).",
 "Processador": "Процессор",
 "Relatório do servidor: {q}": "Отчёт сервера: {q}",
 "Servidor": "Сервер",
 "Servidor do site (Locaweb)": "Сервер сайта (Locaweb)",
 "Sistema": "Система",
 "Só você vê este quadro.": "Этот блок видите только вы.",
 "Versão do site no ar": "Версия сайта в работе",
 "atrasado: confira se o servidor está ligado": "задержка: проверьте, работает ли сервер",
 "sem cadeado": "без замка",
 "{a} ({n} guardadas)": "{a} (хранится: {n})",
 "{d} dia(s) e {h} h": "{d} дн. и {h} ч",
 "{n} núcleo(s) · carga {c}": "ядер: {n} · нагрузка {c}",
 "{n} · {novas} nova(s) e {ativas} ativa(s) em 7 dias": "{n} · за 7 дней новых: {novas}, активных: {ativas}",
 "{u} de {t} ({p}%)": "{u} из {t} ({p}%)",
 "Fechar teclado": "Скрыть клавиатуру",
 "Mostrar as ferramentas": "Показать инструменты",
 "Últimas cores usadas": "Недавние цвета",
 "Voltar ao topo": "Наверх",
 "Topo": "Наверх",
 "1 atividade do roteiro por fazer": "1 занятие в маршруте не выполнено",
 "1 dia": "1 день",
 "1 item por pôr na mala": "1 вещь ещё не упакована",
 "1 lista de Viagens ia inteira para o My Planner e saiu de lá. Agora o envio é item por item, pelo ⋮ de cada item.": "1 список из раздела «Путешествия» отправлялся в My Planner целиком и был оттуда удалён. Теперь пункты отправляются по одному через ⋮ у каждого пункта.",
 "1 lugar não visitado": "1 место не посещено",
 "1 reserva por confirmar": "1 бронь не подтверждена",
 "Abrir o bloco": "Развернуть блок",
 "Adicionar pessoa": "Добавить человека",
 "Ainda pode gastar {v}": "Ещё можно потратить {v}",
 "Ao ligar, o valor entra em Gastos como pago.": "Если включено, сумма попадёт в «Расходы» как оплаченная.",
 "Até (dd/mm/aaaa)": "До (дд/мм/гггг)",
 "Coloque as pessoas em \"Quem vai\" (edite a viagem).": "Добавьте людей в поле \"Кто едет\" (измените поездку).",
 "Como foi?": "Как всё прошло?",
 "Concluído em {d}": "Выполнено {d}",
 "Confirmada em {d}": "Подтверждено {d}",
 "Confirmadas": "Подтверждённые",
 "Dia anterior": "Предыдущий день",
 "Dias": "Дни",
 "Dias × valor por dia": "Дни × сумма в день",
 "Documentos (só o tipo e a validade)": "Документы (только тип и срок действия)",
 "EXIGÊNCIAS DO DESTINO": "ТРЕБОВАНИЯ СТРАНЫ НАЗНАЧЕНИЯ",
 "Em mãos": "На руках",
 "Escreva o que o destino pede (ex.: 2 páginas em branco no passaporte, certificado de vacina). Confira no site oficial do país.": "Укажите, что требует страна назначения (например: 2 чистые страницы в паспорте, сертификат о вакцинации). Проверьте на официальном сайте страны.",
 "Ex.: Lisboa (LIS)": "Напр.: Лиссабон (LIS)",
 "Ex.: São Paulo (GRU)": "Напр.: Сан-Паулу (GRU)",
 "Falta confirmar": "Не подтверждено",
 "Falta pôr": "Не упаковано",
 "Faltou ({n}): {l}": "Забыто ({n}): {l}",
 "Foi ({n}): {l}": "Взято ({n}): {l}",
 "Fotos (lista das legendas)": "Фото (список подписей)",
 "Gasto de {nome} em {d}": "Расход: {nome}, {d}",
 "Gastos do dia": "Расходы за день",
 "Gastos em outras moedas (não convertidos): {v}": "Расходы в других валютах (без пересчёта): {v}",
 "Gastos por dia": "Расходы по дням",
 "Horário de chegada": "Время прибытия",
 "Lugares (visitados, faltam, imperdíveis e a nota)": "Места (посещённые, оставшиеся, обязательные и оценка)",
 "Mala (o que foi e o que faltou)": "Багаж (что взято и что забыто)",
 "Marcar como acertado": "Отметить как рассчитано",
 "Marcar como acertado?": "Отметить как рассчитано?",
 "Na mala": "Упаковано",
 "Nenhuma parada ainda": "Остановок пока нет",
 "Nova exigência": "Новое требование",
 "Números de documentos e o que está no cofre nunca vão para o relatório. Valores em moedas diferentes aparecem separados.": "Номера документов и содержимое сейфа никогда не попадают в отчёт. Суммы в разных валютах показываются отдельно.",
 "O QUE AINDA FALTA": "ЧТО ЕЩЁ ОСТАЛОСЬ",
 "O QUE INCLUIR": "ЧТО ВКЛЮЧИТЬ",
 "Opcional. O app avisa se o passaporte vencer antes disso, contado da volta. Confira a exigência do país.": "Необязательно. Приложение предупредит, если паспорт истекает раньше, считая от даты возвращения. Уточните требование страны.",
 "Orçamento previsto × gasto por categoria": "Плановый бюджет × расходы по категориям",
 "Passou do previsto em {v}": "Превышение бюджета на {v}",
 "Ponha a validade de cada documento: o app avisa antes de vencer. As fotos dos documentos ficam protegidas no cofre.": "Укажите срок действия каждого документа: приложение предупредит заранее. Фото документов надёжно хранятся в сейфе.",
 "Próximo dia": "Следующий день",
 "Quem está no grupo da viagem entra sozinho. Use \"+ Adicionar pessoa\" para quem não tem o app.": "Участники группы поездки добавляются автоматически. Для тех, у кого нет приложения, нажмите \"+ Добавить человека\".",
 "Recolher o bloco": "Свернуть блок",
 "Relatório da viagem": "Отчёт о поездке",
 "Reserva confirmada": "Бронь подтверждена",
 "Resumo da viagem": "Сводка поездки",
 "Resumo da viagem (datas, destino, pessoas)": "Сводка поездки (даты, направление, люди)",
 "Roteiro por dia (feito e falta)": "Маршрут по дням (выполнено и осталось)",
 "Sem data": "Без даты",
 "Seu passaporte pode não ser aceito. Confira a exigência do país": "Ваш паспорт могут не принять. Уточните требование страны",
 "Subir": "Вверх",
 "Total do dia: {v}": "Итого за день: {v}",
 "Uma frase (opcional)": "Одна фраза (необязательно)",
 "Validade mínima exigida (meses)": "Минимальный срок действия паспорта (мес.)",
 "Validade: {d}": "Срок действия: {d}",
 "Valor por dia": "Сумма в день",
 "Viagens no My Planner": "Путешествия в My Planner",
 "Visitado": "Посещено",
 "Visitado em {d}": "Посещено {d}",
 "Voltaria: {r}": "Вернулся бы: {r}",
 "Voltaria?": "Вернулись бы?",
 "confirmada": "подтверждено",
 "em mãos": "на руках",
 "gasto na viagem {d}": "расход в поездке {d}",
 "meses": "мес.",
 "outro gasto": "другой расход",
 "vence em {d}": "истекает {d}",
 "{a} de {b} confirmadas": "Подтверждено {a} из {b}",
 "{a} de {b} em mãos": "На руках {a} из {b}",
 "{a} de {b} feitos": "Выполнено {a} из {b}",
 "{a} de {b} na mala": "Упаковано {a} из {b}",
 "{a} de {b} pagos": "Оплачено {a} из {b}",
 "{a} de {b} visitados": "Посещено {a} из {b}",
 "{de} deve {v} a {para}": "{de} должен {para} {v}",
 "{g} de {p}": "{g} из {p}",
 "{n} atividades do roteiro por fazer": "Невыполненных занятий в маршруте: {n}",
 "{n} item(ns) enviado(s).": "Отправлено пунктов: {n}.",
 "{n} itens por pôr na mala": "Не упаковано вещей: {n}",
 "{n} já estava(m) no My Planner.": "Уже было в My Planner: {n}.",
 "{n} listas de Viagens iam inteiras para o My Planner e saíram de lá. Agora o envio é item por item, pelo ⋮ de cada item.": "Списков из раздела «Путешествия», которые отправлялись в My Planner целиком и были оттуда удалены: {n}. Теперь пункты отправляются по одному через ⋮ у каждого пункта.",
 "{n} lugares não visitados": "Не посещено мест: {n}",
 "{n} reservas por confirmar": "Не подтверждено броней: {n}",
 "{n} sem data (não foi).": "Без даты (не отправлено): {n}.",
 "ARTIGOS E SITES": "СТАТЬИ И САЙТЫ",
 "Agora o envio é item por item (pelo ⋮ do item ou selecionando vários). Estas listas iam inteiras e saíram do My Planner ({n} item(ns), nada foi apagado):": "Теперь отправка поштучно (через ⋮ у элемента или выбрав несколько). Эти списки отправлялись целиком и убраны из My Planner ({n} эл., ничего не удалено):",
 "Artigo científico": "Научная статья",
 "Artigo de site ou blog": "Статья с сайта или блога",
 "Artigo ou site": "Статья или сайт",
 "Artigos e sites": "Статьи и сайты",
 "Autor(es)": "Автор(ы)",
 "Cadastrar pela foto ou PDF": "Добавить по фото или PDF",
 "Capítulo de livro": "Глава книги",
 "Crie o grupo e mande o link: quem entrar vê os artigos e acompanha a leitura. Quem administra inclui, edita e põe fotos, e pode liberar isso para quem também usa a aba. Só quem administra coloca ou tira pessoas.": "Создайте группу и отправьте ссылку: вошедшие видят статьи и следят за чтением. Администраторы добавляют, редактируют и загружают фото и могут разрешить это тем, кто тоже пользуется вкладкой. Только администраторы добавляют и удаляют людей.",
 "DOI": "DOI",
 "Data ou ano de publicação": "Дата или год публикации",
 "Editar artigo ou site": "Изменить статью или сайт",
 "Enviar para o My Planner (lembrete de renovação)": "Отправить в My Planner (напоминание о продлении)",
 "Envio para o My Planner": "Отправка в My Planner",
 "Ex.: 2024 ou 12/03/2024": "Напр.: 2024 или 12.03.2024",
 "Ex.: 45-60": "Напр.: 45-60",
 "Grupo de artigos": "Группа статей",
 "Guarde artigos, notícias e páginas da internet com a referência pronta (ABNT e APA). Preencha pelo DOI ou pelo link.": "Сохраняйте статьи, новости и веб-страницы с готовой ссылкой (ABNT и APA). Заполните по DOI или ссылке.",
 "Li {a} · Lendo {b} · Parei {c} · Quero ler {d}": "Прочитано {a} · Читаю {b} · Бросил {c} · Хочу прочитать {d}",
 "Minhas anotações do artigo": "Мои заметки к статье",
 "Notícia": "Новость",
 "Novo artigo ou site": "Новая статья или сайт",
 "Os dados vêm da ficha do artigo (Editar).": "Данные берутся из карточки статьи (Изменить).",
 "Páginas (opcional)": "Страницы (необязательно)",
 "Revista, site ou veículo": "Журнал, сайт или издание",
 "artigos e sites lidos no período": "статьи и сайты, прочитанные за период",
 "1 confirmado": "1 подтвердил",
 "1 convidado que estava em \"Pendente\" passou para \"A convidar\". Ao enviar o convite pelo app, ele passa sozinho para \"Convidado, sem resposta\".": "1 гость из «Ожидает» перенесён в «Пригласить». Когда вы отправите приглашение через приложение, он сам перейдёт в «Приглашён, нет ответа».",
 "1 extra": "1 дополнительно",
 "1 talvez": "1 возможно",
 "A convidar": "Пригласить",
 "Agendar na igreja": "Записаться в церкви",
 "Agora": "Сейчас",
 "Agradeci": "Поблагодарил",
 "Agradeci em {d}": "Поблагодарил {d}",
 "Agradecidos": "Поблагодарены",
 "Alianças": "Обручальные кольца",
 "Aluguéis (mesas, cadeiras, louças)": "Аренда (столы, стулья, посуда)",
 "Avisar a data (save the date)": "Сообщить дату (save the date)",
 "Bebidas": "Напитки",
 "Beca e cerimônia": "Мантия и церемония",
 "Bolo": "Торт",
 "Brincadeiras": "Игры",
 "Brincadeiras e amigo secreto": "Игры и Тайный Санта",
 "Brindes": "Подарки",
 "Buffet": "Кейтеринг",
 "Calculado sozinho: valor menos o sinal.": "Считается автоматически: сумма минус задаток.",
 "Calcular quantidades": "Рассчитать количество",
 "Categoria do orçamento": "Категория бюджета",
 "Celebrante": "Ведущий церемонии",
 "Cerimônia": "Церемония",
 "Cerveja (adultos)": "Пиво (взрослые)",
 "Checklist de preparação": "Чек-лист подготовки",
 "Coloque a data do evento (edite o evento) para ver até quando fazer cada item.": "Укажите дату мероприятия (измените мероприятие), чтобы видеть срок каждого пункта.",
 "Coloque as pessoas em \"Pessoas do evento\" (edite o evento).": "Добавьте людей в «Участники мероприятия» (измените мероприятие).",
 "Coloque quanto pretende gastar em cada categoria. Use o ⊕ para calcular por convidado. Os fornecedores contratados entram sozinhos na categoria escolhida.": "Укажите, сколько планируете потратить в каждой категории. Нажмите ⊕, чтобы посчитать на гостя. Нанятые подрядчики попадают в выбранную категорию автоматически.",
 "Combinado: {v}": "Договорено: {v}",
 "Comprado": "Куплено",
 "Comprados": "Куплено",
 "Comprar a decoração e as lembrancinhas": "Купить декор и сувениры для гостей",
 "Comprar as alianças": "Купить кольца",
 "Comprar as lembrancinhas": "Купить сувениры для гостей",
 "Comprar bebidas e gelo": "Купить напитки и лёд",
 "Comprar comida e bebidas": "Купить еду и напитки",
 "Comprar o que falta": "Докупить недостающее",
 "Comprar ou alugar a roupa": "Купить или взять напрокат наряд",
 "Confirmados com os acompanhantes. Muda sozinho quando alguém confirma ou desconfirma.": "Подтвердившие вместе со спутниками. Меняется само, когда кто-то подтверждает или отменяет.",
 "Confirmar a presença dos convidados": "Подтвердить присутствие гостей",
 "Confirmar os fornecedores": "Подтвердить подрядчиков",
 "Confirmar os fornecedores e os convidados": "Подтвердить подрядчиков и гостей",
 "Contratar a comida": "Заказать еду",
 "Contratar a comida e o bolo": "Заказать еду и торт",
 "Contratar a decoração": "Заказать декор",
 "Contratar comida e bebidas": "Заказать еду и напитки",
 "Contratar foto e vídeo": "Заказать фото и видео",
 "Contratar o buffet": "Заказать кейтеринг",
 "Convidado, sem resposta": "Приглашён, нет ответа",
 "Convidados (por situação, com acompanhantes)": "Гости (по статусу, со спутниками)",
 "Convidados que contam no ⊕": "Гости, учитываемые в ⊕",
 "Convites": "Приглашения",
 "Cronograma do dia (com responsáveis e situação)": "Расписание дня (с ответственными и статусом)",
 "Data do restante": "Дата остатка",
 "Data do sinal": "Дата задатка",
 "Decoração": "Декор",
 "Definir a data e o orçamento": "Определить дату и бюджет",
 "Definir a lista de convidados": "Составить список гостей",
 "Doces": "Сладости",
 "Dá para mudar, tirar e incluir itens depois.": "Пункты можно потом изменить, удалить и добавить.",
 "Enviar os convites": "Разослать приглашения",
 "Equipamentos (projetor, som)": "Оборудование (проектор, звук)",
 "Equipe (garçons, limpeza)": "Персонал (официанты, уборка)",
 "Escolha \"Outro\" para escrever o nome.": "Выберите «Другое», чтобы ввести название.",
 "Escolher a roupa": "Выбрать наряд",
 "Escolher a roupa dos noivos": "Выбрать наряды жениха и невесты",
 "Escolher os padrinhos": "Выбрать свидетелей или крёстных",
 "Estimativa para {n} convidados. Mude o que quiser antes de levar.": "Оценка на {n} гостей. Измените что угодно, прежде чем перенести.",
 "Eu faço": "Я сделаю",
 "Ex.: 200 un.": "Напр.: 200 шт.",
 "Ex.: Copos descartáveis": "Напр.: Одноразовые стаканы",
 "Ex.: Jogo de panelas": "Напр.: Набор кастрюль",
 "Ex.: Reservar o local": "Напр.: Забронировать место",
 "Ex.: em negociação": "Напр.: в переговорах",
 "Extras de margem (quem aparece sem avisar)": "Запас (кто придёт без предупреждения)",
 "Falta 1 dia": "Остался 1 день",
 "Falta agradecer": "Не поблагодарены",
 "Falta comprar": "Купить",
 "Falta pagar": "Не оплачено",
 "Fazer a lista de presentes": "Составить список подарков",
 "Fazer o curso de batismo": "Пройти курс перед крещением",
 "Fornecedores (contratado, pago, falta)": "Подрядчики (договор, оплачено, осталось)",
 "Foto e vídeo": "Фото и видео",
 "Fraldas": "Подгузники",
 "Frase curta (opcional)": "Короткая фраза (необязательно)",
 "Hoje é o dia do evento!": "Сегодня день мероприятия!",
 "Igreja e celebrante": "Церковь и ведущий церемонии",
 "Incluir os Talvez": "Учитывать «Возможно»",
 "Incluir telefones": "Включить телефоны",
 "Item da lista de compras": "Пункт списка покупок",
 "Item da preparação": "Пункт подготовки",
 "Já deram: {d} · Falta: {f}": "Уже внесли: {d} · Осталось: {f}",
 "Já deu": "Уже внёс",
 "L": "л",
 "Lance aqui o que foi gasto. Os pagamentos aos fornecedores e as compras marcadas entram sozinhos.": "Записывайте здесь расходы. Оплаты подрядчикам и отмеченные покупки добавляются автоматически.",
 "Lançar o gasto": "Записать расход",
 "Lembrancinhas": "Сувениры для гостей",
 "Levar para os itens": "Перенести в пункты",
 "Local / espaço": "Место / площадка",
 "Mais um extra": "Ещё один",
 "Menos um extra": "На одного меньше",
 "Música / som / DJ": "Музыка / звук / диджей",
 "No dia do evento": "В день мероприятия",
 "O que comprar": "Что купить",
 "O total muda sozinho quando alguém confirma ou desconfirma.": "Итог меняется сам, когда кто-то подтверждает или отменяет.",
 "O valor do contrato entra sozinho como previsto nesta categoria, e o que for pago entra nos gastos.": "Сумма договора автоматически попадает в план этой категории, а оплаченное — в расходы.",
 "O valor entra nos gastos do evento, na categoria do item. Se preferir, pule.": "Сумма попадёт в расходы мероприятия, в категорию пункта. Можно пропустить.",
 "Onde comprar": "Где купить",
 "Orçamento do evento": "Бюджет мероприятия",
 "Os itens marcados entram na categoria com o ⊕ por convidado. Depois é só tocar no ⊕ e pôr o valor unitário.": "Отмеченные пункты попадут в категорию с ⊕ на гостя. Потом просто нажмите ⊕ и укажите цену за единицу.",
 "Os telefones dos convidados só saem no PDF se você marcar \"Incluir telefones\". Valores em moedas diferentes aparecem separados.": "Телефоны гостей попадут в PDF, только если отметить «Включить телефоны». Суммы в разных валютах показываются отдельно.",
 "Pago em {d}": "Оплачено {d}",
 "Parte da vaquinha": "Доля в общем сборе",
 "Pessoas do evento": "Участники мероприятия",
 "Pessoas do evento: {p}": "Участники мероприятия: {p}",
 "Preparar as brincadeiras": "Подготовить игры",
 "Preparação": "Подготовка",
 "Presente recebido": "Подарок получен",
 "Presentes": "Подарки",
 "Prova final da roupa": "Последняя примерка",
 "Pular": "Пропустить",
 "Quantidade por convidado": "Количество на гостя",
 "Quantidade por convidado × valor unitário": "Количество на гостя × цена за единицу",
 "Quanto custou?": "Сколько стоило?",
 "Quanto já deu": "Сколько уже внёс",
 "Quanto vai contribuir": "Сколько внесёт",
 "Quantos dias antes do evento": "За сколько дней до мероприятия",
 "Quem deu": "От кого",
 "Quem está no grupo do evento entra sozinho. Use \"+ Adicionar pessoa\" para quem não tem o app. Esta lista é usada no cronograma, nos gastos e na vaquinha.": "Участники группы мероприятия добавляются автоматически. Для тех, у кого нет приложения, используйте «+ Добавить человека». Этот список используется в расписании, расходах и общем сборе.",
 "Recreação e brinquedos": "Аниматоры и аттракционы",
 "Refrigerante": "Газировка",
 "Relatório do evento": "Отчёт о мероприятии",
 "Relatório do evento (PDF)": "Отчёт о мероприятии (PDF)",
 "Reservar o local": "Забронировать место",
 "Reservar o local da cerimônia e da festa": "Забронировать место для церемонии и праздника",
 "Reservar o local ou a mesa da festa": "Забронировать место или столик для праздника",
 "Restante": "Остаток",
 "Restante pago": "Остаток оплачен",
 "Resumo do evento": "Сводка мероприятия",
 "Roupa e beleza": "Наряд и красота",
 "Salgados": "Закуски",
 "Separar a roupa e o que levar": "Приготовить наряд и всё, что взять с собой",
 "Separar os documentos e as alianças": "Приготовить документы и кольца",
 "Separar os documentos e os ingressos": "Приготовить документы и билеты",
 "Sinal": "Задаток",
 "Sinal pago": "Задаток оплачен",
 "Sinal {v} pago": "Задаток {v} оплачен",
 "Usar a lista pronta para {tipo}": "Использовать готовый список для {tipo}",
 "Vai contribuir": "Будет участвовать",
 "Valor unitário": "Цена за единицу",
 "Vaquinha": "Общий сбор",
 "Você acompanha tudo o que foi compartilhado, sempre atualizado. Para incluir, editar e pegar tarefas, assine a aba.": "Вы видите всё, чем поделились, всегда в актуальном виде. Чтобы добавлять, изменять и брать задачи, оформите подписку на вкладку.",
 "agradeci": "поблагодарил",
 "atrasado": "просрочено",
 "completo": "собрано",
 "deu {d} de {v}": "внёс {d} из {v}",
 "em {l}": "в {l}",
 "falta o valor": "не указана сумма",
 "falta {v} até {d}": "осталось {v} до {d}",
 "gasto em {e}": "потрачено на {e}",
 "kg": "кг",
 "o evento": "мероприятие",
 "restante": "остаток",
 "sinal": "задаток",
 "total": "итого",
 "un.": "шт.",
 "{n} confirmados": "подтвердили: {n}",
 "{n} convidados contam no ⊕ por convidado.": "Гостей, учитываемых в ⊕ на гостя: {n}.",
 "{n} convidados que estavam em \"Pendente\" passaram para \"A convidar\". Ao enviar o convite pelo app, eles passam sozinhos para \"Convidado, sem resposta\".": "Гости из «Ожидает» перенесены в «Пригласить» ({n}). Когда вы отправите приглашение через приложение, они сами перейдут в «Приглашён, нет ответа».",
 "{n} extras": "дополнительно: {n}",
 "{n} talvez": "возможно: {n}",
 "{q} por convidado": "{q} на гостя",
 "{v} por convidado": "{v} на гостя",
 "Item completo": "Полный элемент",
 "Nota rápida": "Быстрая заметка",
 "📝 Nota rápida": "📝 Быстрая заметка",
 "Conteúdo da nota": "Текст заметки",
 "{c} confirmado(s) de {n} convidado(s)": "{c} подтвердили из {n} гостей",
 "Serão apagados para todos: os documentos, as reuniões marcadas e as gravações do escritório \"{nome}\". A conversa continua no Mensagens.": "Будут удалены для всех: документы, запланированные встречи и записи офиса «{nome}». Чат останется в Сообщениях.",
 "Confirme para apagar o escritório": "Подтвердите удаление офиса",
 "Escreva o assunto da reunião para poder marcar.": "Напишите тему встречи, чтобы назначить её.",
 "{n} min (marcada para {m} min)": "{n} мин (запланировано {m} мин)",
 "Não foi possível baixar o arquivo agora. Confira a internet e tente de novo.": "Не удалось скачать файл. Проверьте интернет и попробуйте снова.",
 "Meus clientes": "Мои клиенты",
 "Uma lista só de clientes, usada por todas as abas de trabalho: contato, endereço, etiquetas, anotações e arquivos.": "Единый список клиентов для всех рабочих вкладок: контакты, адрес, метки, заметки и файлы.",
 "Copiar para Meus clientes": "Скопировать в «Мои клиенты»",
 "Ver ou mudar": "Посмотреть или изменить",
 "Ver o documento completo": "Показать документ полностью",
 "CEP incompleto": "Неполный CEP",
 "O CEP tem 8 números.": "CEP состоит из 8 цифр.",
 "CEP não encontrado": "CEP не найден",
 "Confira os números ou preencha o endereço à mão.": "Проверьте цифры или введите адрес вручную.",
 "Não foi possível buscar o CEP": "Не удалось найти CEP",
 "Confira a internet ou preencha o endereço à mão.": "Проверьте подключение к интернету или введите адрес вручную.",
 "Parece que falta algo neste e-mail (ex.: nome@site.com).": "Кажется, в этом адресе чего-то не хватает (напр.: name@site.com).",
 "opcional": "необязательно",
 "Os seus clientes agora ficam numa lista só, usada por todas as abas de trabalho.": "Теперь ваши клиенты в одном списке, который используют все рабочие вкладки.",
 "Portal do Cliente: {n} cliente(s).": "Портал клиента: клиентов — {n}.",
 "Freelancer & Projetos: {n} cliente(s).": "Фриланс и проекты: клиентов — {n}.",
 "{n} eram o mesmo cliente em mais de uma aba e viraram uma ficha só.": "{n} — один и тот же клиент в нескольких вкладках; теперь это одна карточка.",
 "Nenhum cliente repetido.": "Повторяющихся клиентов нет.",
 "Nada foi apagado: documentos, pedidos, cartões e horas continuam onde estavam.": "Ничего не удалено: документы, заказы, карточки и часы остались на месте.",
 "Já está em Meus clientes": "Уже в «Мои клиенты»",
 "{nome} já está na lista.": "{nome} уже в списке.",
 "Copiado para Meus clientes": "Скопировано в «Мои клиенты»",
 "Só o nome e o contato foram copiados.": "Скопированы только имя и контакты.",
 "Aniversário hoje!": "Сегодня день рождения!",
 "Fechar tudo": "Свернуть всё",
 "Abrir tudo": "Развернуть всё",
 "Quem é": "Кто это",
 "Razão social": "Юридическое название",
 "Nome fantasia": "Торговое название",
 "Data de abertura": "Дата открытия",
 "Inscrição estadual / municipal": "Регистрация штата / муниципальная",
 "Outras pessoas de contato": "Другие контактные лица",
 "Como chamar": "Как обращаться",
 "Cliente desde": "Клиент с",
 "Outro telefone": "Другой телефон",
 "Site": "Сайт",
 "Melhor jeito de falar": "Как лучше связаться",
 "Autorizou receber mensagens": "Согласие на сообщения",
 "Outros endereços": "Другие адреса",
 "Relacionamento": "Отношения",
 "Como me conheceu": "Как узнал обо мне",
 "Etiquetas": "Метки",
 "Nada anotado ainda.": "Заметок пока нет.",
 "Bloco da aba {aba}": "Блок вкладки {aba}",
 "Abrir na aba {aba}": "Открыть во вкладке {aba}",
 "Uma lista só, usada por todas as abas de trabalho.": "Один список для всех рабочих вкладок.",
 "Escreva o nome do cliente.": "Введите имя клиента.",
 "Telefone / WhatsApp": "Телефон / WhatsApp",
 "Só o nome é obrigatório. Abra as partes que quiser preencher.": "Обязательно только имя. Откройте разделы, которые хотите заполнить.",
 "Como chamar (apelido)": "Как обращаться (прозвище)",
 "Inscrição estadual / municipal (opcional)": "Регистрация штата / муниципальная (необязательно)",
 "Cargo": "Должность",
 "Telefone da pessoa de contato": "Телефон контактного лица",
 "Outras pessoas de contato (uma por linha: nome, cargo, telefone)": "Другие контактные лица (по одному в строке: имя, должность, телефон)",
 "O telefone principal é WhatsApp": "Основной телефон — WhatsApp",
 "O outro telefone é WhatsApp": "Другой телефон — WhatsApp",
 "Instagram": "Instagram",
 "Ex.: @nome": "Напр.: @name",
 "Ex.: WhatsApp, à tarde": "Напр.: WhatsApp, днём",
 "Estado (UF)": "Штат (UF)",
 "Endereço (como estava escrito)": "Адрес (как был записан)",
 "Outros endereços (trabalho, entrega...)": "Другие адреса (работа, доставка...)",
 "Google": "Google",
 "Passou na frente": "Проходил мимо",
 "Indicado por": "По рекомендации",
 "Criar etiqueta": "Создать метку",
 "Ex.: VIP, Mensal, Atacado": "Напр.: VIP, Ежемесячно, Опт",
 "Ativo": "Активный",
 "Inativo": "Неактивный",
 "Em negociação": "На переговорах",
 "O cliente autorizou receber mensagens?": "Клиент согласился получать сообщения?",
 "Sem autorização, nada de mensagem de aniversário, cobrança automática ou promoção para este cliente.": "Без согласия — никаких поздравлений с днём рождения, автоматических напоминаний об оплате и акций для этого клиента.",
 "aniversário hoje": "сегодня день рождения",
 "contato: {n}": "контакт: {n}",
 "com esse telefone": "с этим телефоном",
 "com esse e-mail": "с этим e-mail",
 "com esse documento": "с этим документом",
 "com esse nome": "с этим именем",
 "Cliente parecido": "Похожий клиент",
 "Já existe {nome} {por}. Abrir?": "{nome} уже есть {por}. Открыть?",
 "Cadastrar mesmo assim": "Всё равно добавить",
 "Serão apagados: a ficha, as anotações e os arquivos deste cliente.": "Будут удалены: карточка, заметки и файлы этого клиента.",
 "Também nas abas: {abas} (com os documentos, pedidos, cartões e horas de lá).": "Также во вкладках: {abas} (вместе с документами, заказами, карточками и часами).",
 "Juntar com outra ficha": "Объединить с другой карточкой",
 "Juntar fichas": "Объединить карточки",
 "Não há outra ficha para juntar.": "Нет другой карточки для объединения.",
 "Juntar \"{nome}\" com:": "Объединить «{nome}» с:",
 "Juntar as duas fichas?": "Объединить две карточки?",
 "\"{a}\" fica com tudo de \"{b}\" (dados, anotações, arquivos e as ligações com as abas). A ficha \"{b}\" deixa de existir.": "«{a}» получит всё из «{b}» (данные, заметки, файлы и связи с вкладками). Карточка «{b}» перестанет существовать.",
 "Juntar": "Объединить",
 "Confirme para juntar as fichas": "Подтвердите объединение карточек",
 "Aniversariantes do mês": "Дни рождения в этом месяце",
 "Ativos": "Активные",
 "Inativos": "Неактивные",
 "Cadastre cada cliente uma vez: ele aparece em todas as abas de trabalho que você usa.": "Добавьте каждого клиента один раз — он появится во всех рабочих вкладках, которыми вы пользуетесь.",
 "Novo cliente": "Новый клиент",
 "Editar cliente": "Изменить клиента",
 "Linha do tempo": "Хронология",
 "{n} registro(s)": "Записей: {n}",
 "Nada ainda. Vendas, pagamentos, documentos e horas aparecem aqui.": "Пока пусто. Здесь появятся продажи, платежи, документы и часы.",
 "Me deve": "Должен мне",
 "Total pago": "Всего оплачено",
 "Última compra ou atendimento": "Последняя покупка или обслуживание",
 "Próximo compromisso": "Следующая встреча",
 "na entrega": "при получении",
 "Passou do limite de fiado ({v}).": "Превышен лимит долга ({v}).",
 "Recebeu {v} ({p})": "Получено {v} ({p})",
 "Hoje é aniversário de {n}.": "Сегодня у {n} день рождения.",
 "Mandar parabéns": "Поздравить",
 "{n}: parcela de {v} atrasada.": "{n}: просрочен платёж {v}.",
 "Cobrar": "Напомнить об оплате",
 "{n} não compra há {d} dias.": "{n} не покупает уже {d} дн.",
 "Chamar de volta": "Напомнить о себе",
 "🟢 em dia · 🟡 sumido": "🟢 всё в порядке · 🟡 давно не было",
 "🟢 em dia · 🟡 algo vencendo ou cliente sumido · 🔴 atrasado": "🟢 всё в порядке · 🟡 скоро срок или клиент пропал · 🔴 просрочено",
 "Limite de fiado (opcional)": "Лимит долга (необязательно)",
 "Avisa quando o que ele deve passar deste valor.": "Предупредит, когда долг превысит эту сумму.",
 "A prazo": "В рассрочку",
 "parcela atrasada": "просроченный платёж",
 "falta na entrega": "остаток при получении",
 "Sumidos": "Давно не было",
 "Sinal pago, falta o resto": "Предоплата внесена, остаток не оплачен",
 "Pagou {a} de {b}": "Оплачено {a} из {b}",
 "Esta parcela vem de Meus clientes. Marque aqui como recebida ou abra o cliente para cobrar e gerar o recibo.": "Этот платёж из раздела «Мои клиенты». Отметьте его здесь как полученный или откройте клиента, чтобы напомнить об оплате и создать квитанцию.",
 "Sinal + restante": "Предоплата + остаток",
 "Pix": "Pix",
 "Cartão de crédito à vista": "Кредитная карта, одним платежом",
 "Cartão de crédito parcelado": "Кредитная карта, в рассрочку",
 "Fiado / a prazo": "В долг / в рассрочку",
 "Parcela única": "Один платёж",
 "Oi, {nome}! Feliz aniversário! 🎉 Que o seu dia seja lindo. Um abraço!": "Здравствуйте, {nome}! С днём рождения! 🎉 Пусть этот день будет прекрасным. Обнимаю!",
 "Oi, {nome}! Faz tempo que a gente não se fala. Posso ajudar em alguma coisa? Vai ser um prazer te atender de novo!": "Здравствуйте, {nome}! Давно не общались. Могу чем-нибудь помочь? Буду рада снова вам помочь!",
 "Oi, {nome}! Passando para lembrar da parcela de {v} que venceu dia {d}. Qualquer coisa, me chama. Obrigada!": "Здравствуйте, {nome}! Напоминаю о платеже {v}, срок которого был {d}. Если что, пишите. Спасибо!",
 "Oi, {nome}! Passando para lembrar da parcela de {v}{d}. Qualquer coisa, me chama. Obrigada!": "Здравствуйте, {nome}! Напоминаю о платеже {v}{d}. Если что, пишите. Спасибо!",
 "que vence dia {d}": "со сроком {d}",
 "Quanto recebeu?": "Сколько получено?",
 "Falta {v}. Pode ser só uma parte.": "Осталось {v}. Можно внести часть.",
 "(seu nome ou sua marca, em Como você recebe?)": "(ваше имя или бренд, в разделе «Как вы получаете оплату?»)",
 "Recibo {c}": "Квитанция {c}",
 "Recebi de {c} a quantia de {v}, referente a {o}.": "Получено от {c} {v} за {o}.",
 "{v} no {f} → recebe {l}": "{v} через {f} → вы получите {l}",
 "Pagou {a} de {b}, faltam {c}": "Оплачено {a} из {b}, осталось {c}",
 "Recebido em {d}": "Получено {d}",
 "Cobrar pelo WhatsApp": "Напомнить в WhatsApp",
 "Sem autorização": "Нет согласия",
 "Este cliente não autorizou receber mensagens (ficha do cliente › Relacionamento).": "Клиент не дал согласия на сообщения (карточка клиента › Отношения).",
 "Sem telefone": "Нет телефона",
 "Coloque o telefone na ficha do cliente.": "Укажите телефон в карточке клиента.",
 "Gerar recibo": "Создать квитанцию",
 "Como você recebe?": "Как вы получаете оплату?",
 "Só \"À vista\": a tela fica limpa, sem a prazo, parcelas nem vermelho.": "Только «Сразу»: чистый экран, без рассрочки, платежей и красного.",
 "Taxa da maquininha (%)": "Комиссия терминала (%)",
 "Taxa {k}": "Комиссия {k}",
 "Cliente sumido depois de (dias sem comprar)": "Клиент «пропал» через (дней без покупок)",
 "Dias para considerar sumido": "Дней до статуса «пропал»",
 "Lembretes de cobrança por parcela atrasada": "Напоминания о просроченных платежах",
 "Nome ou marca no recibo": "Имя или бренд в квитанции",
 "Ex.: Ana Beatriz Doces": "Напр.: Ana Beatriz Сладости",
 "Venda ou serviço": "Продажа или услуга",
 "O que foi vendido ou feito": "Что продано или сделано",
 "Ex.: Bolo de aniversário": "Напр.: Торт на день рождения",
 "Como paga": "Способ оплаты",
 "Sinal (%)": "Предоплата (%)",
 "Ou escreva o valor do sinal logo abaixo.": "Или укажите сумму предоплаты ниже.",
 "Sinal (valor)": "Предоплата (сумма)",
 "Restante na entrega": "Остаток при получении",
 "Próximo vencimento": "Следующий срок оплаты",
 "Sinal a receber": "Ожидается предоплата",
 "falta {v}{q}": "осталось {v}{q}",
 "quitado": "погашено",
 "Parcelas mantidas": "Платежи сохранены",
 "Já há pagamento registrado: as parcelas não foram refeitas. Para mudar, desfaça os pagamentos primeiro.": "Уже есть зарегистрированная оплата, поэтому платежи не пересчитаны. Чтобы изменить их, сначала отмените оплаты.",
 "Registre o que o cliente comprou ou o serviço que você fez, e como ele paga.": "Запишите, что купил клиент или какую услугу вы оказали, и как он платит.",
 "Débito": "Дебетовая карта",
 "Crédito à vista": "Кредит, одним платежом",
 "Crédito 2x": "Кредит, 2 платежа",
 "Crédito 3x": "Кредит, 3 платежа",
 "Crédito 4x": "Кредит, 4 платежа",
 "Crédito 5x": "Кредит, 5 платежей",
 "Crédito 6x": "Кредит, 6 платежей",
 "Crédito 7x": "Кредит, 7 платежей",
 "Crédito 8x": "Кредит, 8 платежей",
 "Crédito 9x": "Кредит, 9 платежей",
 "Crédito 10x": "Кредит, 10 платежей",
 "Crédito 11x": "Кредит, 11 платежей",
 "Crédito 12x": "Кредит, 12 платежей",
 "ATRASADOS": "ПРОСРОЧЕНО",
 "Atrasado (hoje): {v}": "Просрочено (на сегодня): {v}",
 "Buscar um cliente": "Найти клиента",
 "CPF/CNPJ completo, endereço completo e data de nascimento. Pede a senha do app.": "Полный CPF/CNPJ, полный адрес и дата рождения. Нужен пароль приложения.",
 "Cliente cadastrado": "Клиент добавлен",
 "Com documentos: guarde o arquivo em lugar seguro.": "С документами: храните файл в надёжном месте.",
 "Como pagou": "Способ оплаты",
 "Esse contato não tem nome.": "У этого контакта нет имени.",
 "Exportar planilha": "Экспорт таблицы",
 "Falta receber": "Осталось получить",
 "Falta receber (hoje): {v}": "Осталось получить (на сегодня): {v}",
 "Importar dos contatos": "Импорт из контактов",
 "Importar dos contatos do celular": "Импорт из контактов телефона",
 "Incluir documentos": "Включить документы",
 "Incluir documentos no relatório": "Включить документы в отчёт",
 "MELHORES CLIENTES": "ЛУЧШИЕ КЛИЕНТЫ",
 "Melhores clientes": "Лучшие клиенты",
 "Não foi possível gerar a planilha.": "Не удалось создать таблицу.",
 "O que foi": "Что было",
 "Pago em": "Оплачено",
 "Para trazer clientes dos contatos do celular, atualize o My Planner pela loja de aplicativos.": "Чтобы добавлять клиентов из контактов телефона, обновите My Planner в магазине приложений.",
 "RECEBIDO POR DIA": "ПОЛУЧЕНО ПО ДНЯМ",
 "RECEBIDO POR MÊS": "ПОЛУЧЕНО ПО МЕСЯЦАМ",
 "Recebeu": "Получено",
 "Recebeu no período": "Получено за период",
 "Recebeu no período: {v}": "Получено за период: {v}",
 "Recebido no período": "Получено за период",
 "Relatório de clientes": "Отчёт по клиентам",
 "Relatório deste cliente": "Отчёт по этому клиенту",
 "Sem a permissão de contatos não dá para escolher um contato. Você pode liberar nos ajustes do celular.": "Без доступа к контактам нельзя выбрать контакт. Разрешите его в настройках телефона.",
 "Sem documentos: o CPF/CNPJ sai só com os 2 últimos números. As anotações nunca saem.": "Без документов: в CPF/CNPJ видны только 2 последние цифры. Заметки никогда не включаются.",
 "Todos os clientes": "Все клиенты",
 "Trabalha em: {e}": "Работает в: {e}",
 "Trazer outro": "Добавить ещё",
 "VENDAS E ATENDIMENTOS": "ПРОДАЖИ И ОБСЛУЖИВАНИЕ",
 "Vence": "Срок",
 "Venceu": "Срок истёк",
 "Vendas e atendimentos": "Продажи и обслуживание",
 "Vendeu": "Продано",
 "Vendeu no período": "Продано за период",
 "Vendeu no período: {v}": "Продано за период: {v}",
 "venceu {d}": "срок истёк {d}",
 "vendido no período": "продано за период",
 "{nome} comprou no período": "{nome} купил(а) за период",
 "{nome} entrou em Meus clientes. Confira a ficha e marque se ele autorizou receber mensagens.": "{nome} добавлен(а) в «Мои клиенты». Проверьте карточку и отметьте, согласен ли клиент получать сообщения.",
 "{n} compra(s)": "Покупок: {n}",
 "Arraste uma caixa para a esquerda para arquivar ou para a direita para excluir. Segure numa parte livre da caixa e arraste para mudar a ordem.": "Смахните блок влево, чтобы архивировать, или вправо, чтобы удалить. Удерживайте свободное место блока и перетащите, чтобы изменить порядок.",
 "Bloco": "Блок",
 "Confirme para apagar o grupo": "Подтвердите удаление группы",
 "Descer": "Вниз",
 "Opções do bloco": "Параметры блока",
 "Exigências do destino": "Требования страны назначения",
 "{n} para acertar": "К расчёту: {n}",
 "{n} parada(s)": "Остановок: {n}",
 "Cor do item selecionado": "Цвет выбранного элемента",
 "Abrir o grupo": "Развернуть группу",
 "Recolher o grupo": "Свернуть группу",
 "Arraste uma caixa para a direita para excluir ou para a esquerda para arquivar. Segure e arraste para mudar a ordem.": "Смахните блок вправо, чтобы удалить, или влево, чтобы архивировать. Удерживайте и перетаскивайте, чтобы изменить порядок.",
 "Editar subtítulo": "Изменить подзаголовок",
 "Início da caixa": "Начало блока",
 "Mover para…": "Переместить в…",
 "Mover {n} item(ns) para": "Переместить элементы ({n}) в",
 "Opções do item": "Параметры элемента",
 "Transformar em subtítulo": "Сделать подзаголовком",
 "Transformar em texto": "Сделать текстом",
 "esta caixa": "этот блок",
 "{a} de {n} feitos": "Сделано {a} из {n}",
 "1 documento pedido atrasado": "1 запрошенный документ просрочен",
 "1 pedido vence logo": "1 запрос скоро истекает",
 "A lista vem de \"Meus clientes\".": "Список берётся из «Мои клиенты».",
 "Abrir Meus clientes": "Открыть «Мои клиенты»",
 "As abas Escritório e Portal do Cliente agora são uma aba só.": "Вкладки «Офис» и «Портал клиента» теперь объединены.",
 "Clientes com pendência": "Клиенты с незавершёнными делами",
 "Com pendência ({n})": "Незавершённые ({n})",
 "Conversa da equipe": "Чат команды",
 "Crie o escritório e chame a equipe (amigos do app ou convite pelo link): conversa, reuniões de vídeo e documentos internos. Trabalha sozinho? Use só os Clientes.": "Создайте офис и пригласите команду (друзья в приложении или приглашение по ссылке): чат, видеовстречи и внутренние документы. Работаете один? Используйте только «Клиенты».",
 "Documentos internos": "Внутренние документы",
 "Entrar com um código de convite": "Войти по коду приглашения",
 "Escritório & Clientes": "Офис и клиенты",
 "Escritórios: {n}": "Офисы: {n}",
 "Esta parte é para quem trabalha com equipe": "Этот раздел для тех, кто работает в команде",
 "Guias vencendo": "Налоговые квитанции к оплате",
 "Minhas tarefas": "Мои задачи",
 "Nada foi apagado: a equipe, a conversa, as reuniões, os documentos e os clientes convidados continuam como estavam.": "Ничего не удалено: команда, чат, встречи, документы и приглашённые клиенты остались на месте.",
 "Nenhum cliente ainda. Cadastre em \"Meus clientes\": ele aparece aqui na hora.": "Клиентов пока нет. Добавьте в «Мои клиенты» — он сразу появится здесь.",
 "Para quem trabalha com clientes, sozinho ou com equipe: a pasta de cada cliente (documentos, pedidos, guias), equipe, conversa, reuniões e documentos internos.": "Для тех, кто работает с клиентами, один или в команде: папка каждого клиента (документы, запросы, налоговые квитанции), команда, чат, встречи и внутренние документы.",
 "Pastas de clientes do Portal: {c} (com {d} documentos e {p} pedidos)": "Папки клиентов портала: {c} (документов: {d}, запросов: {p})",
 "Pessoa física": "Физическое лицо",
 "Procurar por nome, CNPJ ou CPF": "Поиск по имени, CNPJ или CPF",
 "Reuniões hoje": "Встречи сегодня",
 "Sem escritório (equipe). Toque para criar ou entrar com um código.": "Нет офиса (команды). Нажмите, чтобы создать или войти по коду.",
 "Só a equipe vê. Clientes nunca veem esta parte.": "Видит только команда. Клиенты этот раздел не видят.",
 "Tudo em dia": "Всё в порядке",
 "Vencendo ({n})": "Скоро срок ({n})",
 "chega na próxima versão": "появится в следующей версии",
 "nos próximos 7 dias": "в ближайшие 7 дней",
 "vence amanhã": "срок завтра",
 "vence hoje": "срок сегодня",
 "{doc} venceu em {d}": "{doc}: срок истёк {d}",
 "{n} documentos pedidos atrasados": "Просрочено запрошенных документов: {n}",
 "{n} pedidos vencem logo": "Скоро истекают запросы: {n}",
 "🟢 em dia · 🟡 algo vence logo · 🔴 pedido atrasado ou guia vencida": "🟢 в порядке · 🟡 скоро срок · 🔴 запрос просрочен или квитанция просрочена",
 "Acesso ao gov.br": "Доступ к gov.br",
 "Alvará": "Лицензия на деятельность",
 "Até o dia (do mês)": "До числа (месяца)",
 "CCMEI (certificado do MEI)": "CCMEI (свидетельство MEI)",
 "Cadastre o telefone do cliente para lembrar pelo WhatsApp.": "Добавьте телефон клиента, чтобы напоминать через WhatsApp.",
 "Cartão CNPJ": "Карточка CNPJ",
 "Checklist criado": "Чек-лист создан",
 "Checklist de cliente novo": "Чек-лист нового клиента",
 "Cliente viu {doc}": "Клиент просмотрел {doc}",
 "Cole no app do banco, em Pix copia e cola.": "Вставьте в приложение банка, в раздел Pix «копировать и вставить».",
 "Cole no app do banco.": "Вставьте в приложение банка.",
 "Comprovante de endereço": "Подтверждение адреса",
 "Contrato social e alterações": "Устав и изменения",
 "Copiado": "Скопировано",
 "Copiar Pix": "Копировать Pix",
 "Copiar código de barras": "Копировать штрихкод",
 "Código de barras (linha digitável)": "Штрихкод (цифровая строка)",
 "Dados bancários": "Банковские реквизиты",
 "Escreva o recado.": "Напишите сообщение.",
 "Escritório enviou {doc}": "Офис отправил {doc}",
 "Este cliente não autorizou receber mensagens (ficha em Meus clientes).": "Этот клиент не разрешил присылать сообщения (карточка в разделе «Мои клиенты»).",
 "Extratos bancários": "Банковские выписки",
 "Ficha completa": "Полная карточка",
 "Guia": "Платёжка",
 "Guias a pagar": "Платёжки к оплате",
 "Honorário": "Гонорар",
 "Honorário por": "Гонорар за",
 "Informes de rendimentos": "Справки о доходах",
 "Lembrar pelo WhatsApp": "Напомнить в WhatsApp",
 "Ler a guia ou o boleto com a minha IA": "Распознать платёжку или boleto моим ИИ",
 "Lucro presumido": "Предполагаемая прибыль",
 "Lucro real": "Фактическая прибыль",
 "Nada ainda.": "Пока ничего.",
 "Nenhum pedido em aberto.": "Открытых запросов нет.",
 "Notas fiscais emitidas": "Выставленные счета",
 "O cliente": "Клиент",
 "O pedido entrou em Pedidos de documentos.": "Запрос добавлен в «Запросы документов».",
 "Oi, {nome}! Falta: {itens}. Pode mandar por aqui?": "Здравствуйте, {nome}! Не хватает: {itens}. Можете прислать сюда?",
 "Oi, {nome}! Faltam: {itens}. Pode mandar por aqui?": "Здравствуйте, {nome}! Не хватает: {itens}. Можете прислать сюда?",
 "Oi, {nome}! Tudo certo por aí?": "Здравствуйте, {nome}! Как у вас дела?",
 "Pedido criado": "Запрос создан",
 "Pedido feito: {o}": "Запрос отправлен: {o}",
 "Pedido recebido: {o}": "Запрос получен: {o}",
 "Pedidos pendentes": "Ожидающие запросы",
 "Pedir de novo todo mês": "Запрашивать каждый месяц",
 "Pedir nova ({c})": "Запросить новую ({c})",
 "Pendentes": "Ожидают",
 "Que tipo de cliente?": "Какой тип клиента?",
 "RG e CPF": "RG и CPF",
 "RG e CPF do titular": "RG и CPF владельца",
 "RG e CPF dos sócios": "RG и CPF партнёров",
 "Recados": "Сообщения",
 "Recados entre você e o cliente, presos à pasta dele.": "Сообщения между вами и клиентом хранятся в его папке.",
 "Responde ao pedido": "Ответ на запрос",
 "Tipo / regime": "Тип / режим",
 "Visto pelo cliente em {d}": "Просмотрено клиентом {d}",
 "Válido até": "Действует до",
 "ano": "год",
 "código Pix copia e cola, se houver": "код Pix «копировать и вставить», если есть",
 "data de vencimento": "срок оплаты",
 "documento": "документ",
 "linha digitável do boleto ou da guia, só números": "цифровая строка boleto или платёжки, только цифры",
 "mês": "месяц",
 "novo": "новый",
 "todo mês, até o dia {n}": "каждый месяц, до {n}-го числа",
 "valor a pagar": "сумма к оплате",
 "válido até {d}": "действует до {d}",
 "{c} nova": "Новый: {c}",
 "{doc} pago": "{doc}: оплачено",
 "{n} a pagar": "К оплате: {n}",
 "{n} enviou {doc}": "{n} отправил(а) {doc}",
 "{n} novo(s)": "Новых: {n}",
 "{n} pedido(s) de documentos criados, com prazo de 7 dias.": "Создано запросов документов: {n}, срок 7 дней.",
 "{n} vencida(s)": "Просрочено: {n}",
 "Última declaração do Imposto de Renda": "Последняя декларация о подоходном налоге",
 "Últimas guias pagas": "Последние оплаченные платёжки",
 "Esta parte do Escritório ainda não foi ligada no servidor. No computador, rode o 56-SERVIDOR-0.96.bat (uma vez só).": "Эта часть Офиса ещё не подключена к серверу. На компьютере запустите 56-SERVIDOR-0.96.bat (только один раз).",
 "Só vê": "Только просмотр",
 "Nova versão": "Новая версия",
 "Já havia um arquivo com este nome: o anterior fica guardado como versão {n}.": "Файл с таким именем уже был: предыдущий сохранён как версия {n}.",
 "Visto por e comentários": "Просмотры и комментарии",
 "Arquivar (só neste aparelho)": "В архив (только на этом устройстве)",
 "Tirar do topo": "Открепить",
 "Fixar no topo (para todos)": "Закрепить (для всех)",
 "Mover para a pasta…": "Переместить в папку…",
 "versão {n}": "версия {n}",
 "visto por {n}": "просмотрено: {n}",
 "Até 50 MB por arquivo. Enviar um arquivo com o mesmo nome guarda o anterior como versão.": "До 50 МБ на файл. Загрузка файла с тем же именем сохраняет предыдущий как версию.",
 "Procurar documento ou pasta": "Поиск документа или папки",
 "Fixados": "Закреплённые",
 "Abrir o documento": "Открыть документ",
 "enviado por {nome}": "загрузил(а) {nome}",
 "Versões ({n})": "Версии ({n})",
 "Versão {n} (atual)": "Версия {n} (текущая)",
 "Versão {n}": "Версия {n}",
 "Visto por ({n})": "Просмотрели ({n})",
 "Ninguém da equipe abriu ainda.": "Никто из команды ещё не открывал.",
 "{nome} em {d}": "{nome}, {d}",
 "Comentários ({n})": "Комментарии ({n})",
 "Escreva um comentário": "Напишите комментарий",
 "Contratos": "Договоры",
 "Financeiro do escritório": "Финансы офиса",
 "RH": "Кадры",
 "Mover para a pasta": "Переместить в папку",
 "Ou escreva o nome de uma pasta nova": "Или введите название новой папки",
 "Ela se repete toda semana: cancelando, sai de todas as semanas, da lista e dos Recebidos da equipe.": "Она повторяется каждую неделю: при отмене исчезнет из всех недель, из списка и из «Входящих» команды.",
 "a equipe toda": "вся команда",
 "Com {quem}": "С {quem}",
 "toda semana": "каждую неделю",
 "Vão: {n}": "Придут: {n}",
 "Não vão: {n}": "Не придут: {n}",
 "Vou": "Приду",
 "Não vou": "Не приду",
 "Pauta": "Повестка",
 "Ata": "Протокол",
 "Escrever a ata": "Написать протокол",
 "Abrir o link": "Открыть ссылку",
 "Cada pessoa convidada recebe a reunião em Recebidos e coloca no Planner com um toque, com o alerta.": "Каждый приглашённый получает встречу во «Входящих» и одним касанием добавляет её в Planner с напоминанием.",
 "Escreva primeiro as anotações da reunião (o que foi falado e decidido); a IA organiza em ata.": "Сначала запишите заметки о встрече (что обсуждали и решили); ИИ оформит их в протокол.",
 "Ata: {nome}": "Протокол: {nome}",
 "Gerando...": "Создаётся...",
 "Gerar ata com a minha IA": "Создать протокол с моим ИИ",
 "A IA organiza a pauta e as suas anotações em ata. Confira antes de salvar.": "ИИ оформит повестку и ваши заметки в протокол. Проверьте перед сохранением.",
 "Ainda sem ata.": "Протокола пока нет.",
 "Tarefas da reunião ({n})": "Задачи встречи ({n})",
 "Tarefa da reunião": "Задача встречи",
 "Salvar a ata": "Сохранить протокол",
 "Repetir toda semana ({dia})": "Повторять каждую неделю ({dia})",
 "Quem participa": "Участники",
 "A equipe toda": "Вся команда",
 "Link externo (opcional: Meet, Zoom, Teams)": "Внешняя ссылка (необязательно: Meet, Zoom, Teams)",
 "O link precisa começar com https://": "Ссылка должна начинаться с https://",
 "Marcar e avisar quem participa": "Назначить и уведомить участников",
 "Cargo e papel": "Должность и роль",
 "Passar o Admin": "Передать Админа",
 "Passar o Admin para {nome}?": "Передать Админа пользователю {nome}?",
 "{nome} passa a ser quem cuida do escritório (pode apagá-lo). Você continua na equipe como administrador (quem recebe pode mudar isso depois).": "{nome} станет тем, кто управляет офисом (может его удалить). Вы остаётесь в команде администратором (новый Админ сможет изменить это позже).",
 "Passar": "Передать",
 "{nome} agora cuida do escritório.": "{nome} теперь управляет офисом.",
 "Seu papel aqui é \"Só vê\": você acompanha avisos, tarefas, reuniões e documentos.": "Ваша роль здесь — «Только просмотр»: вы следите за объявлениями, задачами, встречами и документами.",
 "Edita": "Редактирует",
 "Incluir": "Добавить",
 "Novo aviso no mural": "Новое объявление на доске",
 "Você só pode ver este escritório: quem administra escolheu o papel \"Só vê\" para você. Peça a quem administra para mudar, se precisar.": "Вы можете только просматривать этот офис: администратор выбрал для вас роль «Только просмотр». При необходимости попросите администратора её изменить.",
 "Quem viu": "Кто видел",
 "Apagar aviso": "Удалить объявление",
 "Mural de avisos": "Доска объявлений",
 "Novo aviso": "Новое объявление",
 "Ex.: Feriado na sexta: escritório fechado": "Напр.: В пятницу праздник: офис закрыт",
 "Fixar no mural": "Закрепить на доске",
 "Nenhum aviso. Os avisos ficam fixados aqui para toda a equipe.": "Объявлений нет. Объявления закрепляются здесь для всей команды.",
 "visto por {n} de {m}": "просмотрели {n} из {m}",
 "sem responsável": "без ответственного",
 "atrasada desde {d}": "просрочена с {d}",
 "prazo {d}": "срок {d}",
 "Comecei": "Начал(а)",
 "Terminei": "Готово",
 "Reabrir": "Открыть снова",
 "Tarefas da equipe": "Задачи команды",
 "1 aberta": "1 открытая",
 "{n} abertas": "{n} открытых",
 "Minhas tarefas ({n})": "Мои задачи ({n})",
 "Nenhuma tarefa sua aberta. Toque em \"Eu faço\" numa tarefa da equipe.": "Открытых задач у вас нет. Нажмите «Я сделаю» на задаче команды.",
 "Nenhuma tarefa aberta.": "Открытых задач нет.",
 "Feitas ({n})": "Выполнено ({n})",
 "Apagar a tarefa?": "Удалить задачу?",
 "O que precisa ser feito? (ex.: Apurar o DAS de março)": "Что нужно сделать? (напр.: рассчитать DAS за март)",
 "Cliente (opcional)": "Клиент (необязательно)",
 "Prazo (opcional)": "Срок (необязательно)",
 "Responsável (opcional; senão, alguém toca em \"Eu faço\")": "Ответственный (необязательно; иначе кто-то нажмёт «Я сделаю»)",
 "Escreva a tarefa para poder salvar.": "Введите задачу, чтобы сохранить.",
 "Membro": "Участник",
 "Cargo (livre)": "Должность (произвольно)",
 "Ex.: Advogada, Assistente, Estagiário": "Напр.: Юрист, Ассистент, Стажёр",
 "Papel": "Роль",
 "Admin: pode tudo no escritório.": "Админ: может всё в офисе.",
 "Edita: inclui tarefas, avisos, documentos e reuniões": "Редактирует: добавляет задачи, объявления, документы и встречи",
 "Só vê: acompanha tudo, sem incluir nem mudar": "Только просмотр: следит за всем, без добавления и изменений",
 "Proposta": "Предложение",
 "Documento sensível (pede a senha do app para abrir)": "Конфиденциальный документ (для открытия нужен пароль приложения)",
 "Li e concordo: {d}": "Прочитано и принято: {d}",
 "Li e concordo": "Прочитал(а) и согласен(на)",
 "Ao tocar em Concordo, o app guarda a data e a hora em que você leu e concordou com \"{doc}\". É um aceite simples: não substitui uma assinatura digital oficial.": "Когда вы нажмёте «Согласен», приложение сохранит дату и время, когда вы прочитали «{doc}» и согласились. Это простое согласие: оно не заменяет официальную электронную подпись.",
 "Concordo": "Согласен",
 "Fotos (escolha quais entram)": "Фото (выберите, какие)",
 "1 foto não pôde ser lida neste dispositivo e ficou de fora.": "1 фото не удалось прочитать на этом устройстве, оно пропущено.",
 "{n} fotos não puderam ser lidas neste dispositivo e ficaram de fora.": "{n} фото не удалось прочитать на этом устройстве, они пропущены.",
 "Nenhuma foto no álbum desta viagem.": "В альбоме этой поездки нет фото.",
 "Toque nas fotos para marcar ou desmarcar. Elas entram reduzidas, para o PDF ficar leve.": "Нажимайте на фото, чтобы отметить или снять отметку. Они уменьшаются, чтобы PDF был лёгким.",
 "Sugerir até 12": "Предложить до 12",
 "1 foto marcada": "Выбрано 1 фото",
 "{n} fotos marcadas": "Выбрано фото: {n}",
 "Com mais de 12 fotos o PDF fica mais pesado.": "Больше 12 фото — PDF тяжелее.",
 "Confirme para abrir este documento": "Подтвердите, чтобы открыть документ",
 "Como usar esta aba": "Как пользоваться этим разделом",
 "1 cliente estava em mais de uma aba e virou uma ficha só.": "1 клиент был в нескольких разделах и стал одной карточкой.",
 "Juntar {n} fotos num PDF?": "Объединить {n} фото в один PDF?",
 "As fotos viram as páginas de um PDF só, na ordem da lista. As fotos soltas saem desta ficha.": "Фото станут страницами одного PDF в порядке списка. Отдельные фото будут удалены из этой карточки.",
 "Não foi possível ler as fotos neste dispositivo.": "Не удалось прочитать фото на этом устройстве.",
 "PDF criado": "PDF создан",
 "Montando o PDF...": "Создание PDF...",
 "Juntar as {n} fotos num PDF": "Объединить {n} фото в один PDF",
 "Baixar o mês": "Скачать месяц",
 "Os arquivos deste mês estão em outro dispositivo e não puderam ser lidos aqui.": "Файлы этого месяца находятся на другом устройстве, и прочитать их здесь не удалось.",
 "Os documentos deste mês não têm arquivos.": "У документов этого месяца нет файлов.",
 "1 arquivo está em outro dispositivo e ficou de fora.": "1 файл находится на другом устройстве и не был включён.",
 "{n} arquivos estão em outro dispositivo e ficaram de fora.": "{n} файлов находятся на другом устройстве и не были включены.",
 "Conversa sobre este documento": "Обсуждение этого документа",
 "Pergunte ou responda algo sobre este documento. O escritório e o cliente veem.": "Задайте вопрос или ответьте по этому документу. Его видят офис и клиент.",
 "Escreva a mensagem": "Напишите сообщение",
 "Usar um modelo de pedido ({n})": "Использовать шаблон запроса ({n})",
 "Lembrar {nome} pelo WhatsApp: {o}": "Напомнить {nome} в WhatsApp: {o}",
 "Sem honorário": "Без гонорара",
 "Cadastre o valor do honorário no bloco \"Escritório\" da ficha do cliente, em Meus clientes.": "Укажите сумму гонорара в блоке «Офис» карточки клиента, в разделе «Мои клиенты».",
 "Recebi de {c} a quantia de {v}, referente aos honorários da competência {m}.": "Получено от {c} {v} в счёт гонорара за период {m}.",
 "Recibo honorário {m} {c}": "Квитанция о гонораре {m} {c}",
 "Recibo do honorário {m}": "Квитанция о гонораре {m}",
 "Recibo criado": "Квитанция создана",
 "O recibo entrou em Documentos, na competência {m}.": "Квитанция добавлена в «Документы», в период {m}.",
 "Vendo como o cliente": "Просмотр как клиент",
 "É assim que o cliente vê a pasta dele: sem as anotações internas e sem o que é só da equipe. Nada pode ser mudado neste modo.": "Так клиент видит свою папку: без внутренних заметок и без того, что предназначено только для команды. В этом режиме ничего нельзя изменить.",
 "Voltar a ver como escritório": "Вернуться к виду офиса",
 "Ver como o cliente": "Смотреть как клиент",
 "🔒 Anotações internas (o cliente nunca vê)": "🔒 Внутренние заметки (клиент их никогда не видит)",
 "Recibo do honorário…": "Квитанция о гонораре…",
 "Competência do recibo": "Период квитанции",
 "⬇️ Baixar o mês": "⬇️ Скачать месяц",
 "Me avisar para lembrar o cliente": "Напомнить мне напомнить клиенту",
 "Guardar como modelo": "Сохранить как шаблон",
 "Modelo guardado": "Шаблон сохранён",
 "Ao criar um pedido para qualquer cliente, toque em \"Usar um modelo de pedido\".": "При создании запроса для любого клиента нажмите «Использовать шаблон запроса».",
 "Relatório do mês": "Отчёт за месяц",
 "Notas rápidas": "Быстрые заметки",
 "Item completo: {o}": "Полный элемент: {o}",
 "Reuniões do mês": "Встречи месяца",
 "Tarefas feitas e pendentes": "Выполненные и невыполненные задачи",
 "Documentos internos enviados": "Отправленные внутренние документы",
 "Documentos enviados e recebidos dos clientes": "Документы, отправленные клиентам и полученные от них",
 "Documentos da competência": "Документы периода",
 "Guias pagas e vencidas": "Оплаченные и просроченные платёжные квитанции",
 "Honorários": "Гонорары",
 "Relatório do mês · {m}": "Отчёт за месяц · {m}",
 "Reuniões ({n})": "Встречи ({n})",
 "Tarefas: {f} feitas no mês · {p} pendentes": "Задачи: выполнено за месяц — {f} · в ожидании — {p}",
 "Quem fez": "Кто выполнил",
 "Feita em": "Выполнена",
 "Documentos internos enviados ({n})": "Отправленные внутренние документы ({n})",
 "Documentos trocados com os clientes": "Документы, которыми обменялись с клиентами",
 "Enviados pelo escritório": "Отправлено офисом",
 "Recebidos do cliente": "Получено от клиента",
 "Nenhum documento trocado neste mês.": "В этом месяце документами не обменивались.",
 "Clientes com pendência ({n})": "Клиенты с незавершёнными вопросами ({n})",
 "Pendência": "Незавершённый вопрос",
 "Nenhum cliente com pendência.": "Нет клиентов с незавершёнными вопросами.",
 "Documentos da competência {m} ({n})": "Документы периода {m} ({n})",
 "Pedidos de documentos ({n})": "Запросы документов ({n})",
 "Guias do mês: {p} pagas · {v} vencidas": "Платёжные квитанции месяца: оплачено {p} · просрочено {v}",
 "Vencida": "Просрочена",
 "Recebido no mês": "Получено за месяц",
 "Relatório {m} {q}": "Отчёт {m} {q}",
 "MÊS": "МЕСЯЦ",
 "DE QUEM": "ЧЕЙ",
 "O escritório": "Офис",
 "Reuniões, tarefas e documentos internos entram quando há um escritório (equipe).": "Встречи, задачи и внутренние документы включаются, когда есть офис (команда).",
 "CPF, CNPJ, anotações internas e conversas nunca vão para o relatório.": "CPF, CNPJ, внутренние заметки и переписка никогда не попадают в отчёт.",
 "Anotações recebidas": "Полученные заметки",
 "Os valores a receber desta lista aparecem no My Planner, inclusive os novos.": "Суммы к получению из этого списка видны в My Planner, включая новые.",
 "Envia só os valores a receber desta lista (as consultas já vão sozinhas), inclusive os novos.": "Отправляет только суммы к получению из этого списка (приёмы уже попадают сами), включая новые.",
 "Acrescentar": "Добавить",
 "As {n} caixas estão em {aba}, em \"Anotações recebidas\".": "{n} блоков теперь в {aba}, в разделе «Полученные заметки».",
 "Enviadas": "Отправлено",
 "Enviar para": "Отправить в",
 "Excluir 1 item?": "Удалить 1 элемент?",
 "Excluir {n} itens?": "Удалить элементы: {n}?",
 "Inserir abaixo": "Вставить ниже",
 "Mover para": "Переместить в",
 "Mover {n} selecionados para": "Переместить выбранные ({n}) в",
 "adicionar aqui": "добавить сюда",
 "continue segurando para selecionar": "удерживайте, чтобы выбрать"
}
